import React, { useState, useEffect, useMemo, useRef } from "react";
// import toast from "react-hot-toast";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

// Components
import Layout from "../../../../Layout/Layout";
import { InputField } from "../../../../Components/formElements/InputField";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import RichTextEditor from "../../../../Components/Editor/RichTextEditor";
import { useNavigate } from "react-router-dom";
import CustomerConstants from "../../../../common/CustomerConstants";
import GridGenerator from "./GridGenerator";
import { useSelector } from "react-redux";
// import toast from "react-hot-toast";
import ItemService from "../../../../services/customer_appCommonService";
import RoofSloopCase from "./RoofSloopCase";
import CaseSelectionModal from "./CaseSelectionModal";
import ComponentDataViewModal from "./ComponentDataViewModal";
import toast from "react-hot-toast";
import "./FrontWallTable.scss";
import { setEstimationData } from "../../../../redux/feature/customer_app/customerV1Slice";
// import { setEstimationData } from "../../../../redux/feature/customer_app/customerV1Slice";
import Form from "react-bootstrap/Form";

import { useDispatch } from "react-redux";
import RoofSloopMonoSlope from "./RoofSloopMonoSlope";
import EstimationMatchModal from "./EstimationMatchModal";
import EstimationSpecificationReminderModal from "./EstimationSpecificationReminderModal";
import FileUploadComponentForHB from "../../../../Components/formElements/FileUploadComponentForHB";
import FileViewerModalForHB from "../../../../Components/FileViewer/FileViewerModalForHB";
import useConfirmNavigation  from "../Estimation/useConfirmNavigation"


const statusOptions = [
  { id: 1, name: "Hold" },
  { id: 2, name: "Inprogress" },
];

const priorityOptions = [
  { id: 0, name: "High" },
  { id: 1, name: "Low" },
  { id: 2, name: "Medium" },
];
const buildingStrctures = [
  { id: 1, name: "Symmetric", code: "SYM", description: "Symmetric" },
  { id: 1, name: "Asymmetric", code: "ASY", description: "Asymmetric" },
];
// const designs = [
//   { id: 1, name: "AB", code: "AB", description: "AB" },
//   { id: 1, name: "CD", code: "CD", description: "CD" },
// ];

const designs = [
  { id: 1, name: "INDIAN", code: "INDIAN", description: "INDIAN" },
  { id: 2, name: "AMERICAN", code: "AMERICAN", description: "AMERICAN" },
  { id: 3, name: "OTHER", code: "OTHER", description: "OTHER" },
  // { id: 3, name: "AB", code: "AB", description: "AB" },
  // { id: 3, name: "CD", code: "CD", description: "CD" },
];
// eslint-disable-next-line
const buildingInputs = [
  { id: 0, name: "Outer to Outer", code: "OO", description: "outer to outer" },
  { id: 1, name: "Inner to Inner", code: "II", description: "inner to inner" },
  {
    id: 2,
    name: "Center to Center",
    code: "CC",
    description: "center to center",
  },
  {
    id: 3,
    name: "Other",
    code: "OT",
    description: "other",
  },
];

const mainBuildingTypes = [
  {
    id: 0,
    name: "Clear Span Building",
    code: "CSB",
    description: "CLEAR SPAN BUILDING",
  },
  {
    id: 1,
    name: "Multi Span Building",
    code: "MSB",
    description: "MULTI SPAN BUILDING ",
  },
  {
    id: 2,
    name: "Multi Gable Building",
    code: "MGB",
    description: "MULTI GABLE BUILDING ",
  },
  {
    id: 3,
    name: "Low Bay and High Building",
    code: "LHB",
    description: "LOW BAY AND HIGH BAY BUILDING",
  },
  {
    id: 4,
    name: "Multi Level Mezzanine Building",
    code: "MLMB",
    description: "MULTI LEVEL MEZZANINE BUILDING",
  },
];

// Sub Building Data for MGB and LHB
const multiGableBuildingSubTypes = [
  {
    id: 0,
    name: "Clear Span Building",
    code: "CSB",
    description: "CLEAR SPAN BUILDING",
  },
  {
    id: 1,
    name: "Multi Span Building",
    code: "MSB",
    description: "MULTI SPAN BUILDING",
  },
];

const lowBayHighBuildingSubTypes = [
  {
    id: 0,
    name: "Clear Span Building",
    code: "CSB",
    description: "CLEAR SPAN BUILDING",
  },
  {
    id: 1,
    name: "Multi Span Building",
    code: "MSB",
    description: "MULTI SPAN BUILDING",
  },
];

// Building Types Data

const clearSpanBuilding = [
  { id: 0, name: "Mono Slope Building", code: "MCS", description: "MCS" },

  { id: 1, name: "Double Slope Clear Span", code: "CS", description: "CS" },
];

const multiSpanBuilding = [
  {
    id: 0,
    name: "Mono Slope Multi Span Building",
    code: "MSMSB",
    description: "MSMSB",
  },
  {
    id: 1,
    name: "Double Slope Multi Span Building",
    code: "MSB",
    description: "MSB",
  },
];

const multiGableBuildingCSB = [
  {
    id: 0,
    name: "Mono Slope Clear Span Building",
    code: "MCS",
    description: "MCS",
  },
  {
    id: 1,
    name: "Double Slope Clear Span Building",
    code: "CS",
    description: "CS",
  },
];

const multiGableBuildingMSB = [
  {
    id: 0,
    name: "Mono Slope Multi Span Building",
    code: "MSMSB",
    description: "MONO SLOPE MULTI SPAN BUILDING",
  },
  {
    id: 1,
    name: "Double Slope Multi Span Building",
    code: "MSB",
    description: "MSB",
  },
];

const lowBayHighBuildingCSB = [
  {
    id: 0,
    name: "Mono Slope Clear Span Building",
    code: "MCS",
    description: "MCS",
  },
  {
    id: 1,
    name: "Double Slope Clear Span Building",
    code: "CS",
    description: "CS",
  },
];

const lowBayHighBuildingMSB = [
  {
    id: 0,
    name: "Mono Slope Multi Span Building",
    code: "MSMSB",
    description: "MONO SLOPE MULTI SPAN BUILDING",
  },
  {
    id: 1,
    name: "Double Slope Multi Span Building",
    code: "MSB",
    description: "MSB",
  },
];
/* const buildingTypes = [
  { id: 0, name: "Double slope clear span", code: "CS", description: "CS" },
  { id: 1, name: "Mono slope Building", code: "MCS", description: "MCS" },
  {
    id: 2,
    name: "Double Slope Multi Span Building",
    code: "MSB",
    description: "MSB",
  },
]; */

// eslint-disable-next-line
const buildingInputsLength = [
  { id: 0, name: "Outer to Outer", code: "OO", description: "outer to outer" },
  { id: 1, name: "Inner to Inner", code: "II", description: "inner to inner" },
  {
    id: 0,
    name: "Center to Center",
    code: "CC",
    description: "center to center",
  },
];
// New Requirement
// eslint-disable-next-line
const wallTypes = [
  { id: 0, name: "Backend Wall", code: "BEW", description: "backendwall" },
  { id: 1, name: "Frontend Wall", code: "FEW", description: "frontendwall" },
  { id: 2, name: "Left Side Wall", code: "LSW", description: "leftSide wall" },
  {
    id: 2,
    name: "Right Side Wall",
    code: "RSW",
    description: "lightSide wall",
  },
];
//  drop down for columns
const yesNoOptions = [
  { id: 1, name: "Yes", code: "YES", description: "Yes" },
  { id: 2, name: "No", code: "NO", description: "No" },
];
const girtCondition = [
  { id: 1, name: "Bypass", code: "BYPASS", description: "Bypass" },
  { id: 2, name: "Flush", code: "FLUSH", description: "Flush" },
];

const EstimationSpecification = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const location = useLocation();
  useConfirmNavigation();

  let qtnJobRef = useSelector(
    (state) => state?.customerV1?.quotation_Job?.quotation_JobNr
  );

  const estimationData = useSelector(
    (state) => state.customerV1.estimationDraft.estimationData
  );

  // let estimationNr = useSelector(
  //   (state) => state?.customerV1?.estimation?.estimationNr
  // );
  // eslint-disable-next-line
  const [disabled, setDisabled] = useState(false);
  const [isCardVisible1, setCardVisible1] = useState(true);

  // eslint-disable-next-line
  const [backValidation, setBackValidation] = useState({ isInvalid: false });
  // eslint-disable-next-line
  const [frontValidation, setfrontValidation] = useState({ isInvalid: false });
  // eslint-disable-next-line
  const [leftValidation, setLeftValidation] = useState({ isInvalid: false });
  // eslint-disable-next-line
  const [rightValidation, setRightValidation] = useState({ isInvalid: false });

  const [isTableScrolled, setIsTableScrolled] = useState(false);

  // const [isCardVisible6, setCardVisible6] = useState(false);
  // eslint-disable-next-line
  const [crossSectionData, setCrossSectionData] = useState({});

  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };
 
const inputRefs = useRef({});
const handleEnterKey = (
  e,
  section, 
  buildingId,
  rowIndex,
  fieldName
) => {
  if (e.key === "Enter") {
    e.preventDefault();

    const nextRowIndex = rowIndex + 1;
    const nextKey = `${section}-${buildingId}-${fieldName}-${nextRowIndex}`;

    if (inputRefs.current[nextKey]) {
      inputRefs.current[nextKey].focus();
    }
  }
};


  const [formInputs, setFormInputs] = useState({
    // date: "",
    jobNr: "",
    companyName: "",
    buildingStrcture: "Symmetric",
    buildingStrctureCode: "SYM",
    buildingStrctureDesc: "Symmetric",
    transactionDate: "",
    priority: "Low",
    timeLine: "",
    estimateStartdate: new Date().toISOString().split("T")[0],
    estimateEndDate: "",
    qtn_Job_Remarks: "",
    estimationStatus: "Inprogress",
    projectSize: "",
    remarkestimation: "",
    buildingName: "",
    clientName: "",
    salesOfficerName: "",
    Location: "",
    quotationNr: "",
    buildingInputsLength: "",
    buildingInputs: "",
    version: "V0",
    wallTypes: "",
  });

  // New save as a draft api
  const handleEstimation = async () => {
    // Validate before saving
    // validateBackBaySpacing();
    // validatefrontBaySpacing();
    // validateLeftBaySpacing();
    // validateRightBaySpacing();
    let allValid = true;
     let allAreasFilled = true;

  buildings.forEach((building) => {
    const area = building.totalArea || building.buildingArea;
    if (!area || Number(area) === 0) {
      allAreasFilled = false;
    }
  });

  if (!allAreasFilled) {
    toast.error("Please fill all building area fields before saving.", {
      duration: 4000,
      position: "top-right",
    });
    return; // Stop execution if any area is empty
  }

    buildings.forEach((building) => {
      const isMSBBuilding =
        building?.mainBuildingTypeCode === "MSB" ||
        building?.subBuildingTypeCode === "MSB";

      if (isMSBBuilding) {
        if (!validateBuildingCFields(building)) {
          allValid = false;
        }
      }
    });

    if (!allValid) {
      return; // Stop if validation fails for any MSB building
    }

    // Proceed with save

    // Proceed with save
    if (
      frontValidation.isInvalid ||
      backValidation.isInvalid ||
      leftValidation.isInvalid ||
      rightValidation.isInvalid
    ) {
      toast.error(
        "Bay spacings do not add up to total meters. Please fix before saving.",
        {
          duration: 4000,
          position: "top-right",
        }
      );
      return;
    }

    // Prepare main object
    let obj = {
      data: {
        ...formInputs,
        getOverallBuildingArea,
        buildingCount, //number of building counts
        buildings, //buildings
        // copyFrontToBack,
        // copyLeftToRight,
        additionalComponent: additionalComponents,
        activeBuildingId: activeBuildingId,
        canopyInputsTable: canopyInputs,
        // attachABplan,
        componentDataView,
        // selectedCaseObject,
        // selectedCases,
        draftStatus: "DF",
        documentNumber: formInputs?.estimationNr || "",
        comonentKey: selectedComponentKeys,
      },
    };
    // console.log(">>obj", obj);
    const toastId = toast.loading("Saving Estimation...", {
      position: "top-right",
    });
    // api call
    try {
      setDisabled(true);

      let response;

      if (!formInputs?.estimationNr) {
        response = await ItemService.addEstimation(obj);
        // after success → extract estimationNr and save it to state
        if (response?.status === 200) {
          const code = (response?.message.match(/[A-Za-z]+\d+/) || [])[0] || "";
          setFormInputs((prev) => ({ ...prev, estimationNr: code }));
          dispatch(
            setEstimationData({
              ...obj.data,
              estimationNr: code,
            })
          );

          toast.success(
            response?.message || "Estimation created successfully!",
            {
              duration: 2000,
              position: "top-right",
            }
          );
        }
      } else {
        response = await ItemService.updateEstimation(obj.data);
        dispatch(setEstimationData(obj.data));
        if (response?.status === 200) {
          toast.success(
            response?.message || "Estimation updated successfully!",
            {
              duration: 2000,
              position: "top-right",
            }
          );
        }
      }

      if (response?.status === 200) {
        // navigate(CustomerConstants.CUSTOMER_V4_CUSTOMER_ESTIMATE_SPECIFICATION_LIST);
      } else if (response && response?.status !== 200) {
        toast.error(response?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    } catch (error) {
      console.error("Error saving estimation:", error);
      toast.error("Something went wrong. Please try again!", {
        duration: 4000,
        position: "top-right",
      });
    } finally {
      toast.dismiss(toastId);
      setDisabled(false);
    }
  };

  const navigateSpecification = () => {
    localStorage.setItem(
      "selectedComponents",
      JSON.stringify(additionalComponents)
    );
    dispatch(
      setEstimationData({
        ...estimationData,
        getOverallBuildingArea,
        buildingCount,
        buildings,
        additionalComponent: additionalComponents,
        activeBuildingId: activeBuildingId,
        canopyInputsTable: canopyInputs,
        componentDataView,
        draftStatus: "DF",
        documentNumber: formInputs?.estimationNr || "",
        comonentKey: selectedComponentKeys,
      })
    );
    //validation for MS-1 and total widht = C1..
    let allValid = true;

    buildings.forEach((building) => {
      const isMSBBuilding =
        building?.mainBuildingTypeCode === "MSB" ||
        building?.subBuildingTypeCode === "MSB";

      if (isMSBBuilding) {
        if (!validateBuildingCFields(building)) {
          allValid = false;
        }
      }
    });

    if (!allValid) {
      return; // Stop if validation fails for any MSB building
    }

    navigate(CustomerConstants.CUSTOMER_V4_CUSTOMER_ESTIMATE_SPECIFICATION);
  };

  const loadFirstLevelData = async (queryName) => {
    if (!qtnJobRef) return; // safety guard

    const obj = {
      queryName,
      documentNumber: qtnJobRef,
    };

    try {
      const item = await ItemService.generateCustomerQuery(obj);

      if (item?.status === 200 && item?.data?.length > 0) {
        setFormInputs((prev) => ({
          ...prev,
          ...item.data[0],
          buildingStrcture: "Symmetric",
          buildingStrctureCode: "SYM",
          buildingStrctureDesc: "Symmetric",
          estimationStatus: "Created",
          // headerStatus: "Estimation Created",
          headerStatus: "Estimation Draft",
        }));
      } else {
        console.warn("No data returned for", queryName);
      }
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };

  useEffect(() => {
    if (estimationData && Object.keys(estimationData).length > 0) return; // ✅ Skip if estimationData already exists
    if (!qtnJobRef) return;

    loadFirstLevelData("Get_JOB_DETAIL");
    loadFirstLevelData("Get_QUOTATION_DETAIL");
    // eslint-disable-next-line
  }, [qtnJobRef, estimationData]);

  const componentKeyMap = {
    BU: "builtUpMembers",
    LSW: "leftSideWall",
    RSW: "rightSideWall",
    FEW: "frontEndWall",
    RF1: "roof01",
    RF2: "roof02",
    CL: "cageLadder",
    PW: "partitionWall",
    RM: "ridgeVentilator",
    CR: "craneBeam",
    MZ: "mezzanine",
    SL: "structuralLouver",
    FL: "frameOpening",
    FA: "fascia",
    FO: "frameOpening",
    CA: "canopy",
    BR: "portalBracing",
    PS: "pipeStrut",
  };

  const [selectedComponentKeys, setSelectedComponentKeys] = useState([]);
  // eslint-disable-next-line
  const [additionalComponents, setAdditionalComponents] = useState({
    leanTo: false,
    canopy: false,
    frameOpening: false,
    partitionWall: false,
    ridgeVentilator: false,
    turboFans: false,
    cageLadder: false,
    craneBeam: false,
    mezzanine: false,
    fascia: false,
    louvers: false,
    structuralLouver: false,
    industrialLouver: false,
    staircase: false,
    handrail: false,
    hotRolled: false,
    others: false,
    builtUpMembers: true,
    leftSideWall: true,
    rightSideWall: true,
    frontEndWall: true,
    backEndWall: true,
    roof01: true,
    roof02: true,
    pipeStrut: true,
    pipeBracing: true,
    hr: true,
    portalBracing: true,
  });

  // for specific componentKeys
  useEffect(() => {
    const selectedKeys = Object.entries(componentKeyMap)
      .filter(([key, compName]) => additionalComponents[compName])
      .map(([key]) => key);

    setSelectedComponentKeys(selectedKeys);
    // eslint-disable-next-line
  }, [additionalComponents]);
  // dropdown
  const [getDropdownData, setDropdownData] = useState("");

  // funstion for Instruction

  const extractBuildingIdFromCode = (code) => {
    // Match any code ending with - followed by digits
    const match = code.match(/-(\d+)$/);
    if (match) {
      const buildingId = parseInt(match[1]);
      // console.log(">>Extracted building ID:", buildingId);
      return buildingId;
    }

    // console.log(">>No building ID found in code:", code);
    return null;
  };
  // Add state to track building types data for each building
  const [subBuildingData, setSubBuildingData] = useState({});
  const [buildingTypesData, setBuildingTypesData] = useState({});

  // Function to get building types based on main building type
  const getSubBuildingData = (mainBuildingTypeCode) => {
    switch (mainBuildingTypeCode) {
      case "MGB":
        return multiGableBuildingSubTypes;
      case "LHB":
        return lowBayHighBuildingSubTypes;
      default:
        return [];
    }
  };

  // Function to get building types data
  const getBuildingTypesData = (mainBuildingTypeCode, subBuildingTypeCode) => {
    // For Multi Gable Building
    if (mainBuildingTypeCode === "MGB") {
      if (subBuildingTypeCode === "CSB") return multiGableBuildingCSB;
      if (subBuildingTypeCode === "MSB") return multiGableBuildingMSB;
    }

    // For Low Bay and High Building
    if (mainBuildingTypeCode === "LHB") {
      if (subBuildingTypeCode === "CSB") return lowBayHighBuildingCSB;
      if (subBuildingTypeCode === "MSB") return lowBayHighBuildingMSB;
    }

    // For direct CSB and MSB
    if (mainBuildingTypeCode === "CSB") return clearSpanBuilding;
    if (mainBuildingTypeCode === "MSB") return multiSpanBuilding;

    return [];
  };

  useEffect(() => {
    if (!getDropdownData) return;

    if (getDropdownData?.textCode?.includes("mainBuildingTypeCode")) {
      const buildingId = extractBuildingIdFromCode(getDropdownData.textCode);
      if (buildingId !== null) {
        setBuildings((prev) =>
          prev.map((building) =>
            building.id === buildingId
              ? {
                  ...building,
                  mainBuildingType: getDropdownData?.name,
                  mainBuildingTypeCode: getDropdownData?.code,
                  mainBuildingTypeDesc: getDropdownData?.description,
                  // Reset all dependent fields
                  subBuildingType: "",
                  subBuildingTypeCode: "",
                  subBuildingTypeDesc: "",
                  buildingTypes: "",
                  buildingTypesCode: "",
                  buildingTypesDesc: "",
                }
              : building
          )
        );
        // AUTO-FILL WHEN MLMB IS SELECTED
        if (getDropdownData?.code === "MLMB") {
          setBuildings((prev) =>
            prev.map((building) =>
              building.id === buildingId
                ? {
                    ...building,
                    buildingTypes: "Multi Level Mezzanine Building",
                    buildingTypesCode: "MLMB",
                    buildingTypesDesc: "MULTI LEVEL MEZZANINE BUILDING",
                  }
                : building
            )
          );

          // No sub building for MLMB
          setSubBuildingData((prev) => ({
            ...prev,
            [buildingId]: [],
          }));

          // No buildingTypes dropdown needed
          setBuildingTypesData((prev) => ({
            ...prev,
            [buildingId]: [],
          }));
        }

        // FLOW 1: For MGB and LHB - Show Sub Building dropdown
        if (
          getDropdownData?.code === "MGB" ||
          getDropdownData?.code === "LHB"
        ) {
          const subData = getSubBuildingData(getDropdownData?.code);
          setSubBuildingData((prev) => ({
            ...prev,
            [buildingId]: subData,
          }));
          // Clear building types data initially
          setBuildingTypesData((prev) => ({
            ...prev,
            [buildingId]: [],
          }));
        }
        // FLOW 2: For CSB and MSB - Directly show Building Types dropdown
        else if (
          getDropdownData?.code === "CSB" ||
          getDropdownData?.code === "MSB"
        ) {
          const typesData = getBuildingTypesData(getDropdownData?.code, "");
          setBuildingTypesData((prev) => ({
            ...prev,
            [buildingId]: typesData,
          }));
          // Clear sub building data
          setSubBuildingData((prev) => ({
            ...prev,
            [buildingId]: [],
          }));
        }
      }
    } else if (getDropdownData?.textCode?.includes("mainBuildingTypeCode")) {
      const buildingId = extractBuildingIdFromCode(getDropdownData.textCode);
      if (buildingId !== null) {
        setBuildings((prev) =>
          prev.map((building) =>
            building.id === buildingId
              ? {
                  ...building,
                  mainBuildingType: getDropdownData?.name,
                  mainBuildingTypeCode: getDropdownData?.code,
                  mainBuildingTypeDesc: getDropdownData?.description,
                  // Reset dependent fields when main type changes
                  subBuildingType: "",
                  subBuildingTypeCode: "",
                  subBuildingTypeDesc: "",
                  buildingTypes: "",
                  buildingTypesCode: "",
                  buildingTypesDesc: "",
                }
              : building
          )
        );

        // Update sub building data
        const subData = getSubBuildingData(getDropdownData?.code);
        setSubBuildingData((prev) => ({
          ...prev,
          [buildingId]: subData,
        }));

        // Clear building types data
        setBuildingTypesData((prev) => ({
          ...prev,
          [buildingId]: [],
        }));
      }
    } else if (getDropdownData?.textCode?.includes("subBuildingTypeCode")) {
      const buildingId = extractBuildingIdFromCode(getDropdownData.textCode);
      if (buildingId !== null) {
        setBuildings((prev) =>
          prev.map((building) =>
            building.id === buildingId
              ? {
                  ...building,
                  subBuildingType: getDropdownData?.name,
                  subBuildingTypeCode: getDropdownData?.code,
                  subBuildingTypeDesc: getDropdownData?.description,
                  // Reset building types when sub type changes
                  buildingTypes: "",
                  buildingTypesCode: "",
                  buildingTypesDesc: "",
                }
              : building
          )
        );

        // Get the current building to access mainBuildingTypeCode
        const currentBuilding = buildings.find((b) => b.id === buildingId);
        if (currentBuilding) {
          const typesData = getBuildingTypesData(
            currentBuilding.mainBuildingTypeCode,
            getDropdownData?.code
          );
          setBuildingTypesData((prev) => ({
            ...prev,
            [buildingId]: typesData,
          }));
        }
      }
    } else if (getDropdownData?.textCode?.includes("subBuildingTypeCode")) {
      const buildingId = extractBuildingIdFromCode(getDropdownData.textCode);
      if (buildingId !== null) {
        setBuildings((prev) =>
          prev.map((building) =>
            building.id === buildingId
              ? {
                  ...building,
                  subBuildingType: getDropdownData?.name,
                  subBuildingTypeCode: getDropdownData?.code,
                  subBuildingTypeDesc: getDropdownData?.description,
                }
              : building
          )
        );
      }
    } else if (getDropdownData?.textCode?.includes("buildingTypesCode")) {
      const buildingId = extractBuildingIdFromCode(getDropdownData.textCode);
      if (buildingId !== null) {
        setBuildings((prev) =>
          prev.map((building) =>
            building.id === buildingId
              ? {
                  ...building,
                  buildingTypes: getDropdownData?.name,
                  buildingTypesCode: getDropdownData?.code,
                  buildingTypesDesc: getDropdownData?.description,
                }
              : building
          )
        );
      }
    } else if (getDropdownData?.textCode?.includes("buildingStructureCode")) {
      const buildingId = extractBuildingIdFromCode(getDropdownData.textCode);
      if (buildingId !== null) {
        setBuildings((prev) =>
          prev.map((building) =>
            building.id === buildingId
              ? {
                  ...building,
                  buildingStructure: getDropdownData?.name,
                  buildingStructureCode: getDropdownData?.code,
                  buildingStructureDesc: getDropdownData?.description,
                }
              : building
          )
        );
      }
    } else if (getDropdownData?.textCode?.includes("designCode")) {
      const buildingId = extractBuildingIdFromCode(getDropdownData.textCode);
      if (buildingId !== null) {
        setBuildings((prev) =>
          prev.map((building) =>
            building.id === buildingId
              ? {
                  ...building,
                  design: getDropdownData?.name,
                  designCode: getDropdownData?.code,
                  designDesc: getDropdownData?.description,
                }
              : building
          )
        );
      }
    } else if (getDropdownData?.textCode?.includes("buildingFrontInputsCode")) {
      const buildingId = extractBuildingIdFromCode(getDropdownData.textCode);
      if (buildingId !== null) {
        setBuildings((prev) =>
          prev.map((building) =>
            building.id === buildingId
              ? {
                  ...building,
                  front: {
                    ...building.front,
                    buildingInputs: getDropdownData?.name,
                    buildingInputsCode: getDropdownData?.code,
                    buildingInputsDesc: getDropdownData?.description,
                  },
                }
              : building
          )
        );
      }
    } else if (getDropdownData?.textCode?.includes("buildingBackInputsCode")) {
      const buildingId = extractBuildingIdFromCode(getDropdownData.textCode);
      if (buildingId !== null) {
        setBuildings((prev) =>
          prev.map((building) =>
            building.id === buildingId
              ? {
                  ...building,
                  back: {
                    ...building.back,
                    buildingInputs: getDropdownData?.name,
                    buildingInputsCode: getDropdownData?.code,
                    buildingInputsDesc: getDropdownData?.description,
                  },
                }
              : building
          )
        );
      }
    } else if (getDropdownData?.textCode?.includes("buildingLeftInputsCode")) {
      const buildingId = extractBuildingIdFromCode(getDropdownData.textCode);
      if (buildingId !== null) {
        setBuildings((prev) =>
          prev.map((building) =>
            building.id === buildingId
              ? {
                  ...building,
                  left: {
                    ...building.left,
                    buildingInputs: getDropdownData?.name,
                    buildingInputsCode: getDropdownData?.code,
                    buildingInputsDesc: getDropdownData?.description,
                  },
                }
              : building
          )
        );
      }
    } else if (getDropdownData?.textCode?.includes("buildingRightInputsCode")) {
      const buildingId = extractBuildingIdFromCode(getDropdownData.textCode);
      if (buildingId !== null) {
        setBuildings((prev) =>
          prev.map((building) =>
            building.id === buildingId
              ? {
                  ...building,
                  right: {
                    ...building.right,
                    buildingInputs: getDropdownData?.name,
                    buildingInputsCode: getDropdownData?.code,
                    buildingInputsDesc: getDropdownData?.description,
                  },
                }
              : building
          )
        );
      }
    }
    // eslint-disable-next-line
  }, [getDropdownData]);

  useEffect(() => {
    if (!getDropdownData) return;
    // console.log(">>getDropdownData", getDropdownData);

    if (getDropdownData?.textField === "buildingTypes") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    } else if (getDropdownData?.textField === "wallTypes") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    } else if (getDropdownData?.textField === "estimationStatus") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
      }));
    } else if (getDropdownData?.textField === "priority") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
      }));
    } else if (getDropdownData?.textField === "buildingStrcture") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    } else if (getDropdownData?.textField === "canopyInputsSoftFitSheeting") {
      setCanopyInputs((canopyInputs) => ({
        ...canopyInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    } else if (getDropdownData?.textField === "canopyInputsGutter") {
      setCanopyInputs((canopyInputs) => ({
        ...canopyInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    } else if (getDropdownData?.textField === "canopyInputskickerPipe") {
      setCanopyInputs((canopyInputs) => ({
        ...canopyInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    } else {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  //attacha ab plan start

  // Handle AB plan content update
  const handleAttachABplan = (content, buildingId) => {
    setBuildings((prevBuildings) =>
      prevBuildings.map((building) =>
        building.id === buildingId
          ? { ...building, attachABplan: content }
          : building
      )
    );
  };
  //attacha ab plan end
  const calculateTimeline = (startDate, endDate) => {
    if (startDate && endDate) {
      const start = new Date(startDate);
      const end = new Date(endDate);
      const diffTime = end - start;

      if (diffTime >= 0) {
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
        setFormInputs((prev) => ({
          ...prev,
          timeLine: `${diffDays} day${diffDays > 1 ? "s" : ""}`,
        }));
      } else {
        setFormInputs((prev) => ({
          ...prev,
          timeLine: "Invalid range",
        }));
      }
    }
  };

  const [buildingstructureDetails, setBuildingstructureDetails] = useState([
    {
      widthInMM: "",
      widthBays: "",
      lengthInMM: "",
      lengthBays: "",
      buildingInputsLength: "",
      buildingInputs: "",
      baysSpacingWidthRows: [],
      baysSpacingLengthRows: [],
      backSideWallValues: [],
      rightSideWallValues: [],
      fascia: "",
      leanTo: "",
    },
  ]);

  const handleFormInputChange = (e) => {
    const { name, value } = e.target;

    setFormInputs((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
/* 
  useEffect(() => {
    setBuildingstructureDetails((prev) => {
      const updated = [...prev];
      if (updated[0].widthInMM && updated[0].widthBays) {
        const bayCount = Number(updated[0].widthBays);
        const defaultCellSize = Number(updated[0].widthInMM) / bayCount;
        updated[0] = {
          ...updated[0],
          baysSpacingWidthRows: Array.from({ length: bayCount }, (_, i) => ({
            gridLine:
              String.fromCharCode(65 + i) + "-" + String.fromCharCode(66 + i),
            cellSize: defaultCellSize,
            blockCondition: "",
            typeOfBracing: "",
            frameOpening: "",
            canopyLocation: "",
          })),
        };
      }
      return updated;
    });
  }, [
    // eslint-disable-next-line
    buildingstructureDetails[0].widthInMM,
    // eslint-disable-next-line
    buildingstructureDetails[0].widthBays,
  ]);

  useEffect(() => {
    setBuildingstructureDetails((prev) => {
      const updated = [...prev];
      if (updated[0].lengthInMM && updated[0].lengthBays) {
        const lengthCount = Number(updated[0].lengthBays);
        const defaultCellSize = Number(updated[0].lengthInMM) / lengthCount;
        updated[0] = {
          ...updated[0],
          baysSpacingLengthRows: Array.from(
            { length: lengthCount },
            (_, i) => ({
              // gridLine: (i + 1).toString(),
              gridLine: i + 1 + "-" + (i + 2),
              cellSize: defaultCellSize,
              blockCondition: "",
              typeOfBracing: "",
              frameOpening: "",
              canopyLocation: "",
            })
          ),
        };
      }
      return updated;
    });
  }, [
    // eslint-disable-next-line
    buildingstructureDetails[0].lengthInMM,
    // eslint-disable-next-line
    buildingstructureDetails[0].lengthBays,
  ]); */

  const labels = [
    "WIDTH",
    "LSW CLEAR HEIGHT",
    "RSW CLEAR HEIGHT",
    "LSW EAVE HEIGHT",
    "RSW EAVE HEIGHT",
    "LEFT SLOPE 1 : X",
    "SLOPE",
    "RIGHT SLOPE 1 : X",
    "RIDGE HEIGHT",
    "RIDGE DISTANCE FROM LEFT",
    "RIDGE DISTANCE FROM RIGHT",
    "LSW WALL HEIGHT",
    "RSW WALL HEIGHT",
    "WIDTH1",
    "WIDTH2",
  ];
  const fieldKeys = [
    "width",
    "clearHeightLSW",
    "clearHeightRSW",
    "eaveHeightLSW",
    "eaveHeightRSW",
    "leftSlope",
    "slope",
    "rightSlope",
    "ridgeHeight",
    "ridgeDistanceLeft",
    "ridgeDistanceRight",
    "lswWallHeight",
    "rswWallHeight",
    "width1",
    "width2",
  ];

  //=====model for case selection====
  const [selectedBuildingId, setSelectedBuildingId] = useState(null);

  const [modalShowCaseSelect, setModalShowCaseSelect] = useState(null);

  // console.log(">>modalShowCaseSelect", modalShowCaseSelect);

  const showCaseSelectModal = (buildingId, buildingCode) => {
    setSelectedBuildingId(buildingId, buildingCode);
    setModalShowCaseSelect(true);
  };

  const hideCaseSelectModal = () => {
    setModalShowCaseSelect(null);
    setSelectedBuildingId(null);
  };

  const handleCaseSelect = (payload) => {
    if (selectedBuildingId) {
      setBuildings((prevBuildings) =>
        prevBuildings.map((building) =>
          building.id === selectedBuildingId
            ? {
                ...building,
                selectedCases: payload,
                selectedCaseObject: {
                  ...building.selectedCaseObject, // Keep existing values
                  ...payload.selectedCaseObject, // Add new case data
                  caseTypeCode: payload.selectedCaseObject.caseTypeCode,
                  caseTypeDiscription:
                    payload.selectedCaseObject.caseTypeDiscription,
                },
              }
            : building
        )
      );
    }
    hideCaseSelectModal();
  };

  const handleCaseSelectInputChange = (fieldKey, value, buildingId) => {
    setBuildings((prevBuildings) =>
      prevBuildings.map((building) => {
        if (building.id === buildingId) {
          let selectedCaseObject = building.selectedCaseObject || {
            // Common fields
            caseTypeCode: "",
            caseTypeDiscription: "",
            width: "",
            clearHeightLSW: "",
            clearHeightRSW: "",
            eaveHeightLSW: "",
            eaveHeightRSW: "",
            ridgeHeight: "",
            leftSlope: "",
            rightSlope: "",
            ridgeDistanceLeft: "",
            ridgeDistanceRight: "",
            lswWallHeight: "",
            rswWallHeight: "",
            width1: "",
            width2: "",
            numberOfBays: "",
            partitionWall: "",
            staircase: "",
            roofMonitor: "",
            cageLadder: "",
            // MSB specific fields (initialize if building is MSB)
            ...(building.buildingTypesCode === "MSB" && {}),
          };

          let updatedCaseObject = {
            ...selectedCaseObject,
            [fieldKey]: value,
          };

          // Your existing calculation logic for CS buildings
          if (
            updatedCaseObject.caseTypeCode &&
            building.buildingTypesCode === "CS"
          ) {
            //  CS calculation logic
            // Parse all numeric values once
            // const leftSlope = parseFloat(updatedCaseObject.leftSlope) || 0;
            // const rightSlope = parseFloat(updatedCaseObject.rightSlope) || 0;
            const ridgeHeight = parseFloat(updatedCaseObject.ridgeHeight) || 0;
            // console.log(">>ridgeHeight",ridgeHeight)
            const ridgeDistanceLeft =
              parseFloat(updatedCaseObject.ridgeDistanceLeft) || 0;
            const ridgeDistanceRight =
              parseFloat(updatedCaseObject.ridgeDistanceRight) || 0;
            const eaveHeightLSW =
              parseFloat(updatedCaseObject.eaveHeightLSW) || 0;
            // console.log(">>eaveHeightLSW",eaveHeightLSW)
            const eaveHeightRSW =
              parseFloat(updatedCaseObject.eaveHeightRSW) || 0;

            // console.log("Field changed:", fieldKey, "Value:", value);
            // console.log("Current case type:", updatedCaseObject.caseTypeCode);

            // Case C1: Symmetrical roof (left and right slopes are equal)
            if (updatedCaseObject.caseTypeCode === "C1") {
              // console.log("Processing C1 case");

              // If left slope changes, update right slope to match
              if (fieldKey === "leftSlope") {
                updatedCaseObject.rightSlope = value;
                // console.log("Updated rightSlope to:", value);
              }
              // If right slope changes, update left slope to match
              else if (fieldKey === "rightSlope") {
                updatedCaseObject.leftSlope = value;
                // console.log("Updated leftSlope to:", value);
              }

              // Recalculate ridge height for C1
              const currentLeftSlope =
                parseFloat(updatedCaseObject.leftSlope) || 0;
              const currentRidgeDistanceLeft =
                parseFloat(updatedCaseObject.ridgeDistanceLeft) || 0;
              const currentEaveHeightLSW =
                parseFloat(updatedCaseObject.eaveHeightLSW) || 0;

              if (currentLeftSlope > 0 && currentRidgeDistanceLeft > 0) {
                const calculatedRidgeHeight = (
                  (1 / currentLeftSlope) * currentRidgeDistanceLeft +
                  currentEaveHeightLSW
                ).toFixed(3);
                updatedCaseObject.ridgeHeight = calculatedRidgeHeight;
              }
            }

            // Cases C2, C3, C4: Asymmetrical roofs
            if (["C2", "C3", "C4"].includes(updatedCaseObject.caseTypeCode)) {
              // Calculate left slope
              if (ridgeDistanceLeft > 0 && ridgeHeight !== eaveHeightLSW) {
                const calculatedLeftSlope = (
                  1 /
                  ((ridgeHeight - eaveHeightLSW) / ridgeDistanceLeft)
                ).toFixed(3);
                updatedCaseObject.leftSlope = calculatedLeftSlope;
              } else {
                updatedCaseObject.leftSlope = "0";
              }

              // Calculate right slope
              if (ridgeDistanceRight > 0 && ridgeHeight !== eaveHeightRSW) {
                const calculatedRightSlope = (
                  1 /
                  ((ridgeHeight - eaveHeightRSW) / ridgeDistanceRight)
                ).toFixed(3);
                updatedCaseObject.rightSlope = calculatedRightSlope;
              } else {
                updatedCaseObject.rightSlope = "0";
              }
            }
          }

          // Add MSB specific calculations if needed
          if (
            updatedCaseObject.caseTypeCode &&
            building.buildingTypesCode === "MSB"
          ) {
            // Add MSB specific calculations here
          }

          return { ...building, selectedCaseObject: updatedCaseObject };
        }
        return building;
      })
    );
  };
  const handleMCSInputChange = (fieldKey, value, buildingId) => {
    setBuildings((prevBuildings) =>
      prevBuildings.map((building) => {
        if (building.id === buildingId) {
          // Initialize selectedCaseObject if it doesn't exist
          let selectedCaseObject = building.selectedCaseObject || {
            caseTypeCode: "",
            caseTypeDiscription: "",
            width: "",
            clearHeightLSW: "",
            clearHeightRSW: "",
            eaveHeightLSW: "",
            eaveHeightRSW: "",
            leftSlope: "",
            rightSlope: "",
            ridgeHeight: "",
            ridgeDistanceLeft: "",
            ridgeDistanceRight: "",
            lswWallHeight: "",
            rswWallHeight: "",
            width1: "",
            width2: "",
            numberOfBays: "",
            partitionWall: "",
            staircase: "",
            roofMonitor: "",
            cageLadder: "",
          };

          return {
            ...building,
            selectedCaseObject: {
              ...selectedCaseObject,
              [fieldKey]: value,
            },
          };
        }
        return building;
      })
    );
  };
  //==================mezzanine start================

  //Mezzanine Inputs
  const mezzaninTableRows = [
    "No. of mezzanine floor",
    "Width",
    "Length",
    "Clear Height",
    "Thickness of slab",
    "Mezzanine Handrails",
    "Mezzanine staircase",
    
  ];

  //==================mezzanine end================

  //==================crane start================

  // crane Table
  const craneTableRows = [
    "Crane Type",
    "Crane AISLE (SPAN 1,2,3)",
    "GRID LINE FROM",
    "GRID LINE TO",
    "Crane Capacity",
    "Crane Bracket/Hook Height",
    "Bridge weight (MT)",
    "Carb / trolley / Hoist weight (MT)",
    "Wheel Base (m)",
    "Bumper to bumper dist (m)",
    "Rail",
    "Tandom operation",
  ];

  // --- FRONT WALL ---

  const handleFrontBaysChange = (value, buildingId) => {
    const bays = Number(value);

    setBuildings((prev) =>
      prev.map((building) => {
        if (building.id !== buildingId) return building;

        const front = building.front || {};
        const meters = Number(front.meters || 0);
        const spacing = bays > 0 && meters ? meters / bays : "";

        const rows = Array.from({ length: bays }, (_, i) => {
          const start = indexToLetter(i);
          const end = indexToLetter(i + 1);
          const existingRow = front.rows[i] || {};
          return {
            ...existingRow,
            local_id: i + 1,
            wall: `1/${start}-${end}`,
            baySpacing: spacing ? spacing.toFixed(3) : "",
            cellSize: existingRow.cellSize || "",
            frameOpening: existingRow.frameOpening || "No",
            canopy: existingRow.canopy || "No",
            leanTo: existingRow.leanTo || "No",
            fixedLouvers: existingRow.fixedLouvers || "No",
            structuralLouvers: existingRow.structuralLouvers || "No",
            blockWallHeight:
              existingRow.blockWallHeight || front.blockWallHeight || "",
            purlinGirtCondition: existingRow.purlinGirtCondition || "Bypass",
            typeOfBracing: existingRow.typeOfBracing || "Nill",
            fascia: existingRow.fascia || "No",
          };
        });

        const updatedBuilding = {
          ...building,
          front: {
            ...front,
            bays: value,
            rows,
          },
        };

        updateGridDetails(updatedBuilding);
        return updatedBuilding;
      })
    );
  };

  // Helper function to update grid details
  const updateGridDetails = (building) => {
    setBuildingstructureDetails((prev) => {
      const updated = [...prev];
      const buildingIndex = updated.findIndex(
        (b) => b.buildingId === building.id
      );

      if (buildingIndex === -1) {
        // Create new entry
        updated.push({
          buildingId: building.id,
          lengthBays: building.left?.bays || 0,
          widthBays: building.front?.bays || 0,
          lengthInMM: (building.left?.meters || 0) * 1000,
          widthInMM: (building.front?.meters || 0) * 1000,
          baysSpacingLengthRows: building.left?.rows || [],
          baysSpacingWidthRows: building.front?.rows || [],
          backSideWallValues: building.back?.rows || [],
          rightSideWallValues: building.right?.rows || [],
          wallsPayload: {
            "Front End Wall": building.front?.rows || [],
            "Back End Wall": building.back?.rows || [],
            "Left Side Wall": building.left?.rows || [],
            "Right Side Wall": building.right?.rows || [],
          },
        });
      } else {
        // Update existing entry
        updated[buildingIndex] = {
          ...updated[buildingIndex],
          lengthBays: building.left?.bays || 0,
          widthBays: building.front?.bays || 0,
          lengthInMM: (building.left?.meters || 0) * 1000,
          widthInMM: (building.front?.meters || 0) * 1000,
          baysSpacingLengthRows: building.left?.rows || [],
          baysSpacingWidthRows: building.front?.rows || [],
          backSideWallValues: building.back?.rows || [],
          rightSideWallValues: building.right?.rows || [],
          wallsPayload: {
            "Front End Wall": building.front?.rows || [],
            "Back End Wall": building.back?.rows || [],
            "Left Side Wall": building.left?.rows || [],
            "Right Side Wall": building.right?.rows || [],
          },
        };
      }

      return updated;
    });
  };
  const handleFrontOtherBuildingInputsChange = (value, buildingId) => {
    setBuildings((prev) =>
      prev.map((b) => {
        if (b.id !== buildingId) return b;

        return {
          ...b,
          front: {
            ...b.front,
            frontOtherBuildingInputs: value,
          },
        };
      })
    );
  };
  const handleBackOtherBuildingInputsChange = (value, buildingId) => {
    setBuildings((prev) =>
      prev.map((b) => {
        if (b.id !== buildingId) return b;

        return {
          ...b,
          back: {
            ...b.back,
            backOtherBuildingInputs: value,
          },
        };
      })
    );
  };
  const handleLeftOtherBuildingInputsChange = (value, buildingId) => {
    setBuildings((prev) =>
      prev.map((b) => {
        if (b.id !== buildingId) return b;

        return {
          ...b,
          left: {
            ...b.left,
            leftOtherBuildingInputs: value,
          },
        };
      })
    );
  };
  const handleRightOtherBuildingInputsChange = (value, buildingId) => {
    setBuildings((prev) =>
      prev.map((b) => {
        if (b.id !== buildingId) return b;

        return {
          ...b,
          right: {
            ...b.right,
            rightOtherBuildingInputs: value,
          },
        };
      })
    );
  };

  // const handleFrontMetersChange = (value, buildingId) => {
  //   // Convert to number and limit to 3 decimals
  //   const meters =
  //     value === "" || isNaN(value) ? "" : Number(parseFloat(value).toFixed(3));

  //   setBuildings((prevBuildings) =>
  //     prevBuildings.map((building) => {
  //       if (building.id === buildingId) {
  //         const leftMeters = Number(building.left?.meters) || 0;
  //         const buildingArea =
  //           meters && leftMeters ? (meters * leftMeters).toFixed(2) : "";

  //         return {
  //           ...building,
  //           front: {
  //             ...building.front,
  //             meters,
  //           },
  //           selectedCaseObject: {
  //             ...building.selectedCaseObject,
  //             width: meters || building?.selectedCaseObject?.width,
  //           },
  //           buildingArea,
  //         };
  //       }
  //       return building;
  //     })
  //   );
  // };
const [enteredArea, setEnteredArea] = useState(0);
  const handleFrontMetersChange = (value, buildingId) => {
    // 1. Convert to number and limit to 3 decimals (Existing logic)
    const newFrontMeters =
      value === "" || isNaN(value) ? "" : Number(parseFloat(value).toFixed(3));

    const currentBuilding = buildings.find(b => b.id === buildingId);
    const leftMeters = Number(currentBuilding?.left?.meters) || 0; // Current Left value

    let newCalculatedArea = 0;
    if (newFrontMeters && leftMeters) {
        newCalculatedArea = newFrontMeters * leftMeters;
    }

    setEnteredArea(newCalculatedArea); 

    setBuildings((prevBuildings) =>
      prevBuildings.map((building) => {
        if (building.id === buildingId) {
          const buildingAreaForDisplay = newCalculatedArea 
            ? newCalculatedArea.toFixed(2) 
            : "";

          return {
            ...building,
            front: {
              ...building.front,
              meters: newFrontMeters,
            },
            selectedCaseObject: {
              ...building.selectedCaseObject,
              width: newFrontMeters || building?.selectedCaseObject?.width,
            },
            buildingArea: buildingAreaForDisplay,
          };
        }
        return building;
      })
    );
};
const handleFrontRowChange = (index, field, value, buildingId, formatOnBlur = false) => {
  setBuildings((prev) =>
    prev.map((building) => {
      if (building.id !== buildingId) return building;

      const updatedBuilding = {
        ...building,
        front: {
          ...building.front,
          rows: building.front.rows?.map((row, i) => {
            if (i !== index) return row;
            let formattedValue = value;
            if (formatOnBlur && value !== "" && !isNaN(value)) {
              formattedValue = parseFloat(value).toFixed(3);
            }
            return { ...row, [field]: formattedValue };
          }),
        },
      };

      // ✅ Update buildingstructureDetails live
      updateGridDetails(updatedBuilding);
      return updatedBuilding;
    })
  );
};
  
  const handleBlockWallHeightChange = (value, buildingId) => {
    setBuildings((prev) =>
      prev.map((building) =>
        building.id === buildingId
          ? {
              ...building,
              front: {
                ...building.front,
                blockWallHeight: value,
                // Update all rows if blockWallHeight is enabled
                rows: building.additionalComponents?.blockWallHeight
                  ? building.front.rows?.map((row) => ({
                      ...row,
                      blockWallHeight: value,
                    }))
                  : building.front.rows,
              },
            }
          : building
      )
    );
  };

  // --- BACK WALL ---

  const skipLetters = ["I", "O"];

  const indexToLetter = (index) => {
    // Allowed letters (A–Z except I and O)
    const letters = [];
    for (let i = 65; i <= 90; i++) {
      const char = String.fromCharCode(i);
      if (!skipLetters.includes(char)) letters.push(char);
    }

    const lettersCount = letters.length;
    let result = "";

    // Convert index to base-(lettersCount) representation
    while (index >= 0) {
      result = letters[index % lettersCount] + result;
      index = Math.floor(index / lettersCount) - 1;
    }

    return result;
  };

  // eslint-disable-next-line
  const generatePairs = (numPairs) => {
    const pairs = [];
    for (let i = 0; i < numPairs; i++) {
      const start = indexToLetter(i);
      const end = indexToLetter(i + 1);
      pairs.push(`${start}-${end}`);
    }
    return pairs;
  };

  useEffect(() => {
    generatePairs();
  }, [generatePairs]);
// eslint-disable-next-line
  const letterToIndex = (letter) => {
    let num = 0;
    for (let i = 0; i < letter.length; i++) {
      num = num * 26 + (letter.charCodeAt(i) - 64);
    }
    return num;
  };

  // --- Back End Wall Start---

  const handleBackMetersChange = (value, buildingId) => {
    setBuildings((prev) =>
      prev.map((building) => {
        if (building.id !== buildingId) return building;
        if (building.copyFrontToBack) return building;

        const back = building.back || {};
        const bays = Number(back.bays) || 0;
        const spacing = bays > 0 && value ? value / bays : "";

        const updatedRows =
          back.rows?.map((row) => ({
            ...row,
            baySpacing: spacing ? spacing.toFixed(2) : "",
          })) || [];

        const updatedBuilding = {
          ...building,
          back: {
            ...back,
            meters: value,
            rows: updatedRows,
          },
        };

        updateGridDetails(updatedBuilding);
        return updatedBuilding;
      })
    );
  };

const handleBackBaysChange = (value, buildingId) => {
  // 🔹 FIX: Kotha Logic - I & O skip chesi, duplicates raakunda chestundi
  const getColumnLabel = (num) => {
    // Manam allow chese letters matrame ikkada untayi (No I, No O)
    const validChars = "ABCDEFGHJKLMNPQRSTUVWXYZ"; 
    const base = validChars.length;
    let label = "";

    while (num >= 0) {
      label = validChars[num % base] + label;
      num = Math.floor(num / base) - 1;
    }
    return label;
  };

  const indexToLetter = (index) => getColumnLabel(index);

  setBuildings((prev) =>
    prev.map((building) => {
      if (building.id !== buildingId) return building;
      if (building.copyFrontToBack) return building;

      // 🔹 Reset case
      if (value === "") {
        const updatedBuilding = {
          ...building,
          back: { ...building.back, bays: "", rows: [] },
        };
        updateGridDetails(updatedBuilding);
        return updatedBuilding;
      }

      const bays = Number(value);
      if (!bays || bays < 1) return building;

      const back = building.back || {};
      const meters = Number(back.meters || 0);
      const spacing = meters && bays ? meters / bays : "";

      // 🔹 Start number based on LEFT bays
      const leftBays = Number(building.left?.bays || 0);
      const startNumber = leftBays + 1;

      // 🔹 Rows creation
      const rows = Array.from({ length: bays }, (_, i) => {
        let start = indexToLetter(i);
        let end = indexToLetter(i + 1);

        const existingRow = back.rows?.[i] || {};

        return {
          ...existingRow,
          local_id: i + 1,
          wall: `${startNumber}/${start}-${end}`, // Ippudu correct ga vastundi (Ex: J-K)
          baySpacing: spacing ? spacing.toFixed(3) : "",
          cellSize: existingRow.cellSize || "",
          frameOpening: existingRow.frameOpening || "No",
          canopy: existingRow.canopy || "No",
          leanTo: existingRow.leanTo || "No",
          fixedLouvers: existingRow.fixedLouvers || "No",
          structuralLouvers: existingRow.structuralLouvers || "No",
          blockWallHeight:
            existingRow.blockWallHeight || back.blockWallHeight || "",
          purlinGirtCondition: existingRow.purlinGirtCondition || "Bypass",
          typeOfBracing: existingRow.typeOfBracing || "Nill",
          fascia: existingRow.fascia || "No",
        };
      });

      const updatedBuilding = {
        ...building,
        back: {
          ...back,
          bays: value,
          rows,
        },
      };

      updateGridDetails(updatedBuilding);
      return updatedBuilding;
    })
  );
};

const handleBackRowChange = (index, field, value, buildingId, formatOnBlur = false) => {
  setBuildings((prev) =>
    prev.map((building) => {
      if (building.id !== buildingId) return building;

      const updatedBuilding = {
        ...building,
        back: {
          ...building.back,
          rows: building.back.rows?.map((row, i) => {
            if (i !== index) return row;
            let formattedValue = value;
            if (formatOnBlur && value !== "" && !isNaN(value)) {
              formattedValue = parseFloat(value).toFixed(3);
            }
            return { ...row, [field]: formattedValue };
          }),
        },
      };

      updateGridDetails(updatedBuilding); // ✅
      return updatedBuilding;
    })
  );
};
  const handleBackBlockWallHeightChange = (value, buildingId) => {
  setBuildings((prev) =>
    prev.map((building) => {
      if (building.id !== buildingId) return building;

      return {
        ...building,
        back: {
          ...building.back,
          blockWallHeight: value,
          rows: building.additionalComponents?.blockWallHeight
            ? building.back.rows?.map((row) => ({
                ...row,
                blockWallHeight: value,
              }))
            : building.back.rows,
        },
      };
    })
  );
};

  useEffect(() => {
    if (additionalComponents?.blockWallHeight) {
      setBuildings((prev) =>
        prev.map((building) =>
          building.additionalComponents?.blockWallHeight
            ? {
                ...building,
                back: {
                  ...building.back,
                  rows: building.back.rows?.map((row) => ({
                    ...row,
                    blockWallHeight: building.back.blockWallHeight || "",
                  })),
                },
              }
            : building
        )
      );
    }
  }, [additionalComponents?.blockWallHeight]);
  // Backend Wall End

  // Left End Wall Start
  const handleLeftMetersChange = (value, buildingId) => {
    // Convert new input value to a usable number (0 if invalid/empty)
    const newLeftMeters =
        value === "" || isNaN(value)
            ? 0
            : Number(parseFloat(value).toFixed(3));

    const currentBuilding = buildings.find(b => b.id === buildingId);
    const frontMeters = Number(currentBuilding?.front?.meters) || 0;

    let newCalculatedArea = 0;
    if (frontMeters > 0 && newLeftMeters > 0) {
        newCalculatedArea = frontMeters * newLeftMeters;
    }


    setEnteredArea(newCalculatedArea); 

    setBuildings((prev) =>
      prev.map((building) => {
        if (building.id !== buildingId) return building;

        const left = building.left || {};
        const bays = Number(left.bays) || 0;
        const spacing = bays > 0 && value ? newLeftMeters / bays : ""; // Use newLeftMeters

        const updatedRows =
          left.rows?.map((row) => ({
            ...row,
            baySpacing: spacing ? spacing.toFixed(2) : "",
          })) || [];

        const buildingAreaForDisplay = newCalculatedArea > 0
            ? newCalculatedArea.toFixed(2)
            : "";
            
        const updatedBuilding = {
          ...building,
          left: {
            ...left,
            meters: newLeftMeters, // Use the cleaned value
            rows: updatedRows,
          },
          buildingArea: buildingAreaForDisplay, // ✅ Update calculated area for display
        };

        // Assuming updateGridDetails is a side effect you need to run
        updateGridDetails(updatedBuilding); 
        return updatedBuilding;
      })
    );
};

  const handleLeftBaysChange = (value, buildingId) => {
    const bays = Number(value);

    setBuildings((prev) =>
      prev.map((building) => {
        if (building.id !== buildingId) return building;

        const left = building.left || {};
        const totalMeters = Number(left.meters || 0);
        const baySpacing = bays > 0 ? totalMeters / bays : "";

        const rows = Array.from({ length: bays }, (_, i) => {
          const existingRow = left.rows[i] || {};
          return {
            ...existingRow,
            local_id: i + 1,
            wall: `A/${i + 1}-${i + 2}`,
            baySpacing: baySpacing ? baySpacing.toFixed(3) : "",
            cellSize: existingRow.cellSize || "",
            frameOpening: existingRow.frameOpening || "No",
            canopy: existingRow.canopy || "No",
            leanTo: existingRow.leanTo || "No",
            fixedLouvers: existingRow.fixedLouvers || "No",
            structuralLouvers: existingRow.structuralLouvers || "No",
            blockWallHeight:
              existingRow.blockWallHeight || left.blockWallHeight || "",
            purlinGirtCondition: existingRow.purlinGirtCondition || "Bypass",
            typeOfBracing: existingRow.typeOfBracing || "Nill",
            fascia: existingRow.fascia || "No",
          };
        });

        const updatedBuilding = {
          ...building,
          left: {
            ...left,
            bays: value,
            rows,
          },
        };

        updateGridDetails(updatedBuilding);
        return updatedBuilding;
      })
    );
  };

  const handleLeftRowChange = (index, field, value, buildingId, formatOnBlur = false) => {
  setBuildings((prev) =>
    prev.map((building) => {
      if (building.id !== buildingId) return building;

      const updatedBuilding = {
        ...building,
        left: {
          ...building.left,
          rows: building.left.rows?.map((row, i) => {
            if (i !== index) return row;
            let formattedValue = value;
            if (formatOnBlur && value !== "" && !isNaN(value)) {
              formattedValue = parseFloat(value).toFixed(3);
            }
            return { ...row, [field]: formattedValue };
          }),
        },
      };

      updateGridDetails(updatedBuilding); // ✅
      return updatedBuilding;
    })
  );
};

  const handleLeftBlockWallHeightChange = (value, buildingId) => {
    setBuildings((prev) =>
      prev.map((building) => {
        if (building.id !== buildingId) return building;

        return {
          ...building,
          left: {
            ...building.left,
            blockWallHeight: value,
            rows: building.additionalComponents?.blockWallHeight
              ? building.left.rows?.map((row) => ({
                  ...row,
                  blockWallHeight: value,
                }))
              : building.left.rows,
          },
        };
      })
    );
  };

  // Update the useEffect for left wall block wall height
  useEffect(() => {
    if (additionalComponents?.blockWallHeight) {
      setBuildings((prev) =>
        prev.map((building) =>
          building.additionalComponents?.blockWallHeight
            ? {
                ...building,
                left: {
                  ...building.left,
                  rows: building.left.rows?.map((row) => ({
                    ...row,
                    blockWallHeight: building.left.blockWallHeight || "",
                  })),
                },
              }
            : building
        )
      );
    }
  }, [additionalComponents?.blockWallHeight]);
  // Left End Wall End

  // Right End Wall
  const handleRightMetersChange = (value, buildingId) => {
    setBuildings((prev) =>
      prev.map((building) => {
        if (building.id !== buildingId) return building;

        // const meters = value === "" ? "" : Number(value);

        const updatedBuilding = {
          ...building,
          right: {
            ...building.right,
            meters: value,
            // Update rows spacing when meters change
            rows: building.right.rows?.map((row) => ({
              ...row,
              baySpacing:
                building.right.bays > 0 && value
                  ? (value / building.right.bays).toFixed(2)
                  : "",
            })),
          },
        };

        return updatedBuilding;
      })
    );
  };

  const handleRightBaysChange = (value, buildingId) => {
    setBuildings((prev) =>
      prev.map((building) => {
        if (building.id !== buildingId) return building;
        if (building.copyLeftToRight) return building;

        if (value === "") {
          const updatedBuilding = {
            ...building,
            right: {
              ...building.right,
              bays: "",
              rows: [],
            },
          };
          updateGridDetails(updatedBuilding);
          return updatedBuilding;
        }

        const bays = Number(value);
        if (!bays || bays < 1) return building;

        const right = building.right || {};
        const back = building.back || {};
        const meters = Number(right.meters || 0);
        const spacing = meters / bays;

        // 🧠 Helper function to convert number -> letter (skipping I, O)
        const skipLetters = ["I", "O"];
        const letters = [];
        for (let i = 65; i <= 90; i++) {
          const char = String.fromCharCode(i);
          if (!skipLetters.includes(char)) letters.push(char);
        }

        const numberToLetter = (num) => {
          const index = (num - 1) % letters.length;
          return letters[index];
        };

        const backBays = Number(back.bays) || 0;

        // ✅ Convert that number (like 17) into letter (like Q)
        const prefix =
          backBays > 0 ? numberToLetter(backBays + 1) : backBays + 1; // 17 → Q

        const rows = Array.from({ length: bays }, (_, i) => {
          const existingRow = right.rows?.[i] || {};
          return {
            ...existingRow,
            local_id: i + 1,
            wall: `${prefix}/${i + 1}-${i + 2}`, // ✅ Example: Q/1-2, Q/2-3
            baySpacing: spacing ? spacing.toFixed(3) : "",
            cellSize: existingRow.cellSize || "",
            frameOpening: existingRow.frameOpening || "No",
            canopy: existingRow.canopy || "No",
            leanTo: existingRow.leanTo || "No",
            fixedLouvers: existingRow.fixedLouvers || "No",
            structuralLouvers: existingRow.structuralLouvers || "No",
            blockWallHeight:
              existingRow.blockWallHeight || right.blockWallHeight || "",
            purlinGirtCondition: existingRow.purlinGirtCondition || "Bypass",
            typeOfBracing: existingRow.typeOfBracing || "Nill",
            fascia: existingRow.fascia || "No",
          };
        });

        const updatedBuilding = {
          ...building,
          right: {
            ...right,
            bays: value,
            rows,
          },
        };

        updateGridDetails(updatedBuilding);
        return updatedBuilding;
      })
    );
  };

  const handleRightRowChange = (index, field, value, buildingId, formatOnBlur = false) => {
  setBuildings((prev) =>
    prev.map((building) => {
      if (building.id !== buildingId) return building;

      const updatedBuilding = {
        ...building,
        right: {
          ...building.right,
          rows: building.right.rows?.map((row, i) => {
            if (i !== index) return row;
            let formattedValue = value;
            if (formatOnBlur && value !== "" && !isNaN(value)) {
              formattedValue = parseFloat(value).toFixed(3);
            }
            return { ...row, [field]: formattedValue };
          }),
        },
      };

      updateGridDetails(updatedBuilding); // ✅
      return updatedBuilding;
    })
  );
};
  // const handleRightRowChange = (
  //   index,
  //   field,
  //   value,
  //   buildingId,
  //   formatOnBlur = false
  // ) => {
  //   setBuildings((prev) =>
  //     prev.map((building) => {
  //       if (building.id !== buildingId) return building;

  //       return {
  //         ...building,
  //         right: {
  //           ...building.right,
  //           rows: building.right.rows?.map((row, i) => {
  //             if (i !== index) return row;

  //             let formattedValue = value;

  //             if (formatOnBlur && value !== "" && !isNaN(value)) {
  //               formattedValue = parseFloat(value).toFixed(3);
  //             }

  //             return { ...row, [field]: formattedValue };
  //           }),
  //         },
  //       };
  //     })
  //   );
  // };

  const handleRightBlockWallHeightChange = (value, buildingId) => {
    setBuildings((prev) =>
      prev.map((building) => {
        if (building.id !== buildingId) return building;

        return {
          ...building,
          right: {
            ...building.right,
            blockWallHeight: value,
            rows: building.additionalComponents?.blockWallHeight
              ? building.right.rows?.map((row) => ({
                  ...row,
                  blockWallHeight: value,
                }))
              : building.right.rows,
          },
        };
      })
    );
  };

  // Update the useEffect for right wall block wall height
  useEffect(() => {
    if (additionalComponents?.blockWallHeight) {
      setBuildings((prev) =>
        prev.map((building) =>
          building.additionalComponents?.blockWallHeight
            ? {
                ...building,
                right: {
                  ...building.right,
                  rows: building.right.rows?.map((row) => ({
                    ...row,
                    blockWallHeight: building.right.blockWallHeight || "",
                  })),
                },
              }
            : building
        )
      );
    }
  }, [additionalComponents?.blockWallHeight]);
  // Right End Wall End

  // end functions
  const [canopyInputs, setCanopyInputs] = useState({
    canopyInputsSoftFitSheeting: "Yes",
    canopyInputsSoftFitSheetingCode: "YES",
    canopyInputsSoftFitSheetingDisc: "Yes",
    canopyInputsGutter: "No",
    canopyInputsGutterCode: "NO",
    canopyInputsGutterDisc: "No",
    canopyInputskickerPipe: "No",
    canopyInputskickerPipeCode: "NO",
    canopyInputskickerPipeDisc: "No",
  });

  /* Structural Louvers Inputs  end*/
  //==================bulding structrue details end ============

  /* Building Case Type details */

  // eslint-disable-next-line
  // const hasBays = right?.bays > 0;

  // Format headers nicely
  const formatHeader = (key) =>
    key.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase());

  //Building Case Type details

  //====================grid component start=========
/*   const handleGridUpdate = (type, index, value, buildingId) => {
    const typeToWallKey = {
      length: "left",
      width: "front",
      backLength: "back",
      rightWidth: "right",
    };

    const wallKey = typeToWallKey[type];

    if (!wallKey) return;

    // Update the specific building's wall state
    setBuildings((prev) =>
      prev.map((building) => {
        if (building.id !== buildingId) return building;

        const wall = building[wallKey] || {};
        const updatedRows = [...(wall.rows || [])];

        if (updatedRows[index]) {
          updatedRows[index] = { ...updatedRows[index], cellSize: value };
        }

        return {
          ...building,
          [wallKey]: {
            ...wall,
            rows: updatedRows,
          },
        };
      })
    );

    // Also update buildingstructureDetails for the specific building
    setBuildingstructureDetails((prev) => {
      const updated = [...prev];
      const buildingIndex = updated.findIndex(
        (b) => b.buildingId === buildingId
      );

      if (buildingIndex === -1) {
        // Create new entry if not exists
        const activeBuilding = buildings.find((b) => b.id === buildingId);
        updated.push({
          buildingId,
          lengthBays: activeBuilding?.left?.bays || 5,
          widthBays: activeBuilding?.front?.bays || 5,
          lengthInMM: (activeBuilding?.left?.meters || 0) * 1000 || 5000,
          widthInMM: (activeBuilding?.front?.meters || 0) * 1000 || 5000,
          baysSpacingLengthRows: activeBuilding?.left?.rows || [],
          baysSpacingWidthRows: activeBuilding?.front?.rows || [],
          backSideWallValues: activeBuilding?.back?.rows || [],
          rightSideWallValues: activeBuilding?.right?.rows || [],
          wallsPayload: {
            "Front End Wall": activeBuilding?.front?.rows || [],
            "Back End Wall": activeBuilding?.back?.rows || [],
            "Left Side Wall": activeBuilding?.left?.rows || [],
            "Right Side Wall": activeBuilding?.right?.rows || [],
          },
        });
        return updated;
      }

      const rowTypeMapping = {
        length: "baysSpacingLengthRows",
        width: "baysSpacingWidthRows",
        backLength: "backSideWallValues",
        rightWidth: "rightSideWallValues",
      };

      const rowType = rowTypeMapping[type];
      if (rowType && updated[buildingIndex]) {
        const rows = [...(updated[buildingIndex][rowType] || [])];
        if (!rows[index]) {
          rows[index] = { wall: "", cellSize: "" };
        }
        rows[index] = { ...rows[index], cellSize: value };
        updated[buildingIndex][rowType] = rows;

        // Update wallsPayload
        const wallKeyMapping = {
          length: "Left Side Wall",
          width: "Front End Wall",
          backLength: "Back End Wall",
          rightWidth: "Right Side Wall",
        };

        const payloadWallKey = wallKeyMapping[type];
        if (updated[buildingIndex].wallsPayload && payloadWallKey) {
          const wallRows = [
            ...(updated[buildingIndex].wallsPayload[payloadWallKey] || []),
          ];
          if (!wallRows[index]) {
            wallRows[index] = { wall: "", cellSize: "" };
          }
          wallRows[index] = { ...wallRows[index], cellSize: value };
          updated[buildingIndex].wallsPayload[payloadWallKey] = wallRows;
        }
      }
      return updated;
    });
  }; */
const handleGridUpdate = (type, index, value, buildingId) => {
  const typeToWallKey = {
    length: "left",
    width: "front", 
    backLength: "back",
    rightWidth: "right",
  };

  const wallKey = typeToWallKey[type];
  if (!wallKey) return;

  setBuildings((prev) =>
    prev.map((building) => {
      if (building.id !== buildingId) return building;

      const wall = building[wallKey] || {};
      const updatedRows = [...(wall.rows || [])];
      
      if (updatedRows[index]) {
        // Get the TOTAL meters for this wall (not individual bay spacing)
        const totalMeters = parseFloat(wall.meters) || 0;
        const currentCellSize = parseFloat(value) || 0;
        const totalCells = updatedRows.length;
        
        if (totalCells > 1 && totalMeters > 0) {
          // Calculate remaining total and distribute equally among other cells
          const remainingTotal = totalMeters - currentCellSize;
          const remainingCellSize = remainingTotal / (totalCells - 1);
          
          // Update all other cells
          updatedRows.forEach((row, i) => {
            if (i === index) {
              updatedRows[i] = { ...row, cellSize: currentCellSize.toFixed(3) };
            } else {
              updatedRows[i] = { ...row, cellSize: remainingCellSize.toFixed(3) };
            }
          });
        } else {
          // Only one cell or no total meters specified
          updatedRows[index] = { ...updatedRows[index], cellSize: currentCellSize.toFixed(3) };
        }
      }

      return {
        ...building,
        [wallKey]: {
          ...wall,
          rows: updatedRows,
        },
      };
    })
  );

  // Update buildingstructureDetails with the same logic
  setBuildingstructureDetails((prev) => {
    const updated = [...prev];
    const buildingIndex = updated.findIndex((b) => b.buildingId === buildingId);

    if (buildingIndex === -1) {
      const activeBuilding = buildings.find((b) => b.id === buildingId);
      const newDetails = {
        buildingId,
        lengthBays: activeBuilding?.left?.bays || 5,
        widthBays: activeBuilding?.front?.bays || 5,
        lengthInMM: (activeBuilding?.left?.meters || 0) * 1000 || 5000,
        widthInMM: (activeBuilding?.front?.meters || 0) * 1000 || 5000,
        baysSpacingLengthRows: activeBuilding?.left?.rows || [],
        baysSpacingWidthRows: activeBuilding?.front?.rows || [],
        backSideWallValues: activeBuilding?.back?.rows || [],
        rightSideWallValues: activeBuilding?.right?.rows || [],
        wallsPayload: {
          "Front End Wall": activeBuilding?.front?.rows || [],
          "Back End Wall": activeBuilding?.back?.rows || [],
          "Left Side Wall": activeBuilding?.left?.rows || [],
          "Right Side Wall": activeBuilding?.right?.rows || [],
        },
      };
      updated.push(newDetails);
      return updated;
    }

    const rowTypeMapping = {
      length: "baysSpacingLengthRows",
      width: "baysSpacingWidthRows", 
      backLength: "backSideWallValues",
      rightWidth: "rightSideWallValues",
    };

    const rowType = rowTypeMapping[type];
    if (rowType && updated[buildingIndex]) {
      const rows = [...(updated[buildingIndex][rowType] || [])];
      
      // Get total meters based on type
      let totalMeters = 0;
      if (type.includes('length')) {
        totalMeters = parseFloat(updated[buildingIndex].lengthInMM) / 1000 || 0;
      } else {
        totalMeters = parseFloat(updated[buildingIndex].widthInMM) / 1000 || 0;
      }
      
      const currentCellSize = parseFloat(value) || 0;
      const totalCells = rows.length;

      if (totalCells > 1 && totalMeters > 0) {
        const remainingTotal = totalMeters - currentCellSize;
        const remainingCellSize = remainingTotal / (totalCells - 1);
        
        // Update all rows
        rows.forEach((row, i) => {
          if (i === index) {
            rows[i] = { ...row, cellSize: currentCellSize.toFixed(3) };
          } else {
            rows[i] = { ...row, cellSize: remainingCellSize.toFixed(3) };
          }
        });
      } else {
        if (!rows[index]) {
          rows[index] = { wall: "", cellSize: "" };
        }
        rows[index] = { ...rows[index], cellSize: currentCellSize.toFixed(3) };
      }
      
      updated[buildingIndex][rowType] = rows;

      // Update wallsPayload
      const wallKeyMapping = {
        length: "Left Side Wall",
        width: "Front End Wall",
        backLength: "Back End Wall", 
        rightWidth: "Right Side Wall",
      };

      const payloadWallKey = wallKeyMapping[type];
      if (updated[buildingIndex].wallsPayload && payloadWallKey) {
        updated[buildingIndex].wallsPayload[payloadWallKey] = rows;
      }
    }
    
    return updated;
  });
};
  // Get building details for specific building
  const getBuildingDetails = (buildingId) => {
    const building = buildings.find((b) => b.id === buildingId);
    if (!building) return null;

    // Check if we have existing details
    const existingDetails = buildingstructureDetails.find(
      (b) => b.buildingId === buildingId
    );

    if (existingDetails) {
      return existingDetails;
    }
    // Return default structure if not found
    return {
      buildingId,
      lengthBays: building.left?.bays || 5,
      widthBays: building.front?.bays || 5,
      lengthInMM: (building.left?.meters || 0) * 1000 || 5000,
      widthInMM: (building.front?.meters || 0) * 1000 || 5000,
      baysSpacingLengthRows: building.left?.rows || [],
      baysSpacingWidthRows: building.front?.rows || [],
      backSideWallValues: building.back?.rows || [],
      rightSideWallValues: building.right?.rows || [],
      wallsPayload: {
        "Front End Wall": building.front?.rows || [],
        "Back End Wall": building.back?.rows || [],
        "Left Side Wall": building.left?.rows || [],
        "Right Side Wall": building.right?.rows || [],
      },
    };
  };

  // Component Data View Modal

  // eslint-disable-next-line
  const [componentDataView, setComponentDataView] = useState(null);
  const [dataViewModal, setDataViewModal] = useState(false);
  const [showComponent, setShowComponent] = useState({});
  const showDataViewModal = (showcanopy) => {
    setShowComponent(showcanopy);
    setDataViewModal(true);
  };
  const hideDataViewModal = () => setDataViewModal(false);

  const validateFrontBaySpacing = (building) => {
    if (!building?.front || !Array.isArray(building.front.rows)) return false;

    const totalMeters = Number(building.front.meters || 0);
    const totalSpacing = building.front.rows.reduce(
      (sum, r) => sum + Number(r.baySpacing || 0),
      0
    );
    return Math.abs(totalSpacing - totalMeters) > 0.01;
  };

  const validateBackBaySpacing = (building) => {
    if (!building?.back || !Array.isArray(building.back.rows)) return false;

    const totalMeters = Number(building.back.meters || 0);
    const totalSpacing = building.back.rows.reduce(
      (sum, r) => sum + Number(r.baySpacing || 0),
      0
    );
    return Math.abs(totalSpacing - totalMeters) > 0.01;
  };
  const validateRightBaySpacing = (building) => {
    if (!building?.right || !Array.isArray(building.right.rows)) return false;

    const totalMeters = Number(building.right.meters || 0);
    const totalSpacing = building.right.rows.reduce(
      (sum, r) => sum + Number(r.baySpacing || 0),
      0
    );
    return Math.abs(totalSpacing - totalMeters) > 0.01;
  };
  const validateLeftBaySpacing = (building) => {
    if (!building?.left || !Array.isArray(building.left.rows)) return false;

    const totalMeters = Number(building.left.meters || 0);
    const totalSpacing = building.left.rows.reduce(
      (sum, r) => sum + Number(r.baySpacing || 0),
      0
    );
    return Math.abs(totalSpacing - totalMeters) > 0.01;
  };

  /* validate back end , front end , right end , left end wall end */

  // File Upload and View Modal FUnctions

  ///state for file view modal
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);

  // const onSuccessUploadDocumentType = (data) => {
  //   setFormInputs((formInputs) => ({
  //     ...formInputs,
  //     [data.fieldName]: data.attachmentId,
  //   }));
  // };
  // File Upload Handler
  const onSuccessUploadDocumentType = (data, buildingId) => {
    setBuildings((prev) =>
      prev.map((building) =>
        building.id === buildingId
          ? {
              ...building,
              [data.fieldName]: data.attachmentId,
            }
          : building
      )
    );
  };

  // File View Handler
  const handleViewFile = (fileAttachmentId, buildingId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };
  // eslint-disable-next-line
    const [fileDeleted, setFileDeleted] = useState(false);
  const handleAttachmentDeleted = ({ attachmentId, hasFiles, remainingCount }) => {
    // console.log("handleAttachmentDeleted called:", { attachmentId, hasFiles, remainingCount });
    
    //  If NO files remain, clear the supportingDoc field
    if (!hasFiles) {
      console.log("No files remaining, clearing supportingDoc");
      setFormInputs((prev) => ({
        ...prev,
        supportingDoc: "",  // ← Clear the attachment ID
      }));
      setFileDeleted(true); 
    } else {
      //  If files still exist, update with new count (optional)
      console.log("Files still exist, count:", remainingCount);
    }
  };
  //================================================= on redux update
  //Dynamic bulding
  // In your component state
  const [buildingCount, setBuildingCount] = useState(1);
  const [activeBuildingId, setActiveBuildingId] = useState(1); // Track active tab

  const [buildings, setBuildings] = useState([
    {
      id: 1,
      buildingId: 1,
      buildingTypes: "",
      buildingTypesCode: "",
      buildingTypesDesc: "",
      buildingStructure: "",
      buildingStructureCode: "",
      buildingStructureDesc: "",
      design: "",
      designCode: "",
      designDesc: "",
      designLoad: {
        deadLoad: "0.1+sw",
        liveLoad: "0.57",
        solarLoad: "0",
        windLoad: "120 KMPH",
      },
      designStandards: {
        codesApplicable: "AISC-10-ASD, MBMA2012",
        windLoadCalculation: "IS 875 Part 3-2015",
        windLoadApplication: "MBMA-2012 ",
        seismicLoad: "IS 1893-2016,Zone-II",
      },
      deflectionCriteria: {
        mainFramesSway: "HEIGHT/100",
        mainFrameDeflection: "SPAN/100",
      },
      minimumThickness: {
        mainFrame: "4mm",
        crSections: "1.5mm",
      },
      front: {
        meters: "",
        bays: "",
        buildingInputs: "",
        blockWallHeight: "",
        frontOtherBuildingInputs: "",
        rows: [],
      },
      back: {
        meters: "",
        bays: "",
        buildingInputs: "",
        blockWallHeight: "",
        backOtherBuildingInputs: "",
        rows: [],
      },
      left: {
        meters: "",
        bays: "",
        buildingInputs: "",
        blockWallHeight: "",
        leftOtherBuildingInputs: "",
        rows: [],
      },
      right: {
        meters: "",
        bays: "",
        buildingInputs: "",
        blockWallHeight: "",
        rightOtherBuildingInputs: "",
        rows: [],
      },
      additionalComponents: {
        leanTo: false,
        canopy: false,
        frameOpening: false,
        partitionWall: false,
        ridgeVentilator: false,
        turboFans: false,
        cageLadder: false,
        craneBeam: false,
        mezzanine: false,
        fascia: false,
        louvers: false,
        structuralLouver: false,
        industrialLouver: false,
        staircase: false,
        handrail: false,
        hotRolled: false,
        others: false,
        builtUpMembers: true,
        leftSideWall: true,
        rightSideWall: true,
        frontEndWall: true,
        backEndWall: true,
        roof01: true,
        roof02: true,
        pipeStrut: true,
        pipeBracing: true,
        hr: true,
        portalBracing: true,
        selectedCases: {},
        selectedCaseObject: {
          caseTypeCode: "",
          caseTypeDiscription: "",
          width: "",
          clearHeightLSW: "",
          clearHeightRSW: "",
          eaveHeightLSW: "",
          eaveHeightRSW: "",
          ridgeHeight: "",
          numberOfBays: "",
          partitionWall: "",
          staircase: "",
          roofMonitor: "",
          cageLadder: "",
        },
      },
      // All component states
      canopy: {
        inputs: {
          canopyInputsSoftFitSheeting: "Yes",
          canopyInputsSoftFitSheetingCode: "YES",
          canopyInputsSoftFitSheetingDisc: "Yes",
          canopyInputsGutter: "No",
          canopyInputsGutterCode: "NO",
          canopyInputsGutterDisc: "No",
          canopyInputskickerPipe: "No",
          canopyInputskickerPipeCode: "NO",
          canopyInputskickerPipeDisc: "No",
        },
        rows: [],
        dynamicRows: [],
      },
      frameOpening: {
        inputs: {},
        rows: [],
        dynamicRows: [],
      },
      leanTo: {
        inputs: {
          leanToInputsGirtcondition: "Bypass",

          leanToInputsGutter: "Yes",
          leanToInputsApron: "Yes",
          leanToInputsDowntake: "Yes",
        },
        rows: [],
        dynamicRows: [],
      },
      // fixedLouvers: {
      //   inputs: {},
      //   rows: [],
      //   dynamicRows: [],
      // },
      fixedLouvers: {
        inputs: {},
        rows: [],
        dynamicColumns: [],
        dynamicRows: [],
        rowOverrides: [],
        manualRows: [],
      },
      structuralLouvers: {
        inputs: {},
        rows: [],
        dynamicRows: [],
      },
      fascia: {
        inputs: {},
        rows: [],
        dynamicRows: [],
      },
      // File attachments
      scopeOfwork: "",
      drawing: "",
      // Visibility states
      isCardVisible2: true,
      isCardVisible3: true,
      isCardVisible4: true,
      isCardVisible5: true,
      isCardVisible8: true,
      isCardVisible9: true,
      isCardVisible10: true,
      isCardVisible11: false,
      copyFrontToBack: false,
      copyLeftToRight: false,
      buildingCaseType: [],
      partitionWallData: {
        gridlineFromInput1: {},
        gridlineFromInput2: {},
      },
      craneData: {
        noofCranes: 1,
        craneDetails: [],
      },
      cageLadderInputs: {},
      staircaseInputs: {},
      mezzanineData: {
        noOfmezzanines: 1,
        mezzanineDetails: [],
      },
      roofMonitorInputs: {},
    },
  ]);

  // Add to your state declarations at the top of your component
  const [activeTabs, setActiveTabs] = useState({});

  // Define the helper function to get current active tab
  const getCurrentActiveTab = (building) => {
    const allowedKeys = [
      "partitionWall",
      "craneBeam",
      "cageLadder",
      "staircase",
      "mezzanine",
      "roofMonitor",
    ];
    const activeComponents = allowedKeys.filter(
      (key) => building.additionalComponents?.[key]
    );

    // If no active tab is set but we have components, set the first one
    if (activeComponents.length > 0 && !activeTabs[building.id]) {
      return activeComponents[0];
    }

    // If the current active tab is no longer available, switch to first available
    if (
      activeTabs[building.id] &&
      !activeComponents.includes(activeTabs[building.id]) &&
      activeComponents.length > 0
    ) {
      return activeComponents[0];
    }

    return activeTabs[building.id] || "";
  };

  // Define the tab change handler
  const handleTabChange = (buildingId, tabKey) => {
    setActiveTabs((prev) => ({
      ...prev,
      [buildingId]: tabKey,
    }));
  };

  // Updated handleAdditionalComponentsChange function
  const handleAdditionalComponentsChange = (
    componentKey,
    isChecked,
    buildingId
  ) => {
    setBuildings((prev) =>
      prev.map((building) =>
        building.id === buildingId
          ? {
              ...building,
              additionalComponents: {
                ...building.additionalComponents,
                [componentKey]: isChecked,
              },
            }
          : building
      )
    );

    // Set as active tab if this is the first component being checked
    if (isChecked) {
      setActiveTabs((prev) => {
        // If no active tab is set for this building, set the checked one as active
        if (!prev[buildingId]) {
          return {
            ...prev,
            [buildingId]: componentKey,
          };
        }
        return prev;
      });
    } else {
      // If unchecking the currently active tab, switch to another available tab
      setActiveTabs((prev) => {
        if (prev[buildingId] === componentKey) {
          const building = buildings.find((b) => b.id === buildingId);
          const allowedKeys = [
            "partitionWall",
            "craneBeam",
            "cageLadder",
            "staircase",
            "mezzanine",
            "roofMonitor",
          ];
          const remainingComponents = allowedKeys.filter(
            (key) =>
              key !== componentKey && building.additionalComponents?.[key]
          );

          // Set to first remaining component, or empty if none left
          return {
            ...prev,
            [buildingId]: remainingComponents[0] || "",
          };
        }
        return prev;
      });
    }
  };

  /* handle building input chnages */

  const handleBuildingInputChange = (e, buildingId) => {
    const { name, value } = e.target;

    setBuildings((prevBuildings) =>
      prevBuildings.map((building) =>
        building.id === buildingId ? { ...building, [name]: value } : building
      )
    );
  };

  // Handle partition wall input changes
  const handlePartitionWallCountChange = (value, buildingId) => {
    const count = parseInt(value) || 0;

    setBuildings((prev) =>
      prev.map((building) => {
        if (building.id !== buildingId) return building;

        const updatedDetails = Array.from({ length: count }, (_, i) => {
          return (
            building.partitionWallData?.partitionDetails?.[i] || {
              wallCode: `PW${i + 1}`,
              local_id: i + 1,
            }
          );
        });

        return {
          ...building,
          partitionWallData: {
            ...building.partitionWallData,
            noOfPartitionWalls: count,
            partitionDetails: updatedDetails,
          },
        };
      })
    );
  };

  const handlePartitionWallInputChangeDynamic = (
    e,
    rowLabel,
    colIndex,
    buildingId
  ) => {
    const { value } = e.target;
    const index = colIndex - 1;

    setBuildings((prevBuildings) =>
      prevBuildings.map((building) => {
        if (building.id !== buildingId) return building;

        const updatedDetails = [
          ...(building.partitionWallData?.partitionDetails || []),
        ];

        const original = updatedDetails[index];

        const item = original
          ? { ...original }
          : {
              wallCode: `PW${colIndex}`,
              local_id: colIndex,
            };

        const keyMap = {
          Width: "width",
          Length: "length",
          "Gridline From Width": "gridFromWidth",
          "Gridline To Width": "gridToWidth",
          "Gridline From Length": "gridFromLength",
          "Gridline To Length": "gridToLength",
          "Block Wall Height": "blockWallHeight",
          "Girt Condition": "girtCondition",
        };

        const key = keyMap[rowLabel] || rowLabel;
        item[key] = value;

        updatedDetails[index] = item;

        return {
          ...building,
          partitionWallData: {
            ...building.partitionWallData,
            partitionDetails: updatedDetails,
          },
        };
      })
    );
  };

  // Handle crane count change
  const handleCraneCountChange = (value, buildingId) => {
    setBuildings((prevBuildings) =>
      prevBuildings.map((building) => {
        if (building.id !== buildingId) return building;

        const count = Math.max(0, parseInt(value) || 0);
        const updatedDetails = [...(building.craneData?.craneDetails || [])];

        // Add missing crane entries
        for (let i = updatedDetails.length; i < count; i++) {
          updatedDetails.push({
            craneTypeCode: `CR${i + 1}`,
            craneDiscripton: `crane${i + 1}`,
            local_id: i + 1,
          });
        }

        // Trim excess if reduced
        const trimmedDetails = updatedDetails.slice(0, count);

        return {
          ...building,
          craneData: {
            noofCranes: count,
            craneDetails: trimmedDetails,
          },
        };
      })
    );
  };

  // Handle crane input change
  const handleCraneInputChange = (e, rowLabel, colIndex, buildingId) => {
    const { value } = e.target;
    const index = colIndex - 1;

    setBuildings((prevBuildings) =>
      prevBuildings.map((building) => {
        if (building.id !== buildingId) return building;

        const updatedDetails = [...(building.craneData?.craneDetails || [])];
        const item = updatedDetails[index] || {
          craneTypeCode: `CR${colIndex}`,
          craneDiscripton: `crane${colIndex}`,
          local_id: colIndex,
        };
        const keyMap = {
          "Crane Type": "craneType",
          "Crane AISLE (SPAN 1,2,3)": "craneAISLE",
          "GRID LINE FROM": "fromGL",
          "GRID LINE TO": "toGL",
          "Crane Capacity": "craneCapacity",
          "Crane Bracket/Hook Height": "craneBracketHookHeight",
          "Bridge weight (MT)": "bridgeWeight",
          "Carb / trolley / Hoist weight (MT)": "carbTrolleyHoistWeight",
          "Wheel Base (m)": "wheelBase",
          "Bumper to bumper dist (m)": "bumperTobumperDist",
          Rail: "rail",
          "Tandom operation": "tandomOperation",
        };

        const key = keyMap[rowLabel] || rowLabel;
        item[key] = value;
        updatedDetails[index] = item;

        return {
          ...building,
          craneData: {
            ...building.craneData,
            craneDetails: updatedDetails,
          },
        };
      })
    );
  };

  // Handle mezzanine count change
  const handleMezzanineCountChange = (value, buildingId) => {
    setBuildings((prevBuildings) =>
      prevBuildings.map((building) => {
        if (building.id !== buildingId) return building;

        const count = Math.max(0, parseInt(value) || 0);
        const updatedDetails = [
          ...(building.mezzanineData?.mezzanineDetails || []),
        ];

        // Add missing mezzanine entries
        for (let i = updatedDetails.length; i < count; i++) {
          updatedDetails.push({
            mezzanineTypeCode: `MI${i + 1}`,
            mezzanineDiscripton: `mezzanine${i + 1}`,
            local_id: i + 1,
          });
        }

        // Trim excess if reduced
        const trimmedDetails = updatedDetails.slice(0, count);

        return {
          ...building,
          mezzanineData: {
            noOfmezzanines: count,
            mezzanineDetails: trimmedDetails,
          },
        };
      })
    );
  };

  // Handle mezzanine input change
  const handleInputChangemezzanine = (e, rowLabel, colIndex, buildingId) => {
    const { value } = e.target;
    const index = colIndex - 1;

    setBuildings((prevBuildings) =>
      prevBuildings.map((building) => {
        if (building.id !== buildingId) return building;

        const updatedDetails = [
          ...(building.mezzanineData?.mezzanineDetails || []),
        ];
        const item = updatedDetails[index] || {
          mezzanineTypeCode: `MI${colIndex}`,
          mezzanineDiscripton: `mezzanine${colIndex}`,
          local_id: colIndex,
        };

        const keyMap = {
          "No. of mezzanine floor": "noOfmezzaninefloor",
          Width: "width",
          Length: "length",
          "Clear Height": "clearHeight",
          "Mezzanine Handrails": "mezzanineHandrails",
          "Mezzanine staircase": "mezzanineStaircase",
          "Thickness of slab": "thicknessOfSlab",
        };

        const key = keyMap[rowLabel] || rowLabel;
        item[key] = value;
        updatedDetails[index] = item;

        return {
          ...building,
          mezzanineData: {
            ...building.mezzanineData,
            mezzanineDetails: updatedDetails,
          },
        };
      })
    );
  };

  // Handle cage ladder input change
  const handleCageLadderInputChange = (field, value, buildingId) => {
    setBuildings((prevBuildings) =>
      prevBuildings.map((building) =>
        building.id === buildingId
          ? {
              ...building,
              cageLadderInputs: {
                ...building.cageLadderInputs,
                [field]: value,
              },
            }
          : building
      )
    );
  };

  // Handle staircase input change
  const handleStaircaseInputChange = (field, value, buildingId) => {
    setBuildings((prevBuildings) =>
      prevBuildings.map((building) =>
        building.id === buildingId
          ? {
              ...building,
              staircaseInputs: {
                ...building.staircaseInputs,
                [field]: value,
              },
            }
          : building
      )
    );
  };

  // Handle roof monitor input change
  const handleRoofMonitorInputChange = (field, value, buildingId) => {
    setBuildings((prevBuildings) =>
      prevBuildings.map((building) =>
        building.id === buildingId
          ? {
              ...building,
              roofMonitorInputs: {
                ...building.roofMonitorInputs,
                [field]: value,
              },
            }
          : building
      )
    );
  };
  //Additional Component End

  //Building Case Type details start

  // useEffect(
  //   () => {
  //     if (activeBuildingId) {
  //       const activeBuilding = buildings.find((b) => b.id === activeBuildingId);
  //       if (
  //         activeBuilding &&
  //         activeBuilding.selectedCaseObject &&
  //         Object.keys(activeBuilding.selectedCaseObject).length > 0
  //       ) {
  //         const keys = Object.keys(activeBuilding.selectedCaseObject);
  //         const bayCount = Number(activeBuilding.right?.bays) || 0;

  //         const dataArray = Array.from({ length: bayCount + 1 }).map(
  //           (_, index) => {
  //             const row = {
  //               local_id: index + 1,
  //               frameType: `Frame Type @${index + 1}`,
  //             };

  //             // Copy only non-empty key-value pairs
  //             keys.forEach((key) => {
  //               const value = activeBuilding.selectedCaseObject[key];
  //               if (value !== "" && value !== null && value !== undefined) {
  //                 row[key] = value;
  //               }
  //             });

  //             return row;
  //           }
  //         );

  //         setBuildings((prevBuildings) =>
  //           prevBuildings.map((building) =>
  //             building.id === activeBuildingId
  //               ? { ...building, buildingCaseType: dataArray }
  //               : building
  //           )
  //         );
  //       } else {
  //         setBuildings((prevBuildings) =>
  //           prevBuildings.map((building) =>
  //             building.id === activeBuildingId
  //               ? { ...building, buildingCaseType: [] }
  //               : building
  //           )
  //         );
  //       }
  //     }
  //     // eslint-disable-next-line
  //   },
  //   // eslint-disable-next-line
  //   [activeBuildingId,buildings.find((b) => b.id === activeBuildingId)?.selectedCaseObject,buildings.find((b) => b.id === activeBuildingId)?.right?.bays,buildings.find((b) => b.id === activeBuildingId)?.right?.rows?.length,
  //   ]
  // );
// REMOVE the existing useEffect for buildingCaseType entirely
// Replace with useMemo - no state update, no flicker

const buildingCaseTypeData = useMemo(() => {
  const activeBuilding = buildings.find((b) => b.id === activeBuildingId);
  if (!activeBuilding) return [];

  if (
    !activeBuilding.selectedCaseObject ||
    Object.keys(activeBuilding.selectedCaseObject).length === 0
  ) {
    return [];
  }

  const keys = Object.keys(activeBuilding.selectedCaseObject);
  const bayCount = Number(activeBuilding.right?.bays) || 0;

  return Array.from({ length: bayCount + 1 }, (_, index) => {
    const row = {
      local_id: index + 1,
      frameType: `Frame Type @${index + 1}`,
    };

    keys.forEach((key) => {
      const value = activeBuilding.selectedCaseObject[key];
      if (value !== "" && value !== null && value !== undefined) {
        row[key] = value;
      }
    });

    return row;
  });
  // eslint-disable-next-line
}, [
  activeBuildingId,
  // eslint-disable-next-line
  buildings.find((b) => b.id === activeBuildingId)?.selectedCaseObject,
  // eslint-disable-next-line
  buildings.find((b) => b.id === activeBuildingId)?.right?.bays,
]);


  const handleInputChangebuildingCaseType = (buildingId, index, key, value) => {
    setBuildings((prevBuildings) =>
      prevBuildings.map((building) => {
        if (building.id === buildingId && building.buildingCaseType) {
          const updatedCaseType = [...building.buildingCaseType];
          if (!updatedCaseType[index]) return building; // Safety check

          let row = { ...updatedCaseType[index], [key]: value };
          const caseTypeCode = building.selectedCaseObject?.caseTypeCode;

          // 🧮 CASE C1: Equal slopes, ridgeHeight auto-calculated
          if (caseTypeCode === "C1") {
            if (key === "leftSlope") {
              row.rightSlope = value;
            } else if (key === "rightSlope") {
              row.leftSlope = value;
            }

            const leftSlope = parseFloat(row.leftSlope) || 0;
            const ridgeDistanceLeft = parseFloat(row.ridgeDistanceLeft) || 0;
            const eaveHeightLSW = parseFloat(row.eaveHeightLSW) || 0;

            if (leftSlope > 0 && ridgeDistanceLeft > 0) {
              row.ridgeHeight = (
                (1 / leftSlope) * ridgeDistanceLeft +
                eaveHeightLSW
              ).toFixed(2);
            }
          }

          // 🧮 CASE C2: Slopes auto-calculated from ridgeHeight and eave heights
          if (caseTypeCode === "C2") {
            const ridgeHeight = parseFloat(row.ridgeHeight) || 0;
            const eaveHeightLSW = parseFloat(row.eaveHeightLSW) || 0;
            const eaveHeightRSW = parseFloat(row.eaveHeightRSW) || 0;
            const ridgeDistanceLeft = parseFloat(row.ridgeDistanceLeft) || 0;
            const ridgeDistanceRight = parseFloat(row.ridgeDistanceRight) || 0;

            if (ridgeDistanceLeft > 0 && ridgeHeight !== eaveHeightLSW) {
              row.leftSlope = (
                1 /
                ((ridgeHeight - eaveHeightLSW) / ridgeDistanceLeft)
              ).toFixed(3);
            }

            if (ridgeDistanceRight > 0 && ridgeHeight !== eaveHeightRSW) {
              row.rightSlope = (
                1 /
                ((ridgeHeight - eaveHeightRSW) / ridgeDistanceRight)
              ).toFixed(3);
            }
          }

          // 🧮 CASE C3: Same logic as C2
          if (caseTypeCode === "C3") {
            const ridgeHeight = parseFloat(row.ridgeHeight) || 0;
            const eaveHeightLSW = parseFloat(row.eaveHeightLSW) || 0;
            const eaveHeightRSW = parseFloat(row.eaveHeightRSW) || 0;
            const ridgeDistanceLeft = parseFloat(row.ridgeDistanceLeft) || 0;
            const ridgeDistanceRight = parseFloat(row.ridgeDistanceRight) || 0;

            if (ridgeDistanceLeft > 0 && ridgeHeight !== eaveHeightLSW) {
              row.leftSlope = (
                1 /
                ((ridgeHeight - eaveHeightLSW) / ridgeDistanceLeft)
              ).toFixed(3);
            }

            if (ridgeDistanceRight > 0 && ridgeHeight !== eaveHeightRSW) {
              row.rightSlope = (
                1 /
                ((ridgeHeight - eaveHeightRSW) / ridgeDistanceRight)
              ).toFixed(3);
            }
          }

          // 🧮 CASE C4: Same logic as C2 and C3
          if (caseTypeCode === "C4") {
            const ridgeHeight = parseFloat(row.ridgeHeight) || 0;
            const eaveHeightLSW = parseFloat(row.eaveHeightLSW) || 0;
            const eaveHeightRSW = parseFloat(row.eaveHeightRSW) || 0;
            const ridgeDistanceLeft = parseFloat(row.ridgeDistanceLeft) || 0;
            const ridgeDistanceRight = parseFloat(row.ridgeDistanceRight) || 0;

            if (ridgeDistanceLeft > 0 && ridgeHeight !== eaveHeightLSW) {
              row.leftSlope = (
                1 /
                ((ridgeHeight - eaveHeightLSW) / ridgeDistanceLeft)
              ).toFixed(3);
            }

            if (ridgeDistanceRight > 0 && ridgeHeight !== eaveHeightRSW) {
              row.rightSlope = (
                1 /
                ((ridgeHeight - eaveHeightRSW) / ridgeDistanceRight)
              ).toFixed(3);
            }
          }

          updatedCaseType[index] = row;
          return { ...building, buildingCaseType: updatedCaseType };
        }
        return building;
      })
    );
  };
  //Building Case Type details END

  //for maping meter to width in roof selection
  useEffect(() => {
    if (activeBuildingId) {
      const activeBuilding = buildings.find((b) => b.id === activeBuildingId);
      if (activeBuilding && activeBuilding.front.meters) {
        setBuildings((prevBuildings) =>
          prevBuildings.map((building) =>
            building.id === activeBuildingId
              ? {
                  ...building,
                  selectedCaseObject: {
                    ...building.selectedCaseObject,
                    width: building.front.meters,
                  },
                }
              : building
          )
        );
      }
    }
    // eslint-disable-next-line
  }, [
    activeBuildingId,
    // eslint-disable-next-line
    buildings.find((b) => b.id === activeBuildingId)?.front.meters,
    // eslint-disable-next-line
    buildings.find((b) => b.id === activeBuildingId)?.selectedCaseObject
      ?.caseTypeDiscription, // Add this
  ]);
  const restrictDecimals = (value) => {
    // Allow up to 3 digits after the decimal
    return value.replace(/^(\d+)(\.(\d{0,3})?)?$/, (m, int, dec) =>
      dec ? int + dec : int
    );
  };

  const canopyInputsChange = ({
    target: { name, value },
    formatOnBlur = false,
  }) => {
    // List fields that should enforce 3 decimals
    const floatFields = [
      "canopyInputsBaySpacing",
      "canopyInputsProjectin",
      "canopyInputsClearHeight",
    ];

    let adjustedValue = value;
    if (floatFields.includes(name) && !formatOnBlur) {
      adjustedValue = restrictDecimals(value);
    }
    if (floatFields.includes(name) && formatOnBlur && value !== "") {
      const num = parseFloat(value);
      adjustedValue = !isNaN(num) ? num.toFixed(3) : value;
    }

    setBuildings((prev) =>
      prev.map((building) => {
        if (building.id !== activeBuildingId) return building;

        const currentCanopy = building.canopy || {};

        // Map input field names to row field names
        const fieldMap = {
          canopyInputsClearHeight: "clearHeight",
          canopyInputsProjectin: "projection",
          canopyInputsSoftFitSheeting: "softFitSheething",
          canopyInputsGutter: "gutter",
          canopyInputsDownTake: "downTake",
          canopyInputskickerPipe: "kickerPipe",
        };

        const rowFieldName = fieldMap[name];

        let updatedOverrides = currentCanopy.rowOverrides || [];

        // If this main input changed, clear the overrides for this specific field in ALL rows
        if (rowFieldName && updatedOverrides.length > 0) {
          updatedOverrides = updatedOverrides
            .map((override) => {
              // Remove this specific field from the override
              const { [rowFieldName]: removed, ...rest } = override || {};
              return Object.keys(rest).length > 0 ? rest : undefined;
            })
            .filter(Boolean); // Remove empty overrides
        }

        return {
          ...building,
          canopy: {
            ...currentCanopy,
            inputs: {
              ...currentCanopy.inputs,
              [name]: adjustedValue,
            },
            rowOverrides: updatedOverrides,
          },
        };
      })
    );
  };

  const deleteCanopyColumn = (columnId) => {
    setBuildings((prev) =>
      prev.map((b) => {
        if (b.id !== activeBuildingId) return b;

        const canopy = b.canopy || {};
        const existingColumns = canopy.dynamicColumns || [];
        const existingRows = canopy.dynamicRows || [];

        const columnToDelete = existingColumns.find(
          (col) => col.id === columnId
        );
        if (!columnToDelete) return b;

        const keyToDelete = columnToDelete.key;

        const updatedColumns = existingColumns.filter(
          (col) => col.id !== columnId
        );

        const updatedRows = existingRows.map((row) => {
          const { [keyToDelete]: removed, ...restOfRow } = row;
          return restOfRow;
        });

        return {
          ...b,
          canopy: {
            ...canopy,
            dynamicColumns: updatedColumns,
            dynamicRows: updatedRows,
          },
        };
      })
    );
  };
  const handleDynomicCanopyInputChange = (
    combinedIndex,
    key,
    value,
    formatOnBlur = false
  ) => {
    const floatKeys = ["baySpacing", "projection", "clearHeight"];

    let finalValueToSave = value;
    if (floatKeys.includes(key) && !formatOnBlur) {
      finalValueToSave = restrictDecimals(value);
    }
    if (floatKeys.includes(key) && formatOnBlur && value !== "") {
      const num = parseFloat(value);
      finalValueToSave = !isNaN(num) ? num.toFixed(3) : value;
    }

    setBuildings((prev) =>
      prev.map((building) => {
        if (building.id !== activeBuildingId) return building;

        const currentCanopy = building.canopy || {};
        const currentOverrides = currentCanopy.rowOverrides || [];
        const currentDynamicRows = currentCanopy.dynamicRows || [];
        const currentManualRows = currentCanopy.manualRows || [];
        const row = canopyRows[combinedIndex];
        if (!row) return building;

        const rowId = row.rowId;
        const overrideIndex = currentOverrides.findIndex(
          (o) => o.rowId === rowId
        );
        const dynamicIndex = currentDynamicRows.findIndex(
          (d) => d.rowId === rowId
        );
        const manualRowIndex = currentManualRows.findIndex(
          (r) => r.rowId === rowId
        );
        const overrideFields = [
          "clearHeight",
          "softFitSheething",
          "gutter",
          "downTake",
          "kickerPipe",
        ];
        const manualEditFields = ["wallType", "wall", "length", "projection"];

        const isDerivedOverride =
          overrideFields.includes(key) ||
          (key === "projection" && !row.isManual);

        if (
          row.isManual &&
          (manualEditFields.includes(key) || overrideFields.includes(key))
        ) {
          const updatedManualRows = [...currentManualRows];

          if (manualRowIndex === -1) return building;

          updatedManualRows[manualRowIndex] = {
            ...updatedManualRows[manualRowIndex],
            [key]: finalValueToSave,
          };

          return {
            ...building,
            canopy: {
              ...currentCanopy,
              manualRows: updatedManualRows,
            },
          };
        } else if (!row.isManual && isDerivedOverride) {
          const newOverride = {
            rowId: rowId,
            ...(overrideIndex !== -1 ? currentOverrides[overrideIndex] : {}),
            [key]: finalValueToSave,
          };

          let finalOverrides;
          if (overrideIndex !== -1) {
            finalOverrides = currentOverrides.map((o, idx) =>
              idx === overrideIndex ? newOverride : o
            );
          } else {
            finalOverrides = [...currentOverrides, newOverride];
          }

          return {
            ...building,
            canopy: {
              ...currentCanopy,
              rowOverrides: finalOverrides,
            },
          };
        } else {
          const newDynamic = {
            rowId: rowId,
            ...(dynamicIndex !== -1 ? currentDynamicRows[dynamicIndex] : {}),
            [key]: finalValueToSave,
          };

          let finalDynamicRows;
          if (dynamicIndex !== -1) {
            finalDynamicRows = currentDynamicRows.map((d, idx) =>
              idx === dynamicIndex ? newDynamic : d
            );
          } else {
            finalDynamicRows = [...currentDynamicRows, newDynamic];
          }

          return {
            ...building,
            canopy: {
              ...currentCanopy,
              dynamicRows: finalDynamicRows,
            },
          };
        }
      })
    );
  };

  const addCanopyRow = () => {
    setBuildings((prev) =>
      prev.map((b) => {
        if (b.id !== activeBuildingId) return b;

        const canopy = b.canopy || {};
        const existingManualRows = canopy.manualRows || [];
        const dynamicColumns = canopy.dynamicColumns || [];

        const newRowId = `manual-${Date.now()}-${Math.floor(
          Math.random() * 1000
        )}`;

        const newDynamicFields = dynamicColumns.reduce((acc, col) => {
          acc[col.key] = "";
          return acc;
        }, {});

        const newRow = {
          rowId: newRowId,
          isManual: true,

          wallType: "Manual Entry",
          wall: "-",
          length: "",
          projection: "",

          clearHeight: "",
          softFitSheething: "",
          gutter: "",
          downTake: "",
          kickerPipe: "",

          ...newDynamicFields,
        };

        return {
          ...b,
          canopy: {
            ...canopy,
            manualRows: [...existingManualRows, newRow],
          },
        };
      })
    );
  };

  const deleteCanopyRow = (combinedIndex) => {
    // Use the calculated canopyRows to check if deletion is allowed
    const rowToDelete = canopyRows[combinedIndex];
    if (!rowToDelete || !rowToDelete.isManual) {
      console.warn("Attempted to delete a non-manual canopy row.");
      return;
    }

    setBuildings((prev) =>
      prev.map((b) => {
        if (b.id !== activeBuildingId) return b;

        const canopy = b.canopy || {};
        const currentManualRows = canopy.manualRows || [];
        const currentOverrides = canopy.rowOverrides || [];
        const currentDynamicRows = canopy.dynamicRows || [];

        // Base row count is needed to find the index in manualRows array
        const baseRowCount = canopyRows.filter((r) => !r.isManual).length;
        const manualRowIndex = combinedIndex - baseRowCount;

        if (manualRowIndex < 0 || manualRowIndex >= currentManualRows.length) {
          return b;
        }

        // 1. Delete the row from the manualRows array
        const updatedManualRows = currentManualRows.filter(
          (_, idx) => idx !== manualRowIndex
        );

        // 2. Shift/Remove data from rowOverrides and dynamicRows at the combinedIndex
        const updatedOverrides = [
          ...currentOverrides.slice(0, combinedIndex),
          ...currentOverrides.slice(combinedIndex + 1),
        ];
        const updatedDynamicRows = [
          ...currentDynamicRows.slice(0, combinedIndex),
          ...currentDynamicRows.slice(combinedIndex + 1),
        ];

        return {
          ...b,
          canopy: {
            ...canopy,
            manualRows: updatedManualRows,
            rowOverrides: updatedOverrides,
            dynamicRows: updatedDynamicRows,
          },
        };
      })
    );
  };

  const addCanopyColumn = () => {
    setBuildings((prev) =>
      prev.map((b) => {
        if (b.id !== activeBuildingId) return b;

        const canopy = b.canopy || {};
        const existingColumns = canopy.dynamicColumns || [];
        const existingRows = canopy.dynamicRows || [];

        // Create new column definition
        const newColumn = {
          id: Date.now(),
          header: `Extra Field ${existingColumns.length + 1}`,
          key: `extraField_${existingColumns.length + 1}`,
        };

        // Add the new field key to all existing dynamic rows with an empty value
        const updatedRows = existingRows.map((row) => ({
          ...row,
          [newColumn.key]: row[newColumn.key] ?? "",
        }));

        // Check if there are base canopy rows but no existing dynamic rows (first add)
        if (updatedRows.length === 0 && canopyRows.length > 0) {
          for (let i = 0; i < canopyRows.length; i++) {
            updatedRows.push({ [newColumn.key]: "" });
          }
        } else if (updatedRows.length === 0 && canopyRows.length === 0) {
          updatedRows.push({ id: 1, [newColumn.key]: "" });
        }

        if (updatedRows.length < canopyRows.length) {
          for (let i = updatedRows.length; i < canopyRows.length; i++) {
            updatedRows.push({ [newColumn.key]: "" });
          }
        }

        return {
          ...b,
          canopy: {
            ...canopy,
            dynamicColumns: [...existingColumns, newColumn],
            dynamicRows: updatedRows,
          },
        };
      })
    );
  };
  const handleDynamicHeaderChange = (columnId, value) => {
    setBuildings((prev) =>
      prev.map((b) => {
        if (b.id !== activeBuildingId) return b;

        const canopy = b.canopy || {};
        const updatedColumns = (canopy.dynamicColumns || []).map((col) =>
          col.id === columnId ? { ...col, header: value } : col
        );

        return {
          ...b,
          canopy: {
            ...canopy,
            dynamicColumns: updatedColumns,
          },
        };
      })
    );
  };
  /* Frame Opening Inputs start */
  const frameOpeningInputsChange = ({
    target: { name, value },
    formatOnBlur = false,
  }) => {
    let displayValue = value;

    // Restrict decimals while typing
    if (!formatOnBlur && value !== "") {
      displayValue = restrictDecimals(value);
    }
    // Format to 3 decimals on blur
    if (formatOnBlur && value !== "" && !isNaN(parseFloat(value))) {
      displayValue = parseFloat(value).toFixed(3);
    }

    setBuildings((prev) =>
      prev.map((building) => {
        if (building.id !== activeBuildingId) return building;

        const currentFrameOpening = building.frameOpening || {};

        // Map input field names to row field names
        const fieldMap = {
          frameOpeningInputsWidth: "width",
          frameOpeningInputsHeight: "height",
        };
        const rowFieldName = fieldMap[name];

        // VALIDATION FOR GLOBAL WIDTH
        if (name === "frameOpeningInputsWidth") {
          const newWidth = parseFloat(displayValue) || 0;
          for (let row of frameOpeningRows) {
            const baySpacing = parseFloat(row?.baySpacing) || 0;
            if (newWidth > baySpacing) {
              alert("Width cannot be greater than Bay Spacing in any row");
              return building; // block update
            }
          }
        }

        let updatedOverrides = currentFrameOpening.rowOverrides || [];
        // If global input changed, clear overrides for this field in ALL rows
        if (rowFieldName && updatedOverrides.length > 0) {
          updatedOverrides = updatedOverrides
            .map((override) => {
              const { [rowFieldName]: removed, ...rest } = override || {};
              return Object.keys(rest).length > 0 ? rest : undefined;
            })
            .filter(Boolean); // Remove empty overrides
        }

        return {
          ...building,
          frameOpening: {
            ...currentFrameOpening,
            inputs: {
              ...currentFrameOpening.inputs,
              [name]: displayValue,
            },
            rowOverrides: updatedOverrides,
          },
        };
      })
    );
  };

  const handleDynomicFrameOpeningInputsChange = (
    combinedIndex,
    key,
    value,
    formatOnBlur = false
  ) => {
    setBuildings((prev) =>
      prev.map((building) => {
        if (building.id !== activeBuildingId) return building;

        const currentFrameOpening = building.frameOpening || {};
        const currentOverrides = currentFrameOpening.rowOverrides || [];
        const currentDynamicRows = currentFrameOpening.dynamicRows || [];
        const currentManualRows = currentFrameOpening.manualRows || [];
        const overrideFields = ["width", "height", "baySpacing"];
        const manualEditFields = [
          "wallType",
          "wall",
          "baySpacing",
          "width",
          "height",
        ];
        const allRows = frameOpeningRows;
        const row = allRows[combinedIndex];
        const baseRowCount = allRows.filter((r) => !r.isManual).length;
        const manualRowIndex = combinedIndex - baseRowCount;
        const rowId = row?.rowId;
        const overrideIndex = currentOverrides.findIndex(
          (o) => o.rowId === rowId
        );
        const dynamicIndex = currentDynamicRows.findIndex(
          (d) => d.rowId === rowId
        );

        let finalValueToSave = value;

        // 1. Restrict decimals on input for width, height, baySpacing
        if (["width", "height", "baySpacing"].includes(key) && !formatOnBlur) {
          finalValueToSave = restrictDecimals(value);
        }

        // 2. Format to 3 decimals on blur for width, height, baySpacing
        if (
          ["width", "height", "baySpacing"].includes(key) &&
          formatOnBlur &&
          value !== ""
        ) {
          const num = parseFloat(value);
          finalValueToSave =
            !isNaN(num) && isFinite(num) ? num.toFixed(3) : value;
        } else if (formatOnBlur && value === "") {
          finalValueToSave = "";
        }

        // 3. Width validation logic
        if (key === "width") {
          const rawForValidation = parseFloat(finalValueToSave) || 0;
          const baySpacing = parseFloat(row?.baySpacing) || 0;
          if (rawForValidation > baySpacing) {
            alert("Width cannot be greater than Bay Spacing");
            return building;
          }
        }

        if (
          (overrideFields.includes(key) && !row?.isManual) ||
          (key === "baySpacing" && !row?.isManual) ||
          (overrideFields.includes(key) && row?.isManual)
        ) {
          const newOverride = {
            rowId: rowId,
            ...(overrideIndex !== -1 ? currentOverrides[overrideIndex] : {}),
            [key]: finalValueToSave,
          };

          let finalOverrides;

          if (overrideIndex !== -1) {
            finalOverrides = currentOverrides.map((override, idx) =>
              idx === overrideIndex ? newOverride : override
            );
          } else {
            finalOverrides = [...currentOverrides, newOverride];
          }

          return {
            ...building,
            frameOpening: {
              ...currentFrameOpening,
              rowOverrides: finalOverrides,
            },
          };
        }

        // --- 4. Manual Row editing a non-size base property (Wall Type, Wall) ---
        else if (row?.isManual && manualEditFields.includes(key)) {
          const updatedManualRows = [...currentManualRows];

          if (
            manualRowIndex >= 0 &&
            manualRowIndex < updatedManualRows.length
          ) {
            updatedManualRows[manualRowIndex] = {
              ...updatedManualRows[manualRowIndex],
              [key]: finalValueToSave, // Use the potentially formatted value
            };
          }

          return {
            ...building,
            frameOpening: {
              ...currentFrameOpening,
              manualRows: updatedManualRows,
            },
          };
        }

        // --- 5. Dynamic Columns (The catch-all for custom columns) ---
        else {
          const newDynamic = {
            rowId: rowId,
            ...(dynamicIndex !== -1 ? currentDynamicRows[dynamicIndex] : {}),
            [key]: finalValueToSave, // Use the potentially formatted value
          };

          let finalDynamicRows;

          if (dynamicIndex !== -1) {
            finalDynamicRows = currentDynamicRows.map((dynamic, idx) =>
              idx === dynamicIndex ? newDynamic : dynamic
            );
          } else {
            finalDynamicRows = [...currentDynamicRows, newDynamic];
          }

          return {
            ...building,
            frameOpening: {
              ...currentFrameOpening,
              dynamicRows: finalDynamicRows,
            },
          };
        }
      })
    );
  };

  const addFrameOpeningRow = () => {
    setBuildings((prev) =>
      prev.map((b) => {
        if (b.id !== activeBuildingId) return b;

        const frameOpening = b.frameOpening || {};
        const existingManualRows = frameOpening.manualRows || [];
        const dynamicColumns = frameOpening.dynamicColumns || [];

        // Initialize dynamic fields for the new row
        const newDynamicFields = dynamicColumns.reduce((acc, col) => {
          acc[col.key] = "";
          return acc;
        }, {});

        // Initialize the new row object
        const newRow = {
          id: Date.now(),
          wallType: "Manual Entry",
          wall: "-",
          width: 0,
          height: 0,
          baySpacing: 0, // Manual rows need to specify baySpacing
          ...newDynamicFields,
        };

        return {
          ...b,
          frameOpening: {
            ...frameOpening,
            manualRows: [...existingManualRows, newRow],
          },
        };
      })
    );
  };

  const deleteFrameOpeningRow = (combinedIndex) => {
    // Use the calculated frameOpeningRows to check if deletion is allowed
    const rowToDelete = frameOpeningRows[combinedIndex];
    if (!rowToDelete || !rowToDelete.isManual) {
      console.warn("Attempted to delete a non-manual frame opening row.");
      return;
    }

    setBuildings((prev) =>
      prev.map((b) => {
        if (b.id !== activeBuildingId) return b;

        const frameOpening = b.frameOpening || {};
        const currentManualRows = frameOpening.manualRows || [];
        const currentOverrides = frameOpening.rowOverrides || [];
        const currentDynamicRows = frameOpening.dynamicRows || [];

        // Base row count is needed to find the index in manualRows array
        const baseRowCount = frameOpeningRows.filter((r) => !r.isManual).length;
        const manualRowIndex = combinedIndex - baseRowCount;

        if (manualRowIndex < 0 || manualRowIndex >= currentManualRows.length) {
          return b;
        }

        // 1. Delete the row from the manualRows array
        const updatedManualRows = currentManualRows.filter(
          (_, idx) => idx !== manualRowIndex
        );

        // 2. Shift/Remove data from rowOverrides and dynamicRows at the combinedIndex
        const updatedOverrides = [
          ...currentOverrides.slice(0, combinedIndex),
          ...currentOverrides.slice(combinedIndex + 1),
        ];
        const updatedDynamicRows = [
          ...currentDynamicRows.slice(0, combinedIndex),
          ...currentDynamicRows.slice(combinedIndex + 1),
        ];

        return {
          ...b,
          frameOpening: {
            ...frameOpening,
            manualRows: updatedManualRows,
            rowOverrides: updatedOverrides,
            dynamicRows: updatedDynamicRows,
          },
        };
      })
    );
  };
  const handleFrameOpeningDynamicHeaderChange = (columnId, value) => {
    setBuildings((prev) =>
      prev.map((b) => {
        if (b.id !== activeBuildingId) return b;

        const frameOpening = b.frameOpening || {};
        const updatedColumns = (frameOpening.dynamicColumns || []).map((col) =>
          col.id === columnId ? { ...col, header: value } : col
        );

        return {
          ...b,
          frameOpening: {
            ...frameOpening,
            dynamicColumns: updatedColumns,
          },
        };
      })
    );
  };

  const deleteFrameOpeningColumn = (columnId) => {
    setBuildings((prev) =>
      prev.map((b) => {
        if (b.id !== activeBuildingId) return b;

        const frameOpening = b.frameOpening || {};
        const existingColumns = frameOpening.dynamicColumns || [];
        const existingRows = frameOpening.dynamicRows || [];

        const columnToDelete = existingColumns.find(
          (col) => col.id === columnId
        );
        if (!columnToDelete) return b;

        const keyToDelete = columnToDelete.key;

        const updatedColumns = existingColumns.filter(
          (col) => col.id !== columnId
        );

        const updatedRows = existingRows.map((row) => {
          const { [keyToDelete]: removed, ...restOfRow } = row;
          return restOfRow;
        });

        return {
          ...b,
          frameOpening: {
            ...frameOpening,
            dynamicColumns: updatedColumns,
            dynamicRows: updatedRows,
          },
        };
      })
    );
  };
  const addFrameOpeningColumn = () => {
    setBuildings((prev) =>
      prev.map((b) => {
        if (b.id !== activeBuildingId) return b;

        const frameOpening = b.frameOpening || {};
        const existingColumns = frameOpening.dynamicColumns || [];
        const existingRows = frameOpening.dynamicRows || [];

        // Create new column definition
        const newColumn = {
          id: Date.now(),
          header: `Extra Field ${existingColumns.length + 1}`,
          key: `extraField_${existingColumns.length + 1}`,
        };

        // Add the new field key to all existing dynamic rows with an empty value
        const updatedRows = existingRows.map((row) => ({
          ...row,
          [newColumn.key]: row[newColumn.key] ?? "",
        }));

        // Check if there are base frameOpening rows but no existing dynamic rows (first add)
        if (updatedRows.length === 0 && frameOpeningRows.length > 0) {
          for (let i = 0; i < frameOpeningRows.length; i++) {
            updatedRows.push({ [newColumn.key]: "" });
          }
        } else if (updatedRows.length === 0 && frameOpeningRows.length === 0) {
          updatedRows.push({ id: 1, [newColumn.key]: "" });
        }

        if (updatedRows.length < frameOpeningRows.length) {
          for (let i = updatedRows.length; i < frameOpeningRows.length; i++) {
            updatedRows.push({ [newColumn.key]: "" });
          }
        }

        return {
          ...b,
          frameOpening: {
            ...frameOpening,
            dynamicColumns: [...existingColumns, newColumn],
            dynamicRows: updatedRows,
          },
        };
      })
    );
  };

  /* Lean To Inputs start */
  const leanToInputsChange = ({
    target: { name, value },
    formatOnBlur = false,
  }) => {
    const floatFields = [
      "leanToInputsBaySpacing",
      "leanToInputsWidth",
      "leanToInputsClearHight", // typo probably, correct if needed
      "leanToInputsBlockWall",
    ];

    let adjustedValue = value;
    if (floatFields.includes(name) && !formatOnBlur) {
      adjustedValue = restrictDecimals(value);
    }
    if (floatFields.includes(name) && formatOnBlur && value !== "") {
      const num = parseFloat(value);
      adjustedValue = !isNaN(num) ? num.toFixed(3) : value;
    }

    setBuildings((prev) =>
      prev.map((building) => {
        if (building.id !== activeBuildingId) return building;

        const currentLeanTo = building.leanTo || {};

        // Map input field names to row field names
        const fieldMap = {
          leanToInputsWidth: "width",
          leanToInputsClearHight: "clearHeight",
          leanToInputsBlockWall: "blockWall",
          leanToInputsSlope: "slope",
          leanToInputsApron: "apron",
          leanToInputsDowntake: "downTake",
          leanToInputsGutter: "gutter",
          leanToInputsGirtcondition: "girtCondition",
        };

        const rowFieldName = fieldMap[name];

        let updatedOverrides = currentLeanTo.rowOverrides || [];

        // If this main input changed, clear the overrides for this specific field in ALL rows
        if (rowFieldName && updatedOverrides.length > 0) {
          updatedOverrides = updatedOverrides
            .map((override) => {
              // Remove this specific field from the override
              const { [rowFieldName]: removed, ...rest } = override || {};
              return Object.keys(rest).length > 0 ? rest : undefined;
            })
            .filter(Boolean); // Remove empty overrides
        }

        return {
          ...building,
          leanTo: {
            ...currentLeanTo,
            inputs: {
              ...currentLeanTo.inputs,
              [name]: adjustedValue,
            },
            rowOverrides: updatedOverrides,
          },
        };
      })
    );
  };

  // Add dynamic column for Lean To
  const addLeanToColumn = () => {
    setBuildings((prev) =>
      prev.map((b) => {
        if (b.id !== activeBuildingId) return b;

        const leanTo = b.leanTo || {};
        const existingColumns = leanTo.dynamicColumns || [];
        const existingRows = leanTo.dynamicRows || [];

        // Create new column definition
        const newColumn = {
          id: Date.now(),
          header: `Extra Field ${existingColumns.length + 1}`,
          key: `extraField_${existingColumns.length + 1}`,
        };

        // Add the new field key to all existing dynamic rows with an empty value
        const updatedRows = existingRows.map((row) => ({
          ...row,
          [newColumn.key]: row[newColumn.key] ?? "",
        }));

        // Check if there are base leanTo rows but no existing dynamic rows (first add)
        if (updatedRows.length === 0 && leanToRows.length > 0) {
          for (let i = 0; i < leanToRows.length; i++) {
            updatedRows.push({ [newColumn.key]: "" });
          }
        } else if (updatedRows.length === 0 && leanToRows.length === 0) {
          updatedRows.push({ id: 1, [newColumn.key]: "" });
        }

        if (updatedRows.length < leanToRows.length) {
          for (let i = updatedRows.length; i < leanToRows.length; i++) {
            updatedRows.push({ [newColumn.key]: "" });
          }
        }

        return {
          ...b,
          leanTo: {
            ...leanTo,
            dynamicColumns: [...existingColumns, newColumn],
            dynamicRows: updatedRows,
          },
        };
      })
    );
  };

  const deleteLeanToColumn = (columnId) => {
    setBuildings((prev) =>
      prev.map((b) => {
        if (b.id !== activeBuildingId) return b;

        const leanTo = b.leanTo || {};
        const existingColumns = leanTo.dynamicColumns || [];
        const existingRows = leanTo.dynamicRows || [];

        const columnToDelete = existingColumns.find(
          (col) => col.id === columnId
        );
        if (!columnToDelete) return b;

        const keyToDelete = columnToDelete.key;

        const updatedColumns = existingColumns.filter(
          (col) => col.id !== columnId
        );

        const updatedRows = existingRows.map((row) => {
          const { [keyToDelete]: removed, ...restOfRow } = row;
          return restOfRow;
        });

        return {
          ...b,
          leanTo: {
            ...leanTo,
            dynamicColumns: updatedColumns,
            dynamicRows: updatedRows,
          },
        };
      })
    );
  };
  const handleLeanToDynamicHeaderChange = (columnId, value) => {
    setBuildings((prev) =>
      prev.map((b) => {
        if (b.id !== activeBuildingId) return b;

        const leanTo = b.leanTo || {};
        const updatedColumns = (leanTo.dynamicColumns || []).map((col) =>
          col.id === columnId ? { ...col, header: value } : col
        );

        return {
          ...b,
          leanTo: {
            ...leanTo,
            dynamicColumns: updatedColumns,
          },
        };
      })
    );
  };

  const handleDynomicLeanToInputs = (
    combinedIndex,
    key,
    value,
    formatOnBlur = false
  ) => {
    const floatKeys = ["baySpacing", "width", "clearHeight", "blockWall"];

    let finalValueToSave = value;
    if (floatKeys.includes(key) && !formatOnBlur) {
      finalValueToSave = restrictDecimals(value);
    }

    if (floatKeys.includes(key) && formatOnBlur && value !== "") {
      const num = parseFloat(value);
      finalValueToSave = !isNaN(num) ? num.toFixed(3) : value;
    }

    setBuildings((prev) =>
      prev.map((building) => {
        if (building.id !== activeBuildingId) return building;

        const currentLeanTo = building.leanTo || {};
        const currentOverrides = currentLeanTo.rowOverrides || [];
        const currentManualRows = currentLeanTo.manualRows || [];
        const currentDynamicRows = currentLeanTo.dynamicRows || [];

        const row = leanToRows[combinedIndex];
        if (!row) return building;
        const rowId = row.rowId;
        const overrideIndex = currentOverrides.findIndex(
          (o) => o.rowId === rowId
        );
        const dynamicIndex = currentDynamicRows.findIndex(
          (d) => d.rowId === rowId
        );

        const overrideFields = [
          "width",
          "length",
          "clearHeight",
          "blockWall",
          "slope",
          "apron",
          "downTake",
          "gutter",
          "girtCondition",
        ];

        // Manual Row base fields (wallType, wall)
        const manualEditFields = ["wallType", "wall"];

        // 1. Manual Row Base Edit Logic (wallType, wall)
        if (row.isManual && manualEditFields.includes(key)) {
          const updatedManualRows = [...currentManualRows];
          const manualRowStateIndex = updatedManualRows.findIndex(
            (r) => r.rowId === rowId
          );

          if (manualRowStateIndex !== -1) {
            updatedManualRows[manualRowStateIndex] = {
              ...updatedManualRows[manualRowStateIndex],
              [key]: finalValueToSave,
            };
          }

          return {
            ...building,
            leanTo: {
              ...currentLeanTo,
              manualRows: updatedManualRows,
            },
          };
        }

        // 2. Override/Manual Row Size/Attribute Update Logic
        else if (overrideFields.includes(key)) {
          if (row.isManual) {
            // Manual Rows లోని Size/Attributes ను direct గా manualRows లో అప్‌డేట్ చేయండి
            const updatedManualRows = [...currentManualRows];
            const manualRowStateIndex = updatedManualRows.findIndex(
              (r) => r.rowId === rowId
            );

            if (manualRowStateIndex !== -1) {
              updatedManualRows[manualRowStateIndex] = {
                ...updatedManualRows[manualRowStateIndex],
                [key]: finalValueToSave,
              };
            }

            return {
              ...building,
              leanTo: {
                ...currentLeanTo,
                manualRows: updatedManualRows,
              },
            };
          } else {
            // Derived Rows లో rowOverrides ను అప్‌డేట్ చేయండి
            const newOverride = {
              rowId: rowId,
              ...(overrideIndex !== -1 ? currentOverrides[overrideIndex] : {}),
              [key]: finalValueToSave,
            };

            let finalOverrides;

            if (overrideIndex !== -1) {
              finalOverrides = currentOverrides.map((override, idx) =>
                idx === overrideIndex ? newOverride : override
              );
            } else {
              finalOverrides = [...currentOverrides, newOverride];
            }

            return {
              ...building,
              leanTo: {
                ...currentLeanTo,
                rowOverrides: finalOverrides,
              },
            };
          }
        }

        // 3. Dynamic Field Logic
        else {
          const newDynamic = {
            rowId: rowId,
            ...(dynamicIndex !== -1 ? currentDynamicRows[dynamicIndex] : {}),
            [key]: finalValueToSave,
          };

          let finalDynamicRows;

          if (dynamicIndex !== -1) {
            finalDynamicRows = currentDynamicRows.map((dynamic, idx) =>
              idx === dynamicIndex ? newDynamic : dynamic
            );
          } else {
            finalDynamicRows = [...currentDynamicRows, newDynamic];
          }

          return {
            ...building,
            leanTo: {
              ...currentLeanTo,
              dynamicRows: finalDynamicRows,
            },
          };
        }
      })
    );
  };

  const addLeanToRow = () => {
    setBuildings((prev) =>
      prev.map((b) => {
        if (b.id !== activeBuildingId) return b;

        const leanTo = b.leanTo || {};
        const existingManualRows = leanTo.manualRows || [];
        const dynamicColumns = leanTo.dynamicColumns || [];

        const newRowId = `manual-${Date.now()}-${Math.floor(
          Math.random() * 1000
        )}`;

        const newDynamicFields = dynamicColumns.reduce((acc, col) => {
          acc[col.key] = "";
          return acc;
        }, {});

        const newRow = {
          rowId: newRowId,
          wallType: "Manual Entry",
          wall: "-",
          isManual: true,
          length: "",
          width: "",
          clearHeight: "",
          blockWall: "",
          slope: "",
          apron: "",
          downTake: "",
          gutter: "",
          girtCondition: "",
          ...newDynamicFields,
        };

        return {
          ...b,
          leanTo: {
            ...leanTo,
            manualRows: [...existingManualRows, newRow],
          },
        };
      })
    );
  };

  const deleteLeanToRow = (combinedIndex) => {
    // Use the calculated leanToRows to check if deletion is allowed
    const rowToDelete = leanToRows[combinedIndex];
    if (!rowToDelete || !rowToDelete.isManual) {
      console.warn("Attempted to delete a non-manual lean-to row.");
      return;
    }

    setBuildings((prev) =>
      prev.map((b) => {
        if (b.id !== activeBuildingId) return b;

        const leanTo = b.leanTo || {};
        const currentManualRows = leanTo.manualRows || [];
        const currentOverrides = leanTo.rowOverrides || [];
        const currentDynamicRows = leanTo.dynamicRows || [];

        // Base row count is needed to find the index in manualRows array
        const baseRowCount = leanToRows.filter((r) => !r.isManual).length;
        const manualRowIndex = combinedIndex - baseRowCount;

        if (manualRowIndex < 0 || manualRowIndex >= currentManualRows.length) {
          return b;
        }

        // 1. Delete the row from the manualRows array
        const updatedManualRows = currentManualRows.filter(
          (_, idx) => idx !== manualRowIndex
        );

        // 2. Shift/Remove data from rowOverrides and dynamicRows at the combinedIndex
        const updatedOverrides = [
          ...currentOverrides.slice(0, combinedIndex),
          ...currentOverrides.slice(combinedIndex + 1),
        ];
        const updatedDynamicRows = [
          ...currentDynamicRows.slice(0, combinedIndex),
          ...currentDynamicRows.slice(combinedIndex + 1),
        ];

        return {
          ...b,
          leanTo: {
            ...leanTo,
            manualRows: updatedManualRows,
            rowOverrides: updatedOverrides,
            dynamicRows: updatedDynamicRows,
          },
        };
      })
    );
  };
  /* Fascia Inputs start */
  /* Fascia Inputs start */
  const fasciaInputsChange = ({
    target: { name, value },
    formatOnBlur = false,
  }) => {
    const floatFields = ["fasciaInputsBaySpacing", "fasciaInputsHeight"];

    let adjustedValue = value;
    if (floatFields.includes(name) && !formatOnBlur) {
      adjustedValue = restrictDecimals(value);
    }
    if (floatFields.includes(name) && formatOnBlur && value !== "") {
      const num = parseFloat(value);
      adjustedValue = !isNaN(num) ? num.toFixed(3) : value;
    }

    setBuildings((prev) =>
      prev.map((building) => {
        if (building.id !== activeBuildingId) return building;

        const currentFascia = building.fascia || {};

        // Map input field names to row field names
        const fieldMap = {
          fasciaInputsHeight: "height",
          fasciaInputsSheeting: "sheeting",
          fasciaInputsPurlinCondition: "purlinCondition",
        };

        const rowFieldName = fieldMap[name];

        let updatedOverrides = currentFascia.rowOverrides || [];

        // If this main input changed, clear the overrides for this specific field in ALL rows
        if (rowFieldName && updatedOverrides.length > 0) {
          updatedOverrides = updatedOverrides
            .map((override) => {
              // Remove this specific field from the override
              const { [rowFieldName]: removed, ...rest } = override || {};
              return Object.keys(rest).length > 0 ? rest : undefined;
            })
            .filter(Boolean); // Remove empty overrides
        }

        return {
          ...building,
          fascia: {
            ...currentFascia,
            inputs: {
              ...currentFascia.inputs,
              [name]: adjustedValue,
            },
            rowOverrides: updatedOverrides,
          },
        };
      })
    );
  };

  const handleDynomicfasciaInputs = (
    combinedIndex,
    key,
    value,
    formatOnBlur = false
  ) => {
    const floatKeys = ["baySpacing", "height"];

    let finalValueToSave = value;
    if (floatKeys.includes(key) && !formatOnBlur) {
      finalValueToSave = restrictDecimals(value);
    }
    if (floatKeys.includes(key) && formatOnBlur && value !== "") {
      const num = parseFloat(value);
      finalValueToSave = !isNaN(num) ? num.toFixed(3) : value;
    }

    setBuildings((prev) =>
      prev.map((building) => {
        if (building.id !== activeBuildingId) return building;

        const currentFascia = building.fascia || {};
        const currentOverrides = currentFascia.rowOverrides || [];
        const currentDynamicRows = currentFascia.dynamicRows || [];
        const currentManualRows = currentFascia.manualRows || [];

        const allFasciaRows = fasciaRows;
        const row = allFasciaRows[combinedIndex];
        if (!row) return building;

        const rowId = row.rowId;
        const overrideIndex = currentOverrides.findIndex(
          (o) => o.rowId === rowId
        ); // rowId ద్వారా index ను కనుగొనండి
        const dynamicIndex = currentDynamicRows.findIndex(
          (d) => d.rowId === rowId
        );
        const manualRowIndex = currentManualRows.findIndex(
          (r) => r.rowId === rowId
        );

        // Fields that are standard overrides
        const overrideFields = ["height", "purlinCondition"];
        // Fields editable ONLY in manual rows
        const manualEditFields = ["wallType", "wall", "length"];

        // 1. Manual Row Editing Logic (wallType, wall, length, height, purlinCondition)
        if (
          row.isManual &&
          (manualEditFields.includes(key) || overrideFields.includes(key))
        ) {
          const updatedManualRows = [...currentManualRows];

          if (manualRowIndex === -1) return building;

          updatedManualRows[manualRowIndex] = {
            ...updatedManualRows[manualRowIndex],
            [key]: finalValueToSave,
          };

          return {
            ...building,
            fascia: {
              ...currentFascia,
              manualRows: updatedManualRows,
            },
          };
        }

        // 2. Derived Row Override Logic (height, purlinCondition)
        else if (!row.isManual && overrideFields.includes(key)) {
          const newOverride = {
            rowId: rowId,
            ...(overrideIndex !== -1 ? currentOverrides[overrideIndex] : {}),
            [key]: finalValueToSave,
          };

          let finalOverrides;
          if (overrideIndex !== -1) {
            finalOverrides = currentOverrides.map((o, idx) =>
              idx === overrideIndex ? newOverride : o
            );
          } else {
            finalOverrides = [...currentOverrides, newOverride];
          }

          return {
            ...building,
            fascia: {
              ...currentFascia,
              rowOverrides: finalOverrides,
            },
          };
        }

        // 3. Dynamic Field Logic
        else {
          const newDynamic = {
            rowId: rowId,
            ...(dynamicIndex !== -1 ? currentDynamicRows[dynamicIndex] : {}),
            [key]: finalValueToSave,
          };

          let finalDynamicRows;
          if (dynamicIndex !== -1) {
            finalDynamicRows = currentDynamicRows.map((d, idx) =>
              idx === dynamicIndex ? newDynamic : d
            );
          } else {
            finalDynamicRows = [...currentDynamicRows, newDynamic];
          }

          return {
            ...building,
            fascia: {
              ...currentFascia,
              dynamicRows: finalDynamicRows,
            },
          };
        }
      })
    );
  };

  const addFasciaRow = () => {
    setBuildings((prev) =>
      prev.map((b) => {
        if (b.id !== activeBuildingId) return b;

        const fascia = b.fascia || {};
        const existingManualRows = fascia.manualRows || [];
        const dynamicColumns = fascia.dynamicColumns || [];

        const newRowId = `manual-${Date.now()}-${Math.floor(
          Math.random() * 1000
        )}`;
        const newDynamicFields = dynamicColumns.reduce((acc, col) => {
          acc[col.key] = "";
          return acc;
        }, {});

        const newRow = {
          rowId: newRowId,
          wallType: "Manual Entry",
          wall: "-",
          isManual: true, //
          length: "", // Editable
          height: "", // Editable
          purlinCondition: "", // Editable
          ...newDynamicFields,
        };

        return {
          ...b,
          fascia: {
            ...fascia,
            manualRows: [...existingManualRows, newRow],
          },
        };
      })
    );
  };

  const deleteFasciaRow = (combinedIndex) => {
    // Use the calculated fasciaRows to check if deletion is allowed
    const rowToDelete = fasciaRows[combinedIndex];
    if (!rowToDelete || !rowToDelete.isManual) {
      console.warn("Attempted to delete a non-manual fascia row.");
      return;
    }

    setBuildings((prev) =>
      prev.map((b) => {
        if (b.id !== activeBuildingId) return b;

        const fascia = b.fascia || {};
        const currentManualRows = fascia.manualRows || [];
        const currentOverrides = fascia.rowOverrides || [];
        const currentDynamicRows = fascia.dynamicRows || [];

        // Base row count (derived from walls) is needed to find the index in manualRows array
        const baseRowCount = fasciaRows.filter((r) => !r.isManual).length;
        const manualRowIndex = combinedIndex - baseRowCount;

        if (manualRowIndex < 0 || manualRowIndex >= currentManualRows.length) {
          return b;
        }

        // 1. Delete the row from the manualRows array
        const updatedManualRows = currentManualRows.filter(
          (_, idx) => idx !== manualRowIndex
        );

        // 2. Shift/Remove data from rowOverrides and dynamicRows at the combinedIndex
        const updatedOverrides = [
          ...currentOverrides.slice(0, combinedIndex),
          ...currentOverrides.slice(combinedIndex + 1),
        ];
        const updatedDynamicRows = [
          ...currentDynamicRows.slice(0, combinedIndex),
          ...currentDynamicRows.slice(combinedIndex + 1),
        ];

        return {
          ...b,
          fascia: {
            ...fascia,
            manualRows: updatedManualRows,
            rowOverrides: updatedOverrides,
            dynamicRows: updatedDynamicRows,
          },
        };
      })
    );
  };

  const addFasciaColumn = () => {
    setBuildings((prev) =>
      prev.map((b) => {
        if (b.id !== activeBuildingId) return b;

        const fascia = b.fascia || {};
        const existingColumns = fascia.dynamicColumns || [];
        const existingRows = fascia.dynamicRows || [];

        // New column definition
        const newColumn = {
          id: Date.now(),
          header: `Fascia Field ${existingColumns.length + 1}`,
          key: `fasciaField_${existingColumns.length + 1}`,
        };

        // Add the new key to existing dynamic rows
        let updatedRows = existingRows.map((row) => ({
          ...row,
          [newColumn.key]: row[newColumn.key] ?? "",
        }));

        // Initialize rows if dynamicRows is shorter than fasciaRows
        if (updatedRows.length < fasciaRows.length) {
          for (let i = updatedRows.length; i < fasciaRows.length; i++) {
            updatedRows.push({ [newColumn.key]: "" });
          }
        }

        return {
          ...b,
          fascia: {
            ...fascia,
            dynamicColumns: [...existingColumns, newColumn],
            dynamicRows: updatedRows,
          },
        };
      })
    );
  };
  const deleteFasciaColumn = (columnId) => {
    setBuildings((prev) =>
      prev.map((b) => {
        if (b.id !== activeBuildingId) return b;

        const fascia = b.fascia || {};
        const existingColumns = fascia.dynamicColumns || [];
        const existingRows = fascia.dynamicRows || [];

        const columnToDelete = existingColumns.find(
          (col) => col.id === columnId
        );
        if (!columnToDelete) return b;

        const keyToDelete = columnToDelete.key;

        // 1. Remove the column definition
        const updatedColumns = existingColumns.filter(
          (col) => col.id !== columnId
        );

        // 2. Remove the corresponding key from every row
        const updatedRows = existingRows.map((row) => {
          const { [keyToDelete]: removed, ...restOfRow } = row;
          return restOfRow;
        });

        return {
          ...b,
          fascia: {
            ...fascia,
            dynamicColumns: updatedColumns,
            dynamicRows: updatedRows,
          },
        };
      })
    );
  };
  const handleDynamicFasciaHeaderChange = (columnId, value) => {
    setBuildings((prev) =>
      prev.map((b) => {
        if (b.id !== activeBuildingId) return b;

        const fascia = b.fascia || {};
        const updatedColumns = (fascia.dynamicColumns || []).map((col) =>
          col.id === columnId ? { ...col, header: value } : col
        );

        return {
          ...b,
          fascia: {
            ...fascia,
            dynamicColumns: updatedColumns,
          },
        };
      })
    );
  };
  /* Structural Louvers Inputs start */

  /* Structural Louvers Inputs start */
  const structuralLouversInputsChange = ({
    target: { name, value },
    formatOnBlur = false,
  }) => {
    const floatFields = [
      "structuralLouversInputsBaySpacing",
      "structuralLouversInputsProjectin",
      "structuralLouversInputsHeight",
    ];

    // let adjustedValue = value;
    // if (floatFields.includes(name) && !formatOnBlur) {
    //   adjustedValue = restrictDecimals(value);
    // }
    // if (floatFields.includes(name) && formatOnBlur && value !== "") {
    //   const num = parseFloat(value);
    //   adjustedValue = !isNaN(num) ? num.toFixed(3) : value;
    // }

    const integerFields = ["structuralLouversInputsNoOffins"];

    let adjustedValue = value;

    if (integerFields.includes(name)) {
      if (!formatOnBlur) {
        // Only allow digits while typing
        adjustedValue = value.replace(/[^0-9]/g, "");
      } else if (value !== "") {
        // On blur, convert to integer or blank if invalid
        const num = parseInt(value, 10);
        adjustedValue = isNaN(num) ? "" : num;
      }
    } else if (floatFields.includes(name) && !formatOnBlur) {
      adjustedValue = restrictDecimals(value);
    } else if (floatFields.includes(name) && formatOnBlur && value !== "") {
      const num = parseFloat(value);
      adjustedValue = !isNaN(num) ? num.toFixed(3) : value;
    }

    setBuildings((prev) =>
      prev.map((building) => {
        if (building.id !== activeBuildingId) return building;

        const currentStructuralLouvers = building.structuralLouvers || {};

        // Map input field names to row field names
        const fieldMap = {
          structuralLouversInputsProjectin: "projectin",
          structuralLouversInputsHeight: "height",
          structuralLouversInputsMesh: "mesh",
          structuralLouversInputsNoOffins: "noOfFins",
        };

        const rowFieldName = fieldMap[name];

        let updatedOverrides = currentStructuralLouvers.rowOverrides || [];

        // If this main input changed, clear the overrides for this specific field in ALL rows
        if (rowFieldName && updatedOverrides.length > 0) {
          updatedOverrides = updatedOverrides
            .map((override) => {
              // Remove this specific field from the override
              const { [rowFieldName]: removed, ...rest } = override || {};
              return Object.keys(rest).length > 0 ? rest : undefined;
            })
            .filter(Boolean); // Remove empty overrides
        }

        return {
          ...building,
          structuralLouvers: {
            ...currentStructuralLouvers,
            inputs: {
              ...currentStructuralLouvers.inputs,
              [name]: adjustedValue,
            },
            rowOverrides: updatedOverrides,
          },
        };
      })
    );
  };

  const handleDynomicStructuralLouversInputs = (
    combinedIndex,
    key,
    value,
    formatOnBlur = false
  ) => {
    const floatKeys = ["baySpacing", "projectin", "height"];

    const integerKeys = ["noOfFins"];

    let finalValueToSave = value;
    if (integerKeys.includes(key)) {
      if (!formatOnBlur) {
        // Remove all non-digit characters while typing
        finalValueToSave = value.replace(/[^0-9]/g, "");
      } else if (value !== "") {
        // On blur, convert to integer or blank
        const num = parseInt(value, 10);
        finalValueToSave = isNaN(num) ? "" : num;
      }
    } else if (floatKeys.includes(key) && !formatOnBlur) {
      finalValueToSave = restrictDecimals(value);
    } else if (floatKeys.includes(key) && formatOnBlur && value !== "") {
      const num = parseFloat(value);
      finalValueToSave = !isNaN(num) ? num.toFixed(3) : value;
    }

    setBuildings((prev) =>
      prev.map((building) => {
        if (building.id !== activeBuildingId) return building;

        const currentStructuralLouvers = building.structuralLouvers || {};
        const currentOverrides = currentStructuralLouvers.rowOverrides || [];
        const currentDynamicRows = currentStructuralLouvers.dynamicRows || [];
        const currentManualRows = currentStructuralLouvers.manualRows || [];

        const row = structuralLouversRows[combinedIndex];
        if (!row) return building;

        const rowId = row.rowId;
        const overrideIndex = currentOverrides.findIndex(
          (o) => o.rowId === rowId
        );
        const dynamicIndex = currentDynamicRows.findIndex(
          (d) => d.rowId === rowId
        );
        const manualRowIndex = currentManualRows.findIndex(
          (r) => r.rowId === rowId
        );

        // Fields that are standard overrides (projectin, height, mesh, noOfFins)
        const overrideFields = ["projectin", "height", "mesh", "noOfFins"];
        // Fields editable ONLY in manual rows (wallType, wall, length)
        const manualEditFields = ["wallType", "wall", "length"];

        // 1. Manual Row Editing Logic (Base fields OR Override fields)
        if (
          row.isManual &&
          (manualEditFields.includes(key) || overrideFields.includes(key))
        ) {
          const updatedManualRows = [...currentManualRows];

          // మాన్యువల్ రో దొరకకపోతే ఆపండి
          if (manualRowIndex === -1) return building;

          updatedManualRows[manualRowIndex] = {
            ...updatedManualRows[manualRowIndex],
            [key]: finalValueToSave,
          };

          return {
            ...building,
            structuralLouvers: {
              ...currentStructuralLouvers,
              manualRows: updatedManualRows,
            },
          };
        }

        // 2. Derived Row Override Logic (projectin, height, mesh, noOfFins)
        else if (!row.isManual && overrideFields.includes(key)) {
          const newOverride = {
            rowId: rowId,
            ...(overrideIndex !== -1 ? currentOverrides[overrideIndex] : {}),
            [key]: finalValueToSave,
          };

          let finalOverrides;
          if (overrideIndex !== -1) {
            finalOverrides = currentOverrides.map((o, idx) =>
              idx === overrideIndex ? newOverride : o
            );
          } else {
            finalOverrides = [...currentOverrides, newOverride];
          }

          return {
            ...building,
            structuralLouvers: {
              ...currentStructuralLouvers,
              rowOverrides: finalOverrides,
            },
          };
        } else {
          const newDynamic = {
            rowId: rowId,
            ...(dynamicIndex !== -1 ? currentDynamicRows[dynamicIndex] : {}),
            [key]: finalValueToSave,
          };

          let finalDynamicRows;
          if (dynamicIndex !== -1) {
            finalDynamicRows = currentDynamicRows.map((d, idx) =>
              idx === dynamicIndex ? newDynamic : d
            );
          } else {
            finalDynamicRows = [...currentDynamicRows, newDynamic];
          }

          return {
            ...building,
            structuralLouvers: {
              ...currentStructuralLouvers,
              dynamicRows: finalDynamicRows,
            },
          };
        }
      })
    );
  };

  const addStructuralLouversRow = () => {
    setBuildings((prev) =>
      prev.map((b) => {
        if (b.id !== activeBuildingId) return b;

        const structuralLouvers = b.structuralLouvers || {};
        const existingManualRows = structuralLouvers.manualRows || [];
        const dynamicColumns = structuralLouvers.dynamicColumns || [];

        const newRowId = `manual-${Date.now()}-${Math.floor(
          Math.random() * 1000
        )}`;

        const newDynamicFields = dynamicColumns.reduce((acc, col) => {
          acc[col.key] = "";
          return acc;
        }, {});

        const newRow = {
          rowId: newRowId,
          wallType: "Manual Entry",
          wall: "-",
          isManual: true,
          length: "",
          projectin: "",
          height: "",
          mesh: "",
          noOfFins: "",
          ...newDynamicFields,
        };

        return {
          ...b,
          structuralLouvers: {
            ...structuralLouvers,
            manualRows: [...existingManualRows, newRow],
          },
        };
      })
    );
  };

  const deleteStructuralLouversRow = (combinedIndex) => {
    const rowToDelete = structuralLouversRows[combinedIndex];
    if (!rowToDelete || !rowToDelete.isManual) {
      // Prevent deletion of derived rows (Front/Back/Left/Right wall data)
      // console.warn("Attempted to delete a non-manual structural louver row.");
      return;
    }

    setBuildings((prev) =>
      prev.map((b) => {
        if (b.id !== activeBuildingId) return b;

        const structuralLouvers = b.structuralLouvers || {};
        const currentManualRows = structuralLouvers.manualRows || [];
        const currentOverrides = structuralLouvers.rowOverrides || [];
        const currentDynamicRows = structuralLouvers.dynamicRows || [];

        // Base row count (derived from walls) is needed to find the index in manualRows array
        const baseRowCount = structuralLouversRows.filter(
          (r) => !r.isManual
        ).length;
        const manualRowIndex = combinedIndex - baseRowCount;

        if (manualRowIndex < 0 || manualRowIndex >= currentManualRows.length) {
          // Safety check
          return b;
        }

        // 2. Delete the row from the manualRows array
        const updatedManualRows = currentManualRows.filter(
          (_, idx) => idx !== manualRowIndex
        );

        // 3. Shift/Remove data from rowOverrides and dynamicRows
        // Remove the item at the combinedIndex and shift subsequent elements
        const updatedOverrides = [
          ...currentOverrides.slice(0, combinedIndex),
          ...currentOverrides.slice(combinedIndex + 1),
        ];
        const updatedDynamicRows = [
          ...currentDynamicRows.slice(0, combinedIndex),
          ...currentDynamicRows.slice(combinedIndex + 1),
        ];

        return {
          ...b,
          structuralLouvers: {
            ...structuralLouvers,
            manualRows: updatedManualRows,
            rowOverrides: updatedOverrides,
            dynamicRows: updatedDynamicRows,
          },
        };
      })
    );
  };
  const addStructuralLouversColumn = () => {
    setBuildings((prev) =>
      prev.map((b) => {
        if (b.id !== activeBuildingId) return b;

        const structuralLouvers = b.structuralLouvers || {};
        const existingColumns = structuralLouvers.dynamicColumns || [];
        const existingRows = structuralLouvers.dynamicRows || [];

        // New column definition
        const newColumn = {
          id: Date.now(),
          header: `SL Field ${existingColumns.length + 1}`,
          key: `structuralLouversField_${existingColumns.length + 1}`,
        };

        // Add the new key to existing dynamic rows
        let updatedRows = existingRows.map((row) => ({
          ...row,
          [newColumn.key]: row[newColumn.key] ?? "",
        }));

        if (updatedRows.length < structuralLouversRows.length) {
          for (
            let i = updatedRows.length;
            i < structuralLouversRows.length;
            i++
          ) {
            updatedRows.push({ [newColumn.key]: "" });
          }
        }

        return {
          ...b,
          structuralLouvers: {
            ...structuralLouvers,
            dynamicColumns: [...existingColumns, newColumn],
            dynamicRows: updatedRows,
          },
        };
      })
    );
  };

  const deleteStructuralLouversColumn = (columnId) => {
    setBuildings((prev) =>
      prev.map((b) => {
        if (b.id !== activeBuildingId) return b;

        const structuralLouvers = b.structuralLouvers || {};
        const existingColumns = structuralLouvers.dynamicColumns || [];
        const existingRows = structuralLouvers.dynamicRows || [];

        const columnToDelete = existingColumns.find(
          (col) => col.id === columnId
        );
        if (!columnToDelete) return b;

        const keyToDelete = columnToDelete.key;

        // 1. Remove the column definition
        const updatedColumns = existingColumns.filter(
          (col) => col.id !== columnId
        );

        // 2. Remove the corresponding key from every row
        const updatedRows = existingRows.map((row) => {
          const { [keyToDelete]: removed, ...restOfRow } = row;
          return restOfRow;
        });

        return {
          ...b,
          structuralLouvers: {
            ...structuralLouvers,
            dynamicColumns: updatedColumns,
            dynamicRows: updatedRows,
          },
        };
      })
    );
  };

  const handleDynamicStructuralLouversHeaderChange = (columnId, value) => {
    setBuildings((prev) =>
      prev.map((b) => {
        if (b.id !== activeBuildingId) return b;

        const structuralLouvers = b.structuralLouvers || {};
        const updatedColumns = (structuralLouvers.dynamicColumns || []).map(
          (col) => (col.id === columnId ? { ...col, header: value } : col)
        );

        return {
          ...b,
          structuralLouvers: {
            ...structuralLouvers,
            dynamicColumns: updatedColumns,
          },
        };
      })
    );
  };

  /* Structural Louvers Inputs end */

  // Combined useEffect to avoid multiple state updates
  useEffect(() => {
    const activeBuilding = buildings.find((b) => b.id === activeBuildingId);
    if (!activeBuilding) return;

    const updates = {};
    let shouldUpdate = false;

    // Check each feature and prepare updates
    if (
      activeBuilding?.canopy?.rows?.length > 0 &&
      !activeBuilding.canopy.dynamicRows
    ) {
      updates.canopy = {
        ...activeBuilding.canopy,
        dynamicRows: activeBuilding.canopy.rows,
      };
      shouldUpdate = true;
    }

    if (
      activeBuilding?.frameOpening?.rows?.length > 0 &&
      !activeBuilding.frameOpening.dynamicRows
    ) {
      updates.frameOpening = {
        ...activeBuilding.frameOpening,
        dynamicRows: activeBuilding.frameOpening.rows,
      };
      shouldUpdate = true;
    }

    if (
      activeBuilding?.leanTo?.rows?.length > 0 &&
      !activeBuilding.leanTo.dynamicRows
    ) {
      updates.leanTo = {
        ...activeBuilding.leanTo,
        dynamicRows: activeBuilding.leanTo.rows,
      };
      shouldUpdate = true;
    }

    if (
      activeBuilding?.fascia?.rows?.length > 0 &&
      !activeBuilding.fascia.dynamicRows
    ) {
      updates.fascia = {
        ...activeBuilding.fascia,
        dynamicRows: activeBuilding.fascia.rows,
      };
      shouldUpdate = true;
    }

    if (
      activeBuilding?.structuralLouvers?.rows?.length > 0 &&
      !activeBuilding.structuralLouvers.dynamicRows
    ) {
      updates.structuralLouvers = {
        ...activeBuilding.structuralLouvers,
        dynamicRows: activeBuilding.structuralLouvers.rows,
      };
      shouldUpdate = true;
    }

    if (
      activeBuilding?.fixedLouvers?.rows?.length > 0 &&
      !activeBuilding.fixedLouvers.dynamicRows
    ) {
      updates.fixedLouvers = {
        ...activeBuilding.fixedLouvers,
        dynamicRows: activeBuilding.fixedLouvers.rows,
      };
      shouldUpdate = true;
    }

    if (shouldUpdate) {
      setBuildings((prev) =>
        prev.map((building) =>
          building.id === activeBuildingId
            ? { ...building, ...updates }
            : building
        )
      );
    }
  }, [buildings, activeBuildingId]); // Only run when activeBuildingId changes or buildings structure changes
  // /* Fixed Louvers Inputs start */

  const handleDynomicFixedLouversInputs = (
    index,
    key,
    value,
    formatOnBlur = false
  ) => {
    const floatKeys = ["width", "height"];
    let finalValueToSave = value;

    if (key === "quantity") {
      if (!formatOnBlur) {
        // Remove all but digits (for live typing)
        finalValueToSave = value.replace(/[^0-9]/g, "");
      } else if (value !== "") {
        // On blur, convert to integer (or blank if invalid)
        const num = parseInt(value, 10);
        finalValueToSave = isNaN(num) ? "" : num;
      }
    } else if (floatKeys.includes(key) && !formatOnBlur) {
      finalValueToSave = restrictDecimals(value);
    } else if (floatKeys.includes(key) && formatOnBlur && value !== "") {
      const num = parseFloat(value);
      finalValueToSave = !isNaN(num) ? num.toFixed(3) : value;
    }

    setBuildings((prev) =>
      prev.map((building) => {
        if (building.id !== activeBuildingId) return building;

        const currentFixedLouvers = building.fixedLouvers || {};
        const currentOverrides = currentFixedLouvers.rowOverrides || [];
        const currentDynamicRows = currentFixedLouvers.dynamicRows || [];
        const currentManualRows = currentFixedLouvers.manualRows || [];

        const row = fixedLouversRows[index];
        if (!row) return building;
        const rowId = row.rowId;
        const overrideIndex = currentOverrides.findIndex(
          (o) => o.rowId === rowId
        );
        const dynamicIndex = currentDynamicRows.findIndex(
          (d) => d.rowId === rowId
        );

        const overrideFields = ["type", "width", "height", "quantity"];
        const isManualRow = row.isManual;

        const manualRowIndex = currentManualRows.findIndex(
          (r) => r.rowId === rowId
        );

        // --- 1. Manual Row Editing Logic (type, width, height, quantity) ---
        if (isManualRow && overrideFields.includes(key)) {
          const updatedManualRows = [...currentManualRows];

          if (manualRowIndex === -1) return building;

          updatedManualRows[manualRowIndex] = {
            ...updatedManualRows[manualRowIndex],
            [key]: finalValueToSave,
          };

          return {
            ...building,
            fixedLouvers: {
              ...currentFixedLouvers,
              manualRows: updatedManualRows,
            },
          };
        }

        // --- 2. Derived Row Override Logic (type, width, height, quantity) ---
        else if (!isManualRow && overrideFields.includes(key)) {
          const newOverride = {
            rowId: rowId,
            ...(overrideIndex !== -1 ? currentOverrides[overrideIndex] : {}),
            [key]: finalValueToSave,
          };

          let finalOverrides;

          if (overrideIndex !== -1) {
            finalOverrides = currentOverrides.map((override, idx) =>
              idx === overrideIndex ? newOverride : override
            );
          } else {
            finalOverrides = [...currentOverrides, newOverride];
          }

          return {
            ...building,
            fixedLouvers: {
              ...currentFixedLouvers,
              rowOverrides: finalOverrides,
            },
          };
        } else {
          const newDynamic = {
            rowId: rowId,
            ...(dynamicIndex !== -1 ? currentDynamicRows[dynamicIndex] : {}),
            [key]: finalValueToSave,
          };

          let finalDynamicRows;

          if (dynamicIndex !== -1) {
            finalDynamicRows = currentDynamicRows.map((dynamic, idx) =>
              idx === dynamicIndex ? newDynamic : dynamic
            );
          } else {
            finalDynamicRows = [...currentDynamicRows, newDynamic];
          }

          return {
            ...building,
            fixedLouvers: {
              ...currentFixedLouvers,
              dynamicRows: finalDynamicRows,
            },
          };
        }
      })
    );
  };

  const addFixedLouversRow = () => {
    setBuildings((prev) =>
      prev.map((b) => {
        if (b.id !== activeBuildingId) return b;

        const fixedLouvers = b.fixedLouvers || {};
        const existingManualRows = fixedLouvers.manualRows || [];

        const newRowId = `manual-${Date.now()}-${Math.floor(
          Math.random() * 1000
        )}`;

        const newRow = {
          rowId: newRowId,

          wallType: "Manual Entry",
          wall: "-",
          isManual: true,
          type: fixedLouvers.inputs?.type || "",
          width: fixedLouvers.inputs?.width || "",
          height: fixedLouvers.inputs?.height || "",
          quantity: fixedLouvers.inputs?.quantity || "",
        };
        return {
          ...b,
          fixedLouvers: {
            ...fixedLouvers,
            manualRows: [...existingManualRows, newRow],
          },
        };
      })
    );
  };

  const deleteFixedLouversRow = (indexToDelete) => {
    setBuildings((prev) =>
      prev.map((b) => {
        if (b.id !== activeBuildingId) return b;

        const fixedLouvers = b.fixedLouvers || {};
        const derivedRowsLength = fixedLouversRows.filter(
          (r) => !r.isManual
        ).length;

        // IMPORTANT: Only allow deletion of manual rows
        if (indexToDelete < derivedRowsLength) {
          console.warn("Cannot delete derived rows.");
          return b;
        }

        const manualRowIndex = indexToDelete - derivedRowsLength;
        const updatedManualRows = (fixedLouvers.manualRows || []).filter(
          (_, index) => index !== manualRowIndex
        );

        // Deleting a row shifts the indexes of all subsequent rows in the combined list,
        // which affects `dynamicRows` and `rowOverrides`. We need to handle this.

        const updatedDynamicRows = (fixedLouvers.dynamicRows || []).filter(
          (_, index) => index !== indexToDelete
        );

        const updatedRowOverrides = (fixedLouvers.rowOverrides || []).filter(
          (_, index) => index !== indexToDelete
        );

        return {
          ...b,
          fixedLouvers: {
            ...fixedLouvers,
            manualRows: updatedManualRows,
            dynamicRows: updatedDynamicRows,
            rowOverrides: updatedRowOverrides,
          },
        };
      })
    );
  };

  const handleFixedLouversDynamicHeaderChange = (columnId, value) => {
    setBuildings((prev) =>
      prev.map((b) => {
        if (b.id !== activeBuildingId) return b;

        const fixedLouvers = b.fixedLouvers || {};
        const updatedColumns = (fixedLouvers.dynamicColumns || []).map((col) =>
          col.id === columnId ? { ...col, header: value } : col
        );

        return {
          ...b,
          fixedLouvers: {
            ...fixedLouvers,
            dynamicColumns: updatedColumns,
          },
        };
      })
    );
  };
  const deleteFixedLouversColumn = (columnId) => {
    setBuildings((prev) =>
      prev.map((b) => {
        if (b.id !== activeBuildingId) return b;

        const fixedLouvers = b.fixedLouvers || {};
        const existingColumns = fixedLouvers.dynamicColumns || [];
        const existingRows = fixedLouvers.dynamicRows || [];

        const columnToDelete = existingColumns.find(
          (col) => col.id === columnId
        );
        if (!columnToDelete) return b;

        const keyToDelete = columnToDelete.key;

        const updatedColumns = existingColumns.filter(
          (col) => col.id !== columnId
        );

        const updatedRows = existingRows.map((row) => {
          const { [keyToDelete]: removed, ...restOfRow } = row;
          return restOfRow;
        });

        return {
          ...b,
          fixedLouvers: {
            ...fixedLouvers,
            dynamicColumns: updatedColumns,
            dynamicRows: updatedRows,
          },
        };
      })
    );
  };
  const addFixedLouversColumn = () => {
    setBuildings((prev) =>
      prev.map((b) => {
        if (b.id !== activeBuildingId) return b;

        const fixedLouvers = b.fixedLouvers || {};
        const existingColumns = fixedLouvers.dynamicColumns || [];
        const existingRows = fixedLouvers.dynamicRows || [];

        // Create new column definition
        const newColumn = {
          id: Date.now(),
          header: `Extra Field ${existingColumns.length + 1}`,
          key: `extraField_${existingColumns.length + 1}`,
        };

        // Add the new field key to all existing dynamic rows with an empty value
        const updatedRows = existingRows.map((row) => ({
          ...row,
          [newColumn.key]: row[newColumn.key] ?? "",
        }));

        // Check if there are base fixedLouvers rows but no existing dynamic rows (first add)
        if (updatedRows.length === 0 && fixedLouversRows.length > 0) {
          for (let i = 0; i < fixedLouversRows.length; i++) {
            updatedRows.push({ [newColumn.key]: "" });
          }
        } else if (updatedRows.length === 0 && fixedLouversRows.length === 0) {
          updatedRows.push({ id: 1, [newColumn.key]: "" });
        }

        if (updatedRows.length < fixedLouversRows.length) {
          for (let i = updatedRows.length; i < fixedLouversRows.length; i++) {
            updatedRows.push({ [newColumn.key]: "" });
          }
        }

        return {
          ...b,
          fixedLouvers: {
            ...fixedLouvers,
            dynamicColumns: [...existingColumns, newColumn],
            dynamicRows: updatedRows,
          },
        };
      })
    );
  };
  const fixedLouversInputsChange = ({
    target: { name, value },
    formatOnBlur = false,
  }) => {
    const floatFields = ["width", "height"];

    let adjustedValue = value;
    if (name === "quantity") {
      if (!formatOnBlur) {
        // Remove all except digits (for live typing)
        adjustedValue = value.replace(/[^0-9]/g, "");
      } else if (value !== "") {
        const num = parseInt(value, 10);
        adjustedValue = isNaN(num) ? "" : num;
      }
    } else if (floatFields.includes(name)) {
      if (!formatOnBlur) {
        adjustedValue = restrictDecimals(value);
      } else if (value !== "") {
        const num = parseFloat(value);
        adjustedValue = !isNaN(num) ? num.toFixed(3) : value;
      }
    }
    // if (floatFields.includes(name) && !formatOnBlur) {
    //   adjustedValue = restrictDecimals(value);
    // }
    // if (floatFields.includes(name) && formatOnBlur && value !== "") {
    //   const num = parseFloat(value);
    //   adjustedValue = !isNaN(num) ? num.toFixed(3) : value;
    // }

    setBuildings((prev) =>
      prev.map((building) => {
        if (building.id !== activeBuildingId) return building;

        const currentFixedLouvers = building.fixedLouvers || {};

        // Map input field names to row field names
        const fieldMap = {
          type: "type",
          width: "width",
          height: "height",
          quantity: "quantity",
        };

        const rowFieldName = fieldMap[name];

        let updatedOverrides = currentFixedLouvers.rowOverrides || [];

        // If this main input changed, clear the overrides for this specific field in ALL rows
        if (rowFieldName && updatedOverrides.length > 0) {
          updatedOverrides = updatedOverrides
            .map((override) => {
              // Remove this specific field from the override
              const { [rowFieldName]: removed, ...rest } = override;
              return Object.keys(rest).length > 0 ? rest : undefined;
            })
            .filter(Boolean); // Remove empty overrides
        }

        return {
          ...building,
          fixedLouvers: {
            ...currentFixedLouvers,
            inputs: {
              ...currentFixedLouvers.inputs,
              [name]: adjustedValue,
            },
            rowOverrides: updatedOverrides,
          },
        };
      })
    );
  };

  const handleDataViewModal = (payload) => {
    setBuildings((prev) =>
      prev.map((building) =>
        building.id === activeBuildingId
          ? {
              ...building,
              canopy: {
                ...building.canopy,
                inputs: payload?.canopyInputs || building.canopy?.inputs || {},
                dynamicRows:
                  payload?.dynamicCanopyRows ||
                  building.canopy?.dynamicRows ||
                  [],
              },
              frameOpening: {
                ...building.frameOpening,
                inputs:
                  payload?.frameOpeningInputs ||
                  building.frameOpening?.inputs ||
                  {},
                dynamicRows:
                  payload?.dynamicFrameOpening ||
                  building.frameOpening?.dynamicRows ||
                  [],
              },
              leanTo: {
                ...building.leanTo,
                inputs: payload?.leanToInputs || building.leanTo?.inputs || {},
                dynamicRows:
                  payload?.dynomicLeanToInputs ||
                  building.leanTo?.dynamicRows ||
                  [],
              },
              fixedLouvers: {
                ...building.fixedLouvers,
                dynamicRows:
                  payload?.dynomicFixedLouversInputs ||
                  building.fixedLouvers?.dynamicRows ||
                  [],
              },
              structuralLouvers: {
                ...building.structuralLouvers,
                inputs:
                  payload?.structuralLouversInputs ||
                  building.structuralLouvers?.inputs ||
                  {},
                dynamicRows:
                  payload?.dynomicStructuralLouversInputs ||
                  building.structuralLouvers?.dynamicRows ||
                  [],
              },
              fascia: {
                ...building.fascia,
                inputs: payload?.fasciaInputs || building.fascia?.inputs || {},
                dynamicRows:
                  payload?.dynomicfasciaInputs ||
                  building.fascia?.dynamicRows ||
                  [],
              },
            }
          : building
      )
    );
  };
  // Fixed useMemo calculations
  const getOverrideById = (overrides = [], rowId) => {
    return overrides.find((o) => o && o.rowId === rowId) || {};
  };

  const canopyRows = useMemo(() => {
    const activeBuilding = buildings.find((b) => b.id === activeBuildingId);
    if (!activeBuilding) return [];

    const getOverrideById = (arr, id) => arr.find((item) => item.rowId === id);

    const frontRows = Array.isArray(activeBuilding.front?.rows)
      ? activeBuilding.front.rows
      : [];
    const backRows = Array.isArray(activeBuilding.back?.rows)
      ? activeBuilding.back.rows
      : [];
    const leftRows = Array.isArray(activeBuilding.left?.rows)
      ? activeBuilding.left.rows
      : [];
    const rightRows = Array.isArray(activeBuilding.right?.rows)
      ? activeBuilding.right.rows
      : [];

    const baseRows = [
      ...frontRows.map((r, i) => ({
        ...r,
        wallType: "Front End Wall",
        isManual: false,
        rowId: `base-${r.local_id || i}-${r.wall}`,
      })),
      ...backRows.map((r, i) => ({
        ...r,
        wallType: "Back End Wall",
        isManual: false,
        rowId: `base-${r.local_id || i}-${r.wall}`,
      })),
      ...leftRows.map((r, i) => ({
        ...r,
        wallType: "Left Side Wall",
        isManual: false,
        rowId: `base-${r.local_id || i}-${r.wall}`,
      })),
      ...rightRows.map((r, i) => ({
        ...r,
        wallType: "Right Side Wall",
        isManual: false,
        rowId: `base-${r.local_id || i}-${r.wall}`,
      })),
    ].filter((r) => r.canopy?.toLowerCase() === "yes");

    const manualRows = (activeBuilding.canopy?.manualRows || []).map(
      (r, i) => ({
        ...r,
        isManual: true,
        rowId: r.rowId || r.id || `manual-${i}`,
      })
    );

    const combinedRows = [...baseRows, ...manualRows];

    const rowOverrides = activeBuilding.canopy?.rowOverrides || [];
    const dynamicRows = activeBuilding.canopy?.dynamicRows || [];

    return combinedRows.map((baseRow) => {
      const override = getOverrideById(rowOverrides, baseRow.rowId) || {};
      const dynamicValues = getOverrideById(dynamicRows, baseRow.rowId) || {};

      const length = baseRow.isManual
        ? baseRow.length || 0
        : baseRow.baySpacing || 0;

      // B. Base Values (Manual value or Global Input)
      const baseProjection = baseRow.isManual
        ? baseRow.projection
        : activeBuilding.canopy?.inputs?.canopyInputsProjectin;
      const baseClearHeight = baseRow.isManual
        ? baseRow.clearHeight
        : activeBuilding.canopy?.inputs?.canopyInputsClearHeight;
      const baseSoftFitSheething = baseRow.isManual
        ? baseRow.softFitSheething
        : activeBuilding.canopy?.inputs?.canopyInputsSoftFitSheeting;
      const baseGutter = baseRow.isManual
        ? baseRow.gutter
        : activeBuilding.canopy?.inputs?.canopyInputsGutter;
      const baseDownTake = baseRow.isManual
        ? baseRow.downTake
        : activeBuilding.canopy?.inputs?.canopyInputsDownTake;
      const baseKickerPipe = baseRow.isManual
        ? baseRow.kickerPipe
        : activeBuilding.canopy?.inputs?.canopyInputskickerPipe;

      // C. Final Values (Override or Base Value)
      const projection = override.projection ?? baseProjection;
      const clearHeight = override.clearHeight ?? baseClearHeight;
      const softFitSheething =
        override.softFitSheething ?? baseSoftFitSheething;
      const gutter = override.gutter ?? baseGutter;
      const downTake = override.downTake ?? baseDownTake;
      const kickerPipe = override.kickerPipe ?? baseKickerPipe;

      // D. Area Calculation
      const area = (parseFloat(length) || 0) * (parseFloat(projection) || 0);

      return {
        ...baseRow,
        ...dynamicValues,

        // Calculated / Resolved Fields
        length,
        projection,
        clearHeight,
        softFitSheething,
        gutter,
        downTake,
        kickerPipe,
        area,
      };
    });
  }, [buildings, activeBuildingId]);

  const frameOpeningRows = useMemo(() => {
    const activeBuilding = buildings.find((b) => b.id === activeBuildingId);
    if (!activeBuilding) return [];

    const frontRows = Array.isArray(activeBuilding.front?.rows)
      ? activeBuilding.front.rows
      : [];
    const backRows = Array.isArray(activeBuilding.back?.rows)
      ? activeBuilding.back.rows
      : [];
    const leftRows = Array.isArray(activeBuilding.left?.rows)
      ? activeBuilding.left.rows
      : [];
    const rightRows = Array.isArray(activeBuilding.right?.rows)
      ? activeBuilding.right.rows
      : [];

    const baseRows = [
      ...frontRows.map((r, i) => ({
        ...r,
        wallType: "Front End Wall",
        isManual: false,
        rowId: `base-${r.local_id || i}-${r.wall}`,
      })),
      ...backRows.map((r, i) => ({
        ...r,
        wallType: "Back End Wall",
        isManual: false,
        rowId: `base-${r.local_id || i}-${r.wall}`,
      })),
      ...leftRows.map((r, i) => ({
        ...r,
        wallType: "Left Side Wall",
        isManual: false,
        rowId: `base-${r.local_id || i}-${r.wall}`,
      })),
      ...rightRows.map((r, i) => ({
        ...r,
        wallType: "Right Side Wall",
        isManual: false,
        rowId: `base-${r.local_id || i}-${r.wall}`,
      })),
    ].filter((r) => r.frameOpening?.toLowerCase() === "yes");

    const manualRows = (activeBuilding.frameOpening?.manualRows || []).map(
      (r, i) => ({
        ...r,
        isManual: true,
        rowId: r.rowId || `manual-${i}`,
      })
    );

    const combined = [...baseRows, ...manualRows];

    const rowOverrides = activeBuilding.frameOpening?.rowOverrides || [];
    const dynamicRows = activeBuilding.frameOpening?.dynamicRows || [];

    return combined.map((row) => {
      const override = getOverrideById(rowOverrides, row.rowId) || {};
      const dynamic = getOverrideById(dynamicRows, row.rowId) || {};

      // 1. Override Bay Spacing
      let baySpacingValue = override.baySpacing ?? row.baySpacing;
      const baySpacing = parseFloat(baySpacingValue) || 0;

      // 2. Override Width
      let widthValue =
        override.width ??
        (row.isManual
          ? row.width
          : activeBuilding.frameOpening.inputs?.frameOpeningInputsWidth);

      let validatedWidth = parseFloat(widthValue) || 0;

      if (validatedWidth > baySpacing) {
        validatedWidth = baySpacing;
        widthValue = baySpacing.toFixed(3);
      } else {
        widthValue = override.width ?? widthValue;
      }

      // 4. Override Height
      let heightValue =
        override.height ??
        (row.isManual
          ? row.height
          : activeBuilding.frameOpening.inputs?.frameOpeningInputsHeight);

      // 5. Area Calculation
      const area = validatedWidth * (parseFloat(heightValue) || 0);

      return {
        ...row,
        ...dynamic,
        width: widthValue,
        height: heightValue,
        baySpacing: baySpacingValue,
        area: area,
      };
    });
  }, [buildings, activeBuildingId]);

  const leanToRows = useMemo(() => {
    const activeBuilding = buildings.find((b) => b.id === activeBuildingId);
    if (!activeBuilding) return [];

    const frontRows = Array.isArray(activeBuilding.front?.rows)
      ? activeBuilding.front.rows
      : [];
    const backRows = Array.isArray(activeBuilding.back?.rows)
      ? activeBuilding.back.rows
      : [];
    const leftRows = Array.isArray(activeBuilding.left?.rows)
      ? activeBuilding.left.rows
      : [];
    const rightRows = Array.isArray(activeBuilding.right?.rows)
      ? activeBuilding.right.rows
      : [];

    const baseRows = [
      ...frontRows.map((r, i) => ({
        ...r,
        wallType: "Front End Wall",
        isManual: false,
        rowId: `base-${r.local_id || i}-${r.wall}`,
      })),
      ...backRows.map((r, i) => ({
        ...r,
        wallType: "Back End Wall",
        isManual: false,
        rowId: `base-${r.local_id || i}-${r.wall}`,
      })),
      ...leftRows.map((r, i) => ({
        ...r,
        wallType: "Left Side Wall",
        isManual: false,
        rowId: `base-${r.local_id || i}-${r.wall}`,
      })),
      ...rightRows.map((r, i) => ({
        ...r,
        wallType: "Right Side Wall",
        isManual: false,
        rowId: `base-${r.local_id || i}-${r.wall}`,
      })),
    ].filter((r) => r.leanTo?.toLowerCase() === "yes");

    const getOverrideById = (arr, id) => arr.find((item) => item.rowId === id);

    const manualRows = (activeBuilding.leanTo?.manualRows || []).map(
      (r, i) => ({
        ...r,
        isManual: true,
        rowId: r.rowId || `manual-${i}`,
      })
    );

    const combined = [...baseRows, ...manualRows];

    const rowOverrides = activeBuilding.leanTo?.rowOverrides || [];
    const dynamicRows = activeBuilding.leanTo?.dynamicRows || [];

    const defaultInputs = activeBuilding.leanTo.inputs || {};

    return combined.map((row) => {
      const override = getOverrideById(rowOverrides, row.rowId) || {};
      const dynamic = getOverrideById(dynamicRows, row.rowId) || {};

      const baseLength = row.isManual ? row.length : row.baySpacing;
      const baseWidth = row.isManual
        ? row.width
        : defaultInputs?.leanToInputsWidth;

      const length = override.length ?? baseLength;

      const width = override.width ?? baseWidth;

      const clearHeight =
        override.clearHeight ??
        (row.isManual
          ? row.clearHeight
          : defaultInputs?.leanToInputsClearHight);
      const blockWall =
        override.blockWall ??
        (row.isManual ? row.blockWall : defaultInputs?.leanToInputsBlockWall);
      const slope =
        override.slope ??
        (row.isManual ? row.slope : defaultInputs?.leanToInputsSlope);
      const apron =
        override.apron ??
        (row.isManual ? row.apron : defaultInputs?.leanToInputsApron);
      const downTake =
        override.downTake ??
        (row.isManual ? row.downTake : defaultInputs?.leanToInputsDowntake);
      const gutter =
        override.gutter ??
        (row.isManual ? row.gutter : defaultInputs?.leanToInputsGutter);
      const girtCondition =
        override.girtCondition ??
        (row.isManual
          ? row.girtCondition
          : defaultInputs?.leanToInputsGirtcondition);

      const area = (parseFloat(length) || 0) * (parseFloat(width) || 0);

      return {
        ...row,
        ...dynamic,
        length,
        width,
        clearHeight,
        blockWall,
        slope,
        apron,
        downTake,
        gutter,
        girtCondition,
        area,
      };
    });
  }, [buildings, activeBuildingId]);

  const fixedLouversRows = useMemo(() => {
    const activeBuilding = buildings.find((b) => b.id === activeBuildingId);
    if (!activeBuilding) return [];

    const frontRows = Array.isArray(activeBuilding.front?.rows)
      ? activeBuilding.front.rows
      : [];
    const backRows = Array.isArray(activeBuilding.back?.rows)
      ? activeBuilding.back.rows
      : [];
    const leftRows = Array.isArray(activeBuilding.left?.rows)
      ? activeBuilding.left.rows
      : [];
    const rightRows = Array.isArray(activeBuilding.right?.rows)
      ? activeBuilding.right.rows
      : [];

    const baseRows = [
      ...frontRows.map((r, i) => ({
        ...r,
        wallType: "Front End Wall",
        isManual: false,
        rowId: `base-${r.local_id || i}-${r.wall}`,
      })),
      ...backRows.map((r, i) => ({
        ...r,
        wallType: "Back End Wall",
        isManual: false,
        rowId: `base-${r.local_id || i}-${r.wall}`,
      })),
      ...leftRows.map((r, i) => ({
        ...r,
        wallType: "Left Side Wall",
        isManual: false,
        rowId: `base-${r.local_id || i}-${r.wall}`,
      })),
      ...rightRows.map((r, i) => ({
        ...r,
        wallType: "Right Side Wall",
        isManual: false,
        rowId: `base-${r.local_id || i}-${r.wall}`,
      })),
    ].filter((r) => r.fixedLouvers?.toLowerCase() === "yes");

    const getOverrideById = (arr, id) => arr.find((item) => item.rowId === id);

    const manualRows = (activeBuilding.fixedLouvers?.manualRows || []).map(
      (r, i) => ({
        ...r,
        wallType: r.wallType || "Manual Entry", // default override
        wall: r.wall || "-", // default override
        isManual: true,
        rowId: r.rowId || `manual-${i}`,
      })
    );

    const combined = [...baseRows, ...manualRows];

    const rowOverrides = activeBuilding.fixedLouvers?.rowOverrides || [];
    const dynamicRows = activeBuilding.fixedLouvers?.dynamicRows || [];

    return combined.map((row) => {
      const override = getOverrideById(rowOverrides, row.rowId) || {};
      const dynamic = getOverrideById(dynamicRows, row.rowId) || {};

      const baseType = row.isManual
        ? row.type
        : activeBuilding.fixedLouvers.inputs?.type;
      const baseWidth = row.isManual
        ? row.width
        : activeBuilding.fixedLouvers.inputs?.width;
      const baseHeight = row.isManual
        ? row.height
        : activeBuilding.fixedLouvers.inputs?.height;
      const baseQuantity = row.isManual
        ? row.quantity
        : activeBuilding.fixedLouvers.inputs?.quantity;

      const type = override.type ?? baseType;

      const width = override.width ?? baseWidth;

      const height = override.height ?? baseHeight;

      const quantity = override.quantity ?? baseQuantity;

      const area =
        (parseFloat(width) || 0) *
        (parseFloat(height) || 0) *
        (parseFloat(quantity) || 0);

      return {
        ...row,
        ...dynamic,
        type,
        width,
        height,
        quantity,
        area,
      };
    });
  }, [buildings, activeBuildingId]);

  const structuralLouversRows = useMemo(() => {
    const activeBuilding = buildings.find((b) => b.id === activeBuildingId);
    if (!activeBuilding) return [];

    const frontRows = Array.isArray(activeBuilding.front?.rows)
      ? activeBuilding.front.rows
      : [];
    const backRows = Array.isArray(activeBuilding.back?.rows)
      ? activeBuilding.back.rows
      : [];
    const leftRows = Array.isArray(activeBuilding.left?.rows)
      ? activeBuilding.left.rows
      : [];
    const rightRows = Array.isArray(activeBuilding.right?.rows)
      ? activeBuilding.right.rows
      : [];

    const baseRows = [
      ...frontRows.map((r, i) => ({
        ...r,
        wallType: "Front End Wall",
        isManual: false,
        rowId: `base-${r.local_id || i}-${r.wall}`,
      })),
      ...backRows.map((r, i) => ({
        ...r,
        wallType: "Back End Wall",
        isManual: false,
        rowId: `base-${r.local_id || i}-${r.wall}`,
      })),
      ...leftRows.map((r, i) => ({
        ...r,
        wallType: "Left Side Wall",
        isManual: false,
        rowId: `base-${r.local_id || i}-${r.wall}`,
      })),
      ...rightRows.map((r, i) => ({
        ...r,
        wallType: "Right Side Wall",
        isManual: false,
        rowId: `base-${r.local_id || i}-${r.wall}`,
      })),
    ].filter((r) => r.structuralLouvers?.toLowerCase() === "yes");

    const manualRows = (activeBuilding.structuralLouvers?.manualRows || []).map(
      (r, i) => ({
        ...r,
        isManual: true,
        rowId: r.rowId || r.id || `manual-${i}`,
      })
    );

    const combined = [...baseRows, ...manualRows];

    const rowOverrides = activeBuilding.structuralLouvers?.rowOverrides || [];
    const dynamicRows = activeBuilding.structuralLouvers?.dynamicRows || [];

    const getOverrideById = (arr, id) => arr.find((item) => item.rowId === id);

    return combined.map((row) => {
      const override = getOverrideById(rowOverrides, row.rowId) || {};
      const dynamic = getOverrideById(dynamicRows, row.rowId) || {};

      // 1. Length Logic: Manual row length (row.length) or Derived row length (row.baySpacing)
      const length = row.isManual ? row.length : row.baySpacing;

      // 2. Base Values for Overridable fields (Manual value or Global Input)
      const baseProjectin = row.isManual
        ? row.projectin
        : activeBuilding.structuralLouvers.inputs
            ?.structuralLouversInputsProjectin;
      const baseHeight = row.isManual
        ? row.height
        : activeBuilding.structuralLouvers.inputs
            ?.structuralLouversInputsHeight;
      const baseMesh = row.isManual
        ? row.mesh
        : activeBuilding.structuralLouvers.inputs?.structuralLouversInputsMesh;
      const baseNoOfFins = row.isManual
        ? row.noOfFins
        : activeBuilding.structuralLouvers.inputs
            ?.structuralLouversInputsNoOffins;

      const projectin = override.projectin ?? baseProjectin;
      const height = override.height ?? baseHeight;
      const mesh = override.mesh ?? baseMesh;
      const noOfFins = override.noOfFins ?? baseNoOfFins;

      const area = (parseFloat(length) || 0) * (parseFloat(height) || 0);

      return {
        ...row,
        ...dynamic,
        length,
        projectin,
        height,
        mesh,
        noOfFins,
        area,
      };
    });
  }, [buildings, activeBuildingId]);

  const fasciaRows = useMemo(() => {
    const activeBuilding = buildings.find((b) => b.id === activeBuildingId);
    if (!activeBuilding) return [];

    const frontRows = Array.isArray(activeBuilding.front?.rows)
      ? activeBuilding.front.rows
      : [];
    const backRows = Array.isArray(activeBuilding.back?.rows)
      ? activeBuilding.back.rows
      : [];
    const leftRows = Array.isArray(activeBuilding.left?.rows)
      ? activeBuilding.left.rows
      : [];
    const rightRows = Array.isArray(activeBuilding.right?.rows)
      ? activeBuilding.right.rows
      : [];

    const baseRows = [
      ...frontRows.map((r, i) => ({
        ...r,
        wallType: "Front End Wall",
        isManual: false,
        rowId: `base-${r.local_id || i}-${r.wall}`,
      })),
      ...backRows.map((r, i) => ({
        ...r,
        wallType: "Back End Wall",
        isManual: false,
        rowId: `base-${r.local_id || i}-${r.wall}`,
      })),
      ...leftRows.map((r, i) => ({
        ...r,
        wallType: "Left Side Wall",
        isManual: false,
        rowId: `base-${r.local_id || i}-${r.wall}`,
      })),
      ...rightRows.map((r, i) => ({
        ...r,
        wallType: "Right Side Wall",
        isManual: false,
        rowId: `base-${r.local_id || i}-${r.wall}`,
      })),
    ].filter((r) => r.fascia?.toLowerCase() === "yes");

    const manualRows = (activeBuilding.fascia?.manualRows || []).map(
      (r, i) => ({
        ...r,
        isManual: true,
        rowId: r.rowId || r.id || `manual-${i}`,
      })
    );

    const combined = [...baseRows, ...manualRows];

    const rowOverrides = activeBuilding.fascia?.rowOverrides || [];
    const dynamicRows = activeBuilding.fascia?.dynamicRows || [];
    return combined.map((row) => {
      const override = getOverrideById(rowOverrides, row.rowId) || {};
      const dynamic = getOverrideById(dynamicRows, row.rowId) || {};
      const length = row.isManual ? row.length : row.baySpacing;
      const baseHeight = row.isManual
        ? row.height
        : activeBuilding.fascia.inputs?.fasciaInputsHeight;

      const height = override.height ?? baseHeight;

      const basePurlinCondition = row.isManual
        ? row.purlinCondition
        : activeBuilding.fascia.inputs?.fasciaInputsPurlinCondition;

      const purlinCondition = override.purlinCondition ?? basePurlinCondition;

      const area = (parseFloat(length) || 0) * (parseFloat(height) || 0);

      return {
        ...row,
        ...dynamic,
        length,
        height,
        purlinCondition,
        area,
      };
    });
  }, [buildings, activeBuildingId]);

  useEffect(() => {
    const activeBuilding = buildings.find((b) => b.id === activeBuildingId);
    if (!activeBuilding) return;

    // Check if any rows actually changed to avoid unnecessary updates
    const shouldUpdate =
      JSON.stringify(activeBuilding.canopy?.rows) !==
        JSON.stringify(canopyRows) ||
      JSON.stringify(activeBuilding.frameOpening?.rows) !==
        JSON.stringify(frameOpeningRows) ||
      JSON.stringify(activeBuilding.leanTo?.rows) !==
        JSON.stringify(leanToRows) ||
      JSON.stringify(activeBuilding.fixedLouvers?.rows) !==
        JSON.stringify(fixedLouversRows) ||
      JSON.stringify(activeBuilding.structuralLouvers?.rows) !==
        JSON.stringify(structuralLouversRows) ||
      JSON.stringify(activeBuilding.fascia?.rows) !==
        JSON.stringify(fasciaRows);

    if (shouldUpdate) {
      setBuildings((prev) =>
        prev.map((building) =>
          building.id === activeBuildingId
            ? {
                ...building,
                canopy: {
                  ...building.canopy,
                  rows: Array.isArray(canopyRows) ? canopyRows : [],
                },
                frameOpening: {
                  ...building.frameOpening,
                  rows: Array.isArray(frameOpeningRows) ? frameOpeningRows : [],
                },
                leanTo: {
                  ...building.leanTo,
                  rows: Array.isArray(leanToRows) ? leanToRows : [],
                },
                fixedLouvers: {
                  ...building.fixedLouvers,
                  rows: Array.isArray(fixedLouversRows) ? fixedLouversRows : [],
                },
                structuralLouvers: {
                  ...building.structuralLouvers,
                  rows: Array.isArray(structuralLouversRows)
                    ? structuralLouversRows
                    : [],
                },
                fascia: {
                  ...building.fascia,
                  rows: Array.isArray(fasciaRows) ? fasciaRows : [],
                },
              }
            : building
        )
      );
    }
  }, [
    canopyRows,
    frameOpeningRows,
    leanToRows,
    fixedLouversRows,
    structuralLouversRows,
    fasciaRows,
    activeBuildingId,
    buildings,
    // REMOVED: buildings
  ]);

  // for indvidual total are caluclations

  const updateSubtotal = (buildingId, key, subtotal) => {
    setBuildings((prev) =>
      prev.map((b) => {
        if (b.id !== buildingId) return b;

        return {
          ...b,
          [key]: subtotal, // ex: canopySubtotal, frameOpeningSubtotal
        };
      })
    );
  };

  useEffect(() => {
    const active = buildings.find((b) => b.id === activeBuildingId);
    if (!active) return;

    // 1. Calculate all subtotals
    const subtotals = {
      canopySubtotal: canopyRows.reduce((sum, r) => sum + (r.area || 0), 0),
      frameOpeningSubtotal: frameOpeningRows.reduce(
        (sum, r) => sum + (r.area || 0),
        0
      ),
      leanToSubtotal: leanToRows.reduce((sum, r) => sum + (r.area || 0), 0),
      fixedLouversSubtotal: fixedLouversRows.reduce(
        (sum, r) => sum + (r.area || 0),
        0
      ),
      structuralLouversSubtotal: structuralLouversRows.reduce(
        (sum, r) => sum + (r.area || 0),
        0
      ),
      fasciaSubtotal: fasciaRows.reduce((sum, r) => sum + (r.area || 0), 0),
    };

    // 2. Update only changed subtotals
    Object.entries(subtotals).forEach(([key, value]) => {
      if (active[key] !== value) {
        updateSubtotal(activeBuildingId, key, value);
      }
    });

    // eslint-disable-next-line
  }, [
    activeBuildingId,
    canopyRows,
    frameOpeningRows,
    leanToRows,
    fixedLouversRows,
    structuralLouversRows,
    fasciaRows,
  ]);

  const [getOverallBuildingArea, setOverallBuildingArea] = useState();

  //NUBER OF BUILDING STRAT
  const calculateBuildingTotalArea = (b) => {
    const base = Number(b.buildingArea) || 0;
    let newTotal = base;

    const components = [
      "canopy",
      "frameOpening",
      "leanTo",
      "fixedLouvers",
      "structuralLouvers",
      "blockWall",
      "bracing",
      "fascia",
      "partitionWall",
      "mezzanine",
    ];

    components.forEach((key) => {
      const flagKey = "include" + key.charAt(0).toUpperCase() + key.slice(1);
      const subtotalKey = key + "Subtotal";

      if (b[flagKey]) {
        newTotal += Number(b[subtotalKey] || 0);
      }
    });

    return newTotal;
  };

  const useMezzanineSubtotal = (mezzanineData) => {
    // eslint-disable-next-line
    const mezzanineDetails = mezzanineData?.mezzanineDetails || [];

    return useMemo(() => {
      return mezzanineDetails.reduce((sum, details) => {
        const width = parseFloat(details.width || 0);
        const length = parseFloat(details.length || 0);
        const floors = parseFloat(details.noOfmezzaninefloor || 1);

        const area = width > 0 && length > 0 ? floors * width * length : 0;

        return sum + area;
      }, 0);
    }, [mezzanineDetails]);
  };

  const activeBuilding = buildings.find((b) => b.id === activeBuildingId);
  const mezzanineSubtotal = useMezzanineSubtotal(activeBuilding?.mezzanineData);
  const partitionWallSubtotal = useMemo(() => {
    const partitionDetails =
      activeBuilding?.partitionWallData?.partitionDetails || [];
    return partitionDetails.reduce((sum, item) => {
      const width = parseFloat(item.width || 0);
      const length = parseFloat(item.length || 0);

      const area = width > 0 && length > 0 ? width * length : 0;

      return sum + area;
    }, 0);
  }, [activeBuilding?.partitionWallData?.partitionDetails]);

  // --- 2. State Update Effect (Saves Subtotals to State) ---

  useEffect(() => {
    if (!activeBuildingId || !activeBuilding) return;

    let subtotalChanged = false;
    let updatedMezzanineSubtotal = activeBuilding.mezzanineSubtotal;
    let updatedPartitionWallSubtotal = activeBuilding.partitionWallSubtotal;

    // Check and update Mezzanine subtotal
    if (Number(activeBuilding.mezzanineSubtotal) !== mezzanineSubtotal) {
      updatedMezzanineSubtotal = mezzanineSubtotal;
      subtotalChanged = true;
    }

    // Check and update Partition Wall subtotal
    if (
      Number(activeBuilding.partitionWallSubtotal) !== partitionWallSubtotal
    ) {
      updatedPartitionWallSubtotal = partitionWallSubtotal;
      subtotalChanged = true;
    }

    // Update state only if a subtotal has changed
    if (subtotalChanged) {
      setBuildings((prev) =>
        prev.map((b) => {
          if (b.id === activeBuildingId) {
            let updatedBuilding = {
              ...b,
              mezzanineSubtotal: updatedMezzanineSubtotal,
              partitionWallSubtotal: updatedPartitionWallSubtotal,
            };

            // Recalculate total area using the helper function
            updatedBuilding.totalArea =
              calculateBuildingTotalArea(updatedBuilding);

            return updatedBuilding;
          }
          return b;
        })
      );
    }
  }, [
    mezzanineSubtotal,
    partitionWallSubtotal,
    activeBuildingId,
    activeBuilding,
    setBuildings, // Ensure setBuildings is included if it's from context/props
  ]);

  //NUBER OF BUILDING STRATS
  const handleCheckboxToggle = (buildingId, type, checked) => {
    setBuildings((prev) => {
      const updated = prev.map((b) => {
        if (b.id !== buildingId) return b;

        const base = Number(b.buildingArea) || 0;

        // 1. Define the map of subtotal values from the current building object (b)
        const subtotalMap = {
          canopy: Number(b.canopySubtotal || 0),
          frameOpening: Number(b.frameOpeningSubtotal || 0),
          leanTo: Number(b.leanToSubtotal || 0),
          fixedLouvers: Number(b.fixedLouversSubtotal || 0),
          structuralLouvers: Number(b.structuralLouversSubtotal || 0),
          blockWall: Number(b.blockWallSubtotal || 0),
          bracing: Number(b.bracingSubtotal || 0),
          fascia: Number(b.fasciaSubtotal || 0),

          // 👈 Include the area subtotal from the building object (b)
          partitionWall: Number(b.partitionWallSubtotal || 0),
          mezzanine: Number(b.mezzanineSubtotal || 0),
        };

        // 2. Determine the key for the inclusion flag and update it
        const includeKey =
          "include" + type.charAt(0).toUpperCase() + type.slice(1);

        const updatedBuilding = {
          ...b,
          [includeKey]: checked, // Set the new state (true/false)
        };

        // 3. Recalculate total area based on the new flag state
        let newTotal = base;

        Object.keys(subtotalMap).forEach((key) => {
          const flagKey =
            "include" + key.charAt(0).toUpperCase() + key.slice(1);

          // Check if the component has an area subtotal AND its include flag is set to true on the UPDATED object
          if (updatedBuilding[flagKey] && subtotalMap[key] > 0) {
            newTotal += subtotalMap[key];
          }
        });

        updatedBuilding.totalArea = newTotal;

        return updatedBuilding;
      });

      // 4. Calculate and set the overall total area for all buildings
      const overall = updated.reduce(
        (sum, b) => sum + Number(b.totalArea || 0),
        0
      );
      setOverallBuildingArea(overall);

      return updated;
    });
  };
  useEffect(() => {
    const overall = buildings.reduce(
      (sum, b) => sum + Number(b.totalArea || b.buildingArea || 0),
      0
    );
    setOverallBuildingArea(overall);
  }, [buildings]);

  const handleBuildingCountChange = (count) => {
    setBuildings((prev) => {
      // Ensure count doesn't exceed 10
      const actualCount = Math.min(Math.max(1, count), 50);

      if (actualCount > prev.length) {
        // Add new buildings
        const newBuildings = [...prev];
        for (let i = prev.length; i < actualCount; i++) {
          newBuildings.push({
            id: i + 1,
            buildingId: i + 1,
            buildingTypes: "",
            buildingTypesCode: "",
            buildingTypesDesc: "",
            buildingStructure: "",
            buildingStructureCode: "",
            buildingStructureDesc: "",
            design: "",
            designCode: "",
            designDesc: "",
            designLoad: {
              deadLoad: "0.1+sw",
              liveLoad: "0.57",
              solarLoad: "0",
              windLoad: "120 KMPH",
            },
            designStandards: {
              codesApplicable: "AISC-10-ASD, MBMA2012",
              windLoadCalculation: "IS 875 Part 3-2015",
              windLoadApplication: "MBMA-2012 ",
              seismicLoad: "IS 1893-2016,Zone-II",
            },
            deflectionCriteria: {
              mainFramesSway: "H/500",
              mainFrameDeflection: "L/360",
            },
            minimumThickness: {
              mainFrame: "4mm",
              crSections: "1.5mm",
            },

            front: {
              meters: "",
              bays: "",
              buildingInputs: "",
              blockWallHeight: "",
              rows: [],
            },
            back: {
              meters: "",
              bays: "",
              buildingInputs: "",
              blockWallHeight: "",
              rows: [],
            },
            left: {
              meters: "",
              bays: "",
              buildingInputs: "",
              blockWallHeight: "",
              rows: [],
            },
            right: {
              meters: "",
              bays: "",
              buildingInputs: "",
              blockWallHeight: "",
              rows: [],
            },
            additionalComponents: {
              leanTo: false,
              canopy: false,
              frameOpening: false,
              partitionWall: false,
              ridgeVentilator: false,
              turboFans: false,
              cageLadder: false,
              craneBeam: false,
              mezzanine: false,
              fascia: false,
              louvers: false,
              structuralLouver: false,
              industrialLouver: false,
              staircase: false,
              handrail: false,
              hotRolled: false,
              others: false,
              builtUpMembers: true,
              leftSideWall: true,
              rightSideWall: true,
              frontEndWall: true,
              backEndWall: true,
              roof01: true,
              roof02: true,
              pipeStrut: true,
              pipeBracing: true,
              hr: true,
              portalBracing: true,
              selectedCases: {},
              selectedCaseObject: {
                caseTypeCode: "",
                caseTypeDiscription: "",
                width: "",
                clearHeightLSW: "",
                clearHeightRSW: "",
                eaveHeightLSW: "",
                eaveHeightRSW: "",
                ridgeHeight: "",
                numberOfBays: "",
                partitionWall: "",
                staircase: "",
                roofMonitor: "",
                cageLadder: "",
              },
            },
            // All component states
            canopy: {
              inputs: {
                canopyInputsSoftFitSheeting: "Yes",
                canopyInputsSoftFitSheetingCode: "YES",
                canopyInputsSoftFitSheetingDisc: "Yes",
                canopyInputsGutter: "No",
                canopyInputsGutterCode: "NO",
                canopyInputsGutterDisc: "No",
                canopyInputskickerPipe: "No",
                canopyInputskickerPipeCode: "NO",
                canopyInputskickerPipeDisc: "No",
              },
              rows: [],
              dynamicRows: [],
            },
            frameOpening: {
              inputs: {},
              rows: [],
              dynamicRows: [],
            },
            leanTo: {
              inputs: {
                leanToInputsGirtcondition: "Bypass",
                leanToInputsGirtconditionCode: "BYPASS",
                leanToInputsGirtconditionDisc: "Bypass",
                leanToInputsGutter: "Yes",
                leanToInputsGutterCode: "YES",
                leanToInputsGutterDisc: "Yes",
              },
              rows: [],
              dynamicRows: [],
            },
            fixedLouvers: {
              rows: [],
              dynamicRows: [],
            },
            structuralLouvers: {
              inputs: {},
              rows: [],
              dynamicRows: [],
            },
            fascia: {
              inputs: {},
              rows: [],
              dynamicRows: [],
            },
            // File attachments
            scopeOfwork: "",
            drawing: "",
            // Visibility states
            isCardVisible2: true,
            isCardVisible3: true,
            isCardVisible4: true,
            isCardVisible5: true,
            isCardVisible8: true,
            copyFrontToBack: false,
            copyLeftToRight: false,
            buildingCaseType: [],
            partitionWallData: {
              gridlineFromInput1: {},
              gridlineFromInput2: {},
            },
            craneData: {
              noofCranes: 1,
              craneDetails: [],
            },
            cageLadderInputs: {},
            staircaseInputs: {},
            mezzanineData: {
              noOfmezzanines: 1,
              mezzanineDetails: [],
            },
            roofMonitorInputs: {},
          });
        }
        return newBuildings;
      } else if (actualCount < prev.length) {
        // Remove extra buildings - use the actual prev buildings, not empty ones
        const updatedBuildings = prev.slice(0, actualCount);

        // If we're removing the active building, set the first one as active
        if (!updatedBuildings.find((b) => b.id === activeBuildingId)) {
          setActiveBuildingId(updatedBuildings[0]?.id || 1);
        }

        return updatedBuildings;
      }

      return prev;
    });
  };
  //NUMBER OF BUILDIN END

  //FEW === BEW START

  /*   useEffect(
    () => {
      setBuildings((prevBuildings) =>
        prevBuildings.map((building) => {
          if (!building.copyFrontToBack) return building;

          const front = building.front || {};
          const back = building.back || {};

          const bays = Number(front.bays) || 0;
          const meters = Number(front.meters) || 0;
          const spacing = bays > 0 && meters ? meters / bays : "";

          if (!bays || bays < 1) return building;

          // ✅ start number should be next one
          const startNumber = bays + 1;

          // ✅ skip I and O
          const skipLetters = ["I", "O"];
          const letters = [];
          for (let i = 65; i <= 90; i++) {
            const char = String.fromCharCode(i);
            if (!skipLetters.includes(char)) letters.push(char);
          }

          const indexToLetter = (index) => {
            const len = letters.length;
            const start = letters[index % len];
            const end = letters[(index + 1) % len];
            return `${start}-${end}`;
          };

          const existingRows = back.rows || [];

          const rows = Array.from({ length: bays }, (_, i) => {
            const letterPair = indexToLetter(i);
            const frontRow = front.rows?.[i] || {};
            const backRow = existingRows[i] || {};

            return {
              ...backRow,
              local_id: i + 1,
              wall: `${startNumber}/${letterPair}`, // ✅ main fix here
              baySpacing:
                frontRow.baySpacing ||
                (spacing ? spacing.toFixed(3) : backRow.baySpacing || ""),
              blockWallHeight:
                frontRow.blockWallHeight ||
                front.blockWallHeight ||
                backRow.blockWallHeight ||
                "",
              purlinGirtCondition:
                frontRow.purlinGirtCondition ||
                front.purlinGirtCondition ||
                backRow.purlinGirtCondition ||
                "Bypass",
              typeOfBracing:
                frontRow.typeOfBracing ||
                front.typeOfBracing ||
                backRow.typeOfBracing ||
                "Nill",
            };
          });

          const updatedBuilding = {
            ...building,
            back: {
              ...back,
              meters: front.meters || "",
              bays: front.bays || "",
              blockWallHeight: front.blockWallHeight || "",
              purlinGirtCondition: front.purlinGirtCondition || "",
              typeOfBracing: front.typeOfBracing || "",
              buildingInputs: front.buildingInputs || "",
              rows,
            },
          };

          return updatedBuilding;
        })
      );
    },
    // eslint-disable-next-line
    [
      // eslint-disable-next-line
      JSON.stringify(
        buildings.map((b) => ({
          id: b.id,
          copyFrontToBack: b.copyFrontToBack,
          front: b.front,
        }))
      ),
    ]
  ); */
 useEffect(() => {
  setBuildings((prevBuildings) =>
    prevBuildings.map((building) => {
      const front = building.front || {};
      const back = building.back || {};
      const left = building.left || {};

      const frontBays = Number(front.bays) || 0;
      const leftBays = Number(left.bays) || 0;
      const meters = Number(front.meters) || 0;
      const spacing = frontBays > 0 && meters ? meters / frontBays : "";

      let finalRows = back.rows || [];

      // ------------------------------------------
      // 1️⃣ FRONT → BACK (only when checkbox true)
      // ------------------------------------------
      if (building.copyFrontToBack && frontBays > 0) {
        const startNumber = frontBays + 1;

        finalRows = Array.from({ length: frontBays }, (_, i) => {
          const frontRow = front.rows?.[i] || {};
          const backRow = finalRows[i] || {};

          const start = getColumnLabel(i);
          const end = getColumnLabel(i + 1);

          return {
            ...backRow,
            local_id: i + 1,
            wall: `${startNumber}/${start}-${end}`,
            baySpacing:
              frontRow.baySpacing ||
              (spacing ? spacing.toFixed(3) : backRow.baySpacing || ""),
            blockWallHeight:
              frontRow.blockWallHeight ||
              front.blockWallHeight ||
              backRow.blockWallHeight ||
              "",
            purlinGirtCondition:
              frontRow.purlinGirtCondition ||
              front.purlinGirtCondition ||
              backRow.purlinGirtCondition ||
              "Bypass",
            typeOfBracing:
              frontRow.typeOfBracing ||
              front.typeOfBracing ||
              backRow.typeOfBracing ||
              "Nill",
          };
        });
      }

      // ----------------------------------------------------
      // 2️⃣ LEFT BAYS → ONLY NUMBER PART OVERRIDE
      // ----------------------------------------------------
      if (leftBays > 0 && finalRows.length > 0) {
        const newStart = leftBays + 1;

        finalRows = finalRows.map((row, i) => {
          const letterPart =
            row.wall?.split("/")[1] ||
            `${getColumnLabel(i)}-${getColumnLabel(i + 1)}`;

          return {
            ...row,
            wall: `${newStart}/${letterPart}`,
          };
        });
      }

      return {
        ...building,
        back: {
          ...back,
          rows: finalRows,
        },
      };
    })
  );
  // eslint-disable-next-line
}, [
    // eslint-disable-next-line
  JSON.stringify(
    buildings.map((b) => ({
      id: b.id,
      copy: b.copyFrontToBack,
      front: b.front,
      leftBays: b.left?.bays,
    }))
  ),
]);


  // Checkbox handler
const getColumnLabel = (num) => {
  const validChars = "ABCDEFGHJKLMNPQRSTUVWXYZ"; // No I, No O
  const base = validChars.length;
  let label = "";

  let n = num + 1; // 1-based index
  while (n > 0) {
    const rem = (n - 1) % base;
    label = validChars[rem] + label;
    n = Math.floor((n - 1) / base);
  }
  return label;
};

  const handleCopyFrontToBackChange = (e, buildingId) => {
  const checked = e.target.checked;

  setBuildings((prevBuildings) =>
    prevBuildings.map((building) => {
      if (building.id !== buildingId) return building;

      const front = building.front || {};
      const back = building.back || {};

      if (!checked) {
        return {
          ...building,
          copyFrontToBack: false,
          back: { ...back },
        };
      }

      const bays = Number(front.bays) || 0;
      const meters = Number(front.meters) || 0;
      const spacing = bays > 0 && meters ? meters / bays : "";

      //  Correct Excel-style last letter
      const lastLetter = getColumnLabel(bays - 1);
      const lastLetterNumber = bays; // numeric only, avoid reverse calc

      const existingRows = back.rows || [];

      const rows = Array.from({ length: bays }, (_, i) => {
        const start = getColumnLabel(i);
        const end = getColumnLabel(i + 1);

        const frontRow = front.rows?.[i] || {};
        const backRow = existingRows[i] || {};

        return {
          ...backRow,
          local_id: i + 1,
          wall: `${lastLetterNumber}/${start}-${end}`,
          baySpacing:
            spacing ? spacing.toFixed(3) : backRow.baySpacing || "",
          blockWallHeight:
            frontRow.blockWallHeight ||
            front.blockWallHeight ||
            backRow.blockWallHeight ||
            "",
          purlinGirtCondition:
            frontRow.purlinGirtCondition ||
            front.purlinGirtCondition ||
            backRow.purlinGirtCondition ||
            "",
          typeOfBracing:
            frontRow.typeOfBracing ||
            front.typeOfBracing ||
            backRow.typeOfBracing ||
            "",
        };
      });

      return {
        ...building,
        copyFrontToBack: true,
        back: {
          ...back,
          meters: front.meters || back.meters || "",
          bays: front.bays || back.bays || "",
          blockWallHeight:
            front.blockWallHeight || back.blockWallHeight || "",
          purlinGirtCondition:
            front.purlinGirtCondition || back.purlinGirtCondition || "",
          typeOfBracing:
            front.typeOfBracing || back.typeOfBracing || "",
          buildingInputs:
            front.buildingInputs || back.buildingInputs || "",
          rows,
          lastLetter,
          lastLetterNumber,
        },
      };
    })
  );
};

  //FEW = BEW ENd

  //  LSW = RSW Start
  useEffect(() => {
    setBuildings((prevBuildings) =>
      prevBuildings.map((building) => {
        if (building.id !== 1) return building; // only for first building
        if (!building.copyLeftToRight) return building; // only when checkbox checked

        const left = building.left || {};
        const right = building.right || {};
        const back = building.back || {}; //  add this line (Back End Wall reference)

        // pick back end bays first, else fallback to left bays
        const backBays = Number(back.bays) || 0;
        const leftBays = Number(left.bays) || 0;
        const bays = leftBays; // number of grid sections
        const meters = Number(left.meters) || 0;
        const spacing = bays > 0 && meters ? meters / bays : "";

        // Base number should come from back end wall
        const baseNumber = backBays + 1; //  key change here

        const existingRows = right.rows || [];

        const rows = Array.from({ length: bays }, (_, i) => {
          const letterStart = indexToLetter(i);
          const letterEnd = indexToLetter(i + 1);

          const leftRow = left.rows?.[i] || {};
          const rightRow = existingRows[i] || {};

          return {
            ...rightRow,
            local_id: i + 1,
            gridLine: `${baseNumber}/${letterStart}-${letterEnd}`, // 👈 now depends on back bays
            baySpacing:
              leftRow.baySpacing ||
              (spacing ? spacing.toFixed(3) : rightRow.baySpacing || ""),
            blockWallHeight:
              leftRow.blockWallHeight ||
              left.blockWallHeight ||
              rightRow.blockWallHeight ||
              "",
            purlinGirtCondition:
              leftRow.purlinGirtCondition ||
              left.purlinGirtCondition ||
              rightRow.purlinGirtCondition ||
              "",
            typeOfBracing:
              leftRow.typeOfBracing ||
              left.typeOfBracing ||
              rightRow.typeOfBracing ||
              "",
          };
        });

        return {
          ...building,
          right: {
            ...right,
            meters: left.meters || "",
            bays: left.bays || "",
            blockWallHeight: left.blockWallHeight || "",
            purlinGirtCondition: left.purlinGirtCondition || "",
            typeOfBracing: left.typeOfBracing || "",
            buildingInputs: left.buildingInputs || "",
            rows,
          },
        };
      })
    );
    // eslint-disable-next-line
  }, [
    // eslint-disable-next-line
    JSON.stringify(
      buildings.map((b) => ({
        id: b.id,
        copyLeftToRight: b.copyLeftToRight,
        left: b.left,
        back: b.back,
      }))
    ),
  ]);
 


  // helper to convert number → letter (excluding I, O)

  // Checkbox handler for LSW = RSW
  // ✅ Helper function: number → letter (skip I and O)
  const numberToLetter = (num) => {
    const letters = "ABCDEFGHJKLMNPQRSTUVWXYZ"; // skip I and O
    let result = "";
    while (num > 0) {
      const mod = (num - 1) % letters.length;
      result = letters[mod] + result;
      num = Math.floor((num - 1) / letters.length);
    }
    return result;
  };



  // };

  const handleCopyLeftToRightChange = (e, buildingId) => {
  const checked = e.target.checked;

  // STEP 1: Get current building first
  const building = buildings.find((b) => b.id === buildingId);
  if (!building) return;

  const left = building.left || {};
  const right = building.right || {};
  const back = building.back || {};

  let rows = [];

  // If checked → build rows
  if (checked) {
    const bays = Number(left.bays) || 0;
    const meters = Number(left.meters) || 0;
    const spacing = bays > 0 && meters ? meters / bays : "";

    const backBays = Number(back.bays) || 0;
    const baseIndex = backBays + 1;
    const baseLetter = numberToLetter(baseIndex);

    const existingRows = right.rows || [];

    rows = Array.from({ length: bays }, (_, i) => {
      const start = i + 1;
      const end = i + 2;
      const leftRow = left.rows?.[i] || {};
      const rightRow = existingRows[i] || {};

      return {
        ...rightRow,
        local_id: i + 1,
        wall: `${baseLetter}/${start}-${end}`,
        baySpacing: spacing ? spacing.toFixed(3) : rightRow.baySpacing || "",
        blockWallHeight:
          leftRow.blockWallHeight ||
          left.blockWallHeight ||
          rightRow.blockWallHeight ||
          "",
        purlinGirtCondition:
          leftRow.purlinGirtCondition ||
          left.purlinGirtCondition ||
          rightRow.purlinGirtCondition ||
          "",
        typeOfBracing:
          leftRow.typeOfBracing ||
          left.typeOfBracing ||
          rightRow.typeOfBracing ||
          "",
      };
    });
  }

  // STEP 2: UPDATE BUILDINGS
  setBuildings((prevBuildings) =>
    prevBuildings.map((b) => {
      if (b.id !== buildingId) return b;

      if (!checked) {
        // uncheck logic
        return {
          ...b,
          copyLeftToRight: false,
          right: {
            ...b.right,
            meters: "",
            bays: "",
            blockWallHeight: "",
            buildingInputs: "",
            purlinGirtCondition: "",
            typeOfBracing: "",
            rows: [],
            lastLetter: "",
            lastLetterNumber: "",
          },
        };
      }

      // checked logic
      const baseIndex = (Number(back.bays) || 0) + 1;
      const lastLetter = numberToLetter(baseIndex + (Number(left.bays) || 0));
      const lastLetterNumber = baseIndex + (Number(left.bays) || 0);

      return {
        ...b,
        copyLeftToRight: true,
        right: {
          ...b.right,
          meters: left.meters || "",
          bays: left.bays || "",
          blockWallHeight: left.blockWallHeight || "",
          purlinGirtCondition: left.purlinGirtCondition || "",
          typeOfBracing: left.typeOfBracing || "",
          buildingInputs: left.buildingInputs || right.buildingInputs || "",
          rows,
          lastLetter,
          lastLetterNumber,
        },
      };
    })
  );

  // STEP 3: UPDATE buildingstructureDetails
  setBuildingstructureDetails((prev) =>
    prev.map((item) =>
      item.buildingId === buildingId
        ? {
            ...item,
            rightSideWallValues: rows,
            wallsPayload: {
              ...item.wallsPayload,
              "Right Side Wall": rows,
            },
          }
        : item
    )
  );
};


  //LSW == Rsw end

  // Update your existing toggle functions to work with specific buildings
  const toggleCardVisibility2 = (buildingId) => {
    setBuildings((prev) =>
      prev.map((building) =>
        building.id === buildingId
          ? { ...building, isCardVisible2: !building.isCardVisible2 }
          : building
      )
    );
  };

  const toggleCardVisibility3 = (buildingId) => {
    setBuildings((prev) =>
      prev.map((building) =>
        building.id === buildingId
          ? { ...building, isCardVisible3: !building.isCardVisible3 }
          : building
      )
    );
  };

  const toggleCardVisibility4 = (buildingId) => {
    setBuildings((prev) =>
      prev.map((building) =>
        building.id === buildingId
          ? { ...building, isCardVisible4: !building.isCardVisible4 }
          : building
      )
    );
  };

  const toggleCardVisibility5 = (buildingId) => {
    setBuildings((prev) =>
      prev.map((building) =>
        building.id === buildingId
          ? { ...building, isCardVisible5: !building.isCardVisible5 }
          : building
      )
    );
  };

  const toggleCardVisibility8 = (buildingId) => {
    setBuildings((prev) =>
      prev.map((building) =>
        building.id === buildingId
          ? { ...building, isCardVisible8: !building.isCardVisible8 }
          : building
      )
    );
  };
  const toggleCardVisibility9 = (buildingId) => {
    setBuildings((prev) =>
      prev.map((building) =>
        building.id === buildingId
          ? { ...building, isCardVisible9: !building.isCardVisible9 }
          : building
      )
    );
  };
  const toggleCardVisibility10 = (buildingId) => {
    setBuildings((prev) =>
      prev.map((building) =>
        building.id === buildingId
          ? { ...building, isCardVisible10: !building.isCardVisible10 }
          : building
      )
    );
  };
  const toggleCardVisibility11 = (buildingId) => {
    setBuildings((prev) =>
      prev.map((building) =>
        building.id === buildingId
          ? { ...building, isCardVisible11: !building.isCardVisible11 }
          : building
      )
    );
  };
  // const BuildingTabs = ({ buildings }) => {
  //   const [activeBuildingId, setActiveBuildingId] = useState(
  //     buildings?.[0]?.id || null
  //   );

  //Additional Component details ui tabs
  // Add this to your component state (at the top with other useState declarations)

  //instruction:
  const handleInstruction = (content, buildingId) => {
    setBuildings((prevBuildings) =>
      prevBuildings.map((building) =>
        building.id === buildingId
          ? { ...building, editorContent: content }
          : building
      )
    );
  };

  //MS-1 and C1, C2... calculation
  const renderCFields = (building) => {
    // Extract number from MS-1, MS-2, etc.
    const spanCount = parseInt(building.msNumber?.replace("MS-", "") || "1");

    const cFields = [];

    // Number of C fields needed = spanCount + 1
    // MS-1 (1 span) → 2 columns (C1, C2)
    // MS-2 (2 spans) → 3 columns (C1, C2, C3)
    // MS-3 (3 spans) → 4 columns (C1, C2, C3, C4)
    const numberOfCFields = spanCount + 1;

    for (let i = 1; i <= numberOfCFields; i++) {
      const fieldName = `c${i}`;
      const label = `C${i}`;

      cFields.push(
        <Col
          xs={4}
          md={4}
          lg={4}
          className="commLeftRightPadding"
          key={fieldName}
        >
          <InputField
            type="text"
            className="inputBox"
            label={label}
            value={building.selectedCaseObject?.[fieldName] || ""}
            onChange={(e) =>
              handleMCSInputChange(fieldName, e.target.value, building.id)
            }
            disabled={false}
          />
        </Col>
      );
    }

    return cFields;
  };

  const validateBuildingCFields = (building) => {
    const frontMeters = parseFloat(building.front?.meters) || 0;
    const spanCount = parseInt(building.msNumber?.replace("MS-", "") || "1");
    const numberOfCFields = spanCount + 1;

    let cSum = 0;
    for (let i = 1; i <= numberOfCFields; i++) {
      const value = parseFloat(building.selectedCaseObject?.[`c${i}`]) || 0;
      cSum += value;
    }

    const isValid = Math.abs(cSum - frontMeters) <= 0.01;

    if (!isValid) {
      alert(
        ` Validation Failed!\n\nSum of C fields: ${cSum.toFixed(
          2
        )}\nFront Meters: ${frontMeters}\nDifference: ${(
          cSum - frontMeters
        ).toFixed(
          2
        )}\n\nPlease ensure the sum of all C fields equals the Front Meters.`
      );
    }

    return isValid;
  };

  ///redux
  useEffect(() => {
    if (estimationData && Object.keys(estimationData).length > 0) {
      setFormInputs(estimationData);
      setBuildings(estimationData?.buildings);
      setBuildingCount(estimationData?.buildingCount);
      setActiveBuildingId(estimationData?.activeBuildingId);
      //remove late additionla component
      // setAdditionalComponents(estimationData?.additionalComponent);
    }
  }, [estimationData]);
  //handle design load change
  const handleDesignLoadChange = (buildingId, fieldName, value) => {
    setBuildings((prevBuildings) =>
      prevBuildings.map((building) =>
        building.id === buildingId
          ? {
              ...building,
              designLoad: {
                ...building.designLoad,
                [fieldName]: value,
              },
            }
          : building
      )
    );
  };

  // Add dynamic field
  const addDynamicField = (buildingId) => {
    setBuildings((prevBuildings) =>
      prevBuildings.map((building) => {
        if (building.id === buildingId) {
          // Get existing dynamic field names
          const existingFields = Object.keys(building.designLoad || {});
          // eslint-disable-next-line
          const dynamicFields = existingFields.filter((field) =>
            field.startsWith("designLoad")
          );

          // Find the next available number
          let nextNumber = 1;
          while (existingFields.includes(`designLoad${nextNumber}`)) {
            nextNumber++;
          }

          const newFieldName = `designLoad${nextNumber}`;

          return {
            ...building,
            designLoad: {
              ...building.designLoad,
              [newFieldName]: "", // Initialize with empty string
            },
          };
        }
        return building;
      })
    );
  };

  // Remove dynamic field
  const removeDynamicField = (buildingId, fieldName) => {
    setBuildings((prevBuildings) =>
      prevBuildings.map((building) => {
        if (building.id === buildingId) {
          // Create a copy of designLoad without the removed field
          const { [fieldName]: removed, ...updatedDesignLoad } =
            building.designLoad;

          return {
            ...building,
            designLoad: updatedDesignLoad,
          };
        }
        return building;
      })
    );
  };

  // Helper function to get dynamic field names
  const getDynamicFields = (building) => {
    if (!building.designLoad) return [];

    return Object.keys(building.designLoad)
      .filter((fieldName) => fieldName.startsWith("designLoad"))
      .sort((a, b) => {
        // Sort by number: designLoad1, designLoad2, etc.
        const numA = parseInt(a.replace("designLoad", ""));
        const numB = parseInt(b.replace("designLoad", ""));
        return numA - numB;
      });
  };
  //Design Standard
  // Handle design standards changes
  const handleDesignStandardsChange = (buildingId, fieldName, value) => {
    setBuildings((prevBuildings) =>
      prevBuildings.map((building) =>
        building.id === buildingId
          ? {
              ...building,
              designStandards: {
                ...building.designStandards,
                [fieldName]: value,
              },
            }
          : building
      )
    );
  };

  // Add dynamic standard field
  const addDynamicStandardField = (buildingId) => {
    setBuildings((prevBuildings) =>
      prevBuildings.map((building) => {
        if (building.id === buildingId) {
          // Get existing dynamic standard field names
          const existingFields = Object.keys(building.designStandards || {});
          // eslint-disable-next-line
          const dynamicFields = existingFields.filter((field) =>
            field.startsWith("designStandard")
          );

          // Find the next available number
          let nextNumber = 1;
          while (existingFields.includes(`designStandard${nextNumber}`)) {
            nextNumber++;
          }

          const newFieldName = `designStandard${nextNumber}`;

          return {
            ...building,
            designStandards: {
              ...building.designStandards,
              [newFieldName]: "", // Initialize with empty string
            },
          };
        }
        return building;
      })
    );
  };

  // Remove dynamic standard field
  const removeDynamicStandardField = (buildingId, fieldName) => {
    setBuildings((prevBuildings) =>
      prevBuildings.map((building) => {
        if (building.id === buildingId) {
          // Create a copy of designStandards without the removed field
          const { [fieldName]: removed, ...updatedDesignStandards } =
            building.designStandards;

          return {
            ...building,
            designStandards: updatedDesignStandards,
          };
        }
        return building;
      })
    );
  };

  // Helper function to get dynamic standard field names
  const getDynamicStandardFields = (building) => {
    if (!building.designStandards) return [];

    return Object.keys(building.designStandards)
      .filter((fieldName) => fieldName.startsWith("designStandard"))
      .sort((a, b) => {
        // Sort by number: designStandard1, designStandard2, etc.
        const numA = parseInt(a.replace("designStandard", ""));
        const numB = parseInt(b.replace("designStandard", ""));
        return numA - numB;
      });
  };
  // Handle deflection criteria changes
  const handleDeflectionCriteriaChange = (buildingId, fieldName, value) => {
    setBuildings((prevBuildings) =>
      prevBuildings.map((building) =>
        building.id === buildingId
          ? {
              ...building,
              deflectionCriteria: {
                ...building.deflectionCriteria,
                [fieldName]: value,
              },
            }
          : building
      )
    );
  };

  // Add dynamic deflection field
  const addDynamicDeflectionField = (buildingId) => {
    setBuildings((prevBuildings) =>
      prevBuildings.map((building) => {
        if (building.id === buildingId) {
          // Get existing dynamic deflection field names
          const existingFields = Object.keys(building.deflectionCriteria || {});
          // eslint-disable-next-line
          const dynamicFields = existingFields.filter((field) =>
            field.startsWith("deflectionCriteria")
          );

          // Find the next available number
          let nextNumber = 1;
          while (existingFields.includes(`deflectionCriteria${nextNumber}`)) {
            nextNumber++;
          }

          const newFieldName = `deflectionCriteria${nextNumber}`;

          return {
            ...building,
            deflectionCriteria: {
              ...building.deflectionCriteria,
              [newFieldName]: "", // Initialize with empty string
            },
          };
        }
        return building;
      })
    );
  };

  // Remove dynamic deflection field
  const removeDynamicDeflectionField = (buildingId, fieldName) => {
    setBuildings((prevBuildings) =>
      prevBuildings.map((building) => {
        if (building.id === buildingId) {
          // Create a copy of deflectionCriteria without the removed field
          const { [fieldName]: removed, ...updatedDeflectionCriteria } =
            building.deflectionCriteria;

          return {
            ...building,
            deflectionCriteria: updatedDeflectionCriteria,
          };
        }
        return building;
      })
    );
  };

  // Helper function to get dynamic deflection field names
  const getDynamicDeflectionFields = (building) => {
    if (!building.deflectionCriteria) return [];

    return Object.keys(building.deflectionCriteria)
      .filter((fieldName) => fieldName.startsWith("deflectionCriteria"))
      .sort((a, b) => {
        // Sort by number: deflectionCriteria1, deflectionCriteria2, etc.
        const numA = parseInt(a.replace("deflectionCriteria", ""));
        const numB = parseInt(b.replace("deflectionCriteria", ""));
        return numA - numB;
      });
  };

  // Handle minimum thickness changes
  const handleMinimumThicknessChange = (buildingId, fieldName, value) => {
    setBuildings((prevBuildings) =>
      prevBuildings.map((building) =>
        building.id === buildingId
          ? {
              ...building,
              minimumThickness: {
                ...building.minimumThickness,
                [fieldName]: value,
              },
            }
          : building
      )
    );
  };

  // Add dynamic thickness field
  const addDynamicThicknessField = (buildingId) => {
    setBuildings((prevBuildings) =>
      prevBuildings.map((building) => {
        if (building.id === buildingId) {
          // Get existing dynamic thickness field names
          const existingFields = Object.keys(building.minimumThickness || {});
          // eslint-disable-next-line
          const dynamicFields = existingFields.filter((field) =>
            field.startsWith("minimumThickness")
          );

          // Find the next available number
          let nextNumber = 1;
          while (existingFields.includes(`minimumThickness${nextNumber}`)) {
            nextNumber++;
          }

          const newFieldName = `minimumThickness${nextNumber}`;

          return {
            ...building,
            minimumThickness: {
              ...building.minimumThickness,
              [newFieldName]: "", // Initialize with empty string
            },
          };
        }
        return building;
      })
    );
  };

  // Remove dynamic thickness field
  const removeDynamicThicknessField = (buildingId, fieldName) => {
    setBuildings((prevBuildings) =>
      prevBuildings.map((building) => {
        if (building.id === buildingId) {
          // Create a copy of minimumThickness without the removed field
          const { [fieldName]: removed, ...updatedMinimumThickness } =
            building.minimumThickness;

          return {
            ...building,
            minimumThickness: updatedMinimumThickness,
          };
        }
        return building;
      })
    );
  };

  // Helper function to get dynamic thickness field names
  const getDynamicThicknessFields = (building) => {
    if (!building.minimumThickness) return [];

    return Object.keys(building.minimumThickness)
      .filter((fieldName) => fieldName.startsWith("minimumThickness"))
      .sort((a, b) => {
        // Sort by number: minimumThickness1, minimumThickness2, etc.
        const numA = parseInt(a.replace("minimumThickness", ""));
        const numB = parseInt(b.replace("minimumThickness", ""));
        return numA - numB;
      });
  };

   //match estimation Data
 const [modalShowMatch, setModalShowMatch] = useState(false);
  const [estimationMatchData, setEstimationMatchData] = useState("");
 
 
 const showStatusInfo = () => {
    setModalShowMatch(true);
    setEstimationMatchData("data");
    dispatch(
      setEstimationData({
        ...estimationData,
        ...formInputs,
        getOverallBuildingArea,
        buildingCount,
        buildings,
        additionalComponent: additionalComponents,
        activeBuildingId: activeBuildingId,
        canopyInputsTable: canopyInputs,
        componentDataView,
        draftStatus: "DF",
        documentNumber: formInputs?.estimationNr || "",
        comonentKey: selectedComponentKeys,
      })
    )
  };
 
  const hideModalMatch = () => {
    setModalShowMatch(false);
  };

  // for mezzanine Area 

  const handleEnableWallsChange = (isChecked, buildingId) => {
  setBuildings(buildings.map(building =>
    building.id === buildingId
      ? { ...building, enableWalls: isChecked }
      : building
  ));
};




 
 

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">
              Estimate Specification{" "}
              {formInputs?.qtnReferenceNr ? (
                <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                  {formInputs.qtnReferenceNr}
                </span>
              ) : formInputs?.jobReferenceNr ? (
                <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                  {formInputs.jobReferenceNr}
                </span>
              ) : null}
  <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                  {formInputs?.version}
                </span>
            
            </h2>
            <p className="subText">Details of all design standards, load parameters, and material specifications.</p>
            <hr />
            {/* Date, Company, Sales Person, Remark */}
            <div className="accordion mt-3 mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible1
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility1}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">ED</span>
                    </Col>

                    <Col xs={4} md={4} lg={4}>
                      <span className="headerTitle">Estimate details</span>
                      <span className="subHeaderTitle">Estimate details</span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible1 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          type="date"
                          className="inputBox"
                          label="Date"
                          name="transactionDate"
                          value={formInputs?.transactionDate}
                          onChange={handleFormInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commLeftRightPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Client Name"
                          name="clientName"
                          id="clientName"
                          // value={formInputs?.[0]?.clientName || ""}
                          value={formInputs?.clientName}
                          onChange={handleFormInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commLeftRightPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Company Name"
                          name="companyName"
                          id="companyName"
                          value={formInputs?.companyName}
                          onChange={handleFormInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commLeftRightPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Building name"
                          name="buildingName"
                          id="buildingName"
                          value={formInputs?.buildingName}
                          onChange={handleFormInputChange}
                          disabled={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          type="text"
                          className="inputBox"
                          label="Sales Person Name"
                          name="salesOfficerName"
                          value={formInputs?.salesOfficerName}
                          onChange={handleFormInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          type="text"
                          className="inputBox"
                          label="Location"
                          name="location"
                          value={formInputs?.location}
                          onChange={handleFormInputChange}
                          disabled={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          type="text"
                          className="inputBox"
                          label="Remark"
                          name="remarks"
                          value={formInputs?.remarks}
                          onChange={handleFormInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          type="text"
                          className="inputBox"
                          label="Time Line (Days)"
                          name="timeLine"
                          value={formInputs?.timeLine}
                          onChange={handleFormInputChange}
                          disabled
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          type="date"
                          className="inputBox"
                          label="Estimate Start Date"
                          name="estimateStartdate"
                          value={formInputs?.estimateStartdate}
                          onChange={(e) => {
                            handleFormInputChange(e);
                            calculateTimeline(
                              e.target.value,
                              formInputs?.estimateEndDate
                            );
                          }}
                          min={2000}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          type="date"
                          className="inputBox"
                          label="Estimate End Date"
                          name="estimateEndDate"
                          value={formInputs?.estimateEndDate}
                          onChange={(e) => {
                            handleFormInputChange(e);
                            calculateTimeline(
                              formInputs?.estimateStartdate,
                              e.target.value
                            );
                          }}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          className="inputBox"
                          label="Status"
                          data={statusOptions}
                          name="estimationStatus"
                          id="estimationStatus"
                          setValue={formInputs?.estimationStatus}
                          getvalue={setDropdownData}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          className="inputBox"
                          data={priorityOptions}
                          label="Building Complexity(Priority)"
                          name="priority"
                          id="priority"
                          setValue={formInputs?.priority}
                          getvalue={setDropdownData}
                        />
                      </Col>

                      {formInputs?.qtnReferenceNr && (
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Quote No"
                            name="qtnReferenceNr"
                            value={formInputs?.qtnReferenceNr || ""}
                            onChange={handleFormInputChange}
                            disabled={true}
                          />
                        </Col>
                      )}
                      {formInputs?.jobReferenceNr && (
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Job No"
                            name="jobReferenceNr"
                            value={formInputs?.jobReferenceNr || ""}
                            onChange={handleFormInputChange}
                            disabled={true}
                          />
                        </Col>
                      )}
                      {formInputs?.status === "Hold" && (
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            type="text"
                            className="inputBox"
                            label="Remark (Estimation)"
                            name="remarkestimation"
                            value={formInputs?.remarkestimation}
                            onChange={handleFormInputChange}
                          />
                        </Col>
                      )}
                      <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Revision"
                          name="version"
                          id="version"
                          value={formInputs?.version}
                          onChange={handleFormInputChange}
                          disabled={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={6}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          type="number"
                          label="Number of Buildings"
                          className="inputBox"
                          value={buildingCount}
                          onChange={(e) => {
                            let count = parseInt(e.target.value) || 1;
                            // Enforce the limit
                            count = Math.min(Math.max(1, count), 50);
                            setBuildingCount(count);
                            handleBuildingCountChange(count);
                          }}
                          min="1"
                          max="10"
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Overall Estimation Area"
                          name="overallBuildingArea"
                          value={`${getOverallBuildingArea?.toFixed(3)} Sqm`}
                          readOnly
                          disabled
                        />
                      </Col>
                      <Row>
                      <Col
                        xs={2}
                        md={2}
                        lg={2}
                        className="commTopButtonRightLeftPadding d-flex justify-content-start align-items-center"
                      >
                        <button className="btn btnTable" onClick={showStatusInfo}>
                          <i class="bi bi-link-45deg mx-2"></i>
                          Search Buildings
                        </button>
                      </Col>
                      {buildings.map((building, index) => (
    <React.Fragment key={building.id}>
      
      {/* Show Front & Left only if SYM */}
      {building?.buildingStructureCode === "SYM" && (
        <>
          {/* Front End Wall */}
        <Col
            xs={12}
            md={3}
            lg={3}
            className="commTopButtonRightLeftPadding"
          >
            <div className="checkboxContainer">
              <input
                type="checkbox"
                id={`enableWalls-${building.id}`}
                checked={building.enableWalls || false}
                onChange={(e) =>
                  handleEnableWallsChange(e.target.checked, building.id)
                }
                className="styledCheckbox"
              />
              <label htmlFor={`enableWalls-${building.id}`}>
                Enable Wall Fields
              </label>
            </div>
          </Col>

        </>
      )}


    </React.Fragment>
  ))}


                      </Row>
    <Row>
  {buildings.map((building, index) => (
    <React.Fragment key={building.id}>
      
      {/* Show Front & Left only if SYM */}
      {building?.buildingStructureCode === "SYM" && (
        <>
          {/* Front End Wall */}
          <Col
            xs={12}
            md={6}
            lg={3}
            className="commTopButtonRightLeftPadding"
          >
            <InputField
              className="inputBox"
              type="number"
              label="Front End Wall in (M)"
              placeholder="Width of Building"
              value={building.front?.meters || ""}
              onChange={(e) =>
                handleFrontMetersChange(e.target.value, building.id)
              }
               disabled={!building.enableWalls}
            />
          </Col>

          {/* Left End Wall */}
          <Col
            xs={12}
            md={6}
            lg={3}
            className="commTopButtonRightLeftPadding"
          >
            <InputField
              className="inputBox"
              type="number"
              label="Left End Wall in (M)"
              placeholder="Length of Building"
              value={building.left?.meters || ""}
              onChange={(e) =>
                handleLeftMetersChange(e.target.value, building.id)
              }
               disabled={!building.enableWalls}
            />
          </Col>
                <Col
        xs={12}
        md={3}
        lg={3}
        className="commTopButtonRightLeftPadding"
      >
        <InputField
          className="inputBox"
          label={`Building Area ${index + 1}`}
          name="buildingArea"
          value={`${Number(
            building.totalArea || building.buildingArea || 0
          ).toFixed(4)} Sqm`}
          required={true}
          readOnly
          disabled
        />
      </Col>

        </>
      )}


    </React.Fragment>
  ))}
</Row>



   
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* Dynamic buildings */}

            {/* Single Card Container */}
            <Row>
              <Col xs={12} md={12} lg={12}>
                <div className="card">
                  <div className="card-body pt-3">
                    {/* Building Tabs - Horizontal */}
                    <ul className="nav nav-tabs nav-tabs-bordered">
                      {buildings.map((building, index) => (
                        <li key={building.id} className="nav-item">
                          <button
                            className={`nav-link ${
                              activeBuildingId === building.id ? "active" : ""
                            }`}
                            style={{
                              backgroundColor:
                                activeBuildingId === building.id
                                  ? "#007bff"
                                  : "transparent",
                              color:
                                activeBuildingId === building.id
                                  ? "#fff"
                                  : "#000",
                              borderRadius: "5px",
                              border: "none",
                              transition: "all 0.3s ease",
                              padding: "8px 16px",
                            }}
                            onClick={() => setActiveBuildingId(building.id)}
                          >
                            Building {index + 1}
                          </button>
                        </li>
                      ))}
                    </ul>

                    {/* Building Content - Shows only active building */}
                    <div
                      className="tab-content pt-2"
                      style={{
                        overflowY: "auto",
                        minHeight: "60vh",
                      }}
                    >
                      {buildings.map((building, index) => (
                        <div
                          key={building.id}
                          className={`tab-pane fade ${
                            activeBuildingId === building.id
                              ? "show active"
                              : ""
                          }`}
                        >
                          {/* Only show content for active building */}
                          {activeBuildingId === building.id && (
                            <>
                              {/* Building Structure Details Accordion */}
                              <h5 class="bg-table-status bg-table-new-status ml-2 mt-3 p-3">
                                Building Specification {index + 1}{" "}
                              </h5>
                              <Row className="mb-2">
                                <Col xs={12} md={12} lg={12}>
                                  <h5 className="mb-2 text-primary">
                                    Structure Type
                                  </h5>
                                </Col>
                                <Col
                                  xs={12}
                                  md={3}
                                  lg={3}
                                  className="commTopButtonRightLeftPadding ml-0"
                                >
                                  <ComboboxField
                                    className="inputBox"
                                    label="Type of Building"
                                    placeholder=""
                                    data={mainBuildingTypes}
                                    name="mainBuildingType"
                                    code={`mainBuildingTypeCode-${building?.id}`}
                                    description="mainBuildingTypeDesc"
                                    setValue={building?.mainBuildingType || ""}
                                    getvalue={setDropdownData}
                                  />
                                </Col>
                                {(building.mainBuildingTypeCode === "MGB" ||
                                  building.mainBuildingTypeCode === "LHB") && (
                                  <Col
                                    xs={12}
                                    md={3}
                                    lg={3}
                                    className="commTopButtonRightLeftPadding ml-0"
                                  >
                                    <ComboboxField
                                      className="inputBox"
                                      label="Sub Building"
                                      placeholder=""
                                      data={subBuildingData[building.id] || []}
                                      name="subBuildingType"
                                      code={`subBuildingTypeCode-${building?.id}`}
                                      description="subBuildingTypeDesc"
                                      setValue={building?.subBuildingType || ""}
                                      getvalue={setDropdownData}
                                    />
                                  </Col>
                                )}

                                {((building.mainBuildingTypeCode === "MGB" &&
                                  building.subBuildingTypeCode) ||
                                  (building.mainBuildingTypeCode === "LHB" &&
                                    building.subBuildingTypeCode) ||
                                  building.mainBuildingTypeCode === "CSB" ||
                                  building.mainBuildingTypeCode === "MSB" ||
                                  building.mainBuildingTypeCode === "MLMB") && (
                                  <Col
                                    xs={12}
                                    md={3}
                                    lg={3}
                                    className="commTopButtonRightLeftPadding ml-0"
                                  >
                                    <ComboboxField
                                      className="inputBox"
                                      label="Building Types"
                                      placeholder=""
                                      data={
                                        buildingTypesData[building.id] || []
                                      }
                                      name="buildingTypes"
                                      code={`buildingTypesCode-${building?.id}`}
                                      description="buildingTypesDesc"
                                      setValue={building?.buildingTypes || ""}
                                      getvalue={setDropdownData}
                                      disabled={
                                        // For FLOW 1 (MGB/LHB): disable if no sub type selected
                                        // For FLOW 2 (CSB/MSB): always enabled when main type is selected
                                        (building.mainBuildingTypeCode ===
                                          "MGB" &&
                                          !building.subBuildingTypeCode) ||
                                        (building.mainBuildingTypeCode ===
                                          "LHB" &&
                                          !building.subBuildingTypeCode)
                                      }
                                    />
                                  </Col>
                                )}

                                {(building?.mainBuildingTypeCode === "MSB" ||
                                  building?.subBuildingTypeCode === "MSB") && (
                                  <>
                                    <Col
                                      xs={12}
                                      md={3}
                                      lg={3}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <InputField
                                        className="inputBox"
                                        label="MS Number"
                                        name="msNumber"
                                        id={`msNumber-${building.id}`}
                                        value={building?.msNumber || "MS-"}
                                        onChange={(e) => {
                                          // Allow only numbers, keep "MS-" prefix
                                          const value = e.target.value;
                                          const numberOnly = value.replace(
                                            /[^0-9]/g,
                                            ""
                                          );
                                          handleBuildingInputChange(
                                            {
                                              target: {
                                                name: "msNumber",
                                                value: numberOnly
                                                  ? `MS-${numberOnly}`
                                                  : "MS-",
                                              },
                                            },
                                            building.id
                                          );
                                        }}
                                      />
                                    </Col>
                                  </>
                                )}

                                <Col
                                  xs={12}
                                  md={3}
                                  lg={3}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    className="inputBox"
                                    data={buildingStrctures}
                                    label="Building Structure"
                                    name="buildingStructure"
                                    code={`buildingStructureCode-${building?.id}`}
                                    description="buildingStructureDesc"
                                    setValue={building?.buildingStructure || ""}
                                    getvalue={setDropdownData}
                                  />
                                </Col>

                                <Col
                                  xs={12}
                                  md={3}
                                  lg={3}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    className="inputBox"
                                    data={designs}
                                    label="Design"
                                    name="design"
                                    code={`designCode-${building?.id}`}
                                    description="designDesc"
                                    setValue={building?.design || ""}
                                    getvalue={setDropdownData}
                                  />
                                </Col>
                                {/* <Col
                                  xs={12}
                                  md={3}
                                  lg={3}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label={`Building Area ${index + 1}`}
                                    name="buildingArea"
                                    value={`${Number(
                                      building.totalArea ||
                                        building.buildingArea ||
                                        0
                                    ).toFixed(4)} Sqm`}
                                    readOnly
                                    disabled
                                  />
                                </Col> */}
                                <Col
  xs={12}
  md={3}
  lg={3}
  className="commTopButtonRightLeftPadding"
>
  <InputField
    className="inputBox"
    label={`Building Area ${index + 1}`}
    name="buildingArea"
    value={
      building.totalArea || building.buildingArea
        ? `${Number(building.totalArea || building.buildingArea).toFixed(4)} Sqm`
        : ""
    }
    required={true}
    readOnly
    disabled
  />
  {/* Validation message */}
  {!building.totalArea && !building.buildingArea && (
    <span className="text-danger" style={{ fontSize: "15px" }}>
      Area field is empty
    </span>
  )}
</Col>

                              </Row>
                              {/*  Design Infromation */}
                              <div
                                className="tab-content pt-2"
                                style={{ overflowY: "auto" }}
                              >
                                {buildings.map((building, index) => (
                                  <div
                                    key={building.id}
                                    className={`tab-pane fade ${
                                      activeBuildingId === building.id
                                        ? "show active"
                                        : ""
                                    }`}
                                  >
                                    {/* Only show content for active building */}
                                    {activeBuildingId === building.id && (
                                      <div
                                        className="accordion mt-3 mb-4"
                                        id="accordionExample"
                                      >
                                        <div className="accordion-item">
                                          <h2 className="accordion-header">
                                            <Row className="accordion-button">
                                              <Col
                                                xs={1}
                                                md={1}
                                                lg={1}
                                                className="text-left arrowBtn"
                                              >
                                                <i
                                                  className={`bi ${
                                                    building.isCardVisible11
                                                      ? "bi-chevron-right"
                                                      : "bi-chevron-down"
                                                  }`}
                                                  onClick={() =>
                                                    toggleCardVisibility11(
                                                      building.id
                                                    )
                                                  }
                                                ></i>
                                              </Col>
                                              <Col
                                                xs={1}
                                                md={1}
                                                lg={1}
                                                className="text-center logoBtn"
                                              >
                                                <span className="iconLogo">
                                                  DI
                                                </span>
                                              </Col>
                                              <Col xs={4} md={4} lg={4}>
                                                <span className="headerTitle">
                                                  Design Infromation{" "}
                                                  {building.id}
                                                </span>
                                                <span className="subHeaderTitle">
                                                  Design Infromation Section
                                                </span>
                                              </Col>
                                            </Row>
                                          </h2>
                                          <div
                                            className={`accordion-collapse collapse show ${
                                              building.isCardVisible11
                                                ? "visible"
                                                : ""
                                            }`}
                                          >
                                            <div className="accordion-body pb-5">
                                              <Row className="p-4">
                                                <Col xs={12} md={12} lg={12}>
                                                  {/* desigh load */}
                                                  <Row className="mb-2">
                                                    <Col
                                                      xs={12}
                                                      md={12}
                                                      lg={12}
                                                      className="d-flex align-items-center"
                                                    >
                                                      <h5 className="text-primary pr-2">
                                                        Design Load
                                                      </h5>

                                                      <button
                                                        class="inline-flex items-center justify-center 
            text-blue-500 
            transition-all duration-300 
            w-10 h-10 
            hover:text-blue-600 
            hover:scale-125 
            hover:bg-blue-100 
            rounded-full 
            hover:shadow-[0_0_10px_rgba(59,130,246,0.7)]"
                                                        onClick={() =>
                                                          addDynamicField(
                                                            building.id
                                                          )
                                                        }
                                                      >
                                                        <i class="bi bi-plus-circle text-2xl"></i>
                                                      </button>
                                                    </Col>
                                                    <Col
                                                      xs={12}
                                                      md={3}
                                                      lg={3}
                                                      className="commTopButtonRightLeftPadding"
                                                    >
                                                      <InputField
                                                        label="Dead Load (kn/Sq.m)"
                                                        className="inputBox"
                                                        name="deadLoad"
                                                        value={
                                                          building?.designLoad
                                                            ?.deadLoad || ""
                                                        }
                                                        onChange={(e) =>
                                                          handleDesignLoadChange(
                                                            building.id,
                                                            "deadLoad",
                                                            e.target.value
                                                          )
                                                        }
                                                      />
                                                    </Col>
                                                    <Col
                                                      xs={12}
                                                      md={3}
                                                      lg={3}
                                                      className="commTopButtonRightLeftPadding"
                                                    >
                                                      <InputField
                                                        label="Live Load (kn/Sq.m)"
                                                        className="inputBox"
                                                        name="liveLoad"
                                                        value={
                                                          building?.designLoad
                                                            ?.liveLoad || ""
                                                        }
                                                        onChange={(e) =>
                                                          handleDesignLoadChange(
                                                            building.id,
                                                            "liveLoad",
                                                            e.target.value
                                                          )
                                                        }
                                                      />
                                                    </Col>
                                                    <Col
                                                      xs={12}
                                                      md={3}
                                                      lg={3}
                                                      className="commTopButtonRightLeftPadding"
                                                    >
                                                      <InputField
                                                        label="Solar Load (kn/Sq.m)"
                                                        className="inputBox"
                                                        name="solarLoad"
                                                        value={
                                                          building?.designLoad
                                                            ?.solarLoad || ""
                                                        }
                                                        onChange={(e) =>
                                                          handleDesignLoadChange(
                                                            building.id,
                                                            "solarLoad",
                                                            e.target.value
                                                          )
                                                        }
                                                      />
                                                    </Col>
                                                    <Col
                                                      xs={12}
                                                      md={3}
                                                      lg={3}
                                                      className="commTopButtonRightLeftPadding"
                                                    >
                                                      <InputField
                                                        label="Wind Speed (kmph)"
                                                        className="inputBox"
                                                        name="windLoad"
                                                        value={
                                                          building?.designLoad
                                                            ?.windLoad || ""
                                                        }
                                                        onChange={(e) =>
                                                          handleDesignLoadChange(
                                                            building.id,
                                                            "windLoad",
                                                            e.target.value
                                                          )
                                                        }
                                                      />
                                                    </Col>

                                                    {getDynamicFields(
                                                      building
                                                    ).map(
                                                      (fieldName, index) => (
                                                        <>
                                                          <Col
                                                            xs={12}
                                                            md={2}
                                                            lg={2}
                                                            className="d-flex align-items-center commTopButtonRightLeftPadding mt-2"
                                                          >
                                                            <InputField
                                                              // label={`Design Load ${index + 1}`}

                                                              className="inputBox d-inline"
                                                              value={
                                                                building
                                                                  ?.designLoad?.[
                                                                  fieldName
                                                                ] || ""
                                                              }
                                                              onChange={(e) =>
                                                                handleDesignLoadChange(
                                                                  building.id,
                                                                  fieldName,
                                                                  e.target.value
                                                                )
                                                              }
                                                            />
                                                            <span
                                                              className="ml-2"
                                                              onClick={() =>
                                                                removeDynamicField(
                                                                  building.id,
                                                                  fieldName
                                                                )
                                                              }
                                                            >
                                                              <i className="bi bi-trash text-danger cursor-pointer"></i>
                                                            </span>
                                                          </Col>
                                                          {/* <Col xs={12} md={1} lg={1} className="commTopButtonRightLeftPadding">
                     
                    </Col> */}
                                                        </>
                                                      )
                                                    )}
                                                  </Row>
                                                  {/*      Design Standards  */}
                                                  <Row className="mb-2 mt-4">
                                                    <Col
                                                      xs={12}
                                                      md={12}
                                                      lg={12}
                                                      className="d-flex align-items-center"
                                                    >
                                                      <h5 className="mb-2 text-primary">
                                                        Design Standards
                                                      </h5>
                                                      <button
                                                        class="inline-flex items-center justify-center 
            text-blue-500 
            transition-all duration-300 
            w-10 h-10 
            hover:text-blue-600 
            hover:scale-125 
            hover:bg-blue-100 
            rounded-full 
            hover:shadow-[0_0_10px_rgba(59,130,246,0.7)]"
                                                        onClick={() =>
                                                          addDynamicStandardField(
                                                            building.id
                                                          )
                                                        }
                                                      >
                                                        <i class="bi bi-plus-circle text-2xl"></i>
                                                      </button>
                                                    </Col>
                                                    <Col
                                                      xs={12}
                                                      md={3}
                                                      lg={3}
                                                      className="commTopButtonRightLeftPadding"
                                                    >
                                                      <InputField
                                                        label="Codes Applicable"
                                                        className="inputBox"
                                                        name="codesApplicable"
                                                        value={
                                                          building
                                                            ?.designStandards
                                                            ?.codesApplicable ||
                                                          ""
                                                        }
                                                        onChange={(e) =>
                                                          handleDesignStandardsChange(
                                                            building.id,
                                                            "codesApplicable",
                                                            e.target.value
                                                          )
                                                        }
                                                      />
                                                    </Col>
                                                    <Col
                                                      xs={12}
                                                      md={3}
                                                      lg={3}
                                                      className="commTopButtonRightLeftPadding"
                                                    >
                                                      <InputField
                                                        label="Wind Pressure Calculation"
                                                        className="inputBox"
                                                        name="windLoadCalculation"
                                                        value={
                                                          building
                                                            ?.designStandards
                                                            ?.windLoadCalculation ||
                                                          ""
                                                        }
                                                        onChange={(e) =>
                                                          handleDesignStandardsChange(
                                                            building.id,
                                                            "windLoadCalculation",
                                                            e.target.value
                                                          )
                                                        }
                                                      />
                                                    </Col>
                                                    <Col
                                                      xs={12}
                                                      md={3}
                                                      lg={3}
                                                      className="commTopButtonRightLeftPadding"
                                                    >
                                                      <InputField
                                                        label="Wind Load Application"
                                                        className="inputBox"
                                                        name="windLoadApplication"
                                                        value={
                                                          building
                                                            ?.designStandards
                                                            ?.windLoadApplication ||
                                                          ""
                                                        }
                                                        onChange={(e) =>
                                                          handleDesignStandardsChange(
                                                            building.id,
                                                            "windLoadApplication",
                                                            e.target.value
                                                          )
                                                        }
                                                      />
                                                    </Col>
                                                    <Col
                                                      xs={12}
                                                      md={3}
                                                      lg={3}
                                                      className="commTopButtonRightLeftPadding"
                                                    >
                                                      <InputField
                                                        label="Seismic Zone"
                                                        className="inputBox"
                                                        name="seismicLoad"
                                                        value={
                                                          building
                                                            ?.designStandards
                                                            ?.seismicLoad || ""
                                                        }
                                                        onChange={(e) =>
                                                          handleDesignStandardsChange(
                                                            building.id,
                                                            "seismicLoad",
                                                            e.target.value
                                                          )
                                                        }
                                                      />
                                                    </Col>

                                                    {getDynamicStandardFields(
                                                      building
                                                    ).map(
                                                      (fieldName, index) => (
                                                        <Col
                                                          key={fieldName}
                                                          xs={12}
                                                          md={2}
                                                          lg={2}
                                                          className="d-flex align-items-center commTopButtonRightLeftPadding mt-2"
                                                        >
                                                          <InputField
                                                            className="inputBox d-inline"
                                                            value={
                                                              building
                                                                ?.designStandards?.[
                                                                fieldName
                                                              ] || ""
                                                            }
                                                            onChange={(e) =>
                                                              handleDesignStandardsChange(
                                                                building.id,
                                                                fieldName,
                                                                e.target.value
                                                              )
                                                            }
                                                          />
                                                          <span
                                                            className="ml-2"
                                                            onClick={() =>
                                                              removeDynamicStandardField(
                                                                building.id,
                                                                fieldName
                                                              )
                                                            }
                                                          >
                                                            <i className="bi bi-trash text-danger cursor-pointer"></i>
                                                          </span>
                                                        </Col>
                                                      )
                                                    )}
                                                  </Row>
                                                  {/* Deflection Criteria Section */}
                                                  <Row className="mb-2 mt-4">
                                                    <Col
                                                      xs={12}
                                                      md={12}
                                                      lg={12}
                                                      className="d-flex align-items-center"
                                                    >
                                                      <h5 className="mb-2 text-primary">
                                                        Deflection Criteria
                                                      </h5>

                                                      <button
                                                        class="inline-flex items-center justify-center 
            text-blue-500 
            transition-all duration-300 
            w-10 h-10 
            hover:text-blue-600 
            hover:scale-125 
            hover:bg-blue-100 
            rounded-full 
            hover:shadow-[0_0_10px_rgba(59,130,246,0.7)]"
                                                        onClick={() =>
                                                          addDynamicDeflectionField(
                                                            building.id
                                                          )
                                                        }
                                                      >
                                                        <i class="bi bi-plus-circle text-2xl"></i>
                                                      </button>
                                                    </Col>
                                                    <Col
                                                      xs={12}
                                                      md={3}
                                                      lg={3}
                                                      className="commTopButtonRightLeftPadding"
                                                    >
                                                      <InputField
                                                        label="Main Frames Sway"
                                                        className="inputBox"
                                                        name="mainFramesSway"
                                                        value={
                                                          building
                                                            ?.deflectionCriteria
                                                            ?.mainFramesSway ||
                                                          ""
                                                        }
                                                        onChange={(e) =>
                                                          handleDeflectionCriteriaChange(
                                                            building.id,
                                                            "mainFramesSway",
                                                            e.target.value
                                                          )
                                                        }
                                                      />
                                                    </Col>
                                                    <Col
                                                      xs={12}
                                                      md={3}
                                                      lg={3}
                                                      className="commTopButtonRightLeftPadding"
                                                    >
                                                      <InputField
                                                        label="Main Frame Deflection"
                                                        className="inputBox"
                                                        name="mainFrameDeflection"
                                                        value={
                                                          building
                                                            ?.deflectionCriteria
                                                            ?.mainFrameDeflection ||
                                                          ""
                                                        }
                                                        onChange={(e) =>
                                                          handleDeflectionCriteriaChange(
                                                            building.id,
                                                            "mainFrameDeflection",
                                                            e.target.value
                                                          )
                                                        }
                                                      />
                                                    </Col>

                                                    {getDynamicDeflectionFields(
                                                      building
                                                    ).map(
                                                      (fieldName, index) => (
                                                        <Col
                                                          key={fieldName}
                                                          xs={12}
                                                          md={2}
                                                          lg={2}
                                                          className="d-flex align-items-center commTopButtonRightLeftPadding mt-2"
                                                        >
                                                          <InputField
                                                            className="inputBox d-inline"
                                                            value={
                                                              building
                                                                ?.deflectionCriteria?.[
                                                                fieldName
                                                              ] || ""
                                                            }
                                                            onChange={(e) =>
                                                              handleDeflectionCriteriaChange(
                                                                building.id,
                                                                fieldName,
                                                                e.target.value
                                                              )
                                                            }
                                                          />
                                                          <span
                                                            className="ml-2"
                                                            onClick={() =>
                                                              removeDynamicDeflectionField(
                                                                building.id,
                                                                fieldName
                                                              )
                                                            }
                                                          >
                                                            <i className="bi bi-trash text-danger cursor-pointer"></i>
                                                          </span>
                                                        </Col>
                                                      )
                                                    )}
                                                  </Row>

                                                  {/* Minimum Thickness Section */}
                                                  <Row className="mb-2 mt-4">
                                                    <Col
                                                      xs={12}
                                                      md={12}
                                                      lg={12}
                                                      className="d-flex align-items-center"
                                                    >
                                                      <h5 className="mb-2 text-primary">
                                                        Minimum Thickness
                                                      </h5>
                                                      <button
                                                        class="inline-flex items-center justify-center 
            text-blue-500 
            transition-all duration-300 
            w-10 h-10 
            hover:text-blue-600 
            hover:scale-125 
            hover:bg-blue-100 
            rounded-full 
            hover:shadow-[0_0_10px_rgba(59,130,246,0.7)]"
                                                        onClick={() =>
                                                          addDynamicThicknessField(
                                                            building.id
                                                          )
                                                        }
                                                      >
                                                        <i class="bi bi-plus-circle text-2xl"></i>
                                                      </button>
                                                    </Col>
                                                    <Col
                                                      xs={12}
                                                      md={3}
                                                      lg={3}
                                                      className="commTopButtonRightLeftPadding"
                                                    >
                                                      <InputField
                                                        label="Main Frame"
                                                        className="inputBox"
                                                        name="mainFrame"
                                                        value={
                                                          building
                                                            ?.minimumThickness
                                                            ?.mainFrame || ""
                                                        }
                                                        onChange={(e) =>
                                                          handleMinimumThicknessChange(
                                                            building.id,
                                                            "mainFrame",
                                                            e.target.value
                                                          )
                                                        }
                                                      />
                                                    </Col>
                                                    <Col
                                                      xs={12}
                                                      md={3}
                                                      lg={3}
                                                      className="commTopButtonRightLeftPadding"
                                                    >
                                                      <InputField
                                                        label="CR Sections"
                                                        className="inputBox"
                                                        name="crSections"
                                                        value={
                                                          building
                                                            ?.minimumThickness
                                                            ?.crSections || ""
                                                        }
                                                        onChange={(e) =>
                                                          handleMinimumThicknessChange(
                                                            building.id,
                                                            "crSections",
                                                            e.target.value
                                                          )
                                                        }
                                                      />
                                                    </Col>

                                                    {getDynamicThicknessFields(
                                                      building
                                                    ).map(
                                                      (fieldName, index) => (
                                                        <Col
                                                          key={fieldName}
                                                          xs={12}
                                                          md={2}
                                                          lg={2}
                                                          className="d-flex align-items-center commTopButtonRightLeftPadding mt-2"
                                                        >
                                                          <InputField
                                                            className="inputBox d-inline"
                                                            value={
                                                              building
                                                                ?.minimumThickness?.[
                                                                fieldName
                                                              ] || ""
                                                            }
                                                            onChange={(e) =>
                                                              handleMinimumThicknessChange(
                                                                building.id,
                                                                fieldName,
                                                                e.target.value
                                                              )
                                                            }
                                                          />
                                                          <span
                                                            className="ml-2"
                                                            onClick={() =>
                                                              removeDynamicThicknessField(
                                                                building.id,
                                                                fieldName
                                                              )
                                                            }
                                                          >
                                                            <i className="bi bi-trash text-danger cursor-pointer"></i>
                                                          </span>
                                                        </Col>
                                                      )
                                                    )}
                                                  </Row>
                                                </Col>
                                              </Row>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                ))}
                              </div>

                              {building?.buildingTypesCode && (
                                <div className="accordion mb-3">
                                  <div className="accordion-item">
                                    <h2 className="accordion-header">
                                      <Row className="accordion-button">
                                        <Col
                                          xs={1}
                                          md={1}
                                          lg={1}
                                          className="text-left arrowBtn"
                                        >
                                          <i
                                            className={`bi ${
                                              building.isCardVisible2
                                                ? "bi-chevron-right"
                                                : "bi-chevron-down"
                                            }`}
                                            onClick={() =>
                                              toggleCardVisibility2(building.id)
                                            }
                                          ></i>
                                        </Col>
                                        <Col
                                          xs={1}
                                          md={1}
                                          lg={1}
                                          className="text-center logoBtn"
                                        >
                                          <span className="iconLogo">BD</span>
                                        </Col>
                                        <Col xs={4} md={4} lg={4}>
                                          <span className="headerTitle">
                                            Building Structure Details{" "}
                                            {index + 1}
                                          </span>
                                          <span className="subHeaderTitle">
                                            Building Structure details
                                          </span>
                                        </Col>
                                      </Row>
                                    </h2>
                                    <div
                                      className={`accordion-collapse collapse show ${
                                        building.isCardVisible2 ? "visible" : ""
                                      }`}
                                    >
                                      <hr />
                                      <div>
                                        <h5 className="p-2 text-primary">
                                          Area Calculation
                                        </h5>

                                        <div className="d-flex flex-row flex-wrap gap-4 p-2">
                                          <div style={{ fontSize: "16px" }}>
                                            <Form.Check
                                              label="Canopy"
                                              checked={
                                                building.includeCanopy || false
                                              }
                                              disabled={
                                                !building.additionalComponents
                                                  ?.canopy
                                              }
                                              onChange={(e) =>
                                                handleCheckboxToggle(
                                                  building.id,
                                                  "canopy",
                                                  e.target.checked
                                                )
                                              }
                                            />
                                          </div>

                                          <div style={{ fontSize: "16px" }}>
                                            <Form.Check
                                              label="Frame Opening"
                                              checked={
                                                building.includeFrameOpening ||
                                                false
                                              }
                                              disabled={
                                                !building.additionalComponents
                                                  ?.frameOpening
                                              }
                                              onChange={(e) =>
                                                handleCheckboxToggle(
                                                  building.id,
                                                  "frameOpening",
                                                  e.target.checked
                                                )
                                              }
                                            />
                                          </div>

                                          <div style={{ fontSize: "16px" }}>
                                            <Form.Check
                                              label="Lean To"
                                              checked={
                                                building.includeLeanTo || false
                                              }
                                              disabled={
                                                !building.additionalComponents
                                                  ?.leanTo
                                              }
                                              onChange={(e) =>
                                                handleCheckboxToggle(
                                                  building.id,
                                                  "leanTo",
                                                  e.target.checked
                                                )
                                              }
                                            />
                                          </div>

                                          <div style={{ fontSize: "16px" }}>
                                            <Form.Check
                                              label="Fixed Louvers"
                                              checked={
                                                building.includeFixedLouvers ||
                                                false
                                              }
                                              disabled={
                                                !building.additionalComponents
                                                  ?.fixedLouvers
                                              }
                                              onChange={(e) =>
                                                handleCheckboxToggle(
                                                  building.id,
                                                  "fixedLouvers",
                                                  e.target.checked
                                                )
                                              }
                                            />
                                          </div>

                                          <div style={{ fontSize: "16px" }}>
                                            <Form.Check
                                              label="Structural Louvers"
                                              checked={
                                                building.includeStructuralLouvers ||
                                                false
                                              }
                                              disabled={
                                                !building.additionalComponents
                                                  ?.structuralLouvers
                                              }
                                              onChange={(e) =>
                                                handleCheckboxToggle(
                                                  building.id,
                                                  "structuralLouvers",
                                                  e.target.checked
                                                )
                                              }
                                            />
                                          </div>

                                          <div style={{ fontSize: "16px" }}>
                                            <Form.Check
                                              label="Fascia"
                                              checked={
                                                building.includeFascia || false
                                              }
                                              disabled={
                                                !building.additionalComponents
                                                  ?.fascia
                                              }
                                              onChange={(e) =>
                                                handleCheckboxToggle(
                                                  building.id,
                                                  "fascia",
                                                  e.target.checked
                                                )
                                              }
                                            />
                                          </div>
                                          <div style={{ fontSize: "16px" }}>
                                            <Form.Check
                                              label="Partition Wall"
                                              checked={
                                                building.includePartitionWall ||
                                                false
                                              }
                                              disabled={
                                                !building.additionalComponents
                                                  ?.partitionWall
                                              }
                                              onChange={(e) =>
                                                handleCheckboxToggle(
                                                  building.id,
                                                  "partitionWall",
                                                  e.target.checked
                                                )
                                              }
                                            />
                                          </div>
                                          <div style={{ fontSize: "16px" }}>
                                            <Form.Check
                                              label="Mezzanine"
                                              checked={
                                                building.includeMezzanine ||
                                                false
                                              }
                                              disabled={
                                                !building.additionalComponents
                                                  ?.mezzanine
                                              }
                                              onChange={(e) =>
                                                handleCheckboxToggle(
                                                  building.id,
                                                  "mezzanine",
                                                  e.target.checked
                                                )
                                              }
                                            />
                                          </div>
                                        </div>
                                      </div>

                                      {/* Structure Attachments Section */}
                                      <Row>
                                        <h5 className="mb-3 p-2 text-primary">
                                          Structure Attachments
                                        </h5>

                                        {/* SCOPE OF WORK */}
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={4}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <FileUploadComponentForHB
                                            id={`scopeOfwork-${building.id}`}
                                            name="scopeOfwork"
                                            label="SCOPE OF WORK"
                                            allowedTypes={["image/png", "image/jpeg", "application/pdf", ".dwg"]}
                                            multiple={true}
                                            onSuccessUpload={(file) =>
                                              onSuccessUploadDocumentType(
                                                file,
                                                building.id
                                              )
                                            }
                                            value={building.scopeOfwork || ""}
                                          />
                                        </Col>

                                        <Col
                                          xs={12}
                                          md={1}
                                          lg={1}
                                          className="commTopButtonRightLeftPadding d-flex align-items-center"
                                        >
                                          {building.scopeOfwork ? (
                                            <i
                                              className="bi bi-eye-fill"
                                              style={{
                                                fontSize: "1.5rem",
                                                color: "#007bff",
                                                cursor: "pointer",
                                                marginLeft: "8px",
                                                transition:
                                                  "transform 0.2s ease, color 0.2s ease",
                                              }}
                                              onClick={() =>
                                                handleViewFile(
                                                  building.scopeOfwork,
                                                  building.id
                                                )
                                              }
                                              onMouseEnter={(e) =>
                                                (e.target.style.transform =
                                                  "scale(1.2)")
                                              }
                                              onMouseLeave={(e) =>
                                                (e.target.style.transform =
                                                  "scale(1)")
                                              }
                                            ></i>
                                          ) : (
                                            "--"
                                          )}
                                        </Col>

                                        {/* DRAWING */}
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={4}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <FileUploadComponentForHB
                                            id={`drawing-${building.id}`}
                                            name="drawing"
                                            label="DRAWING"
                                            allowedTypes={["image/png", "image/jpeg", "application/pdf", ".dwg"]}
                                            multiple={true}
                                            onSuccessUpload={(file) =>
                                              onSuccessUploadDocumentType(
                                                file,
                                                building.id
                                              )
                                            }
                                            value={building.drawing || ""}
                                          />
                                        </Col>

                                        <Col
                                          xs={12}
                                          md={1}
                                          lg={1}
                                          className="commTopButtonRightLeftPadding d-flex align-items-center"
                                        >
                                          {building.drawing ? (
                                            <i
                                              className="bi bi-eye-fill"
                                              style={{
                                                fontSize: "1.5rem",
                                                color: "#007bff",
                                                cursor: "pointer",
                                                marginLeft: "8px",
                                                transition:
                                                  "transform 0.2s ease, color 0.2s ease",
                                              }}
                                              onClick={() =>
                                                handleViewFile(
                                                  building.drawing,
                                                  building.id
                                                )
                                              }
                                              onMouseEnter={(e) =>
                                                (e.target.style.transform =
                                                  "scale(1.2)")
                                              }
                                              onMouseLeave={(e) =>
                                                (e.target.style.transform =
                                                  "scale(1)")
                                              }
                                            ></i>
                                          ) : (
                                            "--"
                                          )}
                                        </Col>
                                      </Row>

                                      {/* Components Section */}
                                      <div className="mb-3">
                                        <h5 className="mb-3 text-primary p-2">
                                          Components
                                        </h5>
                                        <div className="d-flex flex-row flex-wrap gap-4 p-2">
                                          {[
                                            "Lean To",
                                            "Canopy",
                                            "Frame Opening",
                                            "Fixed Louvers",
                                            "Structural Louvers",
                                            "Block Wall Height",
                                            "Type Of Bracing",
                                            "Fascia",
                                          ].map((option, optIndex) => {
                                            const camelCaseOption = option
                                              .replace(
                                                /\s(.)/g,
                                                (match, group1) =>
                                                  group1.toUpperCase()
                                              )
                                              .replace(/\s/g, "")
                                              .replace(/^(.)/, (match) =>
                                                match.toLowerCase()
                                              );

                                            return (
                                              <div
                                                className="form-check mb-2"
                                                key={camelCaseOption}
                                              >
                                                <input
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  id={`check-${building.id}-${camelCaseOption}`}
                                                  style={{
                                                    width: "20px",
                                                    height: "20px",
                                                  }}
                                                  checked={
                                                    building
                                                      .additionalComponents?.[
                                                      camelCaseOption
                                                    ] || false
                                                  }
                                                  onChange={(e) =>
                                                    handleAdditionalComponentsChange(
                                                      camelCaseOption,
                                                      e.target.checked,
                                                      building.id
                                                    )
                                                  }
                                                />
                                                <label
                                                  className="form-check-label ms-2"
                                                  htmlFor={`check-${building.id}-${camelCaseOption}`}
                                                  style={{ fontSize: "16px" }}
                                                >
                                                  {`${
                                                    optIndex + 1
                                                  }. ${option.toUpperCase()}`}
                                                </label>
                                              </div>
                                            );
                                          })}
                                        </div>
                                      </div>

                                      {/* Front End Wall Section */}
                                      <div className="table-responsive">
                                        <div className="mb-4">
                                          <Row className="align-items-center justify-content-between">
                                            <Col>
                                              <h5 className="p-2 text-primary mb-0">
                                                Front Side Wall
                                              </h5>
                                            </Col>
                                          </Row>

                                          <Row className="mb-1 w-75">
                                            <Col
                                              className="commTopButtonRightLeftPadding"
                                              xs={12}
                                              md={6}
                                              lg={3}
                                            >
                                              <InputField
                                                className="inputBox"
                                                type="number"
                                                label="Front End Wall in (M)"
                                                placeholder="Width of Building"
                                                value={
                                                  building.front.meters === ""
                                                    ? ""
                                                    : building.front.meters
                                                }
                                                onChange={(e) =>
                                                  handleFrontMetersChange(
                                                    e.target.value,
                                                    building.id
                                                  )
                                                }
                                              />
                                            </Col>

                                            <Col
                                              className="commTopButtonRightLeftPadding"
                                              xs={12}
                                              md={6}
                                              lg={3}
                                            >
                                              <InputField
                                                className="inputBox"
                                                type="number"
                                                label="No Of Bays"
                                                value={
                                                  building.front.bays === 0
                                                    ? ""
                                                    : building.front.bays
                                                }
                                                onChange={(e) =>
                                                  handleFrontBaysChange(
                                                    e.target.value,
                                                    building.id
                                                  )
                                                }
                                              />
                                            </Col>
                                            {building.additionalComponents?.blockWallHeight && (
                                            <Col
                                              className="commTopButtonRightLeftPadding"
                                              xs={12}
                                              md={6}
                                              lg={3}
                                            >
                                              <InputField
                                                type="text"
                                                className="inputBox"
                                                label="Block Wall Height"
                                                value={
                                                  building.front
                                                    .blockWallHeight || ""
                                                }
                                                onChange={(e) =>
                                                  handleBlockWallHeightChange(
                                                    e.target.value,
                                                    building.id
                                                  )
                                                }
                                              />
                                            </Col>
                                            )}

                                            <Col
                                              xs={12}
                                              md={6}
                                              lg={3}
                                              className="commTopButtonRightLeftPadding"
                                            >
                                              <ComboboxField
                                                className="inputBox"
                                                label="Building Inputs"
                                                data={buildingInputs}
                                                name="buildingInputs"
                                                setValue={
                                                  building.front
                                                    ?.buildingInputs || ""
                                                }
                                                id={`buildingInputs-front-${building.id}`}
                                                code={`buildingFrontInputsCode-${building.id}`}
                                                description="buildingInputsDesc"
                                                getvalue={setDropdownData}
                                              />
                                            </Col>

                                            {building.front?.buildingInputs ===
                                              "Other" && (
                                              <Col
                                                xs={12}
                                                md={6}
                                                lg={3}
                                                className="commTopButtonRightLeftPadding"
                                              >
                                                <InputField
                                                  className="inputBox"
                                                  type="text"
                                                  label="Front Other Building Input"
                                                  name="frontOtherBuildingInputs"
                                                  value={
                                                    building?.front
                                                      ?.frontOtherBuildingInputs ===
                                                    ""
                                                      ? ""
                                                      : building?.front
                                                          ?.frontOtherBuildingInputs
                                                  }
                                                  onChange={(e) =>
                                                    handleFrontOtherBuildingInputsChange(
                                                      e.target.value,
                                                      building.id
                                                    )
                                                  }
                                                />
                                              </Col>
                                            )}
                                          </Row>

                                          {/* Front End Wall Table */}
                                          {building.front &&
                                            Array.isArray(
                                              building.front.rows
                                            ) &&
                                            building.front.rows.length > 0 && (
                                              <>
                                                <div
                                                  className={`table-scroll-wrapper ${
                                                    building.isTableScrolled
                                                      ? "scrolled"
                                                      : ""
                                                  }`}
                                                >
                                                  <table className="table table-bordered table-sm text-center align-middle mb-3">
                                                    <thead
                                                      className="bg-light"
                                                      style={{
                                                        position: "sticky",
                                                        top: 0,
                                                        zIndex: 2,
                                                      }}
                                                    >
                                                      <tr>
                                                        <th>Grid Line</th>
                                                        <th>Bay Spacing</th>
                                                        {building
                                                          .additionalComponents
                                                          ?.blockWallHeight && (
                                                          <th>
                                                            Block Wall Height
                                                          </th>
                                                        )}
                                                        <th>
                                                          Purlin/Girt Condition
                                                        </th>

                                                        {/* Dynamic columns */}
                                                        {building
                                                          .additionalComponents
                                                          ?.frameOpening && (
                                                          <th
                                                            title="View Details"
                                                            className="cursor-pointer text-green-600 hover:text-green-800 transition-colors duration-200"
                                                            onClick={() =>
                                                              showDataViewModal(
                                                                {
                                                                  showComponent:
                                                                    "FRAMEOPENING",
                                                                }
                                                              )
                                                            }
                                                          >
                                                            Frame Opening
                                                          </th>
                                                        )}
                                                        {building
                                                          .additionalComponents
                                                          ?.canopy && (
                                                          <th
                                                            title="View Details"
                                                            className="cursor-pointer text-green-600 hover:text-green-800 transition-colors duration-200"
                                                            onClick={() =>
                                                              showDataViewModal(
                                                                {
                                                                  showComponent:
                                                                    "CANOPY",
                                                                }
                                                              )
                                                            }
                                                          >
                                                            Canopy
                                                          </th>
                                                        )}
                                                        {building
                                                          .additionalComponents
                                                          ?.leanTo && (
                                                          <th
                                                            title="View Details"
                                                            className="cursor-pointer text-green-600 hover:text-green-800 transition-colors duration-200"
                                                            onClick={() =>
                                                              showDataViewModal(
                                                                {
                                                                  showComponent:
                                                                    "LEANTO",
                                                                }
                                                              )
                                                            }
                                                          >
                                                            Lean-To
                                                          </th>
                                                        )}
                                                        {building
                                                          .additionalComponents
                                                          ?.fixedLouvers && (
                                                          <th
                                                            title="View Details"
                                                            className="cursor-pointer text-green-600 hover:text-green-800 transition-colors duration-200"
                                                            onClick={() =>
                                                              showDataViewModal(
                                                                {
                                                                  showComponent:
                                                                    "FIXEDLOUVERS",
                                                                }
                                                              )
                                                            }
                                                          >
                                                            Fixed Louvers
                                                          </th>
                                                        )}
                                                        {building
                                                          .additionalComponents
                                                          ?.structuralLouvers && (
                                                          <th
                                                            title="View Details"
                                                            className="cursor-pointer text-green-600 hover:text-green-800 transition-colors duration-200"
                                                            onClick={() =>
                                                              showDataViewModal(
                                                                {
                                                                  showComponent:
                                                                    "STRUCTURALLOUVERS",
                                                                }
                                                              )
                                                            }
                                                          >
                                                            Structural Louvers
                                                          </th>
                                                        )}
                                                        {building
                                                          .additionalComponents
                                                          ?.typeOfBracing && (
                                                          <th
                                                            title="View Details"
                                                            className="text-green-600"
                                                            // onClick={() =>
                                                            //   showDataViewModal(
                                                            //     {
                                                            //       showComponent:
                                                            //         "TYPEOFBRACING",
                                                            //     }
                                                            //   )
                                                            // }
                                                          >
                                                            Type Of Bracing
                                                          </th>
                                                        )}
                                                        {building
                                                          .additionalComponents
                                                          ?.fascia && (
                                                          <th
                                                            title="View Details"
                                                            className="cursor-pointer text-green-600 hover:text-green-800 transition-colors duration-200"
                                                            onClick={() =>
                                                              showDataViewModal(
                                                                {
                                                                  showComponent:
                                                                    "FASCIA",
                                                                }
                                                              )
                                                            }
                                                          >
                                                            Fascia
                                                          </th>
                                                        )}
                                                        {/* Add other dynamic columns as needed */}
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      {building.front.rows.map(
                                                        (row, i) => (
                                                          <tr key={i}>
                                                            <td>
                                                              <InputField
                                                                type="text"
                                                                className="form-control"
                                                                value={
                                                                  row.wall || ""
                                                                }
                                                                onChange={(e) =>
                                                                  handleFrontRowChange(
                                                                    i,
                                                                    "wall",
                                                                    e.target
                                                                      .value,
                                                                    building.id
                                                                  )
                                                                }
                                                               
                                                                onKeyDown={(e) =>
                                                                handleEnterKey(
                                                                  e,
                                                                  "front",
                                                                  building.id,
                                                                  i,
                                                                  "wall"
                                                                )
                                                              }

                                                                inputRef={(
                                                                  el
                                                                ) =>
                                                                  (inputRefs.current[
                                                                    `front-${building.id}-wall-${i}`
                                                                  ] = el)
                                                                }
                                                              />
                                                            </td>
                                                            {/* 
                                                            <td>
                                                              <InputField
                                                                type="number"
                                                                className="form-control"
                                                                value={
                                                                  row.baySpacing ||
                                                                  ""
                                                                }
                                                                onChange={(e) =>
                                                                  handleFrontRowChange(
                                                                    i,
                                                                    "baySpacing",
                                                                    e.target
                                                                      .value,
                                                                    building.id
                                                                  )
                                                                }
                                                                onKeyDown={(
                                                                  e
                                                                ) =>
                                                                  handleEnterKey(
                                                                    e,
                                                                    building.id,
                                                                    i,
                                                                    "baySpacing"
                                                                  )
                                                                }
                                                                inputRef={(
                                                                  el
                                                                ) =>
                                                                  (inputRefs.current[
                                                                    `${building.id}-baySpacing-${i}`
                                                                  ] = el)
                                                                }
                                                              />
                                                            </td> */}
                                                            <td>
                                                              <InputField
                                                                type="number"
                                                                step="0.001"
                                                                className="form-control"
                                                                value={
                                                                  row.baySpacing ??
                                                                  ""
                                                                }
                                                                onChange={(e) =>
                                                                  handleFrontRowChange(
                                                                    i,
                                                                    "baySpacing",
                                                                    e.target
                                                                      .value,
                                                                    building.id
                                                                  )
                                                                }
                                                                onBlur={(e) =>
                                                                  handleFrontRowChange(
                                                                    i,
                                                                    "baySpacing",
                                                                    e.target
                                                                      .value,
                                                                    building.id,
                                                                    true
                                                                  )
                                                                }
                                                                onKeyDown={(e) =>
                                                                handleEnterKey(
                                                                  e,
                                                                  "front",
                                                                  building.id,
                                                                  i,
                                                                  "baySpacing"
                                                                )
                                                              }

                                                                inputRef={(
                                                                  el
                                                                ) =>
                                                                  (inputRefs.current[
                                                                    `front-${building.id}-baySpacing-${i}`
                                                                  ] = el)
                                                                }
                                                                
                                                              />
                                                            </td>

                                                            {building
                                                              .additionalComponents
                                                              ?.blockWallHeight && (
                                                              <td>
                                                                <InputField
                                                                  type="text"
                                                                  className="form-control form-control-sm"
                                                                  value={
                                                                    row.blockWallHeight ||
                                                                    ""
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    handleFrontRowChange(
                                                                      i,
                                                                      "blockWallHeight",
                                                                      e.target
                                                                        .value,
                                                                      building.id
                                                                    )
                                                                  }
                                                                 onKeyDown={(e) =>
                                                                handleEnterKey(
                                                                  e,
                                                                  "front",
                                                                  building.id,
                                                                  i,
                                                                  "blockWallHeight"
                                                                )
                                                              }

                                                                inputRef={(
                                                                  el
                                                                ) =>
                                                                  (inputRefs.current[
                                                                    `front-${building.id}-blockWallHeight-${i}`
                                                                  ] = el)
                                                                }
                                                                />
                                                              </td>
                                                            )}

                                                            <td>
                                                              <select
                                                                value={
                                                                  row.purlinGirtCondition ||
                                                                  "Bypass"
                                                                }
                                                                onChange={(e) =>
                                                                  handleFrontRowChange(
                                                                    i,
                                                                    "purlinGirtCondition",
                                                                    e.target
                                                                      .value,
                                                                    building.id
                                                                  )
                                                                }
                                                              >
                                                                <option value="Bypass">
                                                                  ByPass
                                                                </option>
                                                                <option value="Flush">
                                                                  Flush
                                                                </option>
                                                              </select>
                                                            </td>

                                                            {/* Dynamic columns data */}
                                                            {building
                                                              .additionalComponents
                                                              ?.frameOpening && (
                                                              <td>
                                                                <select
                                                                  value={
                                                                    row.frameOpening ||
                                                                    "No"
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    handleFrontRowChange(
                                                                      i,
                                                                      "frameOpening",
                                                                      e.target
                                                                        .value,
                                                                      building.id
                                                                    )
                                                                  }
                                                                  className={`border rounded px-2 py-1 ${
                                                                    row.frameOpening ===
                                                                    "Yes"
                                                                      ? "bg-green-200 text-green-800"
                                                                      : "bg-white"
                                                                  }`}
                                                                >
                                                                  <option value="No">
                                                                    No
                                                                  </option>
                                                                  <option value="Yes">
                                                                    Yes
                                                                  </option>
                                                                </select>
                                                              </td>
                                                            )}

                                                            {building
                                                              .additionalComponents
                                                              ?.canopy && (
                                                              <td>
                                                                <select
                                                                  value={
                                                                    row.canopy ||
                                                                    "No"
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    handleFrontRowChange(
                                                                      i,
                                                                      "canopy",
                                                                      e.target
                                                                        .value,
                                                                      building.id
                                                                    )
                                                                  }
                                                                  className={`border rounded px-2 py-1 ${
                                                                    row.canopy ===
                                                                    "Yes"
                                                                      ? "bg-green-200 text-green-800"
                                                                      : "bg-white"
                                                                  }`}
                                                                >
                                                                  <option value="No">
                                                                    No
                                                                  </option>
                                                                  <option value="Yes">
                                                                    Yes
                                                                  </option>
                                                                </select>
                                                              </td>
                                                            )}
                                                            {building
                                                              .additionalComponents
                                                              ?.leanTo && (
                                                              <td>
                                                                <select
                                                                  value={
                                                                    row.leanTo ||
                                                                    "No"
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    handleFrontRowChange(
                                                                      i,
                                                                      "leanTo",
                                                                      e.target
                                                                        .value,
                                                                      building.id
                                                                    )
                                                                  }
                                                                  className={`border rounded px-2 py-1 ${
                                                                    row.leanTo ===
                                                                    "Yes"
                                                                      ? "bg-green-200 text-green-800"
                                                                      : "bg-white"
                                                                  }`}
                                                                >
                                                                  <option value="No">
                                                                    No
                                                                  </option>
                                                                  <option value="Yes">
                                                                    Yes
                                                                  </option>
                                                                </select>
                                                              </td>
                                                            )}
                                                            {building
                                                              .additionalComponents
                                                              ?.fixedLouvers && (
                                                              <td>
                                                                <select
                                                                  value={
                                                                    row.fixedLouvers ||
                                                                    "No"
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    handleFrontRowChange(
                                                                      i,
                                                                      "fixedLouvers",
                                                                      e.target
                                                                        .value,
                                                                      building.id
                                                                    )
                                                                  }
                                                                  className={`border rounded px-2 py-1 ${
                                                                    row.fixedLouvers ===
                                                                    "Yes"
                                                                      ? "bg-green-200 text-green-800"
                                                                      : "bg-white"
                                                                  }`}
                                                                >
                                                                  <option value="No">
                                                                    No
                                                                  </option>
                                                                  <option value="Yes">
                                                                    Yes
                                                                  </option>
                                                                </select>
                                                              </td>
                                                            )}

                                                            {building
                                                              .additionalComponents
                                                              ?.structuralLouvers && (
                                                              <td>
                                                                <select
                                                                  value={
                                                                    row.structuralLouvers ||
                                                                    "No"
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    handleFrontRowChange(
                                                                      i,
                                                                      "structuralLouvers",
                                                                      e.target
                                                                        .value,
                                                                      building.id
                                                                    )
                                                                  }
                                                                  className={`border rounded px-2 py-1 ${
                                                                    row.structuralLouvers ===
                                                                    "Yes"
                                                                      ? "bg-green-200 text-green-800"
                                                                      : "bg-white"
                                                                  }`}
                                                                >
                                                                  <option value="No">
                                                                    No
                                                                  </option>
                                                                  <option value="Yes">
                                                                    Yes
                                                                  </option>
                                                                </select>
                                                              </td>
                                                            )}
                                                            {building
                                                              .additionalComponents
                                                              ?.typeOfBracing && (
                                                              <td>
                                                                <select
                                                                  value={
                                                                    row.typeOfBracing
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    handleFrontRowChange(
                                                                      i,
                                                                      "typeOfBracing",
                                                                      e.target
                                                                        .value,
                                                                      building.id
                                                                    )
                                                                  }
                                                                  className={`border rounded px-2 py-1 ${
                                                                    row.typeOfBracing ===
                                                                    "Yes"
                                                                      ? "bg-green-200 text-green-800"
                                                                      : "bg-white"
                                                                  }`}
                                                                >
                                                                  <option value="Nill">
                                                                    Nill
                                                                  </option>
                                                                  <option value="RodBracing">
                                                                    RodBracing
                                                                  </option>
                                                                  <option value="PortalBracing">
                                                                    PortalBracing
                                                                  </option>
                                                                  <option value="Pipe/TubeBracing">
                                                                    Pipe/TubeBracing
                                                                  </option>
                                                                </select>
                                                              </td>
                                                            )}
                                                            {building
                                                              .additionalComponents
                                                              ?.fascia && (
                                                              <td>
                                                                <select
                                                                  value={
                                                                    row.fascia ||
                                                                    "No"
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    handleFrontRowChange(
                                                                      i,
                                                                      "fascia",
                                                                      e.target
                                                                        .value,
                                                                      building.id
                                                                    )
                                                                  }
                                                                  className={`border rounded px-2 py-1 ${
                                                                    row.fascia ===
                                                                    "Yes"
                                                                      ? "bg-green-200 text-green-800"
                                                                      : "bg-white"
                                                                  }`}
                                                                >
                                                                  <option value="No">
                                                                    No
                                                                  </option>
                                                                  <option value="Yes">
                                                                    Yes
                                                                  </option>
                                                                </select>
                                                              </td>
                                                            )}

                                                            {/* Add similar blocks for other dynamic columns... */}
                                                          </tr>
                                                        )
                                                      )}
                                                    </tbody>
                                                  </table>
                                                </div>

                                                {/* Validation message */}
                                                {validateFrontBaySpacing(
                                                  building
                                                ) && (
                                                  <div
                                                    style={{
                                                      color: "red",
                                                      fontSize: "13px",
                                                      marginTop: "5px",
                                                    }}
                                                  >
                                                    ⚠️ Total bay spacing (
                                                    {building.front.rows.reduce(
                                                      (s, r) =>
                                                        s +
                                                        Number(
                                                          r.baySpacing || 0
                                                        ),
                                                      0
                                                    )}{" "}
                                                    m) does not match total
                                                    meters (
                                                    {building.front.meters} m)
                                                  </div>
                                                )}
                                              </>
                                            )}
                                        </div>
                                      </div>
                                      {/* Check Box for FEW = BEW  START*/}

                                      <div className="d-flex align-items-center justify-content-start flex-wrap my-3 p-2 rounded bg-light border">
                                        <input
                                          type="checkbox"
                                          id={`copyFrontToBack-${building.id}`}
                                          className="form-check-input me-2"
                                          style={{
                                            transform: "scale(1.4)",
                                            cursor: "pointer",
                                          }}
                                          checked={
                                            building.copyFrontToBack || false
                                          }
                                          onChange={(e) =>
                                            handleCopyFrontToBackChange(
                                              e,
                                              building.id
                                            )
                                          }
                                        />
                                        <label
                                          htmlFor={`copyFrontToBack-${building.id}`}
                                          className="form-check-label fw-semibold text-secondary"
                                          style={{
                                            fontSize: "1rem",
                                            cursor: "pointer",
                                          }}
                                        >
                                          FEW = BEW
                                        </label>
                                      </div>
                                      {/* Check Box for FEW = BEW  START*/}

                                      {/* BACK END WALL START */}

                                      <div className="mb-4">
                                        <Row className="align-items-center justify-content-between">
                                          <Col>
                                            <h5 className="p-2 text-primary mb-0">
                                              Back End Wall
                                            </h5>
                                          </Col>
                                        </Row>

                                        <Row className="mb-1 w-75">
                                          <Col
                                            className="commTopButtonRightLeftPadding"
                                            xs={12}
                                            md={6}
                                            lg={3}
                                          >
                                            <InputField
                                              className="inputBox"
                                              type="number"
                                              name="meters"
                                              label="Back End Wall (M)"
                                              placeholder="Width of Building"
                                              value={
                                                building.back.meters === ""
                                                  ? ""
                                                  : building.back.meters
                                              }
                                              onChange={(e) =>
                                                handleBackMetersChange(
                                                  e.target.value,
                                                  building.id
                                                )
                                              }
                                              disabled={
                                                building.copyFrontToBack
                                              } // Add this line
                                            />
                                          </Col>
                                          <Col
                                            className="commTopButtonRightLeftPadding"
                                            xs={12}
                                            md={6}
                                            lg={3}
                                          >
                                            <InputField
                                              className="inputBox"
                                              type="number"
                                              label="No Of Bays"
                                              value={
                                                building.back.bays === 0
                                                  ? ""
                                                  : building.back.bays
                                              }
                                              onChange={(e) =>
                                                handleBackBaysChange(
                                                  e.target.value,
                                                  building.id
                                                )
                                              }
                                              disabled={
                                                building.copyFrontToBack
                                              }
                                            />
                                          </Col>
                                          {building.additionalComponents?.blockWallHeight && (

                                          <Col
                                            className="commTopButtonRightLeftPadding"
                                            xs={12}
                                            md={6}
                                            lg={3}
                                          >
                                            <InputField
                                              className="inputBox"
                                              type="text"
                                              label="Block Wall Height"
                                              value={
                                                building.back.blockWallHeight ||
                                                ""
                                              }
                                              onChange={(e) =>
                                                handleBackBlockWallHeightChange(
                                                  e.target.value,
                                                  building.id
                                                )
                                              }
                                              // disabled={
                                              //   building.copyFrontToBack
                                              // } // Add this line
                                            />
                                          </Col>
                                                                                      )}
                                          <Col
                                            xs={12}
                                            md={6}
                                            lg={3}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <ComboboxField
                                              className="inputBox"
                                              label="Building Inputs"
                                              data={buildingInputs}
                                              name="buildingInputs"
                                              setValue={
                                                building.back?.buildingInputs ||
                                                ""
                                              }
                                              id={`buildingInputs-back-${building.id}`}
                                              code={`buildingBackInputsCode-${building.id}`}
                                              description="buildingInputsDesc"
                                              getvalue={setDropdownData}
                                              // disabled={
                                              //   building.copyFrontToBack
                                              // }
                                            />
                                          </Col>
                                          {building.back?.buildingInputs ===
                                            "Other" && (
                                            <Col
                                              xs={12}
                                              md={6}
                                              lg={3}
                                              className="commTopButtonRightLeftPadding"
                                            >
                                              <InputField
                                                className="inputBox"
                                                type="text"
                                                label="Back Other Building Input"
                                                name="backOtherBuildingInputs"
                                                value={
                                                  building?.back
                                                    ?.backOtherBuildingInputs ===
                                                  ""
                                                    ? ""
                                                    : building?.back
                                                        ?.backOtherBuildingInputs
                                                }
                                                onChange={(e) =>
                                                  handleBackOtherBuildingInputsChange(
                                                    e.target.value,
                                                    building.id
                                                  )
                                                }
                                              />
                                            </Col>
                                          )}
                                        </Row>

                                        {building.back &&
                                          Array.isArray(building.back.rows) &&
                                          building.back.rows.length > 0 && (
                                            <>
                                              <div
                                                className={`table-scroll-wrapper ${
                                                  building.isTableScrolled
                                                    ? "scrolled"
                                                    : ""
                                                }`}
                                              >
                                                <table className="table table-bordered table-sm text-center align-middle mb-3">
                                                  <thead
                                                    className="bg-light"
                                                    style={{
                                                      position: "sticky",
                                                      top: 0,
                                                      zIndex: 2,
                                                    }}
                                                  >
                                                    <tr>
                                                      <th>Grid Line</th>
                                                      <th>Bay Spacing</th>
                                                      {building
                                                        .additionalComponents
                                                        ?.blockWallHeight && (
                                                        <th>
                                                          Block Wall Height
                                                        </th>
                                                      )}
                                                      <th>
                                                        Purlin/Girt Condition
                                                      </th>

                                                      {/* Dynamic columns */}
                                                      {building
                                                        .additionalComponents
                                                        ?.frameOpening && (
                                                        <th
                                                          title="View Details"
                                                          className="cursor-pointer text-green-600 hover:text-green-800 transition-colors duration-200"
                                                          onClick={() =>
                                                            showDataViewModal({
                                                              showComponent:
                                                                "FRAMEOPENING",
                                                            })
                                                          }
                                                        >
                                                          Frame Opening
                                                        </th>
                                                      )}
                                                      {building
                                                        .additionalComponents
                                                        ?.canopy && (
                                                        <th
                                                          title="View Details"
                                                          className="cursor-pointer text-green-600 hover:text-green-800 transition-colors duration-200"
                                                          onClick={() =>
                                                            showDataViewModal({
                                                              showComponent:
                                                                "CANOPY",
                                                            })
                                                          }
                                                        >
                                                          Canopy
                                                        </th>
                                                      )}
                                                      {building
                                                        .additionalComponents
                                                        ?.leanTo && (
                                                        <th
                                                          title="View Details"
                                                          className="cursor-pointer text-green-600 hover:text-green-800 transition-colors duration-200"
                                                          onClick={() =>
                                                            showDataViewModal({
                                                              showComponent:
                                                                "LEANTO",
                                                            })
                                                          }
                                                        >
                                                          Lean-To
                                                        </th>
                                                      )}
                                                      {building
                                                        .additionalComponents
                                                        ?.fixedLouvers && (
                                                        <th
                                                          title="View Details"
                                                          className="cursor-pointer text-green-600 hover:text-green-800 transition-colors duration-200"
                                                          onClick={() =>
                                                            showDataViewModal({
                                                              showComponent:
                                                                "FIXEDLOUVERS",
                                                            })
                                                          }
                                                        >
                                                          Fixed Louvers
                                                        </th>
                                                      )}
                                                      {building
                                                        .additionalComponents
                                                        ?.structuralLouvers && (
                                                        <th
                                                          title="View Details"
                                                          className="cursor-pointer text-green-600 hover:text-green-800 transition-colors duration-200"
                                                          onClick={() =>
                                                            showDataViewModal({
                                                              showComponent:
                                                                "STRUCTURALLOUVERS",
                                                            })
                                                          }
                                                        >
                                                          Structural Louvers
                                                        </th>
                                                      )}
                                                      {building
                                                        .additionalComponents
                                                        ?.typeOfBracing && (
                                                        <th
                                                          title="View Details"
                                                          className="text-green-600"
                                                          // onClick={() =>
                                                          //   showDataViewModal(
                                                          //     {
                                                          //       showComponent:
                                                          //         "TYPEOFBRACING",
                                                          //     }
                                                          //   )
                                                          // }
                                                        >
                                                          Type Of Bracing
                                                        </th>
                                                      )}
                                                      {building
                                                        .additionalComponents
                                                        ?.fascia && (
                                                        <th
                                                          title="View Details"
                                                          className="cursor-pointer text-green-600 hover:text-green-800 transition-colors duration-200"
                                                          onClick={() =>
                                                            showDataViewModal({
                                                              showComponent:
                                                                "FASCIA",
                                                            })
                                                          }
                                                        >
                                                          Fascia
                                                        </th>
                                                      )}
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    {building.back.rows.map(
                                                      (row, i) => (
                                                        <tr key={i}>
                                                          <td>
                                                            <InputField
                                                              type="text"
                                                              className="form-control"
                                                              value={
                                                                row.wall || ""
                                                              }
                                                              onChange={(e) =>
                                                                handleBackRowChange(
                                                                  i,
                                                                  "wall",
                                                                  e.target
                                                                    .value,
                                                                  building.id
                                                                )
                                                              }
                                                              onKeyDown={(e) =>
                                                                handleEnterKey(
                                                                  e,
                                                                  "back",
                                                                  building.id,
                                                                  i,
                                                                  "wall"
                                                                )
                                                              }

                                                                inputRef={(
                                                                  el
                                                                ) =>
                                                                  (inputRefs.current[
                                                                    `back-${building.id}-wall-${i}`
                                                                  ] = el)
                                                                }
                                                              disabled={
                                                                building.copyFrontToBack
                                                              } // Add this line
                                                            />
                                                          </td>

                                                          {/* <td>
                                                            <InputField
                                                              type="number"
                                                              className="form-control"
                                                              value={
                                                                row.baySpacing ||
                                                                ""
                                                              }
                                                              onChange={(e) =>
                                                                handleBackRowChange(
                                                                  i,
                                                                  "baySpacing",
                                                                  e.target
                                                                    .value,
                                                                  building.id
                                                                )
                                                              }
                                                              onKeyDown={(e) =>
                                                                handleEnterKey(
                                                                  e,
                                                                  building.id,
                                                                  i,
                                                                  "baySpacing"
                                                                )
                                                              }
                                                              inputRef={(el) =>
                                                                (inputRefs.current[
                                                                  `${building.id}-baySpacing-${i}`
                                                                ] = el)
                                                              }
                                                              disabled={
                                                                building.copyFrontToBack
                                                              } // Add this line
                                                            />
                                                          </td> */}
                                                          <td>
                                                            <InputField
                                                              type="number"
                                                              step="0.001"
                                                              className="form-control"
                                                              value={
                                                                row.baySpacing ??
                                                                ""
                                                              }
                                                              onChange={(e) =>
                                                                handleBackRowChange(
                                                                  i,
                                                                  "baySpacing",
                                                                  e.target
                                                                    .value,
                                                                  building.id
                                                                )
                                                              }
                                                              onBlur={(e) =>
                                                                handleBackRowChange(
                                                                  i,
                                                                  "baySpacing",
                                                                  e.target
                                                                    .value,
                                                                  building.id,
                                                                  true
                                                                )
                                                              }
                                                             onKeyDown={(e) =>
                                                                handleEnterKey(
                                                                  e,
                                                                  "back",
                                                                  building.id,
                                                                  i,
                                                                  "baySpacing"
                                                                )
                                                              }

                                                                inputRef={(
                                                                  el
                                                                ) =>
                                                                  (inputRefs.current[
                                                                    `back-${building.id}-baySpacing-${i}`
                                                                  ] = el)
                                                                }
                                                              disabled={
                                                                building.copyFrontToBack
                                                              } // Add this line
                                                            />
                                                          </td>

                                                          {building
                                                            .additionalComponents
                                                            ?.blockWallHeight && (
                                                            <td>
                                                              <InputField
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                value={
                                                                  row.blockWallHeight ||
                                                                  ""
                                                                }
                                                                onChange={(e) =>
                                                                  handleBackRowChange(
                                                                    i,
                                                                    "blockWallHeight",
                                                                    e.target
                                                                      .value,
                                                                    building.id
                                                                  )
                                                                }
                                                                onKeyDown={(e) =>
                                                                handleEnterKey(
                                                                  e,
                                                                  "back",
                                                                  building.id,
                                                                  i,
                                                                  "blockWallHeight"
                                                                )
                                                              }

                                                                inputRef={(
                                                                  el
                                                                ) =>
                                                                  (inputRefs.current[
                                                                    `back-${building.id}-blockWallHeight-${i}`
                                                                  ] = el)
                                                                }
                                                                // disabled={
                                                                //   building.copyFrontToBack
                                                                // } // Add this line
                                                              />
                                                            </td>
                                                          )}

                                                          <td>
                                                            <select
                                                              value={
                                                                row.purlinGirtCondition ||
                                                                "Bypass"
                                                              }
                                                              onChange={(e) =>
                                                                handleBackRowChange(
                                                                  i,
                                                                  "purlinGirtCondition",
                                                                  e.target
                                                                    .value,
                                                                  building.id
                                                                )
                                                              }
                                                            /*   disabled={
                                                                building.copyFrontToBack
                                                              } */
                                                            >
                                                              <option value="Bypass">
                                                                ByPass
                                                              </option>
                                                              <option value="Flush">
                                                                Flush
                                                              </option>
                                                            </select>
                                                          </td>

                                                          {/* Dynamic columns data */}
                                                          {building
                                                            .additionalComponents
                                                            ?.frameOpening && (
                                                            <td>
                                                              <select
                                                                value={
                                                                  row.frameOpening ||
                                                                  "No"
                                                                }
                                                                onChange={(e) =>
                                                                  handleBackRowChange(
                                                                    i,
                                                                    "frameOpening",
                                                                    e.target
                                                                      .value,
                                                                    building.id
                                                                  )
                                                                }
                                                                className={`border rounded px-2 py-1 ${
                                                                  row.frameOpening ===
                                                                  "Yes"
                                                                    ? "bg-green-200 text-green-800"
                                                                    : "bg-white"
                                                                }`}
                                                                // disabled={
                                                                //   building.copyFrontToBack
                                                                // } // Add this line
                                                              >
                                                                <option value="No">
                                                                  No
                                                                </option>
                                                                <option value="Yes">
                                                                  Yes
                                                                </option>
                                                              </select>
                                                            </td>
                                                          )}

                                                          {building
                                                            .additionalComponents
                                                            ?.canopy && (
                                                            <td>
                                                              <select
                                                                value={
                                                                  row.canopy ||
                                                                  "No"
                                                                }
                                                                onChange={(e) =>
                                                                  handleBackRowChange(
                                                                    i,
                                                                    "canopy",
                                                                    e.target
                                                                      .value,
                                                                    building.id
                                                                  )
                                                                }
                                                                className={`border rounded px-2 py-1 ${
                                                                  row.canopy ===
                                                                  "Yes"
                                                                    ? "bg-green-200 text-green-800"
                                                                    : "bg-white"
                                                                }`}
                                                                // disabled={
                                                                //   building.copyFrontToBack
                                                                // } // Add this line
                                                              >
                                                                <option value="No">
                                                                  No
                                                                </option>
                                                                <option value="Yes">
                                                                  Yes
                                                                </option>
                                                              </select>
                                                            </td>
                                                          )}

                                                          {building
                                                            .additionalComponents
                                                            ?.leanTo && (
                                                            <td>
                                                              <select
                                                                value={
                                                                  row.leanTo ||
                                                                  "No"
                                                                }
                                                                onChange={(e) =>
                                                                  handleBackRowChange(
                                                                    i,
                                                                    "leanTo",
                                                                    e.target
                                                                      .value,
                                                                    building.id
                                                                  )
                                                                }
                                                                className={`border rounded px-2 py-1 ${
                                                                  row.leanTo ===
                                                                  "Yes"
                                                                    ? "bg-green-200 text-green-800"
                                                                    : "bg-white"
                                                                }`}
                                                                // disabled={
                                                                //   building.copyFrontToBack
                                                                // } // Add this line
                                                              >
                                                                <option value="No">
                                                                  No
                                                                </option>
                                                                <option value="Yes">
                                                                  Yes
                                                                </option>
                                                              </select>
                                                            </td>
                                                          )}
                                                          {building
                                                            .additionalComponents
                                                            ?.fixedLouvers && (
                                                            <td>
                                                              <select
                                                                value={
                                                                  row.fixedLouvers ||
                                                                  "No"
                                                                }
                                                                onChange={(e) =>
                                                                  handleBackRowChange(
                                                                    i,
                                                                    "fixedLouvers",
                                                                    e.target
                                                                      .value,
                                                                    building.id
                                                                  )
                                                                }
                                                                className={`border rounded px-2 py-1 ${
                                                                  row.fixedLouvers ===
                                                                  "Yes"
                                                                    ? "bg-green-200 text-green-800"
                                                                    : "bg-white"
                                                                }`}
                                                                // disabled={
                                                                //   building.copyFrontToBack
                                                                // } // Add this line
                                                              >
                                                                <option value="No">
                                                                  No
                                                                </option>
                                                                <option value="Yes">
                                                                  Yes
                                                                </option>
                                                              </select>
                                                            </td>
                                                          )}
                                                          {building
                                                            .additionalComponents
                                                            ?.structuralLouvers && (
                                                            <td>
                                                              <select
                                                                value={
                                                                  row.structuralLouvers ||
                                                                  "No"
                                                                }
                                                                onChange={(e) =>
                                                                  handleBackRowChange(
                                                                    i,
                                                                    "structuralLouvers",
                                                                    e.target
                                                                      .value,
                                                                    building.id
                                                                  )
                                                                }
                                                                className={`border rounded px-2 py-1 ${
                                                                  row.structuralLouvers ===
                                                                  "Yes"
                                                                    ? "bg-green-200 text-green-800"
                                                                    : "bg-white"
                                                                }`}
                                                                // disabled={
                                                                //   building.copyFrontToBack
                                                                // } // Add this line
                                                              >
                                                                <option value="No">
                                                                  No
                                                                </option>
                                                                <option value="Yes">
                                                                  Yes
                                                                </option>
                                                              </select>
                                                            </td>
                                                          )}
                                                          {building
                                                            .additionalComponents
                                                            ?.typeOfBracing && (
                                                            <td>
                                                              <select
                                                                value={
                                                                  row.typeOfBracing
                                                                }
                                                                onChange={(e) =>
                                                                  handleBackRowChange(
                                                                    i,
                                                                    "typeOfBracing",
                                                                    e.target
                                                                      .value,
                                                                    building.id
                                                                  )
                                                                }
                                                                className={`border rounded px-2 py-1 ${
                                                                  row.typeOfBracing ===
                                                                  "Yes"
                                                                    ? "bg-green-200 text-green-800"
                                                                    : "bg-white"
                                                                }`}
                                                              >
                                                                <option value="Nill">
                                                                  Nill
                                                                </option>
                                                                <option value="RodBracing">
                                                                  RodBracing
                                                                </option>
                                                                <option value="PortalBracing">
                                                                  PortalBracing
                                                                </option>
                                                                <option value="Pipe/TubeBracing">
                                                                  Pipe/TubeBracing
                                                                </option>
                                                              </select>
                                                            </td>
                                                          )}
                                                          {building
                                                            .additionalComponents
                                                            ?.fascia && (
                                                            <td>
                                                              <select
                                                                value={
                                                                  row.fascia ||
                                                                  "No"
                                                                }
                                                                onChange={(e) =>
                                                                  handleBackRowChange(
                                                                    i,
                                                                    "fascia",
                                                                    e.target
                                                                      .value,
                                                                    building.id
                                                                  )
                                                                }
                                                                className={`border rounded px-2 py-1 ${
                                                                  row.fascia ===
                                                                  "Yes"
                                                                    ? "bg-green-200 text-green-800"
                                                                    : "bg-white"
                                                                }`}
                                                                // disabled={
                                                                //   building.copyFrontToBack
                                                                // } // Add this line
                                                              >
                                                                <option value="No">
                                                                  No
                                                                </option>
                                                                <option value="Yes">
                                                                  Yes
                                                                </option>
                                                              </select>
                                                            </td>
                                                          )}
                                                        </tr>
                                                      )
                                                    )}
                                                  </tbody>
                                                </table>
                                              </div>

                                              {/* Validation message */}
                                              {validateBackBaySpacing(
                                                building
                                              ) && (
                                                <div
                                                  style={{
                                                    color: "red",
                                                    fontSize: "13px",
                                                    marginTop: "5px",
                                                  }}
                                                >
                                                  ⚠️ Total bay spacing (
                                                  {building.back.rows.reduce(
                                                    (s, r) =>
                                                      s +
                                                      Number(r.baySpacing || 0),
                                                    0
                                                  )}{" "}
                                                  m) does not match total meters
                                                  ({building.back.meters} m)
                                                </div>
                                              )}
                                            </>
                                          )}
                                      </div>
                                      {/* BACK END WALL END */}
                                      {/* LEFT END WALL START*/}
                                      <div className="mb-4">
                                        <Row className="align-items-center justify-content-between">
                                          <Col>
                                            <h5 className="p-2 text-primary mb-0">
                                              Left Side Wall
                                            </h5>
                                          </Col>
                                        </Row>

                                        <Row className="w-75">
                                          <Col
                                            className="commTopButtonRightLeftPadding"
                                            xs={12}
                                            md={6}
                                            lg={3}
                                          >
                                            <InputField
                                              type="number"
                                              label="Left Side Wall in (M)"
                                              placeholder="Length of Building"
                                              className="inputBox"
                                              value={
                                                building.left?.meters === ""
                                                  ? ""
                                                  : building.left?.meters || ""
                                              }
                                              onChange={(e) =>
                                                handleLeftMetersChange(
                                                  e.target.value,
                                                  building.id
                                                )
                                              }
                                            />
                                          </Col>
                                          <Col
                                            className="commTopButtonRightLeftPadding"
                                            xs={12}
                                            md={6}
                                            lg={3}
                                          >
                                            <InputField
                                              type="number"
                                              label="No Of Bays"
                                              className="inputBox"
                                              value={
                                                building.left?.bays === 0
                                                  ? ""
                                                  : building.left?.bays || ""
                                              }
                                              onChange={(e) =>
                                                handleLeftBaysChange(
                                                  e.target.value,
                                                  building.id
                                                )
                                              }
                                            />
                                          </Col>
                                          {building.additionalComponents?.blockWallHeight && (
                                          <Col
                                            className="commTopButtonRightLeftPadding"
                                            xs={12}
                                            md={6}
                                            lg={3}
                                          >
                                            <InputField
                                              type="text"
                                              label="Block Wall Height"
                                              className="inputBox"
                                              value={
                                                building.left
                                                  ?.blockWallHeight || ""
                                              }
                                              onChange={(e) =>
                                                handleLeftBlockWallHeightChange(
                                                  e.target.value,
                                                  building.id
                                                )
                                              }
                                            />
                                          </Col>
                                          )}
                                          <Col
                                            xs={12}
                                            md={6}
                                            lg={3}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <ComboboxField
                                              className="inputBox"
                                              label="Building Inputs"
                                              data={buildingInputs}
                                              name="buildingInputs"
                                              setValue={
                                                building.left?.buildingInputs ||
                                                ""
                                              }
                                              id={`buildingInputs-left-${building.id}`}
                                              code={`buildingLeftInputsCode-${building.id}`}
                                              description="buildingInputsDesc"
                                              getvalue={setDropdownData}
                                            />
                                          </Col>
                                          {building.left?.buildingInputs ===
                                            "Other" && (
                                            <Col
                                              xs={12}
                                              md={6}
                                              lg={3}
                                              className="commTopButtonRightLeftPadding"
                                            >
                                              <InputField
                                                className="inputBox"
                                                type="text"
                                                label="Left Other Building Input"
                                                name="leftOtherBuildingInputs"
                                                value={
                                                  building?.left
                                                    ?.leftOtherBuildingInputs ===
                                                  ""
                                                    ? ""
                                                    : building?.left
                                                        ?.leftOtherBuildingInputs
                                                }
                                                onChange={(e) =>
                                                  handleLeftOtherBuildingInputsChange(
                                                    e.target.value,
                                                    building.id
                                                  )
                                                }
                                              />
                                            </Col>
                                          )}
                                        </Row>

                                        {building.left?.rows?.length > 0 && (
                                          <>
                                            <div
                                              className={`table-scroll-wrapper ${
                                                isTableScrolled
                                                  ? "scrolled"
                                                  : ""
                                              }`}
                                              onScroll={(e) => {
                                                const el = e.target;
                                                setIsTableScrolled(
                                                  el.scrollTop > 0
                                                );
                                              }}
                                            >
                                              <table className="table table-bordered table-sm text-center align-middle mb-3">
                                                <thead
                                                  className="bg-light"
                                                  style={{
                                                    position: "sticky",
                                                    top: 0,
                                                    zIndex: 2,
                                                  }}
                                                >
                                                  <tr>
                                                    <th>Grid Line</th>
                                                    <th>Bay Spacing</th>
                                                    {building
                                                      .additionalComponents
                                                      ?.blockWallHeight && (
                                                      <th>Block Wall Height</th>
                                                    )}
                                                    <th>
                                                      Purlin/Girt Condition
                                                    </th>

                                                    {/* Dynamic columns */}
                                                    {building
                                                      .additionalComponents
                                                      ?.frameOpening && (
                                                      <th
                                                        title="View Details"
                                                        className="cursor-pointer text-green-600 hover:text-green-800 transition-colors duration-200"
                                                        onClick={() =>
                                                          showDataViewModal({
                                                            showComponent:
                                                              "FRAMEOPENING",
                                                          })
                                                        }
                                                      >
                                                        Frame Opening
                                                      </th>
                                                    )}
                                                    {building
                                                      .additionalComponents
                                                      ?.canopy && (
                                                      <th
                                                        title="View Details"
                                                        className="cursor-pointer text-green-600 hover:text-green-800 transition-colors duration-200"
                                                        onClick={() =>
                                                          showDataViewModal({
                                                            showComponent:
                                                              "CANOPY",
                                                          })
                                                        }
                                                      >
                                                        Canopy
                                                      </th>
                                                    )}
                                                    {building
                                                      .additionalComponents
                                                      ?.leanTo && (
                                                      <th
                                                        title="View Details"
                                                        className="cursor-pointer text-green-600 hover:text-green-800 transition-colors duration-200"
                                                        onClick={() =>
                                                          showDataViewModal({
                                                            showComponent:
                                                              "LEANTO",
                                                          })
                                                        }
                                                      >
                                                        Lean-To
                                                      </th>
                                                    )}
                                                    {building
                                                      .additionalComponents
                                                      ?.fixedLouvers && (
                                                      <th
                                                        title="View Details"
                                                        className="cursor-pointer text-green-600 hover:text-green-800 transition-colors duration-200"
                                                        onClick={() =>
                                                          showDataViewModal({
                                                            showComponent:
                                                              "FIXEDLOUVERS",
                                                          })
                                                        }
                                                      >
                                                        Fixed Louvers
                                                      </th>
                                                    )}
                                                    {building
                                                      .additionalComponents
                                                      ?.structuralLouvers && (
                                                      <th
                                                        title="View Details"
                                                        className="cursor-pointer text-green-600 hover:text-green-800 transition-colors duration-200"
                                                        onClick={() =>
                                                          showDataViewModal({
                                                            showComponent:
                                                              "STRUCTURALLOUVERS",
                                                          })
                                                        }
                                                      >
                                                        Structural Louvers
                                                      </th>
                                                    )}
                                                    {building
                                                      .additionalComponents
                                                      ?.typeOfBracing && (
                                                      <th>Type Of Bracing</th>
                                                    )}
                                                    {building
                                                      .additionalComponents
                                                      ?.fascia && (
                                                      <th
                                                        title="View Details"
                                                        className="cursor-pointer text-green-600 hover:text-green-800 transition-colors duration-200"
                                                        onClick={() =>
                                                          showDataViewModal({
                                                            showComponent:
                                                              "FASCIA",
                                                          })
                                                        }
                                                      >
                                                        Fascia
                                                      </th>
                                                    )}
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {building.left?.rows?.map(
                                                    (row, i) => (
                                                      <tr key={i}>
                                                        <td>
                                                          <InputField
                                                            type="text"
                                                            className="form-control"
                                                            value={
                                                              row.wall || ""
                                                            }
                                                            onChange={(e) =>
                                                              handleLeftRowChange(
                                                                i,
                                                                "wall",
                                                                e.target.value,
                                                                building.id
                                                              )
                                                            }
                                                           onKeyDown={(e) =>
                                                                handleEnterKey(
                                                                  e,
                                                                  "left",
                                                                  building.id,
                                                                  i,
                                                                  "wall"
                                                                )
                                                              }

                                                                inputRef={(
                                                                  el
                                                                ) =>
                                                                  (inputRefs.current[
                                                                    `left-${building.id}-wall-${i}`
                                                                  ] = el)
                                                                }
                                                          />
                                                        </td>
                                                        <td
                                                          className={
                                                            leftValidation.isInvalid
                                                              ? "border-2 border-red-500"
                                                              : ""
                                                          }
                                                        >
                                                          {/* <InputField
                                                            type="number"
                                                            className={`form-control ${
                                                              leftValidation.isInvalid
                                                                ? "border-red-500"
                                                                : ""
                                                            }`}
                                                            value={
                                                              row.baySpacing ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleLeftRowChange(
                                                                i,
                                                                "baySpacing",
                                                                e.target.value,
                                                                building.id
                                                              )
                                                            }
                                                            onKeyDown={(e) =>
                                                              handleEnterKey(
                                                                e,
                                                                building.id,
                                                                i,
                                                                "baySpacing"
                                                              )
                                                            }
                                                            inputRef={(el) =>
                                                              (inputRefs.current[
                                                                `${building.id}-baySpacing-${i}`
                                                              ] = el)
                                                            }
                                                          /> */}
                                                          <InputField
                                                            type="number"
                                                            step="0.001"
                                                            className="form-control"
                                                            value={
                                                              row.baySpacing ??
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleLeftRowChange(
                                                                i,
                                                                "baySpacing",
                                                                e.target.value,
                                                                building.id
                                                              )
                                                            }
                                                            onBlur={(e) =>
                                                              handleLeftRowChange(
                                                                i,
                                                                "baySpacing",
                                                                e.target.value,
                                                                building.id,
                                                                true
                                                              )
                                                            }
                                                          onKeyDown={(e) =>
                                                                handleEnterKey(
                                                                  e,
                                                                  "left",
                                                                  building.id,
                                                                  i,
                                                                  "baySpacing"
                                                                )
                                                              }

                                                                inputRef={(
                                                                  el
                                                                ) =>
                                                                  (inputRefs.current[
                                                                    `left-${building.id}-baySpacing-${i}`
                                                                  ] = el)
                                                                }
                                                          />
                                                        </td>
                                                        {building
                                                          .additionalComponents
                                                          ?.blockWallHeight && (
                                                          <td>
                                                            <InputField
                                                              type="text"
                                                              className="form-control form-control-sm"
                                                              value={
                                                                row.blockWallHeight ||
                                                                ""
                                                              }
                                                              onChange={(e) =>
                                                                handleLeftRowChange(
                                                                  i,
                                                                  "blockWallHeight",
                                                                  e.target
                                                                    .value,
                                                                  building.id
                                                                )
                                                              }
                                                              onKeyDown={(e) =>
                                                                handleEnterKey(
                                                                  e,
                                                                  "left",
                                                                  building.id,
                                                                  i,
                                                                  "blockWallHeight"
                                                                )
                                                              }

                                                                inputRef={(
                                                                  el
                                                                ) =>
                                                                  (inputRefs.current[
                                                                    `left-${building.id}-blockWallHeight-${i}`
                                                                  ] = el)
                                                                }
                                                            />
                                                          </td>
                                                        )}
                                                        <td>
                                                          <select
                                                            value={
                                                              row.purlinGirtCondition ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleLeftRowChange(
                                                                i,
                                                                "purlinGirtCondition",
                                                                e.target.value,
                                                                building.id
                                                              )
                                                            }
                                                          >
                                                            <option value="Bypass">
                                                              ByPass
                                                            </option>
                                                            <option value="Flush">
                                                              Flush
                                                            </option>
                                                          </select>
                                                        </td>
                                                        {/* Dynamic Combobox columns */}
                                                        {building
                                                          .additionalComponents
                                                          ?.frameOpening && (
                                                          <td>
                                                            <select
                                                              value={
                                                                row.frameOpening ||
                                                                ""
                                                              }
                                                              onChange={(e) =>
                                                                handleLeftRowChange(
                                                                  i,
                                                                  "frameOpening",
                                                                  e.target
                                                                    .value,
                                                                  building.id
                                                                )
                                                              }
                                                              className={`border rounded px-2 py-1 ${
                                                                row.frameOpening ===
                                                                "Yes"
                                                                  ? "bg-green-200 text-green-800"
                                                                  : "bg-white"
                                                              }`}
                                                            >
                                                              <option value="No">
                                                                No
                                                              </option>
                                                              <option value="Yes">
                                                                Yes
                                                              </option>
                                                            </select>
                                                          </td>
                                                        )}
                                                        {building
                                                          .additionalComponents
                                                          ?.canopy && (
                                                          <td>
                                                            <select
                                                              value={
                                                                row.canopy || ""
                                                              }
                                                              onChange={(e) =>
                                                                handleLeftRowChange(
                                                                  i,
                                                                  "canopy",
                                                                  e.target
                                                                    .value,
                                                                  building.id
                                                                )
                                                              }
                                                              className={`border rounded px-2 py-1 ${
                                                                row.canopy ===
                                                                "Yes"
                                                                  ? "bg-green-200 text-green-800"
                                                                  : "bg-white"
                                                              }`}
                                                            >
                                                              <option value="No">
                                                                No
                                                              </option>
                                                              <option value="Yes">
                                                                Yes
                                                              </option>
                                                            </select>
                                                          </td>
                                                        )}
                                                        {building
                                                          .additionalComponents
                                                          ?.leanTo && (
                                                          <td>
                                                            <select
                                                              value={
                                                                row.leanTo || ""
                                                              }
                                                              onChange={(e) =>
                                                                handleLeftRowChange(
                                                                  i,
                                                                  "leanTo",
                                                                  e.target
                                                                    .value,
                                                                  building.id
                                                                )
                                                              }
                                                              className={`border rounded px-2 py-1 ${
                                                                row.leanTo ===
                                                                "Yes"
                                                                  ? "bg-green-200 text-green-800"
                                                                  : "bg-white"
                                                              }`}
                                                            >
                                                              <option value="No">
                                                                No
                                                              </option>
                                                              <option value="Yes">
                                                                Yes
                                                              </option>
                                                            </select>
                                                          </td>
                                                        )}
                                                        {building
                                                          .additionalComponents
                                                          ?.fixedLouvers && (
                                                          <td>
                                                            <select
                                                              value={
                                                                row.fixedLouvers ||
                                                                ""
                                                              }
                                                              onChange={(e) =>
                                                                handleLeftRowChange(
                                                                  i,
                                                                  "fixedLouvers",
                                                                  e.target
                                                                    .value,
                                                                  building.id
                                                                )
                                                              }
                                                              className={`border rounded px-2 py-1 ${
                                                                row.fixedLouvers ===
                                                                "Yes"
                                                                  ? "bg-green-200 text-green-800"
                                                                  : "bg-white"
                                                              }`}
                                                            >
                                                              <option value="No">
                                                                No
                                                              </option>
                                                              <option value="Yes">
                                                                Yes
                                                              </option>
                                                            </select>
                                                          </td>
                                                        )}
                                                        {building
                                                          .additionalComponents
                                                          ?.structuralLouvers && (
                                                          <td>
                                                            <select
                                                              value={
                                                                row.structuralLouvers ||
                                                                ""
                                                              }
                                                              onChange={(e) =>
                                                                handleLeftRowChange(
                                                                  i,
                                                                  "structuralLouvers",
                                                                  e.target
                                                                    .value,
                                                                  building.id
                                                                )
                                                              }
                                                              className={`border rounded px-2 py-1 ${
                                                                row.structuralLouvers ===
                                                                "Yes"
                                                                  ? "bg-green-200 text-green-800"
                                                                  : "bg-white"
                                                              }`}
                                                            >
                                                              <option value="No">
                                                                No
                                                              </option>
                                                              <option value="Yes">
                                                                Yes
                                                              </option>
                                                            </select>
                                                          </td>
                                                        )}
                                                        {building
                                                          .additionalComponents
                                                          ?.typeOfBracing && (
                                                          <td>
                                                            <select
                                                              value={
                                                                row.typeOfBracing ||
                                                                ""
                                                              }
                                                              onChange={(e) =>
                                                                handleLeftRowChange(
                                                                  i,
                                                                  "typeOfBracing",
                                                                  e.target
                                                                    .value,
                                                                  building.id
                                                                )
                                                              }
                                                            >
                                                              <option value="Nill">
                                                                Nill
                                                              </option>
                                                              <option value="RodBracing">
                                                                RodBracing
                                                              </option>
                                                              <option value="PortalBracing">
                                                                PortalBracing
                                                              </option>
                                                              <option value="Pipe/TubeBracing">
                                                                Pipe/TubeBracing
                                                              </option>
                                                            </select>
                                                          </td>
                                                        )}
                                                        {building
                                                          .additionalComponents
                                                          ?.fascia && (
                                                          <td>
                                                            <select
                                                              value={
                                                                row.fascia || ""
                                                              }
                                                              onChange={(e) =>
                                                                handleLeftRowChange(
                                                                  i,
                                                                  "fascia",
                                                                  e.target
                                                                    .value,
                                                                  building.id
                                                                )
                                                              }
                                                              className={`border rounded px-2 py-1 ${
                                                                row.fascia ===
                                                                "Yes"
                                                                  ? "bg-green-200 text-green-800"
                                                                  : "bg-white"
                                                              }`}
                                                            >
                                                              <option value="No">
                                                                No
                                                              </option>
                                                              <option value="Yes">
                                                                Yes
                                                              </option>
                                                            </select>
                                                          </td>
                                                        )}
                                                      </tr>
                                                    )
                                                  )}
                                                </tbody>
                                              </table>
                                            </div>
                                            {/* {leftValidation.isInvalid && (
                                              <div
                                                className="text-danger mt-1"
                                                style={{ fontSize: 12 }}
                                              >
                                                ⚠️ Total bay spacing (
                                                {building.left?.rows?.reduce(
                                                  (s, r) =>
                                                    s +
                                                    Number(r.baySpacing || 0),
                                                  0
                                                )}{" "}
                                                m) does not match total meters (
                                                {building.left?.meters} m)
                                              </div>
                                            )} */}
                                            {validateLeftBaySpacing(
                                              building
                                            ) && (
                                              <div
                                                className="text-danger mt-1"
                                                style={{ fontSize: 12 }}
                                              >
                                                ⚠️ Total bay spacing (
                                                {building.left?.rows?.reduce(
                                                  (s, r) =>
                                                    s +
                                                    Number(r.baySpacing || 0),
                                                  0
                                                )}{" "}
                                                m) does not match total meters (
                                                {building.left?.meters} m)
                                              </div>
                                            )}
                                          </>
                                        )}
                                      </div>
                                      {/* Left Side Wall End */}

                                      {/* Check Box For LSW = RSW  Start*/}
                                      {/* <div className="d-flex align-items-center justify-content-start flex-wrap my-3 p-2 rounded bg-light border">
                                        <input
                                          type="checkbox"
                                          id="copyLeftToRight"
                                          className="form-check-input me-2"
                                          style={{
                                            transform: "scale(1.4)",
                                            cursor: "pointer",
                                          }}
                                          checked={copyLeftToRight}
                                          onChange={(e) =>
                                            setCopyLeftToRight(e.target.checked)
                                          }
                                        />
                                        <label
                                          htmlFor="copyLeftToRight"
                                          className="form-check-label fw-semibold text-secondary"
                                          style={{
                                            fontSize: "1rem",
                                            cursor: "pointer",
                                          }}
                                        >
                                          LSW = RSW
                                        </label>
                                      </div> */}
                                      <div className="d-flex align-items-center justify-content-start flex-wrap my-3 p-2 rounded bg-light border">
                                        <input
                                          type="checkbox"
                                          id={`copyLeftToRight-${building.id}`}
                                          className="form-check-input me-2"
                                          style={{
                                            transform: "scale(1.4)",
                                            cursor: "pointer",
                                          }}
                                          checked={
                                            building.copyLeftToRight || false
                                          }
                                          onChange={(e) =>
                                            handleCopyLeftToRightChange(
                                              e,
                                              building.id
                                            )
                                          }
                                        />
                                        <label
                                          htmlFor={`copyLeftToRight-${building.id}`}
                                          className="form-check-label fw-semibold text-secondary"
                                          style={{
                                            fontSize: "1rem",
                                            cursor: "pointer",
                                          }}
                                        >
                                          LSW = RSW
                                        </label>
                                      </div>
                                      {/* Check Box For LSW = RSW  End*/}
                                      {/* RIGHT WALL START */}
                                      <div className="mb-4">
                                        <Row className="align-items-center justify-content-between">
                                          <Col>
                                            <h5 className="p-2 text-primary mb-0">
                                              Right Side Wall
                                            </h5>
                                          </Col>
                                        </Row>

                                        <Row className="p-1 w-75">
                                          <Col
                                            xs={12}
                                            md={6}
                                            lg={3}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <InputField
                                              type="number"
                                              label="Right Side Wall In (M)"
                                              placeholder="Length of Building"
                                              className="inputBox"
                                              value={
                                                building.right?.meters === ""
                                                  ? ""
                                                  : building.right?.meters || ""
                                              }
                                              onChange={(e) =>
                                                handleRightMetersChange(
                                                  e.target.value,
                                                  building.id
                                                )
                                              }
                                              disabled={
                                                building.copyLeftToRight
                                              }
                                            />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={6}
                                            lg={3}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <InputField
                                              type="number"
                                              className="inputBox"
                                              label="No Of Bays"
                                              value={
                                                building.right?.bays === 0
                                                  ? ""
                                                  : building.right?.bays || ""
                                              }
                                              onChange={(e) =>
                                                handleRightBaysChange(
                                                  e.target.value,
                                                  building.id
                                                )
                                              }
                                              disabled={
                                                building.copyLeftToRight
                                              }
                                            />
                                          </Col>
                                          {building.additionalComponents?.blockWallHeight && (
                                          <Col
                                            className="commTopButtonRightLeftPadding"
                                            xs={12}
                                            md={6}
                                            lg={3}
                                          >
                                            <InputField
                                              type="text"
                                              className="inputBox"
                                              label="Block Wall Height"
                                              value={
                                                building.right
                                                  ?.blockWallHeight || ""
                                              }
                                              onChange={(e) =>
                                                handleRightBlockWallHeightChange(
                                                  e.target.value,
                                                  building.id
                                                )
                                              }
                                             /*  disabled={
                                                building.copyLeftToRight
                                              } */
                                            />
                                          </Col>
                                          )}
                                          <Col
                                            xs={12}
                                            md={6}
                                            lg={3}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <ComboboxField
                                              className="inputBox"
                                              label="Building Inputs"
                                              data={buildingInputs}
                                              name="buildingInputs"
                                              setValue={
                                                building.right
                                                  ?.buildingInputs || ""
                                              }
                                              id={`buildingInputs-right-${building.id}`}
                                              code={`buildingRightInputsCode-${building.id}`}
                                              description="buildingInputsDesc"
                                              getvalue={setDropdownData}
                                              // disabled={
                                              //   building.copyLeftToRight
                                              // }
                                            />
                                          </Col>
                                          {building.right?.buildingInputs ===
                                            "Other" && (
                                            <Col
                                              xs={12}
                                              md={6}
                                              lg={3}
                                              className="commTopButtonRightLeftPadding"
                                            >
                                              <InputField
                                                className="inputBox"
                                                type="text"
                                                label="Right Other Building Input"
                                                name="rightOtherBuildingInputs"
                                                value={
                                                  building?.right
                                                    ?.rightOtherBuildingInputs ===
                                                  ""
                                                    ? ""
                                                    : building?.right
                                                        ?.rightOtherBuildingInputs
                                                }
                                                onChange={(e) =>
                                                  handleRightOtherBuildingInputsChange(
                                                    e.target.value,
                                                    building.id
                                                  )
                                                }
                                              />
                                            </Col>
                                          )}
                                        </Row>

                                        {building.right?.rows?.length > 0 && (
                                          <>
                                            <div
                                              className={`table-scroll-wrapper ${
                                                isTableScrolled
                                                  ? "scrolled"
                                                  : ""
                                              }`}
                                            >
                                              <table className="table table-bordered table-sm text-center align-middle mb-3">
                                                <thead
                                                  className="bg-light"
                                                  style={{
                                                    position: "sticky",
                                                    top: 0,
                                                    zIndex: 2,
                                                  }}
                                                >
                                                  <tr>
                                                    <th>Grid Line</th>
                                                    <th>Bay Spacing</th>
                                                    {building
                                                      .additionalComponents
                                                      ?.blockWallHeight && (
                                                      <th>Block Wall Height</th>
                                                    )}
                                                    <th>
                                                      Purlin/Girt Condition
                                                    </th>

                                                    {/* Dynamic columns */}
                                                    {building
                                                      .additionalComponents
                                                      ?.frameOpening && (
                                                      <th
                                                        title="View Details"
                                                        className="cursor-pointer text-green-600 hover:text-green-800 transition-colors duration-200"
                                                        onClick={() =>
                                                          showDataViewModal({
                                                            showComponent:
                                                              "FRAMEOPENING",
                                                          })
                                                        }
                                                      >
                                                        Frame Opening
                                                      </th>
                                                    )}
                                                    {building
                                                      .additionalComponents
                                                      ?.canopy && (
                                                      <th
                                                        title="View Details"
                                                        className="cursor-pointer text-green-600 hover:text-green-800 transition-colors duration-200"
                                                        onClick={() =>
                                                          showDataViewModal({
                                                            showComponent:
                                                              "CANOPY",
                                                          })
                                                        }
                                                      >
                                                        Canopy
                                                      </th>
                                                    )}
                                                    {building
                                                      .additionalComponents
                                                      ?.leanTo && (
                                                      <th
                                                        title="View Details"
                                                        className="cursor-pointer text-green-600 hover:text-green-800 transition-colors duration-200"
                                                        onClick={() =>
                                                          showDataViewModal({
                                                            showComponent:
                                                              "LEANTO",
                                                          })
                                                        }
                                                      >
                                                        Lean-To
                                                      </th>
                                                    )}
                                                    {building
                                                      .additionalComponents
                                                      ?.fixedLouvers && (
                                                      <th
                                                        title="View Details"
                                                        className="cursor-pointer text-green-600 hover:text-green-800 transition-colors duration-200"
                                                        onClick={() =>
                                                          showDataViewModal({
                                                            showComponent:
                                                              "FIXEDLOUVERS",
                                                          })
                                                        }
                                                      >
                                                        Fixed Louvers
                                                      </th>
                                                    )}
                                                    {building
                                                      .additionalComponents
                                                      ?.structuralLouvers && (
                                                      <th
                                                        title="View Details"
                                                        className="cursor-pointer text-green-600 hover:text-green-800 transition-colors duration-200"
                                                        onClick={() =>
                                                          showDataViewModal({
                                                            showComponent:
                                                              "STRUCTURALLOUVERS",
                                                          })
                                                        }
                                                      >
                                                        Structural Louvers
                                                      </th>
                                                    )}
                                                    {building
                                                      .additionalComponents
                                                      ?.typeOfBracing && (
                                                      <th>Type Of Bracing</th>
                                                    )}
                                                    {building
                                                      .additionalComponents
                                                      ?.fascia && (
                                                      <th
                                                        title="View Details"
                                                        className="cursor-pointer text-green-600 hover:text-green-800 transition-colors duration-200"
                                                        onClick={() =>
                                                          showDataViewModal({
                                                            showComponent:
                                                              "FASCIA",
                                                          })
                                                        }
                                                      >
                                                        Fascia
                                                      </th>
                                                    )}
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {building.right?.rows?.map(
                                                    (row, i) => (
                                                      <tr key={i}>
                                                        <td>
                                                          <InputField
                                                            type="text"
                                                            className="form-control"
                                                            value={
                                                              row.wall || ""
                                                            }
                                                            onChange={(e) =>
                                                              handleRightRowChange(
                                                                i,
                                                                "wall",
                                                                e.target.value,
                                                                building.id
                                                              )
                                                            }
                                                            onKeyDown={(e) =>
                                                                handleEnterKey(
                                                                  e,
                                                                  "right",
                                                                  building.id,
                                                                  i,
                                                                  "wall"
                                                                )
                                                              }

                                                                inputRef={(
                                                                  el
                                                                ) =>
                                                                  (inputRefs.current[
                                                                    `right-${building.id}-wall-${i}`
                                                                  ] = el)
                                                                }
                                                            disabled={
                                                              building.copyLeftToRight
                                                            }
                                                          />
                                                        </td>
                                                        {/* <td>
                                                          <InputField
                                                            type="number"
                                                            className="form-control"
                                                            value={
                                                              row.baySpacing ||
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleRightRowChange(
                                                                i,
                                                                "baySpacing",
                                                                e.target.value,
                                                                building.id
                                                              )
                                                            }
                                                            onKeyDown={(e) =>
                                                              handleEnterKey(
                                                                e,
                                                                building.id,
                                                                i,
                                                                "baySpacing"
                                                              )
                                                            }
                                                            inputRef={(el) =>
                                                              (inputRefs.current[
                                                                `${building.id}-baySpacing-${i}`
                                                              ] = el)
                                                            }
                                                            disabled={
                                                              building.copyLeftToRight
                                                            }
                                                          />
                                                        </td> */}
                                                        <td>
                                                          <InputField
                                                            type="number"
                                                            step="0.001"
                                                            className="form-control"
                                                            value={
                                                              row.baySpacing ??
                                                              ""
                                                            }
                                                            onChange={(e) =>
                                                              handleRightRowChange(
                                                                i,
                                                                "baySpacing",
                                                                e.target.value,
                                                                building.id
                                                              )
                                                            }
                                                            onBlur={(e) =>
                                                              handleRightRowChange(
                                                                i,
                                                                "baySpacing",
                                                                e.target.value,
                                                                building.id,
                                                                true
                                                              )
                                                            }
                                                            onKeyDown={(e) =>
                                                                handleEnterKey(
                                                                  e,
                                                                  "right",
                                                                  building.id,
                                                                  i,
                                                                  "baySpacing"
                                                                )
                                                              }

                                                                inputRef={(
                                                                  el
                                                                ) =>
                                                                  (inputRefs.current[
                                                                    `right-${building.id}-baySpacing-${i}`
                                                                  ] = el)
                                                                }
                                                            disabled={
                                                              building.copyLeftToRight
                                                            }
                                                          />
                                                        </td>

                                                        {building
                                                          .additionalComponents
                                                          ?.blockWallHeight && (
                                                          <td>
                                                            <InputField
                                                              type="text"
                                                              className="form-control form-control-sm"
                                                              value={
                                                                row.blockWallHeight ||
                                                                ""
                                                              }
                                                              onChange={(e) =>
                                                                handleRightRowChange(
                                                                  i,
                                                                  "blockWallHeight",
                                                                  e.target
                                                                    .value,
                                                                  building.id
                                                                )
                                                              }
                                                              onKeyDown={(e) =>
                                                                handleEnterKey(
                                                                  e,
                                                                  "right",
                                                                  building.id,
                                                                  i,
                                                                  "blockWallHeight"
                                                                )
                                                              }

                                                                inputRef={(
                                                                  el
                                                                ) =>
                                                                  (inputRefs.current[
                                                                    `right-${building.id}-blockWallHeight-${i}`
                                                                  ] = el)
                                                                }
                                                              // disabled={
                                                              //   building.copyLeftToRight
                                                              // }
                                                            />
                                                          </td>
                                                        )}
                                                        <td>
                                                          <select
                                                            value={
                                                              row.purlinGirtCondition ||
                                                              "Bypass"
                                                            }
                                                            onChange={(e) =>
                                                              handleRightRowChange(
                                                                i,
                                                                "purlinGirtCondition",
                                                                e.target.value,
                                                                building.id
                                                              )
                                                            }
                                                            /*   disabled={
                                                              building.copyLeftToRight
                                                            } */
                                                          >
                                                            <option value="Bypass">
                                                              ByPass
                                                            </option>
                                                            <option value="Flush">
                                                              Flush
                                                            </option>
                                                          </select>
                                                        </td>

                                                        {/* Dynamic columns data */}
                                                        {building
                                                          .additionalComponents
                                                          ?.frameOpening && (
                                                          <td>
                                                            <select
                                                              value={
                                                                row.frameOpening ||
                                                                "No"
                                                              }
                                                              onChange={(e) =>
                                                                handleRightRowChange(
                                                                  i,
                                                                  "frameOpening",
                                                                  e.target
                                                                    .value,
                                                                  building.id
                                                                )
                                                              }
                                                              className={`border rounded px-2 py-1 ${
                                                                row.frameOpening ===
                                                                "Yes"
                                                                  ? "bg-green-200 text-green-800"
                                                                  : "bg-white"
                                                              }`}
                                                              // disabled={
                                                              //   building.copyLeftToRight
                                                              // }
                                                            >
                                                              <option value="No">
                                                                No
                                                              </option>
                                                              <option value="Yes">
                                                                Yes
                                                              </option>
                                                            </select>
                                                          </td>
                                                        )}
                                                        {building
                                                          .additionalComponents
                                                          ?.canopy && (
                                                          <td>
                                                            <select
                                                              value={
                                                                row.canopy ||
                                                                "No"
                                                              }
                                                              onChange={(e) =>
                                                                handleRightRowChange(
                                                                  i,
                                                                  "canopy",
                                                                  e.target
                                                                    .value,
                                                                  building.id
                                                                )
                                                              }
                                                              className={`border rounded px-2 py-1 ${
                                                                row.canopy ===
                                                                "Yes"
                                                                  ? "bg-green-200 text-green-800"
                                                                  : "bg-white"
                                                              }`}
                                                              // disabled={
                                                              //   building.copyLeftToRight
                                                              // }
                                                            >
                                                              <option value="No">
                                                                No
                                                              </option>
                                                              <option value="Yes">
                                                                Yes
                                                              </option>
                                                            </select>
                                                          </td>
                                                        )}
                                                        {building
                                                          .additionalComponents
                                                          ?.leanTo && (
                                                          <td>
                                                            <select
                                                              value={
                                                                row.leanTo ||
                                                                "No"
                                                              }
                                                              onChange={(e) =>
                                                                handleRightRowChange(
                                                                  i,
                                                                  "leanTo",
                                                                  e.target
                                                                    .value,
                                                                  building.id
                                                                )
                                                              }
                                                              className={`border rounded px-2 py-1 ${
                                                                row.leanTo ===
                                                                "Yes"
                                                                  ? "bg-green-200 text-green-800"
                                                                  : "bg-white"
                                                              }`}
                                                              // disabled={
                                                              //   building.copyLeftToRight
                                                              // }
                                                            >
                                                              <option value="No">
                                                                No
                                                              </option>
                                                              <option value="Yes">
                                                                Yes
                                                              </option>
                                                            </select>
                                                          </td>
                                                        )}
                                                        {building
                                                          .additionalComponents
                                                          ?.fixedLouvers && (
                                                          <td>
                                                            <select
                                                              value={
                                                                row.fixedLouvers ||
                                                                "No"
                                                              }
                                                              onChange={(e) =>
                                                                handleRightRowChange(
                                                                  i,
                                                                  "fixedLouvers",
                                                                  e.target
                                                                    .value,
                                                                  building.id
                                                                )
                                                              }
                                                              className={`border rounded px-2 py-1 ${
                                                                row.fixedLouvers ===
                                                                "Yes"
                                                                  ? "bg-green-200 text-green-800"
                                                                  : "bg-white"
                                                              }`}
                                                              // disabled={
                                                              //   building.copyLeftToRight
                                                              // }
                                                            >
                                                              <option value="No">
                                                                No
                                                              </option>
                                                              <option value="Yes">
                                                                Yes
                                                              </option>
                                                            </select>
                                                          </td>
                                                        )}
                                                        {building
                                                          .additionalComponents
                                                          ?.structuralLouvers && (
                                                          <td>
                                                            <select
                                                              value={
                                                                row.structuralLouvers ||
                                                                "No"
                                                              }
                                                              onChange={(e) =>
                                                                handleRightRowChange(
                                                                  i,
                                                                  "structuralLouvers",
                                                                  e.target
                                                                    .value,
                                                                  building.id
                                                                )
                                                              }
                                                              className={`border rounded px-2 py-1 ${
                                                                row.structuralLouvers ===
                                                                "Yes"
                                                                  ? "bg-green-200 text-green-800"
                                                                  : "bg-white"
                                                              }`}
                                                              // disabled={
                                                              //   building.copyLeftToRight
                                                              // }
                                                            >
                                                              <option value="No">
                                                                No
                                                              </option>
                                                              <option value="Yes">
                                                                Yes
                                                              </option>
                                                            </select>
                                                          </td>
                                                        )}
                                                        {building
                                                          .additionalComponents
                                                          ?.typeOfBracing && (
                                                          <td>
                                                            <select
                                                              value={
                                                                row.typeOfBracing ||
                                                                "Nill"
                                                              }
                                                              onChange={(e) =>
                                                                handleRightRowChange(
                                                                  i,
                                                                  "typeOfBracing",
                                                                  e.target
                                                                    .value,
                                                                  building.id
                                                                )
                                                              }
                                                              // disabled={
                                                              //   building.copyLeftToRight
                                                              // }
                                                            >
                                                              <option value="Nill">
                                                                Nill
                                                              </option>
                                                              <option value="RodBracing">
                                                                RodBracing
                                                              </option>
                                                              <option value="PortalBracing">
                                                                PortalBracing
                                                              </option>
                                                              <option value="Pipe/TubeBracing">
                                                                Pipe/TubeBracing
                                                              </option>
                                                            </select>
                                                          </td>
                                                        )}
                                                        {building
                                                          .additionalComponents
                                                          ?.fascia && (
                                                          <td>
                                                            <select
                                                              value={
                                                                row.fascia ||
                                                                "No"
                                                              }
                                                              onChange={(e) =>
                                                                handleRightRowChange(
                                                                  i,
                                                                  "fascia",
                                                                  e.target
                                                                    .value,
                                                                  building.id
                                                                )
                                                              }
                                                              className={`border rounded px-2 py-1 ${
                                                                row.fascia ===
                                                                "Yes"
                                                                  ? "bg-green-200 text-green-800"
                                                                  : "bg-white"
                                                              }`}
                                                              // disabled={
                                                              //   building.copyLeftToRight
                                                              // }
                                                            >
                                                              <option value="No">
                                                                No
                                                              </option>
                                                              <option value="Yes">
                                                                Yes
                                                              </option>
                                                            </select>
                                                          </td>
                                                        )}
                                                      </tr>
                                                    )
                                                  )}
                                                </tbody>
                                              </table>
                                            </div>

                                            {/* Validation message */}
                                            {validateRightBaySpacing(
                                              building
                                            ) && (
                                              <div
                                                className="text-danger mt-1"
                                                style={{ fontSize: 12 }}
                                              >
                                                ⚠️ Total bay spacing (
                                                {building.right?.rows?.reduce(
                                                  (s, r) =>
                                                    s +
                                                    Number(r.baySpacing || 0),
                                                  0
                                                )}{" "}
                                                m) does not match total meters (
                                                {building.right?.meters} m)
                                              </div>
                                            )}
                                          </>
                                        )}
                                      </div>
                                      {/* Right Side Wall End */}
                                    </div>
                                  </div>
                                </div>
                              )}
                            </>
                          )}
                        </div>
                      ))}
                    </div>

                    {/* Building Content - Shows only active building */}
                    <div
                      className="tab-content pt-2"
                      style={{
                        overflowY: "auto",
                        // maxHeight: "70vh",
                      }}
                    >
                      {buildings.map((building, index) => (
                        <div
                          key={building.id}
                          className={`tab-pane fade ${
                            activeBuildingId === building.id
                              ? "show active"
                              : ""
                          }`}
                        >
                          {/* Only show content for active building */}
                          {activeBuildingId === building.id && (
                            <>
                              {/* Grid layout Width X Length X Number of Bay Spacing */}
                              {building?.buildingStructureCode === "SYM" &&
                                building?.buildingTypesCode && (
                                  <div
                                    className="accordion mt-3 mb-4"
                                    id="accordionExample"
                                  >
                                    <div className="accordion-item">
                                      <h2 className="accordion-header">
                                        <Row className="accordion-button">
                                          <Col
                                            xs={1}
                                            md={1}
                                            lg={1}
                                            className="text-left arrowBtn"
                                          >
                                            <i
                                              className={`bi ${
                                                building.isCardVisible3
                                                  ? "bi-chevron-right"
                                                  : "bi-chevron-down"
                                              }`}
                                              onClick={() =>
                                                toggleCardVisibility3(
                                                  building.id
                                                )
                                              }
                                            ></i>
                                          </Col>
                                          <Col
                                            xs={1}
                                            md={1}
                                            lg={1}
                                            className="text-center logoBtn"
                                          >
                                            <span className="iconLogo">BS</span>
                                          </Col>

                                          <Col xs={4} md={4} lg={4}>
                                            <span className="headerTitle">
                                              Create The AB Plan {building.id}
                                            </span>
                                            <span className="subHeaderTitle">
                                              Width X Length X Number of Bay
                                              Spacing
                                            </span>
                                          </Col>
                                        </Row>
                                      </h2>
                                      <div
                                        className={`accordion-collapse collapse show ${
                                          building.isCardVisible3
                                            ? "visible"
                                            : ""
                                        }`}
                                      >
                                        <div className="accordion-body pb-5">
                                          <GridGenerator 
                                            buildingDetails={getBuildingDetails(
                                              building.id
                                            )}
                                            onUpdate={(type, index, value) =>
                                              handleGridUpdate(
                                                type,
                                                index,
                                                value,
                                                building.id
                                              )
                                            }
                                            disabled={true}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}

                              {building?.buildingStructureCode === "ASY" && (
                                <div
                                  className="accordion mt-3 mb-4"
                                  id="accordionExample"
                                >
                                  <div className="accordion-item">
                                    <h2 className="accordion-header">
                                      <Row className="accordion-button">
                                        <Col
                                          xs={1}
                                          md={1}
                                          lg={1}
                                          className="text-left arrowBtn"
                                        >
                                          <i
                                            className={`bi ${
                                              building.isCardVisible4
                                                ? "bi-chevron-right"
                                                : "bi-chevron-down"
                                            }`}
                                            onClick={() =>
                                              toggleCardVisibility4(building.id)
                                            }
                                          ></i>
                                        </Col>
                                        <Col
                                          xs={1}
                                          md={1}
                                          lg={1}
                                          className="text-center logoBtn"
                                        >
                                          <span className="iconLogo">AB</span>
                                        </Col>
                                        <Col xs={4} md={4} lg={4}>
                                          <span className="headerTitle">
                                            Attach The AB Plan {building.id}
                                          </span>
                                          <span className="subHeaderTitle">
                                            Attach The AB Plan
                                          </span>
                                        </Col>
                                      </Row>
                                    </h2>
                                    <div
                                      className={`accordion-collapse collapse show ${
                                        building.isCardVisible4 ? "visible" : ""
                                      }`}
                                    >
                                      <div className="accordion-body pb-5">
                                        <Row className="p-4">
                                          <Col xs={12} md={12} lg={12}>
                                            <RichTextEditor
                                              value={
                                                building.attachABplan || ""
                                              }
                                              onChange={(content) =>
                                                handleAttachABplan(
                                                  content,
                                                  building.id
                                                )
                                              }
                                            />
                                          </Col>
                                        </Row>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}

                              {/* Rest of your building content (Structure Type, Front End Wall, Back End Wall, etc.) */}
                              {/* ... your existing building content ... */}
                            </>
                          )}
                        </div>
                      ))}
                    </div>

                    {/* Roof Slope Building */}
                    <div
                      className="tab-content pt-2"
                      style={{
                        overflowY: "auto",
                        // maxHeight: "70vh",
                      }}
                    >
                      {buildings.map((building, index) => (
                        <div
                          key={building.id}
                          className={`tab-pane fade ${
                            activeBuildingId === building.id
                              ? "show active"
                              : ""
                          }`}
                        >
                          {/* clear span  */}

                          <div
                            className="accordion mt-3 mb-4"
                            id="accordionExample"
                          >
                            <div className="accordion-item">
                              <h2 className="accordion-header">
                                <Row className="accordion-button">
                                  <Col
                                    xs={1}
                                    md={1}
                                    lg={1}
                                    className="text-left arrowBtn"
                                  >
                                    <i
                                      className={`bi ${
                                        building.isCardVisible9
                                          ? "bi-chevron-right"
                                          : "bi-chevron-down"
                                      }`}
                                      onClick={() =>
                                        toggleCardVisibility9(building.id)
                                      }
                                    ></i>
                                  </Col>
                                  <Col
                                    xs={1}
                                    md={1}
                                    lg={1}
                                    className="text-center logoBtn"
                                  >
                                    <span className="iconLogo">FD</span>
                                  </Col>
                                  <Col xs={3} md={8} lg={8}>
                                    <span className="headerTitle">
                                      Frame Details {building.id}
                                    </span>
                                    <span className="subHeaderTitle">
                                      Main frame cross section
                                    </span>
                                  </Col>

                                  {(building.buildingTypesCode === "CS" ||
                                    building.buildingTypesCode === "MSB") && (
                                    <Col
                                      xs={2}
                                      md={2}
                                      lg={2}
                                      className="d-flex justify-content-end"
                                    >
                                      <button
                                        className="btn btn-table"
                                        onClick={() =>
                                          showCaseSelectModal(
                                            building.id,
                                            building.buildingTypesCode
                                          )
                                        }
                                      >
                                        Select Case
                                      </button>
                                    </Col>
                                  )}
                                </Row>
                              </h2>
                              <div
                                className={`accordion-collapse collapse show ${
                                  building.isCardVisible9 ? "visible" : ""
                                }`}
                              >
                                <div className="accordion-body ">
                                  {(building.buildingTypesCode === "CS" ||
                                    building.buildingTypesCode === "MSB") && (
                                    <>
                                      <Row className="p-2">
                                        {/* Table Section */}
                                        {!building.selectedCaseObject
                                          ?.caseTypeDiscription ? (
                                          <div className="text-center text-muted border rounded p-4">
                                            <strong>No case selected</strong>
                                          </div>
                                        ) : (
                                          <>
                                            {labels.map((label, index) => {
                                              const fieldKey = fieldKeys[index];
                                              if (fieldKey === "slope") {
                                                return null;
                                              }
                                              if (
                                                building.buildingTypesCode ===
                                                  "MSB" &&
                                                ["M1", "M2"].includes(
                                                  building.selectedCaseObject
                                                    .caseTypeCode
                                                ) &&
                                                ["width1", "width2"].includes(
                                                  fieldKey
                                                )
                                              ) {
                                                return null;
                                              }

                                              // Skip WIDTH1 / WIDTH2 for case01 / case02
                                              if (
                                                ["case01", "case02"].includes(
                                                  building.selectedCaseObject?.caseTypeDiscription?.toLowerCase()
                                                ) &&
                                                ["width1", "width2"].includes(
                                                  fieldKey
                                                )
                                              ) {
                                                return null;
                                              }

                                              return (
                                                <Col
                                                  xs={4}
                                                  md={4}
                                                  lg={4}
                                                  className="commLeftRightPadding"
                                                  key={fieldKey}
                                                >
                                                  <InputField
                                                    type="text"
                                                    className="inputBox"
                                                    label={label}
                                                    value={
                                                      building
                                                        .selectedCaseObject[
                                                        fieldKey
                                                      ] || ""
                                                    }
                                                    onChange={(e) =>
                                                      handleCaseSelectInputChange(
                                                        fieldKey,
                                                        e.target.value,
                                                        building.id
                                                      )
                                                    }
                                                    disabled={
                                                      fieldKey === "width" ||
                                                      (building
                                                        .selectedCaseObject
                                                        .caseTypeCode ===
                                                        "C1" &&
                                                        fieldKey ===
                                                          "ridgeHeight") ||
                                                      (building
                                                        .selectedCaseObject
                                                        .caseTypeCode ===
                                                        "C2" &&
                                                        (fieldKey ===
                                                          "leftSlope" ||
                                                          fieldKey ===
                                                            "rightSlope")) ||
                                                      (building
                                                        .selectedCaseObject
                                                        .caseTypeCode ===
                                                        "C3" &&
                                                        (fieldKey ===
                                                          "leftSlope" ||
                                                          fieldKey ===
                                                            "rightSlope")) ||
                                                      (building
                                                        .selectedCaseObject
                                                        .caseTypeCode ===
                                                        "C4" &&
                                                        (fieldKey ===
                                                          "leftSlope" ||
                                                          fieldKey ===
                                                            "rightSlope"))
                                                    }
                                                  />
                                                </Col>
                                              );
                                            })}
                                          </>
                                        )}
                                      </Row>
                                      {building?.msNumber && (
                                        <Row className="p-2">
                                          {renderCFields(building)}
                                        </Row>
                                      )}
                                      <RoofSloopCase
                                        caseData={building.selectedCaseObject}
                                        buildingType={
                                          building.buildingTypesCode
                                        }
                                      />
                                    </>
                                  )}

                                  {/* mono slope  and others single images*/}

                                  {(building.buildingTypesCode === "MCS" ||
                                    building.buildingTypesCode === "MSMSB" ||
                                    building?.buildingTypesCode === "MLMB") && (
                                    <>
                                      <Row className="p-2">
                                        {labels.map((label, index) => {
                                          const fieldKey = fieldKeys[index];

                                          // Remove unwanted fields for MCS only
                                          // Hide specific fields based on building type
                                          const unwantedFields = [];
                                          if (
                                            building.buildingTypesCode ===
                                            "MSMSB"
                                          ) {
                                            unwantedFields.push(
                                              "ridgeHeight",
                                              "width1",
                                              "width2",
                                              "ridgeDistanceRight",
                                              "ridgeDistanceLeft",
                                              "rightSlope",
                                              "leftSlope"
                                            );
                                          }
                                          // Unwanted for MCS
                                          if (
                                            building.buildingTypesCode === "MCS"
                                          ) {
                                            unwantedFields.push(
                                              "ridgeDistanceRight",
                                              "ridgeDistanceLeft",
                                              "rightSlope",
                                              "leftSlope",
                                              "width1",
                                              "width2",
                                              "ridgeHeight"
                                            );
                                          }
                                          // Unwanted for MLMB
                                          if (
                                            building.buildingTypesCode ===
                                            "MLMB"
                                          ) {
                                            unwantedFields.push(
                                              "clearHeightLSW",
                                              "clearHeightRSW",
                                              "leftSlope",
                                              "inputFromUser",
                                              "unKnownValue",
                                              "width1",
                                              "width2",
                                              "ridgeDistanceRight",
                                              "ridgeDistanceLeft",
                                              "ridgeHeight",
                                              "rightSlope"
                                            );
                                          }

                                          if (
                                            unwantedFields.includes(fieldKey)
                                          ) {
                                            return null; // HIDE FIELD
                                          }

                                          return (
                                            <Col
                                              xs={4}
                                              md={4}
                                              lg={4}
                                              className="commLeftRightPadding"
                                              key={fieldKey}
                                            >
                                              <InputField
                                                type="text"
                                                className="inputBox"
                                                label={label}
                                                value={
                                                  building.selectedCaseObject?.[
                                                    fieldKey
                                                  ] || ""
                                                }
                                                onChange={(e) =>
                                                  handleMCSInputChange(
                                                    fieldKey,
                                                    e.target.value,
                                                    building.id
                                                  )
                                                }
                                                // All remaining fields editable for MCS
                                                disabled={false}
                                              />
                                            </Col>
                                          );
                                        })}
                                      </Row>
                                      {/* Dynamic C Fields based on MS Number */}

                                      {building?.msNumber && (
                                        <Row className="p-2">
                                          {renderCFields(building)}
                                        </Row>
                                      )}
                                      {/* Show RoofSloopCase for MCS with different image */}
                                      <RoofSloopMonoSlope
                                        caseData={building.selectedCaseObject}
                                        buildingType={
                                          building.buildingTypesCode
                                        }
                                        // buildingType="MCS"
                                      />
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>

                    {/* Building Case Type details */}
                    <div
                      className="tab-content pt-2"
                      style={{
                        overflowY: "auto",
                        // maxHeight: "70vh",
                      }}
                    >
                      {buildings.map((building, index) => (
                        <div
                          key={building.id}
                          className={`tab-pane fade ${
                            activeBuildingId === building.id
                              ? "show active"
                              : ""
                          }`}
                        >
                          {/* Only show content for active building */}
                          {activeBuildingId === building.id && (
                            <>
                              {building?.buildingTypesCode && (
                                <div
                                  className="accordion mt-3 mb-4"
                                  id="accordionExample"
                                >
                                  <div className="accordion-item">
                                    <h2 className="accordion-header">
                                      <Row className="accordion-button">
                                        <Col
                                          xs={1}
                                          md={1}
                                          lg={1}
                                          className="text-left arrowBtn"
                                        >
                                          <i
                                            className={`bi ${
                                              building.isCardVisible5
                                                ? "bi-chevron-right"
                                                : "bi-chevron-down"
                                            }`}
                                            onClick={() =>
                                              toggleCardVisibility5(building.id)
                                            }
                                          ></i>
                                        </Col>
                                        <Col
                                          xs={1}
                                          md={1}
                                          lg={1}
                                          className="text-center logoBtn"
                                        >
                                          <span className="iconLogo">BC</span>
                                        </Col>
                                        <Col xs={4} md={4} lg={4}>
                                          <span className="headerTitle">
                                            Building Case Type details{" "}
                                            {building.id}
                                          </span>
                                          <span className="subHeaderTitle">
                                            Building Case Type details
                                          </span>
                                        </Col>
                                      </Row>
                                    </h2>
                                    <div
                                      className={`accordion-collapse collapse show ${
                                        building.isCardVisible5 ? "visible" : ""
                                      }`}
                                    >
                                      <div className="table-responsive">
                                        {buildingCaseTypeData?.length > 0 && building.selectedCaseObject ? (
                                          <>
                                            <table className="table table-bordered text-center">
                                              <thead>
                                                <tr>
                                                  <th
                                                    style={{ width: "140px" }}
                                                  >
                                                    Frame Details
                                                  </th>
                                                  {Object.keys(
                                                    building
                                                      .buildingCaseType[0] || {}
                                                  )
                                                    .filter(
                                                      (key) =>
                                                        key !== "local_id" &&
                                                        key !== "frameType" &&
                                                        key !==
                                                          "caseTypeCode" &&
                                                        key !==
                                                          "caseTypeDiscription"
                                                    )
                                                    .map((key) => (
                                                      <th key={key}>
                                                        {formatHeader(key)}
                                                      </th>
                                                    ))}
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {buildingCaseTypeData.map(
                                                  (row, index) => (
                                                    <tr
                                                      key={
                                                        row.local_id || index
                                                      }
                                                    >
                                                      {/* Frame Type Input */}
                                                      <td>
                                                        <input
                                                          type="text"
                                                          className="form-control form-control-sm"
                                                          value={
                                                            row.frameType ||
                                                            `Frame Type @${
                                                              index + 1
                                                            }`
                                                          }
                                                          onChange={(e) =>
                                                            handleInputChangebuildingCaseType(
                                                              building.id,
                                                              index,
                                                              "frameType",
                                                              e.target.value
                                                            )
                                                          }
                                                        />
                                                      </td>

                                                      {/* All other dynamic fields */}
                                                      {Object.keys(row)
                                                        .filter(
                                                          (key) =>
                                                            key !==
                                                              "local_id" &&
                                                            key !==
                                                              "frameType" &&
                                                            key !==
                                                              "caseTypeCode" &&
                                                            key !==
                                                              "caseTypeDiscription"
                                                        )
                                                        .map((key) => {
                                                          const caseTypeCode =
                                                            building
                                                              .selectedCaseObject
                                                              ?.caseTypeCode;

                                                          // Same disable logic as main input
                                                          const isDisabled =
                                                            key === "width" ||
                                                            (caseTypeCode ===
                                                              "C1" &&
                                                              key ===
                                                                "ridgeHeight") ||
                                                            ((caseTypeCode ===
                                                              "C2" ||
                                                              caseTypeCode ===
                                                                "C3" ||
                                                              caseTypeCode ===
                                                                "C4") &&
                                                              (key ===
                                                                "leftSlope" ||
                                                                key ===
                                                                  "rightSlope"));

                                                          return (
                                                            <td key={key}>
                                                              <InputField
                                                                type="text"
                                                                className="inputBox"
                                                                value={
                                                                  row[key] ?? ""
                                                                }
                                                                onChange={(e) =>
                                                                  handleInputChangebuildingCaseType(
                                                                    building.id,
                                                                    index,
                                                                    key,
                                                                    e.target
                                                                      .value
                                                                  )
                                                                }
                                                                disabled={
                                                                  isDisabled
                                                                }
                                                              />
                                                            </td>
                                                          );
                                                        })}
                                                    </tr>
                                                  )
                                                )}
                                              </tbody>
                                            </table>
                                          </>
                                        ) : (
                                          <Col xs={12}>
                                            <p
                                              style={{
                                                textAlign: "center",
                                                padding: "20px",
                                                fontStyle: "italic",
                                              }}
                                            >
                                              No case selected
                                            </p>
                                          </Col>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </>
                          )}
                        </div>
                      ))}
                    </div>

                    {/* additon component */}
                    <div
                      className="tab-content pt-2"
                      style={{ overflowY: "auto" }}
                    >
                      {buildings.map((building, index) => (
                        <div
                          key={building.id}
                          className={`tab-pane fade ${
                            activeBuildingId === building.id
                              ? "show active"
                              : ""
                          }`}
                        >
                          {/* Only show content for active building */}
                          {activeBuildingId === building.id && (
                            <div
                              className="accordion mb-4"
                              id="accordionExample"
                            >
                              <div className="accordion-item">
                                <h2 className="accordion-header">
                                  <Row className="accordion-button">
                                    <Col
                                      xs={1}
                                      md={1}
                                      lg={1}
                                      className="text-left arrowBtn"
                                    >
                                      <i
                                        className={`bi ${
                                          building.isCardVisible8
                                            ? "bi-chevron-right"
                                            : "bi-chevron-down"
                                        }`}
                                        onClick={() =>
                                          toggleCardVisibility8(building.id)
                                        }
                                      ></i>
                                    </Col>
                                    <Col
                                      xs={1}
                                      md={1}
                                      lg={1}
                                      className="text-center logoBtn"
                                    >
                                      <span className="iconLogo">AL</span>
                                    </Col>
                                    <Col xs={4} md={4} lg={4}>
                                      <span className="headerTitle">
                                        Additional Component {building.id}
                                      </span>
                                      <span className="subHeaderTitle">
                                        Additional Component details
                                      </span>
                                    </Col>
                                  </Row>
                                </h2>

                                <div
                                  className={`accordion-collapse collapse show ${
                                    building.isCardVisible8 ? "visible" : ""
                                  }`}
                                >
                                  <Row>
                                    <Col
                                      xs={12}
                                      md={3}
                                      lg={3}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      {["Partition Wall", "Crane Beam"].map(
                                        (option, index) => {
                                          const camelCaseOption = option
                                            .replace(
                                              /\s(.)/g,
                                              (match, group1) =>
                                                group1.toUpperCase()
                                            )
                                            .replace(/\s/g, "")
                                            .replace(/^(.)/, (match) =>
                                              match.toLowerCase()
                                            );

                                          return (
                                            <div
                                              className="form-check mb-2"
                                              key={camelCaseOption}
                                            >
                                              <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id={`check-${camelCaseOption}-${building.id}`}
                                                style={{
                                                  width: "20px",
                                                  height: "20px",
                                                }}
                                                checked={
                                                  building
                                                    .additionalComponents?.[
                                                    camelCaseOption
                                                  ] || false
                                                }
                                                onChange={(e) =>
                                                  handleAdditionalComponentsChange(
                                                    camelCaseOption,
                                                    e.target.checked,
                                                    building.id
                                                  )
                                                }
                                              />
                                              <label
                                                className="form-check-label ms-2"
                                                htmlFor={`check-${camelCaseOption}-${building.id}`}
                                                style={{ fontSize: "16px" }}
                                              >
                                                {`${
                                                  index + 1
                                                }. ${option.toUpperCase()}`}
                                              </label>
                                            </div>
                                          );
                                        }
                                      )}
                                    </Col>
                                    <Col
                                      xs={12}
                                      md={3}
                                      lg={3}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      {["Cage Ladder", "Staircase"].map(
                                        (option, index) => {
                                          const camelCaseOption = option
                                            .replace(
                                              /\s(.)/g,
                                              (match, group1) =>
                                                group1.toUpperCase()
                                            )
                                            .replace(/\s/g, "")
                                            .replace(/^(.)/, (match) =>
                                              match.toLowerCase()
                                            );

                                          return (
                                            <div
                                              className="form-check mb-2"
                                              key={camelCaseOption}
                                            >
                                              <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id={`check-${camelCaseOption}-${building.id}`}
                                                style={{
                                                  width: "20px",
                                                  height: "20px",
                                                }}
                                                checked={
                                                  building
                                                    .additionalComponents?.[
                                                    camelCaseOption
                                                  ] || false
                                                }
                                                onChange={(e) =>
                                                  handleAdditionalComponentsChange(
                                                    camelCaseOption,
                                                    e.target.checked,
                                                    building.id
                                                  )
                                                }
                                              />
                                              <label
                                                className="form-check-label ms-2"
                                                htmlFor={`check-${camelCaseOption}-${building.id}`}
                                                style={{ fontSize: "16px" }}
                                              >
                                                {`${
                                                  index + 3
                                                }. ${option.toUpperCase()}`}
                                              </label>
                                            </div>
                                          );
                                        }
                                      )}
                                    </Col>
                                    <Col
                                      xs={12}
                                      md={3}
                                      lg={3}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      {["Mezzanine", "RoofMonitor"].map(
                                        (option, index) => {
                                          const camelCaseOption = option
                                            .replace(
                                              /\s(.)/g,
                                              (match, group1) =>
                                                group1.toUpperCase()
                                            )
                                            .replace(/\s/g, "")
                                            .replace(/^(.)/, (match) =>
                                              match.toLowerCase()
                                            );

                                          return (
                                            <div
                                              className="form-check mb-2"
                                              key={camelCaseOption}
                                            >
                                              <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id={`check-${camelCaseOption}-${building.id}`}
                                                style={{
                                                  width: "20px",
                                                  height: "20px",
                                                }}
                                                checked={
                                                  building
                                                    .additionalComponents?.[
                                                    camelCaseOption
                                                  ] || false
                                                }
                                                onChange={(e) =>
                                                  handleAdditionalComponentsChange(
                                                    camelCaseOption,
                                                    e.target.checked,
                                                    building.id
                                                  )
                                                }
                                              />
                                              <label
                                                className="form-check-label ms-2"
                                                htmlFor={`check-${camelCaseOption}-${building.id}`}
                                                style={{ fontSize: "16px" }}
                                              >
                                                {`${
                                                  index + 5
                                                }. ${option.toUpperCase()}`}
                                              </label>
                                            </div>
                                          );
                                        }
                                      )}
                                    </Col>

                                    <Col xs={12} md={12} lg={12}>
                                      <div className="card">
                                        <div className="card-body pt-3">
                                          {(() => {
                                            const allowedKeys = [
                                              "partitionWall",
                                              "craneBeam",
                                              "cageLadder",
                                              "staircase",
                                              "mezzanine",
                                              "roofMonitor",
                                            ];
                                            const activeComponents =
                                              allowedKeys.filter(
                                                (key) =>
                                                  building
                                                    .additionalComponents?.[key]
                                              );

                                            if (activeComponents.length === 0) {
                                              return (
                                                <div className="text-center text-muted border rounded p-4">
                                                  <strong>
                                                    No additional component is
                                                    selected
                                                  </strong>
                                                </div>
                                              );
                                            }

                                            const currentActiveTab =
                                              getCurrentActiveTab(building);

                                            return (
                                              <>
                                                <ul className="nav nav-tabs nav-tabs-bordered">
                                                  {activeComponents.map(
                                                    (key) => {
                                                      const title = key
                                                        .replace(
                                                          /([A-Z])/g,
                                                          " $1"
                                                        )
                                                        .replace(/^./, (str) =>
                                                          str.toUpperCase()
                                                        );

                                                      return (
                                                        <li
                                                          key={key}
                                                          className="nav-item"
                                                        >
                                                          <button
                                                            className={`nav-link ${
                                                              currentActiveTab ===
                                                              key
                                                                ? "active"
                                                                : ""
                                                            }`}
                                                            onClick={() =>
                                                              handleTabChange(
                                                                building.id,
                                                                key
                                                              )
                                                            }
                                                            type="button"
                                                          >
                                                            {title}
                                                          </button>
                                                        </li>
                                                      );
                                                    }
                                                  )}
                                                </ul>

                                                <div className="tab-content pt-2">
                                                  {activeComponents.map(
                                                    (key) => {
                                                      const isActive =
                                                        currentActiveTab ===
                                                        key;

                                                      return (
                                                        <div
                                                          key={key}
                                                          className={`tab-pane fade ${
                                                            isActive
                                                              ? "show active"
                                                              : ""
                                                          }`}
                                                        >
                                                          {/* Partition Wall Content */}
                                                          {key ===
                                                            "partitionWall" && (
                                                            <div>
                                                              <h5 className="card-title text-primary">
                                                                Partition Wall
                                                              </h5>
                                                              <div className="row">
                                                                <div className="col-lg-12 col-md-12 label">
                                                                  <div>
                                                                    {/* Number of Partition Walls */}
                                                                    <Col
                                                                      xs={8}
                                                                      md={3}
                                                                      lg={3}
                                                                      className="commTopButtonRightLeftPadding"
                                                                    >
                                                                      <div
                                                                        style={{
                                                                          display:
                                                                            "flex",
                                                                          alignItems:
                                                                            "center",
                                                                          gap: "10px",
                                                                        }}
                                                                      >
                                                                        <label
                                                                          style={{
                                                                            whiteSpace:
                                                                              "nowrap",
                                                                            marginBottom:
                                                                              "0",
                                                                          }}
                                                                        >
                                                                          No. of
                                                                          Partition
                                                                          Walls:
                                                                        </label>
                                                                        <InputField
                                                                          className="inputBox"
                                                                          type="number"
                                                                          min="0"
                                                                          value={
                                                                            building
                                                                              .partitionWallData
                                                                              ?.noOfPartitionWalls ||
                                                                            0
                                                                          }
                                                                          onChange={(
                                                                            e
                                                                          ) =>
                                                                            handlePartitionWallCountChange(
                                                                              e
                                                                                .target
                                                                                .value,
                                                                              building.id
                                                                            )
                                                                          }
                                                                          style={{
                                                                            width:
                                                                              "60px",
                                                                            padding:
                                                                              "5px",
                                                                          }}
                                                                        />
                                                                      </div>
                                                                    </Col>

                                                                    {/* Table */}
                                                                    <div className="table-responsive">
                                                                      <table
                                                                        style={{
                                                                          borderCollapse:
                                                                            "collapse",
                                                                          width:
                                                                            "100%",
                                                                        }}
                                                                      >
                                                                        <thead>
                                                                          <tr
                                                                            style={{
                                                                              backgroundColor:
                                                                                "#f2f2f2",
                                                                            }}
                                                                          >
                                                                            <th
                                                                              style={{
                                                                                border:
                                                                                  "1px solid #ddd",
                                                                                padding:
                                                                                  "10px",
                                                                                textAlign:
                                                                                  "left",
                                                                                minWidth:
                                                                                  "200px",
                                                                              }}
                                                                            ></th>
                                                                            {Array.from(
                                                                              {
                                                                                length:
                                                                                  building
                                                                                    .partitionWallData
                                                                                    ?.noOfPartitionWalls ||
                                                                                  0,
                                                                              },
                                                                              (
                                                                                _,
                                                                                i
                                                                              ) =>
                                                                                i +
                                                                                1
                                                                            ).map(
                                                                              (
                                                                                index
                                                                              ) => (
                                                                                <th
                                                                                  key={
                                                                                    index
                                                                                  }
                                                                                  style={{
                                                                                    border:
                                                                                      "1px solid #ddd",
                                                                                    padding:
                                                                                      "10px",
                                                                                    minWidth:
                                                                                      "150px",
                                                                                  }}
                                                                                >
                                                                                  Partition
                                                                                  wall
                                                                                  -{" "}
                                                                                  {String(
                                                                                    index
                                                                                  ).padStart(
                                                                                    2,
                                                                                    "0"
                                                                                  )}
                                                                                </th>
                                                                              )
                                                                            )}
                                                                          </tr>
                                                                        </thead>

                                                                        <tbody>
                                                                          {/* WIDTH */}
                                                                          <tr>
                                                                            <td
                                                                              style={{
                                                                                border:
                                                                                  "1px solid #ddd",
                                                                                padding:
                                                                                  "10px",
                                                                                fontWeight:
                                                                                  "bold",
                                                                              }}
                                                                            >
                                                                              Width/Length
                                                                            </td>
                                                                            {Array.from(
                                                                              {
                                                                                length:
                                                                                  building
                                                                                    .partitionWallData
                                                                                    ?.noOfPartitionWalls ||
                                                                                  0,
                                                                              },
                                                                              (
                                                                                _,
                                                                                i
                                                                              ) =>
                                                                                i +
                                                                                1
                                                                            ).map(
                                                                              (
                                                                                colIndex
                                                                              ) => (
                                                                                <td
                                                                                  key={`width-${colIndex}`}
                                                                                  style={{
                                                                                    border:
                                                                                      "1px solid #ddd",
                                                                                    padding:
                                                                                      "5px",
                                                                                  }}
                                                                                >
                                                                                  <InputField
                                                                                    className="inputBox"
                                                                                    type="number"
                                                                                    value={
                                                                                      building
                                                                                        .partitionWallData
                                                                                        ?.partitionDetails?.[
                                                                                        colIndex -
                                                                                          1
                                                                                      ]
                                                                                        ?.width ||
                                                                                      ""
                                                                                    }
                                                                                    onChange={(
                                                                                      e
                                                                                    ) =>
                                                                                      handlePartitionWallInputChangeDynamic(
                                                                                        e,
                                                                                        "Width",
                                                                                        colIndex,
                                                                                        building.id
                                                                                      )
                                                                                    }
                                                                                  />
                                                                                </td>
                                                                              )
                                                                            )}
                                                                          </tr>
                                                                          {/* Width → Gridline From */}
                                                                          <tr>
                                                                            <td
                                                                              style={{
                                                                                border:
                                                                                  "1px solid #ddd",
                                                                                padding:
                                                                                  "8px",
                                                                              }}
                                                                            >
                                                                              &nbsp;&nbsp;Gridline
                                                                              From
                                                                            </td>
                                                                            {Array.from(
                                                                              {
                                                                                length:
                                                                                  building
                                                                                    .partitionWallData
                                                                                    ?.noOfPartitionWalls ||
                                                                                  0,
                                                                              },
                                                                              (
                                                                                _,
                                                                                i
                                                                              ) =>
                                                                                i +
                                                                                1
                                                                            ).map(
                                                                              (
                                                                                colIndex
                                                                              ) => (
                                                                                <td
                                                                                  key={`gridFromW-${colIndex}`}
                                                                                  style={{
                                                                                    border:
                                                                                      "1px solid #ddd",
                                                                                    padding:
                                                                                      "5px",
                                                                                  }}
                                                                                >
                                                                                  <InputField
                                                                                    className="inputBox"
                                                                                    value={
                                                                                      building
                                                                                        .partitionWallData
                                                                                        ?.partitionDetails?.[
                                                                                        colIndex -
                                                                                          1
                                                                                      ]
                                                                                        ?.gridFromWidth ||
                                                                                      ""
                                                                                    }
                                                                                    onChange={(
                                                                                      e
                                                                                    ) =>
                                                                                      handlePartitionWallInputChangeDynamic(
                                                                                        e,
                                                                                        "Gridline From Width",
                                                                                        colIndex,
                                                                                        building.id
                                                                                      )
                                                                                    }
                                                                                  />
                                                                                </td>
                                                                              )
                                                                            )}
                                                                          </tr>

                                                                          {/* Width → Gridline To */}
                                                                          <tr>
                                                                            <td
                                                                              style={{
                                                                                border:
                                                                                  "1px solid #ddd",
                                                                                padding:
                                                                                  "8px",
                                                                              }}
                                                                            >
                                                                              &nbsp;&nbsp;Gridline
                                                                              To
                                                                            </td>
                                                                            {Array.from(
                                                                              {
                                                                                length:
                                                                                  building
                                                                                    .partitionWallData
                                                                                    ?.noOfPartitionWalls ||
                                                                                  0,
                                                                              },
                                                                              (
                                                                                _,
                                                                                i
                                                                              ) =>
                                                                                i +
                                                                                1
                                                                            ).map(
                                                                              (
                                                                                colIndex
                                                                              ) => (
                                                                                <td
                                                                                  key={`gridToW-${colIndex}`}
                                                                                  style={{
                                                                                    border:
                                                                                      "1px solid #ddd",
                                                                                    padding:
                                                                                      "5px",
                                                                                  }}
                                                                                >
                                                                                  <InputField
                                                                                    className="inputBox"
                                                                                    value={
                                                                                      building
                                                                                        .partitionWallData
                                                                                        ?.partitionDetails?.[
                                                                                        colIndex -
                                                                                          1
                                                                                      ]
                                                                                        ?.gridToWidth ||
                                                                                      ""
                                                                                    }
                                                                                    onChange={(
                                                                                      e
                                                                                    ) =>
                                                                                      handlePartitionWallInputChangeDynamic(
                                                                                        e,
                                                                                        "Gridline To Width",
                                                                                        colIndex,
                                                                                        building.id
                                                                                      )
                                                                                    }
                                                                                  />
                                                                                </td>
                                                                              )
                                                                            )}
                                                                          </tr>

                                                                          {/* LENGTH */}
                                                                          <tr>
                                                                            <td
                                                                              style={{
                                                                                border:
                                                                                  "1px solid #ddd",
                                                                                padding:
                                                                                  "10px",
                                                                                fontWeight:
                                                                                  "bold",
                                                                              }}
                                                                            >
                                                                              Height
                                                                            </td>
                                                                            {Array.from(
                                                                              {
                                                                                length:
                                                                                  building
                                                                                    .partitionWallData
                                                                                    ?.noOfPartitionWalls ||
                                                                                  0,
                                                                              },
                                                                              (
                                                                                _,
                                                                                i
                                                                              ) =>
                                                                                i +
                                                                                1
                                                                            ).map(
                                                                              (
                                                                                colIndex
                                                                              ) => (
                                                                                <td
                                                                                  key={`length-${colIndex}`}
                                                                                  style={{
                                                                                    border:
                                                                                      "1px solid #ddd",
                                                                                    padding:
                                                                                      "5px",
                                                                                  }}
                                                                                >
                                                                                  <InputField
                                                                                    className="inputBox"
                                                                                    type="number"
                                                                                    value={
                                                                                      building
                                                                                        .partitionWallData
                                                                                        ?.partitionDetails?.[
                                                                                        colIndex -
                                                                                          1
                                                                                      ]
                                                                                        ?.length ||
                                                                                      ""
                                                                                    }
                                                                                    onChange={(
                                                                                      e
                                                                                    ) =>
                                                                                      handlePartitionWallInputChangeDynamic(
                                                                                        e,
                                                                                        "Length",
                                                                                        colIndex,
                                                                                        building.id
                                                                                      )
                                                                                    }
                                                                                  />
                                                                                </td>
                                                                              )
                                                                            )}
                                                                          </tr>

                                                                          {/* AREA */}
                                                                          <tr>
                                                                            <td
                                                                              style={{
                                                                                border:
                                                                                  "1px solid #ddd",
                                                                                padding:
                                                                                  "8px",
                                                                              }}
                                                                            >
                                                                              Area
                                                                              (Width
                                                                              ×
                                                                              Height)
                                                                            </td>
                                                                            {Array.from(
                                                                              {
                                                                                length:
                                                                                  building
                                                                                    .partitionWallData
                                                                                    ?.noOfPartitionWalls ||
                                                                                  0,
                                                                              },
                                                                              (
                                                                                _,
                                                                                i
                                                                              ) =>
                                                                                i +
                                                                                1
                                                                            ).map(
                                                                              (
                                                                                colIndex
                                                                              ) => {
                                                                                const details =
                                                                                  building
                                                                                    .partitionWallData
                                                                                    ?.partitionDetails?.[
                                                                                    colIndex -
                                                                                      1
                                                                                  ];
                                                                                const width =
                                                                                  parseFloat(
                                                                                    details?.width ||
                                                                                      0
                                                                                  );
                                                                                const length =
                                                                                  parseFloat(
                                                                                    details?.length ||
                                                                                      0
                                                                                  );

                                                                                const area =
                                                                                  width >=
                                                                                    0 &&
                                                                                  length >=
                                                                                    0
                                                                                    ? (
                                                                                        width *
                                                                                        length
                                                                                      ).toFixed(
                                                                                        2
                                                                                      )
                                                                                    : "";

                                                                                return (
                                                                                  <td
                                                                                    key={`area-${colIndex}`}
                                                                                    style={{
                                                                                      border:
                                                                                        "1px solid #ddd",
                                                                                      padding:
                                                                                        "5px",
                                                                                    }}
                                                                                  >
                                                                                    <input
                                                                                      type="text"
                                                                                      value={
                                                                                        area
                                                                                      }
                                                                                      readOnly
                                                                                      className="w-full border border-gray-300 rounded px-2 py-1 focus:outline-none bg-gray-50"
                                                                                    />
                                                                                  </td>
                                                                                );
                                                                              }
                                                                            )}
                                                                          </tr>
                                                                          {/* BLOCK WALL HEIGHT */}
                                                                          <tr>
                                                                            <td
                                                                              style={{
                                                                                border:
                                                                                  "1px solid #ddd",
                                                                                padding:
                                                                                  "8px",
                                                                              }}
                                                                            >
                                                                              Block
                                                                              Wall
                                                                              Height
                                                                            </td>
                                                                            {Array.from(
                                                                              {
                                                                                length:
                                                                                  building
                                                                                    .partitionWallData
                                                                                    ?.noOfPartitionWalls ||
                                                                                  0,
                                                                              },
                                                                              (
                                                                                _,
                                                                                i
                                                                              ) =>
                                                                                i +
                                                                                1
                                                                            ).map(
                                                                              (
                                                                                colIndex
                                                                              ) => (
                                                                                <td
                                                                                  key={`bwh-${colIndex}`}
                                                                                  style={{
                                                                                    border:
                                                                                      "1px solid #ddd",
                                                                                    padding:
                                                                                      "5px",
                                                                                  }}
                                                                                >
                                                                                  <InputField
                                                                                    className="inputBox"
                                                                                    value={
                                                                                      building
                                                                                        .partitionWallData
                                                                                        ?.partitionDetails?.[
                                                                                        colIndex -
                                                                                          1
                                                                                      ]
                                                                                        ?.blockWallHeight ||
                                                                                      ""
                                                                                    }
                                                                                    onChange={(
                                                                                      e
                                                                                    ) =>
                                                                                      handlePartitionWallInputChangeDynamic(
                                                                                        e,
                                                                                        "Block Wall Height",
                                                                                        colIndex,
                                                                                        building.id
                                                                                      )
                                                                                    }
                                                                                  />
                                                                                </td>
                                                                              )
                                                                            )}
                                                                          </tr>

                                                                          {/* GIRT CONDITION */}
                                                                          <tr>
                                                                            <td
                                                                              style={{
                                                                                border:
                                                                                  "1px solid #ddd",
                                                                                padding:
                                                                                  "8px",
                                                                              }}
                                                                            >
                                                                              Girt
                                                                              Condition
                                                                            </td>
                                                                            {Array.from(
                                                                              {
                                                                                length:
                                                                                  building
                                                                                    .partitionWallData
                                                                                    ?.noOfPartitionWalls ||
                                                                                  0,
                                                                              },
                                                                              (
                                                                                _,
                                                                                i
                                                                              ) =>
                                                                                i +
                                                                                1
                                                                            ).map(
                                                                              (
                                                                                colIndex
                                                                              ) => (
                                                                                <td
                                                                                  key={`girt-${colIndex}`}
                                                                                  style={{
                                                                                    padding:
                                                                                      "5px",
                                                                                  }}
                                                                                >
                                                                                  <select
                                                                                    className="w-full border border-gray-300 rounded-md px-2 py-1 focus:outline-none focus:ring-2"
                                                                                    value={
                                                                                      building
                                                                                        .partitionWallData
                                                                                        ?.partitionDetails?.[
                                                                                        colIndex -
                                                                                          1
                                                                                      ]
                                                                                        ?.girtCondition ||
                                                                                      ""
                                                                                    }
                                                                                    onChange={(
                                                                                      e
                                                                                    ) =>
                                                                                      handlePartitionWallInputChangeDynamic(
                                                                                        e,
                                                                                        "Girt Condition",
                                                                                        colIndex,
                                                                                        building.id
                                                                                      )
                                                                                    }
                                                                                  >
                                                                                    <option value="Bypass">
                                                                                      Bypass
                                                                                    </option>
                                                                                    <option value="Flush">
                                                                                      Flush
                                                                                    </option>
                                                                                  </select>
                                                                                </td>
                                                                              )
                                                                            )}
                                                                          </tr>
                                                                          {/* SUB TOTAL ROW */}
                                                                          <tr
                                                                            style={{
                                                                              backgroundColor:
                                                                                "#f9f9f9",
                                                                              fontWeight:
                                                                                "bold",
                                                                            }}
                                                                          >
                                                                            <td
                                                                              // style={{
                                                                              //     border: "1px solid #ddd",
                                                                              //     padding: "10px",
                                                                              //     textAlign: "right",
                                                                              // }}
                                                                              style={{
                                                                                fontWeight:
                                                                                  "bolder",
                                                                                backgroundColor:
                                                                                  "#e0f7fa",
                                                                                color:
                                                                                  "#004d40",
                                                                                border:
                                                                                  "1px solid #ddd",
                                                                                padding:
                                                                                  "10px",
                                                                              }}
                                                                            >
                                                                              Partition-Wall
                                                                              SubTotal
                                                                              Area:
                                                                            </td>

                                                                            <td
                                                                              colSpan={
                                                                                building
                                                                                  .partitionWallData
                                                                                  ?.noOfPartitionWalls ||
                                                                                1
                                                                              }
                                                                              style={{
                                                                                fontWeight:
                                                                                  "bolder",
                                                                                backgroundColor:
                                                                                  "#e0f7fa",
                                                                                color:
                                                                                  "#004d40",
                                                                                border:
                                                                                  "1px solid #ddd",
                                                                                padding:
                                                                                  "10px",
                                                                              }}
                                                                            >
                                                                              {building?.partitionWallSubtotal?.toFixed(
                                                                                3
                                                                              ) ||
                                                                                "0.000"}
                                                                            </td>
                                                                          </tr>
                                                                        </tbody>
                                                                      </table>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          )}

                                                          {/* Add other component contents here */}
                                                          {key ===
                                                            "craneBeam" && (
                                                            <div>
                                                              <h5 className="card-title text-primary">
                                                                Crane Beam
                                                              </h5>
                                                              <div className="row">
                                                                <div className="col-lg-12 col-md-12 label">
                                                                  <div>
                                                                    <Col
                                                                      xs={8}
                                                                      md={2}
                                                                      lg={2}
                                                                      className="commTopButtonRightLeftPadding"
                                                                    >
                                                                      <div
                                                                        style={{
                                                                          display:
                                                                            "flex",
                                                                          alignItems:
                                                                            "center",
                                                                          gap: "10px",
                                                                        }}
                                                                      >
                                                                        <label
                                                                          style={{
                                                                            whiteSpace:
                                                                              "nowrap",
                                                                            marginBottom:
                                                                              "0",
                                                                          }}
                                                                        >
                                                                          No. of
                                                                          Cranes
                                                                        </label>
                                                                        <InputField
                                                                          className="inputBox"
                                                                          type="number"
                                                                          min="0"
                                                                          value={
                                                                            building
                                                                              .craneData
                                                                              ?.noofCranes ||
                                                                            1
                                                                          }
                                                                          onChange={(
                                                                            e
                                                                          ) =>
                                                                            handleCraneCountChange(
                                                                              e
                                                                                .target
                                                                                .value,
                                                                              building.id
                                                                            )
                                                                          }
                                                                          style={{
                                                                            width:
                                                                              "60px",
                                                                            padding:
                                                                              "5px",
                                                                          }}
                                                                        />
                                                                      </div>
                                                                    </Col>
                                                                    <div className="table-responsive">
                                                                      <table
                                                                        style={{
                                                                          borderCollapse:
                                                                            "collapse",
                                                                          width:
                                                                            "100%",
                                                                        }}
                                                                      >
                                                                        <thead>
                                                                          <tr
                                                                            style={{
                                                                              backgroundColor:
                                                                                "#f2f2f2",
                                                                            }}
                                                                          >
                                                                            <th
                                                                              style={{
                                                                                border:
                                                                                  "1px solid #ddd",
                                                                                padding:
                                                                                  "10px",
                                                                                textAlign:
                                                                                  "left",
                                                                                minWidth:
                                                                                  "200px",
                                                                              }}
                                                                            ></th>
                                                                            {Array.from(
                                                                              {
                                                                                length:
                                                                                  building
                                                                                    .craneData
                                                                                    ?.noofCranes ||
                                                                                  0,
                                                                              },
                                                                              (
                                                                                _,
                                                                                i
                                                                              ) =>
                                                                                i +
                                                                                1
                                                                            ).map(
                                                                              (
                                                                                index
                                                                              ) => (
                                                                                <th
                                                                                  key={
                                                                                    index
                                                                                  }
                                                                                  style={{
                                                                                    border:
                                                                                      "1px solid #ddd",
                                                                                    padding:
                                                                                      "10px",
                                                                                    minWidth:
                                                                                      "120px",
                                                                                  }}
                                                                                >
                                                                                  CRANE-
                                                                                  {String(
                                                                                    index
                                                                                  ).padStart(
                                                                                    2,
                                                                                    "0"
                                                                                  )}
                                                                                </th>
                                                                              )
                                                                            )}
                                                                          </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                          {craneTableRows.map(
                                                                            (
                                                                              rowLabel
                                                                            ) => (
                                                                              <tr
                                                                                key={
                                                                                  rowLabel
                                                                                }
                                                                              >
                                                                                <td
                                                                                  style={{
                                                                                    border:
                                                                                      "1px solid #ddd",
                                                                                    padding:
                                                                                      "20px",
                                                                                    fontWeight:
                                                                                      "bold",
                                                                                  }}
                                                                                >
                                                                                  {
                                                                                    rowLabel
                                                                                  }
                                                                                </td>
                                                                                {Array.from(
                                                                                  {
                                                                                    length:
                                                                                      building
                                                                                        .craneData
                                                                                        ?.noofCranes ||
                                                                                      0,
                                                                                  },
                                                                                  (
                                                                                    _,
                                                                                    i
                                                                                  ) =>
                                                                                    i +
                                                                                    1
                                                                                ).map(
                                                                                  (
                                                                                    colIndex
                                                                                  ) => (
                                                                                    <td
                                                                                      key={
                                                                                        colIndex
                                                                                      }
                                                                                      style={{
                                                                                        border:
                                                                                          "1px solid #ddd",
                                                                                        padding:
                                                                                          "5px",
                                                                                      }}
                                                                                    >
                                                                                      <InputField
                                                                                        className="inputBox"
                                                                                        type="text"
                                                                                        value={
                                                                                          building
                                                                                            .craneData
                                                                                            ?.craneDetails[
                                                                                            colIndex -
                                                                                              1
                                                                                          ]?.[
                                                                                            rowLabel ===
                                                                                            "Crane Type"
                                                                                              ? "craneType"
                                                                                              : rowLabel ===
                                                                                                "Crane AISLE (SPAN 1,2,3)"
                                                                                              ? "craneAISLE"
                                                                                              : rowLabel ===
                                                                                                "GRID LINE FROM"
                                                                                              ? "fromGL"
                                                                                              : rowLabel ===
                                                                                                "GRID LINE TO"
                                                                                              ? "toGL"
                                                                                              : rowLabel ===
                                                                                                "Crane Capacity"
                                                                                              ? "craneCapacity"
                                                                                              : rowLabel ===
                                                                                                "Crane Bracket/Hook Height"
                                                                                              ? "craneBracketHookHeight"
                                                                                              : rowLabel ===
                                                                                                "Bridge weight (MT)"
                                                                                              ? "bridgeWeight"
                                                                                              : rowLabel ===
                                                                                                "Carb / trolley / Hoist weight (MT)"
                                                                                              ? "carbTrolleyHoistWeight"
                                                                                              : rowLabel ===
                                                                                                "Wheel Base (m)"
                                                                                              ? "wheelBase"
                                                                                              : rowLabel ===
                                                                                                "Bumper to bumper dist (m)"
                                                                                              ? "bumperTobumperDist"
                                                                                              : rowLabel ===
                                                                                                "Rail"
                                                                                              ? "rail"
                                                                                              : rowLabel ===
                                                                                                "Tandom operation"
                                                                                              ? "tandomOperation"
                                                                                              : rowLabel
                                                                                          ] ||
                                                                                          ""
                                                                                        }
                                                                                        onChange={(
                                                                                          e
                                                                                        ) =>
                                                                                          handleCraneInputChange(
                                                                                            e,
                                                                                            rowLabel,
                                                                                            colIndex,
                                                                                            building.id
                                                                                          )
                                                                                        }
                                                                                        style={{
                                                                                          width:
                                                                                            "100%",
                                                                                          boxSizing:
                                                                                            "border-box",
                                                                                          padding:
                                                                                            "5px",
                                                                                        }}
                                                                                      />
                                                                                    </td>
                                                                                  )
                                                                                )}
                                                                              </tr>
                                                                            )
                                                                          )}
                                                                        </tbody>
                                                                      </table>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>{" "}
                                                            </div>
                                                          )}
                                                          {key ===
                                                            "cageLadder" && (
                                                            <div>
                                                              <h5 className="card-title text-primary">
                                                                Cage Ladder
                                                              </h5>
                                                              <div className="row">
                                                                <div className="col-lg-12 col-md-12 label">
                                                                  <div
                                                                    style={{
                                                                      padding:
                                                                        "20px",
                                                                    }}
                                                                  >
                                                                    <table
                                                                      style={{
                                                                        borderCollapse:
                                                                          "collapse",
                                                                        width:
                                                                          "400px",
                                                                      }}
                                                                    >
                                                                      <tbody>
                                                                        {[
                                                                          {
                                                                            label:
                                                                              "Number",
                                                                            field:
                                                                              "cageLadderNumber",
                                                                          },
                                                                          {
                                                                            label:
                                                                              "Location",
                                                                            field:
                                                                              "cageLadderLocation",
                                                                          },
                                                                          {
                                                                            label:
                                                                              "Height",
                                                                            field:
                                                                              "cageLadderHeight",
                                                                          },
                                                                        ].map(
                                                                          ({
                                                                            label,
                                                                            field,
                                                                          }) => (
                                                                            <tr
                                                                              key={
                                                                                field
                                                                              }
                                                                            >
                                                                              <td
                                                                                style={{
                                                                                  border:
                                                                                    "1px solid #ddd",
                                                                                  padding:
                                                                                    "10px",
                                                                                  fontWeight:
                                                                                    "bold",
                                                                                }}
                                                                              >
                                                                                {
                                                                                  label
                                                                                }
                                                                              </td>
                                                                              <td
                                                                                style={{
                                                                                  border:
                                                                                    "1px solid #ddd",
                                                                                  padding:
                                                                                    "5px",
                                                                                }}
                                                                              >
                                                                                <InputField
                                                                                  className="inputBox"
                                                                                  type="text"
                                                                                  name={
                                                                                    field
                                                                                  }
                                                                                  value={
                                                                                    building
                                                                                      .cageLadderInputs?.[
                                                                                      field
                                                                                    ] ||
                                                                                    ""
                                                                                  }
                                                                                  onChange={(
                                                                                    e
                                                                                  ) =>
                                                                                    handleCageLadderInputChange(
                                                                                      field,
                                                                                      e
                                                                                        .target
                                                                                        .value,
                                                                                      building.id
                                                                                    )
                                                                                  }
                                                                                  style={{
                                                                                    width:
                                                                                      "100%",
                                                                                    boxSizing:
                                                                                      "border-box",
                                                                                  }}
                                                                                />
                                                                              </td>
                                                                            </tr>
                                                                          )
                                                                        )}
                                                                      </tbody>
                                                                    </table>
                                                                  </div>
                                                                </div>
                                                              </div>{" "}
                                                            </div>
                                                          )}
                                                          {key ===
                                                            "staircase" && (
                                                            <div>
                                                              <h5 className="card-title text-primary">
                                                                Staircase
                                                              </h5>
                                                              <div className="row">
                                                                <div className="col-lg-12 col-md-12 label">
                                                                  <div
                                                                    style={{
                                                                      padding:
                                                                        "20px",
                                                                    }}
                                                                  >
                                                                    <table
                                                                      style={{
                                                                        borderCollapse:
                                                                          "collapse",

                                                                        width:
                                                                          "400px",
                                                                      }}
                                                                    >
                                                                      <tbody>
                                                                        {[
                                                                          {
                                                                            label:
                                                                              "Numbers",
                                                                            field:
                                                                              "staircaseNumber",
                                                                          },

                                                                          {
                                                                            label:
                                                                              "Width",
                                                                            field:
                                                                              "staircasewidth",
                                                                          },

                                                                          {
                                                                            label:
                                                                              "Height",
                                                                            field:
                                                                              "staircaseHeight",
                                                                          },

                                                                          {
                                                                            label:
                                                                              "Handrails",
                                                                            field:
                                                                              "staircaseHandrails",
                                                                          },
                                                                        ].map(
                                                                          ({
                                                                            label,
                                                                            field,
                                                                          }) => (
                                                                            <tr
                                                                              key={
                                                                                field
                                                                              }
                                                                            >
                                                                              <td
                                                                                style={{
                                                                                  border:
                                                                                    "1px solid #ddd",

                                                                                  padding:
                                                                                    "10px",

                                                                                  fontWeight:
                                                                                    "bold",

                                                                                  width:
                                                                                    "150px",
                                                                                }}
                                                                              >
                                                                                {
                                                                                  label
                                                                                }
                                                                              </td>
                                                                              <td
                                                                                style={{
                                                                                  border:
                                                                                    "1px solid #ddd",

                                                                                  padding:
                                                                                    "5px",
                                                                                }}
                                                                              >
                                                                                {field ===
                                                                                "staircaseHandrails" ? (
                                                                                  <select
                                                                                    className="w-full border border-gray-300 rounded px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                                                    value={
                                                                                      building
                                                                                        .staircaseInputs?.[
                                                                                        field
                                                                                      ] ||
                                                                                      ""
                                                                                    }
                                                                                    onChange={(
                                                                                      e
                                                                                    ) =>
                                                                                      handleStaircaseInputChange(
                                                                                        field,

                                                                                        e
                                                                                          .target
                                                                                          .value,

                                                                                        building.id
                                                                                      )
                                                                                    }
                                                                                  >
                                                                                    <option value="">
                                                                                      Select
                                                                                    </option>
                                                                                    <option value="Yes">
                                                                                      Yes
                                                                                    </option>
                                                                                    <option value="No">
                                                                                      No
                                                                                    </option>
                                                                                  </select>
                                                                                ) : (
                                                                                  <InputField
                                                                                    className="inputBox"
                                                                                    type="text"
                                                                                    name={
                                                                                      field
                                                                                    }
                                                                                    value={
                                                                                      building
                                                                                        .staircaseInputs?.[
                                                                                        field
                                                                                      ] ||
                                                                                      ""
                                                                                    }
                                                                                    onChange={(
                                                                                      e
                                                                                    ) =>
                                                                                      handleStaircaseInputChange(
                                                                                        field,

                                                                                        e
                                                                                          .target
                                                                                          .value,

                                                                                        building.id
                                                                                      )
                                                                                    }
                                                                                    style={{
                                                                                      width:
                                                                                        "100%",

                                                                                      boxSizing:
                                                                                        "border-box",
                                                                                    }}
                                                                                  />
                                                                                )}
                                                                              </td>
                                                                            </tr>
                                                                          )
                                                                        )}
                                                                      </tbody>
                                                                    </table>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          )}

                                                          {key ===
                                                            "mezzanine" && (
                                                            <div>
                                                              <h5 className="card-title text-primary">
                                                                Mezzanine
                                                              </h5>
                                                              <div className="row">
                                                                <div className="col-lg-12 col-md-12 label">
                                                                  <div>
                                                                    <Col
                                                                      xs={8}
                                                                      md={3}
                                                                      lg={3}
                                                                      className="commTopButtonRightLeftPadding"
                                                                    >
                                                                      <div
                                                                        style={{
                                                                          display:
                                                                            "flex",
                                                                          alignItems:
                                                                            "center",
                                                                          gap: "10px",
                                                                        }}
                                                                      >
                                                                        <label
                                                                          style={{
                                                                            whiteSpace:
                                                                              "nowrap",
                                                                            marginBottom:
                                                                              "0",
                                                                          }}
                                                                        >
                                                                          No. of
                                                                          mezzanines:
                                                                        </label>
                                                                        <InputField
                                                                          className="inputBox"
                                                                          type="number"
                                                                          min="0"
                                                                          value={
                                                                            building
                                                                              .mezzanineData
                                                                              ?.noOfmezzanines ||
                                                                            1
                                                                          }
                                                                          onChange={(
                                                                            e
                                                                          ) =>
                                                                            handleMezzanineCountChange(
                                                                              e
                                                                                .target
                                                                                .value,
                                                                              building.id
                                                                            )
                                                                          }
                                                                          style={{
                                                                            width:
                                                                              "60px",
                                                                            padding:
                                                                              "5px",
                                                                          }}
                                                                        />
                                                                      </div>
                                                                    </Col>
                                                                    <div className="table-responsive">
                                                                      <table
                                                                        style={{
                                                                          borderCollapse:
                                                                            "collapse",
                                                                          width:
                                                                            "100%",
                                                                        }}
                                                                      >
                                                                        <thead>
                                                                          <tr
                                                                            style={{
                                                                              backgroundColor:
                                                                                "#f2f2f2",
                                                                            }}
                                                                          >
                                                                            <th
                                                                              style={{
                                                                                border:
                                                                                  "1px solid #ddd",
                                                                                padding:
                                                                                  "10px",
                                                                                textAlign:
                                                                                  "left",
                                                                                minWidth:
                                                                                  "200px",
                                                                              }}
                                                                            ></th>
                                                                            {Array.from(
                                                                              {
                                                                                length:
                                                                                  building
                                                                                    .mezzanineData
                                                                                    ?.noOfmezzanines ||
                                                                                  0,
                                                                              },
                                                                              (
                                                                                _,
                                                                                i
                                                                              ) =>
                                                                                i +
                                                                                1
                                                                            ).map(
                                                                              (
                                                                                index
                                                                              ) => (
                                                                                <th
                                                                                  key={
                                                                                    index
                                                                                  }
                                                                                  style={{
                                                                                    border:
                                                                                      "1px solid #ddd",
                                                                                    padding:
                                                                                      "10px",
                                                                                    minWidth:
                                                                                      "120px",
                                                                                  }}
                                                                                >
                                                                                  MEZZANINE{" "}
                                                                                  {
                                                                                    index
                                                                                  }
                                                                                </th>
                                                                              )
                                                                            )}
                                                                          </tr>
                                                                        </thead>

                                                                        <tbody>
                                                                          {[
                                                                            ...mezzaninTableRows,
                                                                            "Area (Sqm)",
                                                                            "Mezzanine Sub Total Area",
                                                                          ].map(
                                                                            (
                                                                              rowLabel
                                                                            ) => (
                                                                              <tr
                                                                                key={
                                                                                  rowLabel
                                                                                }
                                                                              >
                                                                                <td
                                                                                  style={{
                                                                                    border:
                                                                                      "1px solid #ddd",
                                                                                    padding:
                                                                                      "10px",
                                                                                    fontWeight:
                                                                                      "bold",
                                                                                  }}
                                                                                >
                                                                                  {
                                                                                    rowLabel
                                                                                  }
                                                                                </td>

                                                                                {Array.from(
                                                                                  {
                                                                                    length:
                                                                                      building
                                                                                        .mezzanineData
                                                                                        ?.noOfmezzanines ||
                                                                                      0,
                                                                                  },
                                                                                  (
                                                                                    _,
                                                                                    i
                                                                                  ) =>
                                                                                    i +
                                                                                    1
                                                                                ).map(
                                                                                  (
                                                                                    colIndex
                                                                                  ) => {
                                                                                    const details =
                                                                                      building
                                                                                        .mezzanineData
                                                                                        ?.mezzanineDetails?.[
                                                                                        colIndex -
                                                                                          1
                                                                                      ] ||
                                                                                      {};
                                                                                    const width =
                                                                                      parseFloat(
                                                                                        details.width ||
                                                                                          0
                                                                                      );
                                                                                    const length =
                                                                                      parseFloat(
                                                                                        details.length ||
                                                                                          0
                                                                                      );
                                                                                    const area =
                                                                                      width &&
                                                                                      length
                                                                                        ? (
                                                                                            width *
                                                                                            length
                                                                                          ).toFixed(
                                                                                            3
                                                                                          )
                                                                                        : "";

                                                                                    // --- AREA row (read-only)
                                                                                    if (
                                                                                      rowLabel ===
                                                                                      "Area (Sqm)"
                                                                                    ) {
                                                                                      return (
                                                                                        <td
                                                                                          key={`area-${colIndex}`}
                                                                                          style={{
                                                                                            border:
                                                                                              "1px solid #ddd",
                                                                                            padding:
                                                                                              "5px",
                                                                                          }}
                                                                                        >
                                                                                          <input
                                                                                            type="text"
                                                                                            value={
                                                                                              area
                                                                                            }
                                                                                            readOnly
                                                                                            className="w-full border border-gray-300 rounded px-2 py-1 bg-gray-50"
                                                                                          />
                                                                                        </td>
                                                                                      );
                                                                                    }
// --- MEZZANINE TOTAL AREA row (read-only)
if (rowLabel === "Mezzanine Sub Total Area") {
  const noOfMezzanineFloor = parseFloat(
    details.noOfmezzaninefloor || 0
  );

  const totalArea =
    width && length && noOfMezzanineFloor
      ? (noOfMezzanineFloor * width * length).toFixed(3)
      : "";

  return (
    <td
      key={`mezz-total-${colIndex}`}
      style={{
        border: "1px solid #ddd",
        padding: "5px",
      }}
    >
      <input
        type="text"
        value={totalArea}
        readOnly
        className="w-full border border-gray-300 rounded px-2 py-1 bg-gray-100 font-semibold"
      />
    </td>
  );
}


                                                                                    // --- DROPDOWNS (Yes/No)
                                                                                    if (
                                                                                      rowLabel ===
                                                                                        "Mezzanine Handrails" ||
                                                                                      rowLabel ===
                                                                                        "Mezzanine staircase"
                                                                                    ) {
                                                                                      const keyName =
                                                                                        rowLabel ===
                                                                                        "Mezzanine Handrails"
                                                                                          ? "mezzanineHandrails"
                                                                                          : "mezzanineStaircase";
                                                                                      return (
                                                                                        <td
                                                                                          key={`${rowLabel}-${colIndex}`}
                                                                                          style={{
                                                                                            border:
                                                                                              "1px solid #ddd",
                                                                                            padding:
                                                                                              "5px",
                                                                                          }}
                                                                                        >
                                                                                          <select
                                                                                            value={
                                                                                              details[
                                                                                                keyName
                                                                                              ] ||
                                                                                              ""
                                                                                            }
                                                                                            onChange={(
                                                                                              e
                                                                                            ) =>
                                                                                              handleInputChangemezzanine(
                                                                                                e,
                                                                                                rowLabel,
                                                                                                colIndex,
                                                                                                building.id
                                                                                              )
                                                                                            }
                                                                                            style={{
                                                                                              width:
                                                                                                "100%",
                                                                                              padding:
                                                                                                "5px",
                                                                                              border:
                                                                                                "1px solid #ccc",
                                                                                              borderRadius:
                                                                                                "4px",
                                                                                            }}
                                                                                          >
                                                                                            {/* <option value="">
                                                                                              Select
                                                                                            </option> */}
                                                                                            <option value="No">
                                                                                              No
                                                                                            </option>
                                                                                            <option value="Yes">
                                                                                              Yes
                                                                                            </option>
                                                                                          </select>
                                                                                        </td>
                                                                                      );
                                                                                    }

                                                                                    // --- NORMAL INPUTS
                                                                                    return (
                                                                                      <td
                                                                                        key={`${rowLabel}-${colIndex}`}
                                                                                        style={{
                                                                                          border:
                                                                                            "1px solid #ddd",
                                                                                          padding:
                                                                                            "5px",
                                                                                        }}
                                                                                      >
                                                                                        <InputField
                                                                                          className="inputBox"
                                                                                          type="text"
                                                                                          value={
                                                                                            details[
                                                                                              rowLabel ===
                                                                                              "No. of mezzanine floor"
                                                                                                ? "noOfmezzaninefloor"
                                                                                                : rowLabel ===
                                                                                                  "Width"
                                                                                                ? "width"
                                                                                                : rowLabel ===
                                                                                                  "Length"
                                                                                                ? "length"
                                                                                                : rowLabel ===
                                                                                                  "Clear Height"
                                                                                                ? "clearHeight"
                                                                                                : rowLabel ===
                                                                                                  "Thickness of slab"
                                                                                                ? "thicknessOfSlab"
                                                                                                : rowLabel
                                                                                            ] ||
                                                                                            ""
                                                                                          }
                                                                                          onChange={(
                                                                                            e
                                                                                          ) =>
                                                                                            handleInputChangemezzanine(
                                                                                              e,
                                                                                              rowLabel,
                                                                                              colIndex,
                                                                                              building.id
                                                                                            )
                                                                                          }
                                                                                          style={{
                                                                                            width:
                                                                                              "100%",
                                                                                            boxSizing:
                                                                                              "border-box",
                                                                                            padding:
                                                                                              "5px",
                                                                                          }}
                                                                                        />
                                                                                      </td>
                                                                                    );
                                                                                  }
                                                                                )}
                                                                              </tr>
                                                                            )
                                                                          )}


                                                                          {/* --- Final Total Mezzanine Sub-total Row --- */}
                                                                          <tr>
                                                                            <td
                                                                              colSpan={
                                                                                1
                                                                              }
                                                                              style={{
                                                                                textAlign:
                                                                                  "right",
                                                                                fontWeight:
                                                                                  "bolder",
                                                                                backgroundColor:
                                                                                  "#e0f7fa",
                                                                                border:
                                                                                  "1px solid #ddd",
                                                                                padding:
                                                                                  "10px",
                                                                              }}
                                                                            >
                                                                              Mezzanine
                                                                              Total
                                                                              Area:
                                                                            </td>

                                                                            <td
                                                                              colSpan={
                                                                                activeBuilding
                                                                                  ?.mezzanineData
                                                                                  ?.noOfmezzanines ||
                                                                                1
                                                                              }
                                                                              style={{
                                                                                fontWeight:
                                                                                  "bolder",
                                                                                backgroundColor:
                                                                                  "#e0f7fa",
                                                                                color:
                                                                                  "#004d40",
                                                                                border:
                                                                                  "1px solid #ddd",
                                                                                padding:
                                                                                  "10px",
                                                                              }}
                                                                            >
                                                                              {activeBuilding?.mezzanineSubtotal?.toFixed(
                                                                                3
                                                                              ) ||
                                                                                "0.000"}
                                                                            </td>
                                                                          </tr>
                                                                        </tbody>
                                                                      </table>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          )}
                                                          {key ===
                                                            "roofMonitor" && (
                                                            <div>
                                                              <h5 className="card-title text-primary">
                                                                Roof Monitor
                                                              </h5>
                                                              <div className="row">
                                                                <div className="col-lg-12 col-md-12 label">
                                                                  <div
                                                                    style={{
                                                                      padding:
                                                                        "20px",
                                                                    }}
                                                                  >
                                                                    <table
                                                                      style={{
                                                                        borderCollapse:
                                                                          "collapse",
                                                                        width:
                                                                          "400px",
                                                                      }}
                                                                    >
                                                                      <tbody>
                                                                        {[
                                                                          {
                                                                            label:
                                                                              "Grid Line From",
                                                                            field:
                                                                              "roofMonitorGridLineFrom",
                                                                          },
                                                                          {
                                                                            label:
                                                                              "Grid Line To",
                                                                            field:
                                                                              "roofMonitorGridLineTo",
                                                                          },
                                                                          {
                                                                            label:
                                                                              "Throat Width",
                                                                            field:
                                                                              "roofMonitorThroatWidth",
                                                                          },
                                                                          {
                                                                            label:
                                                                              "Height",
                                                                            field:
                                                                              "roofMonitorHeight",
                                                                          },
                                                                          {
                                                                            label:
                                                                              "Length",
                                                                            field:
                                                                              "roofMonitorLength",
                                                                          },
                                                                          {
                                                                            label:
                                                                              "Slope",
                                                                            field:
                                                                              "roofMonitorSlope",
                                                                          },
                                                                          {
                                                                            label:
                                                                              "Mesh",
                                                                            field:
                                                                              "roofMonitorMesh",
                                                                          },
                                                                        ].map(
                                                                          ({
                                                                            label,
                                                                            field,
                                                                          }) => (
                                                                            <tr
                                                                              key={
                                                                                field
                                                                              }
                                                                            >
                                                                              <td
                                                                                style={{
                                                                                  border:
                                                                                    "1px solid #ddd",
                                                                                  padding:
                                                                                    "10px",
                                                                                  fontWeight:
                                                                                    "bold",
                                                                                }}
                                                                              >
                                                                                {
                                                                                  label
                                                                                }
                                                                              </td>
                                                                              <td
                                                                                style={{
                                                                                  border:
                                                                                    "1px solid #ddd",
                                                                                  padding:
                                                                                    "5px",
                                                                                }}
                                                                              >
                                                                                <InputField
                                                                                  className="inputBox"
                                                                                  type="text"
                                                                                  name={
                                                                                    field
                                                                                  }
                                                                                  value={
                                                                                    building
                                                                                      .roofMonitorInputs?.[
                                                                                      field
                                                                                    ] ||
                                                                                    ""
                                                                                  }
                                                                                  onChange={(
                                                                                    e
                                                                                  ) =>
                                                                                    handleRoofMonitorInputChange(
                                                                                      field,
                                                                                      e
                                                                                        .target
                                                                                        .value,
                                                                                      building.id
                                                                                    )
                                                                                  }
                                                                                  style={{
                                                                                    width:
                                                                                      "100%",
                                                                                    boxSizing:
                                                                                      "border-box",
                                                                                  }}
                                                                                />
                                                                              </td>
                                                                            </tr>
                                                                          )
                                                                        )}
                                                                      </tbody>
                                                                    </table>
                                                                  </div>
                                                                </div>
                                                              </div>{" "}
                                                            </div>
                                                          )}
                                                        </div>
                                                      );
                                                    }
                                                  )}
                                                </div>
                                              </>
                                            );
                                          })()}
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>

                    {/* instruction */}

                    <div
                      className="tab-content pt-2"
                      style={{ overflowY: "auto" }}
                    >
                      {buildings.map((building, index) => (
                        <div
                          key={building.id}
                          className={`tab-pane fade ${
                            activeBuildingId === building.id
                              ? "show active"
                              : ""
                          }`}
                        >
                          {/* Only show content for active building */}
                          {activeBuildingId === building.id && (
                            <div
                              className="accordion mt-3 mb-4"
                              id="accordionExample"
                            >
                              <div className="accordion-item">
                                <h2 className="accordion-header">
                                  <Row className="accordion-button">
                                    <Col
                                      xs={1}
                                      md={1}
                                      lg={1}
                                      className="text-left arrowBtn"
                                    >
                                      <i
                                        className={`bi ${
                                          building.isCardVisible10
                                            ? "bi-chevron-right"
                                            : "bi-chevron-down"
                                        }`}
                                        onClick={() =>
                                          toggleCardVisibility10(building.id)
                                        }
                                      ></i>
                                    </Col>
                                    <Col
                                      xs={1}
                                      md={1}
                                      lg={1}
                                      className="text-center logoBtn"
                                    >
                                      <span className="iconLogo">AB</span>
                                    </Col>
                                    <Col xs={4} md={4} lg={4}>
                                      <span className="headerTitle">
                                        Instructions {building.id}
                                      </span>
                                      <span className="subHeaderTitle">
                                        Instructions Section
                                      </span>
                                    </Col>
                                  </Row>
                                </h2>
                                <div
                                  className={`accordion-collapse collapse show ${
                                    building.isCardVisible10 ? "visible" : ""
                                  }`}
                                >
                                  <div className="accordion-body pb-5">
                                    <Row className="p-4">
                                      <Col xs={12} md={12} lg={12}>
                                        <RichTextEditor
                                          value={building.editorContent || ""}
                                          onChange={(content) =>
                                            handleInstruction(
                                              content,
                                              building.id
                                            )
                                          }
                                        />
                                      </Col>
                                    </Row>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>

                    {/*  block */}
                  </div>
                </div>
              </Col>
            </Row>

            <Row>
              <Col
                xs={12}
                md={12}
                lg={12}
                className="d-flex justify-content-end"
              >
                <button
                  className="btn btn-primary my-3"
                  onClick={handleEstimation}
                  // disabled={disabled}
                >
                  Save as Draft
                </button>
                {formInputs?.estimationNr && (
                  <button
                    className="btn btn-primary my-3"
                    onClick={navigateSpecification}
                    // disabled={disabled}
                  >
                    Estimation
                  </button>
                )}
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
      {/* <CaseSelectionModal
        show={modalShowCaseSelect}
        onHide={() => hideCaseSelectModal()}
        onCaseSelect={handleCaseSelect}
        // dropdownData={getAccountGroup}
      /> */}

      <CaseSelectionModal
        show={modalShowCaseSelect}
        onHide={() => hideCaseSelectModal()}
        onCaseSelect={handleCaseSelect}
        buildingType={
          selectedBuildingId
            ? buildings.find((b) => b.id === selectedBuildingId)
                ?.buildingTypesCode
            : "CS"
        }
      />
      <ComponentDataViewModal
        show={dataViewModal}
        onHide={hideDataViewModal}
        onCaseSelect={handleDataViewModal}
        additionalComponents={
          buildings.find((b) => b.id === activeBuildingId)
            ?.additionalComponents || {}
        }
        // Replace these with memoized values:
        canopyRows={canopyRows} // Use memoized directly
        canopyInputs={
          buildings.find((b) => b.id === activeBuildingId)?.canopy?.inputs || {}
        }
        canopyInputsChange={canopyInputsChange}
        deleteCanopyColumn={deleteCanopyColumn}
        yesNoOptions={yesNoOptions}
        girtCondition={girtCondition}
        setDropdownData={setDropdownData}
        dynamicCanopyRows={canopyRows} // Use memoized directly instead of dynamicRows
        handleDynomicCanopyInputChange={handleDynomicCanopyInputChange}
        activeBuilding={buildings.find((b) => b.id === activeBuildingId)}
        addCanopyColumn={addCanopyColumn}
        // addCanopyRow={addCanopyRow}
        activeBuildingId={activeBuildingId}
        addCanopyRow={addCanopyRow}
        deleteCanopyRow={deleteCanopyRow}
        handleDynamicHeaderChange={handleDynamicHeaderChange}
        InputField={InputField}
        ComboboxField={ComboboxField}
        frameOpeningRows={frameOpeningRows} // Use memoized directly
        frameOpeningInputs={
          buildings.find((b) => b.id === activeBuildingId)?.frameOpening
            ?.inputs || {}
        }
        frameOpeningInputsChange={frameOpeningInputsChange}
        dynamicFrameOpening={frameOpeningRows} // Use memoized directly
        handleDynomicFrameOpeningInputsChange={
          handleDynomicFrameOpeningInputsChange
        }
        addFrameOpeningColumn={addFrameOpeningColumn}
        handleFrameOpeningDynamicHeaderChange={
          handleFrameOpeningDynamicHeaderChange
        }
        deleteFrameOpeningColumn={deleteFrameOpeningColumn}
        addFrameOpeningRow={addFrameOpeningRow}
        deleteFrameOpeningRow={deleteFrameOpeningRow}
        // leanto inputs
        leanToRows={leanToRows} // Use memoized directly
        leanToInputs={
          buildings.find((b) => b.id === activeBuildingId)?.leanTo?.inputs || {}
        }
        leanToInputsChange={leanToInputsChange}
        dynomicLeanToInputs={leanToRows}
        handleDynomicLeanToInputs={handleDynomicLeanToInputs}
        addLeanToColumn={addLeanToColumn}
        handleLeanToDynamicHeaderChange={handleLeanToDynamicHeaderChange}
        deleteLeanToColumn={deleteLeanToColumn}
        deleteLeanToRow={deleteLeanToRow}
        addLeanToRow={addLeanToRow}
        // Fixed louvers
        fixedLouversRows={fixedLouversRows}
        dynomicFixedLouversInputs={fixedLouversRows}
        handleDynomicFixedLouversInputs={handleDynomicFixedLouversInputs}
        fixedLouversInputsChange={fixedLouversInputsChange}
        addFixedLouversColumn={addFixedLouversColumn}
        addFixedLouversRow={addFixedLouversRow}
        deleteFixedLouversRow={deleteFixedLouversRow}
        handleFixedLouversDynamicHeaderChange={
          handleFixedLouversDynamicHeaderChange
        }
        deleteFixedLouversColumn={deleteFixedLouversColumn}
        fixedLouversInputs={
          buildings.find((b) => b.id === activeBuildingId)?.fixedLouvers
            ?.inputs || {}
        }
        // Structural
        structuralLouversRows={structuralLouversRows} // Use memoized directly
        structuralLouversInputs={
          buildings.find((b) => b.id === activeBuildingId)?.structuralLouvers
            ?.inputs || {}
        }
        structuralLouversInputsChange={structuralLouversInputsChange}
        dynomicStructuralLouversInputs={structuralLouversRows} // Use memoized directly
        handleDynomicStructuralLouversInputs={
          handleDynomicStructuralLouversInputs
        }
        addStructuralLouversColumn={addStructuralLouversColumn}
        deleteStructuralLouversColumn={deleteStructuralLouversColumn}
        handleDynamicStructuralLouversHeaderChange={
          handleDynamicStructuralLouversHeaderChange
        }
        addStructuralLouversRow={addStructuralLouversRow}
        deleteStructuralLouversRow={deleteStructuralLouversRow}
        // Fascia
        fasciaRows={fasciaRows} // Use memoized directly
        handleDynomicfasciaInputs={handleDynomicfasciaInputs}
        fasciaInputs={
          buildings.find((b) => b.id === activeBuildingId)?.fascia?.inputs || {}
        }
        fasciaInputsChange={fasciaInputsChange}
        dynomicfasciaInputs={fasciaRows} // Use memoized directly
        addFasciaColumn={addFasciaColumn}
        deleteFasciaColumn={deleteFasciaColumn}
        handleDynamicFasciaHeaderChange={handleDynamicFasciaHeaderChange}
        showComponent={showComponent}
        addFasciaRow={addFasciaRow}
        deleteFasciaRow={deleteFasciaRow}
      />

      {/* <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      /> */}
      <FileViewerModalForHB
                        show={getShowFileViewModal}
                        onHide={handleViewFileHide}
                        fileid={getFileViewData}
                        onDeleteSuccess={handleAttachmentDeleted}
                      />
      <EstimationMatchModal
        show={modalShowMatch}
        onHide={() => hideModalMatch()}
        rowdatamodal={estimationMatchData}
          enteredArea={enteredArea} // <-- pass calculated area here


       
      />
      <EstimationSpecificationReminderModal
      title="Unsaved Changes"
        message={
          "Please click on Save as Draft to avoid losing your work."
        }
     />
    </main>
  );
};

export default EstimationSpecification;
